/*!
 * zarm-vue v2.0.0-beta.3
 * (c) 2018-2020 ZhonganTech Engineering
 * Released under the MIT License.
 */
module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "./";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 240);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return normalizeComponent; });
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent (
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier, /* server only */
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () {
        injectStyles.call(
          this,
          (options.functional ? this.parent : this).$root.$options.shadowRoot
        )
      }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functional component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 1 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.11' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 2 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(25)('wks');
var uid = __webpack_require__(15);
var Symbol = __webpack_require__(2).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(12)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(11);
var IE8_DOM_DEFINE = __webpack_require__(34);
var toPrimitive = __webpack_require__(27);
var dP = Object.defineProperty;

exports.f = __webpack_require__(4) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 6 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 7 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(5);
var createDesc = __webpack_require__(14);
module.exports = __webpack_require__(4) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(2);
var core = __webpack_require__(1);
var ctx = __webpack_require__(19);
var hide = __webpack_require__(8);
var has = __webpack_require__(6);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(38);
var defined = __webpack_require__(20);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(7);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 12 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return enumGenerator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return isArray; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return defaultThemeValidator; });
function enumGenerator() {
  var enumArr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return function (v) {
    return enumArr.indexOf(v) >= 0;
  };
}
function isArray(val) {
  return Object.prototype.toString.call(val) === '[object Array]';
}
function defaultThemeValidator(v) {
  return ['default', 'primary', 'info', 'success', 'warning', 'danger', 'error'].indexOf(v) >= 0;
}

/***/ }),
/* 14 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 15 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 16 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 17 */
/***/ (function(module, exports) {

module.exports = true;


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(36);
var enumBugKeys = __webpack_require__(26);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(39);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 20 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(20);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 22 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(25)('keys');
var uid = __webpack_require__(15);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(5).f;
var has = __webpack_require__(6);
var TAG = __webpack_require__(3)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(1);
var global = __webpack_require__(2);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(17) ? 'pure' : 'global',
  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 26 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(7);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 28 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(7);
var document = __webpack_require__(2).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(11);
var dPs = __webpack_require__(47);
var enumBugKeys = __webpack_require__(26);
var IE_PROTO = __webpack_require__(23)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(29)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(52).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(22);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 32 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/_vue-loader@15.9.3@vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/_vue-loader@15.9.3@vue-loader/lib??vue-loader-options!./src/icon/src/icon.vue?vue&type=template&id=3968e338&lang=html&
var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{class:( _obj = {}, _obj[("" + _vm.prefixCls)] = true, _obj[(_vm.prefixCls + "-" + _vm.type)] = !!_vm.type, _obj[(_vm.prefixCls + "--" + _vm.theme)] = !!_vm.theme, _obj ),on:{"click":_vm.handleClick}},[(_vm.tag === "symbol")?_c('svg',{attrs:{"width":"1em","height":"1em","fill":"currentColor","viewBox":"0 0 32 32"}},[_c('use',{attrs:{"xlink:href":("#" + _vm.type)}})]):_vm._e()])}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/icon/src/icon.vue?vue&type=template&id=3968e338&lang=html&

// EXTERNAL MODULE: ./src/utils/validator.js
var validator = __webpack_require__(13);

// CONCATENATED MODULE: ./node_modules/_babel-loader@8.1.0@babel-loader/lib!./node_modules/_vue-loader@15.9.3@vue-loader/lib??vue-loader-options!./src/icon/src/icon.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var iconvue_type_script_lang_js_ = ({
  name: 'zaIcon',
  props: {
    prefixCls: {
      type: String,
      default: 'za-icon'
    },
    type: String,
    tag: String,
    theme: {
      type: String,
      validator: validator["a" /* defaultThemeValidator */],
      default: null
    }
  },
  methods: {
    handleClick: function handleClick(event) {
      this.$emit('click', event);
    }
  }
});
// CONCATENATED MODULE: ./src/icon/src/icon.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_iconvue_type_script_lang_js_ = (iconvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(0);

// CONCATENATED MODULE: ./src/icon/src/icon.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  src_iconvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var icon = __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(4) && !__webpack_require__(12)(function () {
  return Object.defineProperty(__webpack_require__(29)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(17);
var $export = __webpack_require__(9);
var redefine = __webpack_require__(40);
var hide = __webpack_require__(8);
var Iterators = __webpack_require__(16);
var $iterCreate = __webpack_require__(61);
var setToStringTag = __webpack_require__(24);
var getPrototypeOf = __webpack_require__(62);
var ITERATOR = __webpack_require__(3)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(6);
var toIObject = __webpack_require__(10);
var arrayIndexOf = __webpack_require__(50)(false);
var IE_PROTO = __webpack_require__(23)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

var _Object$defineProperty = __webpack_require__(79);

function _defineProperty(obj, key, value) {
  if (key in obj) {
    _Object$defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

module.exports = _defineProperty;

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(28);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 39 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(8);


/***/ }),
/* 41 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(3);


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(15)('meta');
var isObject = __webpack_require__(7);
var has = __webpack_require__(6);
var setDesc = __webpack_require__(5).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(12)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(2);
var core = __webpack_require__(1);
var LIBRARY = __webpack_require__(17);
var wksExt = __webpack_require__(42);
var defineProperty = __webpack_require__(5).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(36);
var hiddenKeys = __webpack_require__(26).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(84);

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(5);
var anObject = __webpack_require__(11);
var getKeys = __webpack_require__(18);

module.exports = __webpack_require__(4) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(28);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(60)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(35)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(10);
var toLength = __webpack_require__(31);
var toAbsoluteIndex = __webpack_require__(51);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(22);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(2).document;
module.exports = document && document.documentElement;


/***/ }),
/* 53 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(19);
var call = __webpack_require__(75);
var isArrayIter = __webpack_require__(76);
var anObject = __webpack_require__(11);
var toLength = __webpack_require__(31);
var getIterFn = __webpack_require__(73);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(32);
var createDesc = __webpack_require__(14);
var toIObject = __webpack_require__(10);
var toPrimitive = __webpack_require__(27);
var has = __webpack_require__(6);
var IE8_DOM_DEFINE = __webpack_require__(34);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(4) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(65);
var global = __webpack_require__(2);
var hide = __webpack_require__(8);
var Iterators = __webpack_require__(16);
var TO_STRING_TAG = __webpack_require__(3)('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(28);
var TAG = __webpack_require__(3)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

var _Symbol$iterator = __webpack_require__(119);

var _Symbol = __webpack_require__(86);

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof _Symbol === "function" && typeof _Symbol$iterator === "symbol") {
    module.exports = _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    module.exports = _typeof = function _typeof(obj) {
      return obj && typeof _Symbol === "function" && obj.constructor === _Symbol && obj !== _Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

module.exports = _typeof;

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/_vue-loader@15.9.3@vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/_vue-loader@15.9.3@vue-loader/lib??vue-loader-options!./src/mask/src/mask.vue?vue&type=template&id=43499ab3&lang=html&
var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('div',{class:( _obj = {}, _obj[("" + _vm.prefixCls)] = true, _obj[(_vm.prefixCls + "--" + _vm.type)] = !!_vm.type, _obj ),on:{"click":_vm.maskClick}}):_vm._e()}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/mask/src/mask.vue?vue&type=template&id=43499ab3&lang=html&

// CONCATENATED MODULE: ./src/mixins/scrollable.js
/**
 * document scrollable on clientwindow
 */
function getScrollTop() {
  // vue-jest ignore
  if (!document) return;

  if (document.scrollingElement) {
    return document.scrollingElement.scrollTop;
  }

  if (document.body || window.pageXOffset) {
    return document.body.scrollTop || document.documentElement.scrollTop || window.pageYOffset;
  }
}

function setScrollTop(scrollTop) {
  // vue-jest ignore
  if (!document) return;

  if (document.scrollingElement) {
    document.scrollingElement.scrollTop = scrollTop;
    return;
  }

  document.documentElement.scrollTop = scrollTop;
  document.body.scrollTop = scrollTop;
}

/* harmony default export */ var scrollable = ({
  data: function data() {
    return {
      documentScrollble: this.lockScroller || true,
      // 判断是否开启scrolllock
      documentBodyStyle: null,
      documentScrollTop: 0 // 保留scrolllock的历史scrollTop滚动距离

    };
  },
  mounted: function mounted() {
    var _document$body$style = document.body.style,
        top = _document$body$style.top,
        position = _document$body$style.position,
        width = _document$body$style.width;
    this.documentBodyStyle = {
      top: top,
      position: position,
      width: width
    };
  },
  beforeDestroy: function beforeDestroy() {
    this.onAfterClose();
  },
  methods: {
    handlerClient: function handlerClient(event) {
      event.preventDefault();
    },
    onAfterOpen: function onAfterOpen() {
      if (!this.documentScrollble) return;
      this.documentScrollTop = getScrollTop();
      document.body.style.position = 'fixed';
      document.body.style.width = '100%';
      document.body.style.top = "".concat(-this.documentScrollTop, "px");
    },
    onAfterClose: function onAfterClose() {
      if (!this.documentScrollble) return;
      var _this$documentBodySty = this.documentBodyStyle,
          top = _this$documentBodySty.top,
          position = _this$documentBodySty.position,
          width = _this$documentBodySty.width; // fixed ios10, android5.x readonly property bug

      document.body.style.position = position;
      document.body.style.width = width;
      document.body.style.top = top; // scrollTop lost after set position:fixed, restore it back.

      setScrollTop(this.documentScrollTop);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/_babel-loader@8.1.0@babel-loader/lib!./node_modules/_vue-loader@15.9.3@vue-loader/lib??vue-loader-options!./src/mask/src/mask.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var maskvue_type_script_lang_js_ = ({
  name: 'zaMask',
  mixins: [scrollable],
  props: {
    lockScroller: {
      type: Boolean,
      default: true
    },
    prefixCls: {
      type: String,
      default: 'za-mask'
    },
    visible: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      validator: function validator(v) {
        // eslint-disable-line object-shorthand
        return ['transparent', 'normal'].indexOf(v) >= 0;
      },
      default: 'normal'
    }
  },
  watch: {
    visible: function visible(val) {
      if (val) {
        this.onAfterOpen();
      } else {
        this.onAfterClose();
      }
    }
  },
  methods: {
    maskClick: function maskClick(e) {
      this.$emit('click', e);
    }
  }
});
// CONCATENATED MODULE: ./src/mask/src/mask.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_maskvue_type_script_lang_js_ = (maskvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(0);

// CONCATENATED MODULE: ./src/mask/src/mask.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  src_maskvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var mask = (component.exports);
// CONCATENATED MODULE: ./src/mask/index.js

/* istanbul ignore next */

mask.install = function (Vue) {
  Vue.component(mask.name, mask);
};

/* harmony default export */ var src_mask = __webpack_exports__["default"] = (mask);

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(22);
var defined = __webpack_require__(20);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(30);
var descriptor = __webpack_require__(14);
var setToStringTag = __webpack_require__(24);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(8)(IteratorPrototype, __webpack_require__(3)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(6);
var toObject = __webpack_require__(21);
var IE_PROTO = __webpack_require__(23)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 63 */
/***/ (function(module, exports) {



/***/ }),
/* 64 */
/***/ (function(module, exports) {

module.exports = require("vue");

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(66);
var step = __webpack_require__(53);
var Iterators = __webpack_require__(16);
var toIObject = __webpack_require__(10);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(35)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 66 */
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(2);
var has = __webpack_require__(6);
var DESCRIPTORS = __webpack_require__(4);
var $export = __webpack_require__(9);
var redefine = __webpack_require__(40);
var META = __webpack_require__(43).KEY;
var $fails = __webpack_require__(12);
var shared = __webpack_require__(25);
var setToStringTag = __webpack_require__(24);
var uid = __webpack_require__(15);
var wks = __webpack_require__(3);
var wksExt = __webpack_require__(42);
var wksDefine = __webpack_require__(44);
var enumKeys = __webpack_require__(71);
var isArray = __webpack_require__(48);
var anObject = __webpack_require__(11);
var isObject = __webpack_require__(7);
var toObject = __webpack_require__(21);
var toIObject = __webpack_require__(10);
var toPrimitive = __webpack_require__(27);
var createDesc = __webpack_require__(14);
var _create = __webpack_require__(30);
var gOPNExt = __webpack_require__(72);
var $GOPD = __webpack_require__(55);
var $GOPS = __webpack_require__(41);
var $DP = __webpack_require__(5);
var $keys = __webpack_require__(18);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(45).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(32).f = $propertyIsEnumerable;
  $GOPS.f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(17)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });

$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return $GOPS.f(toObject(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(8)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_corejs2_core_js_set__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83);
/* harmony import */ var _babel_runtime_corejs2_core_js_set__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_corejs2_core_js_set__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _src_icon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(33);


/* istanbul ignore next */

_src_icon__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"].install = function (Vue) {
  Vue.component(_src_icon__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"].name, _src_icon__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"]);
};

var customCache = new _babel_runtime_corejs2_core_js_set__WEBPACK_IMPORTED_MODULE_0___default.a();

_src_icon__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"].createSymbolIconfont = function () {
  var scriptUrl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  /**
   * DOM API required.
   * Make sure in browser environment.
   * The Custom Icon will create a <script/>
   * that loads SVG symbols and insert the SVG Element into the document body.
   */
  if (typeof document !== 'undefined' && typeof window !== 'undefined' && typeof document.createElement === 'function' && typeof scriptUrl === 'string' && scriptUrl.length && !customCache.has(scriptUrl)) {
    var script = document.createElement('script');
    script.setAttribute('src', scriptUrl);
    script.setAttribute('data-namespace', scriptUrl);
    customCache.add(scriptUrl);
    document.body.appendChild(script);
  }
};

/* harmony default export */ __webpack_exports__["default"] = (_src_icon__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"]);

/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    getContainer: Function
  },
  watch: {
    getContainer: function getContainer() {
      this.move();
    }
  },
  methods: {
    removeContainer: function removeContainer() {
      if (this.getContainer) {
        this.getContainer().removeChild(this.$el);
      }
    },
    move: function move() {
      if (this.getContainer) {
        this.getContainer().appendChild(this.$el);
      } else if (this.$parent) {
        this.$parent.$el.appendChild(this.$el);
      }
    }
  },
  mounted: function mounted() {
    if (this.getContainer) {
      this.move();
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.removeContainer();
  }
});

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(9);
var core = __webpack_require__(1);
var fails = __webpack_require__(12);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(18);
var gOPS = __webpack_require__(41);
var pIE = __webpack_require__(32);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(10);
var gOPN = __webpack_require__(45).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(57);
var ITERATOR = __webpack_require__(3)('iterator');
var Iterators = __webpack_require__(16);
module.exports = __webpack_require__(1).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./src/mask/index.js + 6 modules
var mask = __webpack_require__(59);

// EXTERNAL MODULE: ./src/mixins/get-container.js
var get_container = __webpack_require__(69);

// CONCATENATED MODULE: ./node_modules/_babel-loader@8.1.0@babel-loader/lib!./node_modules/_vue-loader@15.9.3@vue-loader/lib??vue-loader-options!./src/popup/src/popup.vue?vue&type=script&lang=js&


/* harmony default export */ var popupvue_type_script_lang_js_ = ({
  name: 'zaPopup',
  components: {
    zaMask: mask["default"]
  },
  mixins: [get_container["a" /* default */]],
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    direction: {
      type: String,
      validator: function validator(v) {
        // eslint-disable-line object-shorthand
        return ['top', 'right', 'bottom', 'left', 'center'].indexOf(v) >= 0;
      },
      default: 'center'
    },
    animationType: {
      type: String,
      validator: function validator(v) {
        // eslint-disable-line object-shorthand
        return ['fade', 'door', 'flip', 'rotate', 'zoom', 'moveUp', 'moveDown', 'moveLeft', 'moveRight', 'slideUp', 'slideDown', 'slideLeft', 'slideRight'].indexOf(v) >= 0;
      },
      default: 'fade'
    },
    animationDuration: {
      type: Number,
      default: 200
    },
    hasMask: {
      type: Boolean,
      default: true
    },
    maskType: {
      type: String,
      validator: function validator(v) {
        // eslint-disable-line object-shorthand
        return ['normal', 'transparent'].indexOf(v) >= 0;
      },
      default: 'normal'
    },
    prefixCls: {
      type: String,
      default: 'za-popup'
    }
  },
  computed: {
    transitionDurationStyle: function transitionDurationStyle() {
      return {
        WebkitTransitionDuration: "".concat(this.animationDuration, "ms"),
        transitionDuration: "".concat(this.animationDuration, "ms")
      };
    },
    animationDurationStyle: function animationDurationStyle() {
      return {
        WebkitAnimationDuration: "".concat(this.animationDuration, "ms"),
        animationDuration: "".concat(this.animationDuration, "ms")
      };
    },
    directionCenter: function directionCenter() {
      return this.direction === 'center';
    }
  },
  data: function data() {
    return {
      currentVisible: this.visible,
      animationState: 'enter',
      maskVisible: this.hasMask && this.visible
    };
  },
  watch: {
    visible: function visible(value, oldValue) {
      // eslint-disable-line no-unused-vars, object-shorthand
      if (value === this.currentVisible) return;
      this.removeTimer();

      if (value) {
        this.enter();
      } else {
        this.leave();
      }
    }
  },
  methods: {
    enter: function enter() {
      var _this = this;

      this.currentVisible = true;
      this.animationState = 'enter';
      this.timerEnter = setTimeout(function () {
        _this.maskVisible = true;
      }, 10);
    },
    leave: function leave() {
      var _this2 = this;

      this.animationState = 'leave';
      this.maskVisible = false;
      this.timerLeave = setTimeout(function () {
        _this2.currentVisible = false;
      }, this.animationDuration);
    },
    removeTimer: function removeTimer() {
      if (this.timerEnter) {
        clearTimeout(this.timerEnter);
      }

      if (this.timerLeave) {
        clearTimeout(this.timerLeave);
      }
    },
    onMaskClick: function onMaskClick(event) {
      this.$emit('maskClick', event);
    }
  },
  mounted: function mounted() {
    if (this.currentVisible) {
      this.enter();
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.removeTimer();
  },
  render: function render() {
    var h = arguments[0];
    var prefixCls = this.prefixCls,
        hasMask = this.hasMask,
        direction = this.direction,
        maskType = this.maskType,
        onMaskClick = this.onMaskClick,
        maskVisible = this.maskVisible,
        currentVisible = this.currentVisible,
        animationState = this.animationState,
        transitionDurationStyle = this.transitionDurationStyle,
        animationDurationStyle = this.animationDurationStyle;
    var popupCls = maskVisible ? "".concat(prefixCls, " ").concat(prefixCls, "--opened") : "".concat(prefixCls);
    return h("transition", [currentVisible && h("div", {
      "class": "".concat(popupCls)
    }, [h("div", {
      "class": "".concat(prefixCls, "__wrapper ").concat(prefixCls, "__wrapper-").concat(direction),
      style: transitionDurationStyle
    }, [this.$slots.default]), hasMask && h("za-mask", {
      "class": "fade-".concat(animationState),
      style: animationDurationStyle,
      attrs: {
        visible: maskVisible,
        type: maskType
      },
      on: {
        "click": onMaskClick
      }
    })])]);
  }
});
// CONCATENATED MODULE: ./src/popup/src/popup.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_popupvue_type_script_lang_js_ = (popupvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(0);

// CONCATENATED MODULE: ./src/popup/src/popup.vue
var render, staticRenderFns




/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  src_popupvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var popup = (component.exports);
// CONCATENATED MODULE: ./src/popup/index.js

/* istanbul ignore next */

popup.install = function (Vue) {
  Vue.component(popup.name, popup);
};

/* harmony default export */ var src_popup = __webpack_exports__["default"] = (popup);

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(11);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(16);
var ITERATOR = __webpack_require__(3)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(124);

/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  on: function on(el, type, callback) {
    if (el.addEventListener) {
      el.addEventListener(type, callback, {
        passive: false
      });
    }
    /* istanbul ignore next  */
    else {
        el.attachEvent("on ".concat(type), function () {
          callback.call(el);
        });
      }
  },
  off: function off(el, type, callback) {
    if (el.removeEventListener) {
      el.removeEventListener(type, callback, {
        passive: false
      });
    }
    /* istanbul ignore next  */
    else {
        el.detachEvent("off ".concat(type), callback);
      }
  },
  once: function once(el, type, callback) {
    var typeArray = type.split(' ');

    var recursiveFunction = function recursiveFunction(e) {
      e.target.removeEventListener(e.type, recursiveFunction, {
        passive: false
      });
      return callback(e);
    };

    for (var i = typeArray.length - 1; i >= 0; i -= 1) {
      this.on(el, typeArray[i], recursiveFunction);
    }
  },
  stopPropagation: function stopPropagation(e) {
    e.stopPropagation();
  }
});

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(122);

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

var hide = __webpack_require__(8);
module.exports = function (target, src, safe) {
  for (var key in src) {
    if (safe && target[key]) target[key] = src[key];
    else hide(target, key, src[key]);
  } return target;
};


/***/ }),
/* 81 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(7);
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(98);

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(85);
module.exports = __webpack_require__(1).Object.keys;


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(21);
var $keys = __webpack_require__(18);

__webpack_require__(70)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(89);

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(140);

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(143);

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(67);
__webpack_require__(63);
__webpack_require__(90);
__webpack_require__(91);
module.exports = __webpack_require__(1).Symbol;


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(44)('asyncIterator');


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(44)('observable');


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(130);

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/_vue-loader@15.9.3@vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/_vue-loader@15.9.3@vue-loader/lib??vue-loader-options!./src/activity-indicator/src/activityIndicator.vue?vue&type=template&id=44bc6b8b&lang=html&
var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{ref:"svg",class:( _obj = {}, _obj[("" + _vm.prefixCls)] = true, _obj[(_vm.prefixCls + "--" + _vm.size)] = !!_vm.size, _obj ),attrs:{"viewBox":("0 0 " + _vm.diameter + " " + _vm.diameter)}},[_c('circle',{class:(_vm.prefixCls + "__path"),style:({ strokeWidth: _vm.strokeWidth }),attrs:{"cx":_vm.half,"cy":_vm.half,"r":_vm.r,"fill":"none"}}),_vm._v(" "),_c('circle',{class:(_vm.prefixCls + "__line"),style:(_vm.style),attrs:{"cx":_vm.half,"cy":_vm.half,"r":_vm.r,"fill":"none"}})])}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/activity-indicator/src/activityIndicator.vue?vue&type=template&id=44bc6b8b&lang=html&

// EXTERNAL MODULE: ./src/utils/validator.js
var validator = __webpack_require__(13);

// CONCATENATED MODULE: ./node_modules/_babel-loader@8.1.0@babel-loader/lib!./node_modules/_vue-loader@15.9.3@vue-loader/lib??vue-loader-options!./src/activity-indicator/src/activityIndicator.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//

var diameter = 62;
/* harmony default export */ var activityIndicatorvue_type_script_lang_js_ = ({
  name: 'zaActivityIndicator',
  props: {
    prefixCls: {
      type: String,
      default: 'za-activity-indicator'
    },
    size: {
      type: String,
      validator: Object(validator["b" /* enumGenerator */])(['xl', 'lg', 'sm', 'xs']),
      default: null
    },
    strokeWidth: {
      type: Number,
      default: 5
    },
    percent: {
      type: Number,
      default: 15
    }
  },
  data: function data() {
    return {
      diameter: diameter
    };
  },
  computed: {
    half: function half() {
      return this.diameter / 2;
    },
    r: function r() {
      return this.half - this.strokeWidth / 2;
    },
    style: function style() {
      var round = 2 * Math.PI * this.r;
      return {
        strokeDasharray: "".concat(round * this.percent / 100, " ").concat(round),
        strokeWidth: this.strokeWidth
      };
    }
  }
});
// CONCATENATED MODULE: ./src/activity-indicator/src/activityIndicator.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_activityIndicatorvue_type_script_lang_js_ = (activityIndicatorvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(0);

// CONCATENATED MODULE: ./src/activity-indicator/src/activityIndicator.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  src_activityIndicatorvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var activityIndicator = (component.exports);
// CONCATENATED MODULE: ./src/activity-indicator/index.js

/* istanbul ignore next */

activityIndicator.install = function (Vue) {
  Vue.component(activityIndicator.name, activityIndicator);
};

/* harmony default export */ var activity_indicator = __webpack_exports__["default"] = (activityIndicator);

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(5);
var createDesc = __webpack_require__(14);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/_@babel_runtime-corejs2@7.11.2@@babel/runtime-corejs2/core-js/object/define-property.js
var define_property = __webpack_require__(79);
var define_property_default = /*#__PURE__*/__webpack_require__.n(define_property);

// EXTERNAL MODULE: ./node_modules/_@babel_runtime-corejs2@7.11.2@@babel/runtime-corejs2/core-js/object/define-properties.js
var define_properties = __webpack_require__(113);
var define_properties_default = /*#__PURE__*/__webpack_require__.n(define_properties);

// EXTERNAL MODULE: ./node_modules/_@babel_runtime-corejs2@7.11.2@@babel/runtime-corejs2/core-js/object/get-own-property-descriptors.js
var get_own_property_descriptors = __webpack_require__(87);
var get_own_property_descriptors_default = /*#__PURE__*/__webpack_require__.n(get_own_property_descriptors);

// EXTERNAL MODULE: ./node_modules/_@babel_runtime-corejs2@7.11.2@@babel/runtime-corejs2/core-js/object/get-own-property-descriptor.js
var get_own_property_descriptor = __webpack_require__(88);
var get_own_property_descriptor_default = /*#__PURE__*/__webpack_require__.n(get_own_property_descriptor);

// EXTERNAL MODULE: ./node_modules/_@babel_runtime-corejs2@7.11.2@@babel/runtime-corejs2/core-js/object/get-own-property-symbols.js
var get_own_property_symbols = __webpack_require__(77);
var get_own_property_symbols_default = /*#__PURE__*/__webpack_require__.n(get_own_property_symbols);

// EXTERNAL MODULE: ./node_modules/_@babel_runtime-corejs2@7.11.2@@babel/runtime-corejs2/core-js/object/keys.js
var object_keys = __webpack_require__(46);
var keys_default = /*#__PURE__*/__webpack_require__.n(object_keys);

// EXTERNAL MODULE: ./node_modules/_@babel_runtime-corejs2@7.11.2@@babel/runtime-corejs2/core-js/object/create.js
var create = __webpack_require__(125);
var create_default = /*#__PURE__*/__webpack_require__.n(create);

// EXTERNAL MODULE: ./node_modules/_@babel_runtime-corejs2@7.11.2@@babel/runtime-corejs2/helpers/defineProperty.js
var defineProperty = __webpack_require__(37);
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// CONCATENATED MODULE: ./node_modules/_babel-loader@8.1.0@babel-loader/lib!./node_modules/_vue-loader@15.9.3@vue-loader/lib??vue-loader-options!./src/drag/src/drag.vue?vue&type=script&lang=js&









function ownKeys(object, enumerableOnly) { var keys = keys_default()(object); if (get_own_property_symbols_default.a) { var symbols = get_own_property_symbols_default()(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return get_own_property_descriptor_default()(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty_default()(target, key, source[key]); }); } else if (get_own_property_descriptors_default.a) { define_properties_default()(target, get_own_property_descriptors_default()(source)); } else { ownKeys(Object(source)).forEach(function (key) { define_property_default()(target, key, get_own_property_descriptor_default()(source, key)); }); } } return target; }

/* harmony default export */ var dragvue_type_script_lang_js_ = ({
  name: 'zaDrag',
  props: {
    dragStart: {
      type: Function,
      default: function _default() {}
    },
    dragMove: {
      type: Function,
      default: function _default() {}
    },
    dragEnd: {
      type: Function,
      default: function _default() {}
    }
  },
  created: function created() {
    this.dragState = {};
  },
  methods: {
    onTouchStart: function onTouchStart(event) {
      var dragState = this.dragState;

      if (!event.touches) {
        dragState.startX = event.clientX;
        dragState.startY = event.clientY;
      } else {
        var touch = event.touches[0];
        dragState.startX = touch.pageX;
        dragState.startY = touch.pageY;
      }

      dragState.startTime = new Date();
      this.dragStart(event, dragState);
    },
    onTouchMove: function onTouchMove(event) {
      var dragState = this.dragState;
      var currentX;
      var currentY;

      if (!event.touches) {
        currentX = event.clientX;
        currentY = event.clientY;
      } else {
        var touch = event.touches[0];
        currentX = touch.pageX;
        currentY = touch.pageY;
      }

      var offsetX = currentX - dragState.startX;
      var offsetY = currentY - dragState.startY;

      var state = _objectSpread(_objectSpread({}, dragState), {}, {
        offsetX: offsetX,
        offsetY: offsetY,
        currentX: currentX,
        currentY: currentY
      });

      if (!this.dragMove(event, state)) return; // only if it returns true

      this.dragState = state;
    },
    onTouchEnd: function onTouchEnd(event) {
      var dragState = this.dragState;
      this.dragEnd(event, dragState);
      this.dragState = create_default()(null);
    }
  },
  render: function render() {
    var h = arguments[0];
    return h("div", {
      ref: "drag",
      on: {
        "touchstart": this.onTouchStart,
        "touchmove": this.onTouchMove,
        "touchend": this.onTouchEnd,
        "touchcancel": this.onTouchEnd,
        "mousedown": this.onTouchStart,
        "mousemove": this.onTouchMove,
        "mouseup": this.onTouchEnd
      }
    }, [this.$slots.default]);
  }
});
// CONCATENATED MODULE: ./src/drag/src/drag.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_dragvue_type_script_lang_js_ = (dragvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(0);

// CONCATENATED MODULE: ./src/drag/src/drag.vue
var render, staticRenderFns




/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  src_dragvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var drag = (component.exports);
// CONCATENATED MODULE: ./src/drag/index.js

/* istanbul ignore next */

drag.install = function (Vue) {
  Vue.component(drag.name, drag);
};

/* harmony default export */ var src_drag = __webpack_exports__["default"] = (drag);

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/_vue-loader@15.9.3@vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/_vue-loader@15.9.3@vue-loader/lib??vue-loader-options!./src/wheel/src/wheel.vue?vue&type=template&id=1700ca89&lang=html&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"wrapper",class:_vm.prefixCls},[_c('div',{class:(_vm.prefixCls + "__content")},_vm._l((_vm.dataSource),function(item,index){
var _obj;
return _c('div',{key:index+1,class:( _obj = {}, _obj[(_vm.prefixCls + "__item")] = true, _obj[(_vm.prefixCls + "__item--selected")] = _vm.value === item[_vm.valueMember], _obj )},[_vm._v("\n        "+_vm._s(_vm.itemRender(item))+"\n      ")])}),0)])}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/wheel/src/wheel.vue?vue&type=template&id=1700ca89&lang=html&

// CONCATENATED MODULE: ./node_modules/_better-scroll@1.12.0@better-scroll/dist/bscroll.esm.js
/*!
 * better-normal-scroll v1.12.0
 * (c) 2016-2018 ustbhuangyi
 * Released under the MIT License.
 */
var slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();













var toConsumableArray = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  } else {
    return Array.from(arr);
  }
};

function eventMixin(BScroll) {
  BScroll.prototype.on = function (type, fn) {
    var context = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this;

    if (!this._events[type]) {
      this._events[type] = [];
    }

    this._events[type].push([fn, context]);
  };

  BScroll.prototype.once = function (type, fn) {
    var context = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this;

    function magic() {
      this.off(type, magic);

      fn.apply(context, arguments);
    }
    // To expose the corresponding function method in order to execute the off method
    magic.fn = fn;

    this.on(type, magic);
  };

  BScroll.prototype.off = function (type, fn) {
    var _events = this._events[type];
    if (!_events) {
      return;
    }

    var count = _events.length;
    while (count--) {
      if (_events[count][0] === fn || _events[count][0] && _events[count][0].fn === fn) {
        _events[count][0] = undefined;
      }
    }
  };

  BScroll.prototype.trigger = function (type) {
    var events = this._events[type];
    if (!events) {
      return;
    }

    var len = events.length;
    var eventsCopy = [].concat(toConsumableArray(events));
    for (var i = 0; i < len; i++) {
      var event = eventsCopy[i];

      var _event = slicedToArray(event, 2),
          fn = _event[0],
          context = _event[1];

      if (fn) {
        fn.apply(context, [].slice.call(arguments, 1));
      }
    }
  };
}

// ssr support
var inBrowser = typeof window !== 'undefined';
var ua = inBrowser && navigator.userAgent.toLowerCase();
var isWeChatDevTools = ua && /wechatdevtools/.test(ua);
var isAndroid = ua && ua.indexOf('android') > 0;

function getNow() {
  return window.performance && window.performance.now ? window.performance.now() + window.performance.timing.navigationStart : +new Date();
}

function extend(target) {
  for (var _len = arguments.length, rest = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    rest[_key - 1] = arguments[_key];
  }

  for (var i = 0; i < rest.length; i++) {
    var source = rest[i];
    for (var key in source) {
      target[key] = source[key];
    }
  }
  return target;
}

function isUndef(v) {
  return v === undefined || v === null;
}

function getDistance(x, y) {
  return Math.sqrt(x * x + y * y);
}

var elementStyle = inBrowser && document.createElement('div').style;

var vendor = function () {
  if (!inBrowser) {
    return false;
  }
  var transformNames = {
    webkit: 'webkitTransform',
    Moz: 'MozTransform',
    O: 'OTransform',
    ms: 'msTransform',
    standard: 'transform'
  };

  for (var key in transformNames) {
    if (elementStyle[transformNames[key]] !== undefined) {
      return key;
    }
  }

  return false;
}();

function prefixStyle(style) {
  if (vendor === false) {
    return false;
  }

  if (vendor === 'standard') {
    if (style === 'transitionEnd') {
      return 'transitionend';
    }
    return style;
  }

  return vendor + style.charAt(0).toUpperCase() + style.substr(1);
}

function addEvent(el, type, fn, capture) {
  el.addEventListener(type, fn, { passive: false, capture: !!capture });
}

function removeEvent(el, type, fn, capture) {
  el.removeEventListener(type, fn, { passive: false, capture: !!capture });
}

function offset(el) {
  var left = 0;
  var top = 0;

  while (el) {
    left -= el.offsetLeft;
    top -= el.offsetTop;
    el = el.offsetParent;
  }

  return {
    left: left,
    top: top
  };
}

function offsetToBody(el) {
  var rect = el.getBoundingClientRect();

  return {
    left: -(rect.left + window.pageXOffset),
    top: -(rect.top + window.pageYOffset)
  };
}

var transform = prefixStyle('transform');

var hasPerspective = inBrowser && prefixStyle('perspective') in elementStyle;
// fix issue #361
var hasTouch = inBrowser && ('ontouchstart' in window || isWeChatDevTools);
var hasTransform = transform !== false;
var hasTransition = inBrowser && prefixStyle('transition') in elementStyle;

var style = {
  transform: transform,
  transitionTimingFunction: prefixStyle('transitionTimingFunction'),
  transitionDuration: prefixStyle('transitionDuration'),
  transitionDelay: prefixStyle('transitionDelay'),
  transformOrigin: prefixStyle('transformOrigin'),
  transitionEnd: prefixStyle('transitionEnd')
};

var TOUCH_EVENT = 1;
var MOUSE_EVENT = 2;

var eventType = {
  touchstart: TOUCH_EVENT,
  touchmove: TOUCH_EVENT,
  touchend: TOUCH_EVENT,

  mousedown: MOUSE_EVENT,
  mousemove: MOUSE_EVENT,
  mouseup: MOUSE_EVENT
};

function getRect(el) {
  if (el instanceof window.SVGElement) {
    var rect = el.getBoundingClientRect();
    return {
      top: rect.top,
      left: rect.left,
      width: rect.width,
      height: rect.height
    };
  } else {
    return {
      top: el.offsetTop,
      left: el.offsetLeft,
      width: el.offsetWidth,
      height: el.offsetHeight
    };
  }
}

function preventDefaultException(el, exceptions) {
  for (var i in exceptions) {
    if (exceptions[i].test(el[i])) {
      return true;
    }
  }
  return false;
}

function tap(e, eventName) {
  var ev = document.createEvent('Event');
  ev.initEvent(eventName, true, true);
  ev.pageX = e.pageX;
  ev.pageY = e.pageY;
  e.target.dispatchEvent(ev);
}

function click(e) {
  var event = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'click';

  var eventSource = void 0;
  if (e.type === 'mouseup' || e.type === 'mousecancel') {
    eventSource = e;
  } else if (e.type === 'touchend' || e.type === 'touchcancel') {
    eventSource = e.changedTouches[0];
  }
  var posSrc = {};
  if (eventSource) {
    posSrc.screenX = eventSource.screenX || 0;
    posSrc.screenY = eventSource.screenY || 0;
    posSrc.clientX = eventSource.clientX || 0;
    posSrc.clientY = eventSource.clientY || 0;
  }
  var ev = void 0;
  var bubbles = true;
  var cancelable = true;
  if (typeof MouseEvent !== 'undefined') {
    try {
      ev = new MouseEvent(event, extend({
        bubbles: bubbles,
        cancelable: cancelable
      }, posSrc));
    } catch (e) {
      createEvent();
    }
  } else {
    createEvent();
  }

  function createEvent() {
    ev = document.createEvent('Event');
    ev.initEvent(event, bubbles, cancelable);
    extend(ev, posSrc);
  }

  // forwardedTouchEvent set to true in case of the conflict with fastclick
  ev.forwardedTouchEvent = true;
  ev._constructed = true;
  e.target.dispatchEvent(ev);
}

function dblclick(e) {
  click(e, 'dblclick');
}

function prepend(el, target) {
  if (target.firstChild) {
    before(el, target.firstChild);
  } else {
    target.appendChild(el);
  }
}

function before(el, target) {
  target.parentNode.insertBefore(el, target);
}

function removeChild(el, child) {
  el.removeChild(child);
}

var DEFAULT_OPTIONS = {
  startX: 0,
  startY: 0,
  scrollX: false,
  scrollY: true,
  freeScroll: false,
  directionLockThreshold: 5,
  eventPassthrough: '',
  click: false,
  tap: false,
  /**
   * support any side
   * bounce: {
   *   top: true,
   *   bottom: true,
   *   left: true,
   *   right: true
   * }
   */
  bounce: true,
  bounceTime: 800,
  momentum: true,
  momentumLimitTime: 300,
  momentumLimitDistance: 15,
  swipeTime: 2500,
  swipeBounceTime: 500,
  deceleration: 0.0015,
  flickLimitTime: 200,
  flickLimitDistance: 100,
  resizePolling: 60,
  probeType: 0,
  preventDefault: true,
  preventDefaultException: {
    tagName: /^(INPUT|TEXTAREA|BUTTON|SELECT)$/
  },
  HWCompositing: true,
  useTransition: true,
  useTransform: true,
  bindToWrapper: false,
  disableMouse: hasTouch,
  disableTouch: !hasTouch,
  observeDOM: true,
  autoBlur: true,
  /**
   * for picker
   * wheel: {
   *   selectedIndex: 0,
   *   rotate: 25,
   *   adjustTime: 400
   *   wheelWrapperClass: 'wheel-scroll',
   *   wheelItemClass: 'wheel-item'
   * }
   */
  wheel: false,
  /**
   * for slide
   * snap: {
   *   loop: false,
   *   el: domEl,
   *   threshold: 0.1,
   *   stepX: 100,
   *   stepY: 100,
   *   speed: 400,
   *   easing: {
   *     style: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)',
   *     fn: function (t) {
   *       return t * (2 - t)
   *     }
   *   }
   *   listenFlick: true
   * }
   */
  snap: false,
  /**
   * for scrollbar
   * scrollbar: {
   *   fade: true,
   *   interactive: false
   * }
   */
  scrollbar: false,
  /**
   * for pull down and refresh
   * pullDownRefresh: {
   *   threshold: 50,
   *   stop: 20
   * }
   */
  pullDownRefresh: false,
  /**
   * for pull up and load
   * pullUpLoad: {
   *   threshold: 50
   * }
   */
  pullUpLoad: false,
  /**
   * for mouse wheel
   * mouseWheel: {
   *   speed: 20,
   *   invert: false,
   *   easeTime: 300
   * }
   */
  mouseWheel: false,
  stopPropagation: false,
  /**
   * for zoom
   * zoom: {
   *   start: 1,
   *   min: 1,
   *   max: 4
   * }
   */
  zoom: false,
  /**
   * for infinity
   * infinity: {
   *   render(item, div) {
   *   },
   *   createTombstone() {
   *   },
   *   fetch(count) {
   *   }
   * }
   */
  infinity: false,
  /**
   * for double click
   * dblclick: {
   *   delay: 300
   * }
   */
  dblclick: false
};

function initMixin(BScroll) {
  BScroll.prototype._init = function (el, options) {
    this._handleOptions(options);

    // init private custom events
    this._events = {};

    this.x = 0;
    this.y = 0;
    this.directionX = 0;
    this.directionY = 0;

    this.setScale(1);

    this._addDOMEvents();

    this._initExtFeatures();

    this._watchTransition();

    if (this.options.observeDOM) {
      this._initDOMObserver();
    }

    if (this.options.autoBlur) {
      this._handleAutoBlur();
    }

    this.refresh();

    if (!this.options.snap) {
      this.scrollTo(this.options.startX, this.options.startY);
    }

    this.enable();
  };

  BScroll.prototype.setScale = function (scale) {
    this.lastScale = isUndef(this.scale) ? scale : this.scale;
    this.scale = scale;
  };

  BScroll.prototype._handleOptions = function (options) {
    this.options = extend({}, DEFAULT_OPTIONS, options);

    this.translateZ = this.options.HWCompositing && hasPerspective ? ' translateZ(0)' : '';

    this.options.useTransition = this.options.useTransition && hasTransition;
    this.options.useTransform = this.options.useTransform && hasTransform;

    this.options.preventDefault = !this.options.eventPassthrough && this.options.preventDefault;

    // If you want eventPassthrough I have to lock one of the axes
    this.options.scrollX = this.options.eventPassthrough === 'horizontal' ? false : this.options.scrollX;
    this.options.scrollY = this.options.eventPassthrough === 'vertical' ? false : this.options.scrollY;

    // With eventPassthrough we also need lockDirection mechanism
    this.options.freeScroll = this.options.freeScroll && !this.options.eventPassthrough;
    this.options.directionLockThreshold = this.options.eventPassthrough ? 0 : this.options.directionLockThreshold;

    if (this.options.tap === true) {
      this.options.tap = 'tap';
    }
  };

  BScroll.prototype._addDOMEvents = function () {
    var eventOperation = addEvent;
    this._handleDOMEvents(eventOperation);
  };

  BScroll.prototype._removeDOMEvents = function () {
    var eventOperation = removeEvent;
    this._handleDOMEvents(eventOperation);
  };

  BScroll.prototype._handleDOMEvents = function (eventOperation) {
    var target = this.options.bindToWrapper ? this.wrapper : window;
    eventOperation(window, 'orientationchange', this);
    eventOperation(window, 'resize', this);

    if (this.options.click) {
      eventOperation(this.wrapper, 'click', this, true);
    }

    if (!this.options.disableMouse) {
      eventOperation(this.wrapper, 'mousedown', this);
      eventOperation(target, 'mousemove', this);
      eventOperation(target, 'mousecancel', this);
      eventOperation(target, 'mouseup', this);
    }

    if (hasTouch && !this.options.disableTouch) {
      eventOperation(this.wrapper, 'touchstart', this);
      eventOperation(target, 'touchmove', this);
      eventOperation(target, 'touchcancel', this);
      eventOperation(target, 'touchend', this);
    }

    eventOperation(this.scroller, style.transitionEnd, this);
  };

  BScroll.prototype._initExtFeatures = function () {
    if (this.options.snap) {
      this._initSnap();
    }
    if (this.options.scrollbar) {
      this._initScrollbar();
    }
    if (this.options.pullUpLoad) {
      this._initPullUp();
    }
    if (this.options.pullDownRefresh) {
      this._initPullDown();
    }
    if (this.options.wheel) {
      this._initWheel();
    }
    if (this.options.mouseWheel) {
      this._initMouseWheel();
    }
    if (this.options.zoom) {
      this._initZoom();
    }
    if (this.options.infinity) {
      this._initInfinite();
    }
  };

  BScroll.prototype._watchTransition = function () {
    if (typeof Object.defineProperty !== 'function') {
      return;
    }
    var me = this;
    var isInTransition = false;
    var key = this.useTransition ? 'isInTransition' : 'isAnimating';
    Object.defineProperty(this, key, {
      get: function get() {
        return isInTransition;
      },
      set: function set(newVal) {
        isInTransition = newVal;
        // fix issue #359
        var el = me.scroller.children.length ? me.scroller.children : [me.scroller];
        var pointerEvents = isInTransition && !me.pulling ? 'none' : 'auto';
        for (var i = 0; i < el.length; i++) {
          el[i].style.pointerEvents = pointerEvents;
        }
      }
    });
  };

  BScroll.prototype._handleAutoBlur = function () {
    this.on('scrollStart', function () {
      var activeElement = document.activeElement;
      if (activeElement && (activeElement.tagName === 'INPUT' || activeElement.tagName === 'TEXTAREA')) {
        activeElement.blur();
      }
    });
  };

  BScroll.prototype._initDOMObserver = function () {
    var _this = this;

    if (typeof MutationObserver !== 'undefined') {
      var timer = void 0;
      var observer = new MutationObserver(function (mutations) {
        // don't do any refresh during the transition, or outside of the boundaries
        if (_this._shouldNotRefresh()) {
          return;
        }
        var immediateRefresh = false;
        var deferredRefresh = false;
        for (var i = 0; i < mutations.length; i++) {
          var mutation = mutations[i];
          if (mutation.type !== 'attributes') {
            immediateRefresh = true;
            break;
          } else {
            if (mutation.target !== _this.scroller) {
              deferredRefresh = true;
              break;
            }
          }
        }
        if (immediateRefresh) {
          _this.refresh();
        } else if (deferredRefresh) {
          // attributes changes too often
          clearTimeout(timer);
          timer = setTimeout(function () {
            if (!_this._shouldNotRefresh()) {
              _this.refresh();
            }
          }, 60);
        }
      });
      var config = {
        attributes: true,
        childList: true,
        subtree: true
      };
      observer.observe(this.scroller, config);

      this.on('destroy', function () {
        observer.disconnect();
      });
    } else {
      this._checkDOMUpdate();
    }
  };

  BScroll.prototype._shouldNotRefresh = function () {
    var outsideBoundaries = this.x > this.minScrollX || this.x < this.maxScrollX || this.y > this.minScrollY || this.y < this.maxScrollY;

    return this.isInTransition || this.stopFromTransition || outsideBoundaries;
  };

  BScroll.prototype._checkDOMUpdate = function () {
    var scrollerRect = getRect(this.scroller);
    var oldWidth = scrollerRect.width;
    var oldHeight = scrollerRect.height;

    function check() {
      if (this.destroyed) {
        return;
      }
      scrollerRect = getRect(this.scroller);
      var newWidth = scrollerRect.width;
      var newHeight = scrollerRect.height;

      if (oldWidth !== newWidth || oldHeight !== newHeight) {
        this.refresh();
      }
      oldWidth = newWidth;
      oldHeight = newHeight;

      next.call(this);
    }

    function next() {
      var _this2 = this;

      setTimeout(function () {
        check.call(_this2);
      }, 1000);
    }

    next.call(this);
  };

  BScroll.prototype.handleEvent = function (e) {
    switch (e.type) {
      case 'touchstart':
      case 'mousedown':
        this._start(e);
        if (this.options.zoom && e.touches && e.touches.length > 1) {
          this._zoomStart(e);
        }
        break;
      case 'touchmove':
      case 'mousemove':
        if (this.options.zoom && e.touches && e.touches.length > 1) {
          this._zoom(e);
        } else {
          this._move(e);
        }
        break;
      case 'touchend':
      case 'mouseup':
      case 'touchcancel':
      case 'mousecancel':
        if (this.scaled) {
          this._zoomEnd(e);
        } else {
          this._end(e);
        }
        break;
      case 'orientationchange':
      case 'resize':
        this._resize();
        break;
      case 'transitionend':
      case 'webkitTransitionEnd':
      case 'oTransitionEnd':
      case 'MSTransitionEnd':
        this._transitionEnd(e);
        break;
      case 'click':
        if (this.enabled && !e._constructed) {
          if (!preventDefaultException(e.target, this.options.preventDefaultException)) {
            e.preventDefault();
            e.stopPropagation();
          }
        }
        break;
      case 'wheel':
      case 'DOMMouseScroll':
      case 'mousewheel':
        this._onMouseWheel(e);
        break;
    }
  };

  BScroll.prototype.refresh = function () {
    var wrapperRect = getRect(this.wrapper);
    this.wrapperWidth = wrapperRect.width;
    this.wrapperHeight = wrapperRect.height;

    var scrollerRect = getRect(this.scroller);
    this.scrollerWidth = Math.round(scrollerRect.width * this.scale);
    this.scrollerHeight = Math.round(scrollerRect.height * this.scale);

    this.relativeX = scrollerRect.left;
    this.relativeY = scrollerRect.top;

    this.minScrollX = 0;
    this.minScrollY = 0;

    var wheel = this.options.wheel;
    if (wheel) {
      this.items = this.scroller.children;
      this.options.itemHeight = this.itemHeight = this.items.length ? this.scrollerHeight / this.items.length : 0;
      if (this.selectedIndex === undefined) {
        this.selectedIndex = wheel.selectedIndex || 0;
      }
      this.options.startY = -this.selectedIndex * this.itemHeight;
      this.maxScrollX = 0;
      this.maxScrollY = -this.itemHeight * (this.items.length - 1);
    } else {
      this.maxScrollX = this.wrapperWidth - this.scrollerWidth;
      if (!this.options.infinity) {
        this.maxScrollY = this.wrapperHeight - this.scrollerHeight;
      }
      if (this.maxScrollX < 0) {
        this.maxScrollX -= this.relativeX;
        this.minScrollX = -this.relativeX;
      } else if (this.scale > 1) {
        this.maxScrollX = this.maxScrollX / 2 - this.relativeX;
        this.minScrollX = this.maxScrollX;
      }
      if (this.maxScrollY < 0) {
        this.maxScrollY -= this.relativeY;
        this.minScrollY = -this.relativeY;
      } else if (this.scale > 1) {
        this.maxScrollY = this.maxScrollY / 2 - this.relativeY;
        this.minScrollY = this.maxScrollY;
      }
    }

    this.hasHorizontalScroll = this.options.scrollX && this.maxScrollX < this.minScrollX;
    this.hasVerticalScroll = this.options.scrollY && this.maxScrollY < this.minScrollY;

    if (!this.hasHorizontalScroll) {
      this.maxScrollX = this.minScrollX;
      this.scrollerWidth = this.wrapperWidth;
    }

    if (!this.hasVerticalScroll) {
      this.maxScrollY = this.minScrollY;
      this.scrollerHeight = this.wrapperHeight;
    }

    this.endTime = 0;
    this.directionX = 0;
    this.directionY = 0;
    this.wrapperOffset = offset(this.wrapper);

    this.trigger('refresh');

    !this.scaled && this.resetPosition();
  };

  BScroll.prototype.enable = function () {
    this.enabled = true;
  };

  BScroll.prototype.disable = function () {
    this.enabled = false;
  };
}

var ease = {
  // easeOutQuint
  swipe: {
    style: 'cubic-bezier(0.23, 1, 0.32, 1)',
    fn: function fn(t) {
      return 1 + --t * t * t * t * t;
    }
  },
  // easeOutQuard
  swipeBounce: {
    style: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)',
    fn: function fn(t) {
      return t * (2 - t);
    }
  },
  // easeOutQuart
  bounce: {
    style: 'cubic-bezier(0.165, 0.84, 0.44, 1)',
    fn: function fn(t) {
      return 1 - --t * t * t * t;
    }
  }
};

function momentum(current, start, time, lowerMargin, upperMargin, wrapperSize, options) {
  var distance = current - start;
  var speed = Math.abs(distance) / time;

  var deceleration = options.deceleration,
      itemHeight = options.itemHeight,
      swipeBounceTime = options.swipeBounceTime,
      wheel = options.wheel,
      swipeTime = options.swipeTime;

  var duration = swipeTime;
  var rate = wheel ? 4 : 15;

  var destination = current + speed / deceleration * (distance < 0 ? -1 : 1);

  if (wheel && itemHeight) {
    destination = Math.round(destination / itemHeight) * itemHeight;
  }

  if (destination < lowerMargin) {
    destination = wrapperSize ? Math.max(lowerMargin - wrapperSize / 4, lowerMargin - wrapperSize / rate * speed) : lowerMargin;
    duration = swipeBounceTime;
  } else if (destination > upperMargin) {
    destination = wrapperSize ? Math.min(upperMargin + wrapperSize / 4, upperMargin + wrapperSize / rate * speed) : upperMargin;
    duration = swipeBounceTime;
  }

  return {
    destination: Math.round(destination),
    duration: duration
  };
}

var DEFAULT_INTERVAL = 100 / 60;

function noop() {}

var requestAnimationFrame = function () {
  if (!inBrowser) {
    /* istanbul ignore if */
    return noop;
  }
  return window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame ||
  // if all else fails, use setTimeout
  function (callback) {
    return window.setTimeout(callback, (callback.interval || DEFAULT_INTERVAL) / 2); // make interval as precise as possible.
  };
}();

var cancelAnimationFrame = function () {
  if (!inBrowser) {
    /* istanbul ignore if */
    return noop;
  }
  return window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || window.oCancelAnimationFrame || function (id) {
    window.clearTimeout(id);
  };
}();

var DIRECTION_UP = 1;
var DIRECTION_DOWN = -1;
var DIRECTION_LEFT = 1;
var DIRECTION_RIGHT = -1;

var PROBE_DEBOUNCE = 1;

var PROBE_REALTIME = 3;

function warn(msg) {
  console.error('[BScroll warn]: ' + msg);
}

function assert(condition, msg) {
  if (!condition) {
    throw new Error('[BScroll] ' + msg);
  }
}

function coreMixin(BScroll) {
  BScroll.prototype._start = function (e) {
    var _eventType = eventType[e.type];
    if (_eventType !== TOUCH_EVENT) {
      if (e.button !== 0) {
        return;
      }
    }
    if (!this.enabled || this.destroyed || this.initiated && this.initiated !== _eventType) {
      return;
    }
    this.initiated = _eventType;

    if (this.options.preventDefault && !preventDefaultException(e.target, this.options.preventDefaultException)) {
      e.preventDefault();
    }
    if (this.options.stopPropagation) {
      e.stopPropagation();
    }

    this.moved = false;
    this.distX = 0;
    this.distY = 0;
    this.directionX = 0;
    this.directionY = 0;
    this.movingDirectionX = 0;
    this.movingDirectionY = 0;
    this.directionLocked = 0;

    this._transitionTime();
    this.startTime = getNow();

    if (this.options.wheel) {
      this.target = e.target;
    }

    this.stop();

    var point = e.touches ? e.touches[0] : e;

    this.startX = this.x;
    this.startY = this.y;
    this.absStartX = this.x;
    this.absStartY = this.y;
    this.pointX = point.pageX;
    this.pointY = point.pageY;

    this.trigger('beforeScrollStart');
  };

  BScroll.prototype._move = function (e) {
    if (!this.enabled || this.destroyed || eventType[e.type] !== this.initiated) {
      return;
    }

    if (this.options.preventDefault) {
      e.preventDefault();
    }
    if (this.options.stopPropagation) {
      e.stopPropagation();
    }

    var point = e.touches ? e.touches[0] : e;
    var deltaX = point.pageX - this.pointX;
    var deltaY = point.pageY - this.pointY;

    this.pointX = point.pageX;
    this.pointY = point.pageY;

    this.distX += deltaX;
    this.distY += deltaY;

    var absDistX = Math.abs(this.distX);
    var absDistY = Math.abs(this.distY);

    var timestamp = getNow();

    // We need to move at least momentumLimitDistance pixels for the scrolling to initiate
    if (timestamp - this.endTime > this.options.momentumLimitTime && absDistY < this.options.momentumLimitDistance && absDistX < this.options.momentumLimitDistance) {
      return;
    }

    // If you are scrolling in one direction lock the other
    if (!this.directionLocked && !this.options.freeScroll) {
      if (absDistX > absDistY + this.options.directionLockThreshold) {
        this.directionLocked = 'h'; // lock horizontally
      } else if (absDistY >= absDistX + this.options.directionLockThreshold) {
        this.directionLocked = 'v'; // lock vertically
      } else {
        this.directionLocked = 'n'; // no lock
      }
    }

    if (this.directionLocked === 'h') {
      if (this.options.eventPassthrough === 'vertical') {
        e.preventDefault();
      } else if (this.options.eventPassthrough === 'horizontal') {
        this.initiated = false;
        return;
      }
      deltaY = 0;
    } else if (this.directionLocked === 'v') {
      if (this.options.eventPassthrough === 'horizontal') {
        e.preventDefault();
      } else if (this.options.eventPassthrough === 'vertical') {
        this.initiated = false;
        return;
      }
      deltaX = 0;
    }

    deltaX = this.hasHorizontalScroll ? deltaX : 0;
    deltaY = this.hasVerticalScroll ? deltaY : 0;
    this.movingDirectionX = deltaX > 0 ? DIRECTION_RIGHT : deltaX < 0 ? DIRECTION_LEFT : 0;
    this.movingDirectionY = deltaY > 0 ? DIRECTION_DOWN : deltaY < 0 ? DIRECTION_UP : 0;

    var newX = this.x + deltaX;
    var newY = this.y + deltaY;

    var top = false;
    var bottom = false;
    var left = false;
    var right = false;
    // Slow down or stop if outside of the boundaries
    var bounce = this.options.bounce;
    if (bounce !== false) {
      top = bounce.top === undefined ? true : bounce.top;
      bottom = bounce.bottom === undefined ? true : bounce.bottom;
      left = bounce.left === undefined ? true : bounce.left;
      right = bounce.right === undefined ? true : bounce.right;
    }
    if (newX > this.minScrollX || newX < this.maxScrollX) {
      if (newX > this.minScrollX && left || newX < this.maxScrollX && right) {
        newX = this.x + deltaX / 3;
      } else {
        newX = newX > this.minScrollX ? this.minScrollX : this.maxScrollX;
      }
    }
    if (newY > this.minScrollY || newY < this.maxScrollY) {
      if (newY > this.minScrollY && top || newY < this.maxScrollY && bottom) {
        newY = this.y + deltaY / 3;
      } else {
        newY = newY > this.minScrollY ? this.minScrollY : this.maxScrollY;
      }
    }

    if (!this.moved) {
      this.moved = true;
      this.trigger('scrollStart');
    }

    this._translate(newX, newY);

    if (timestamp - this.startTime > this.options.momentumLimitTime) {
      this.startTime = timestamp;
      this.startX = this.x;
      this.startY = this.y;

      if (this.options.probeType === PROBE_DEBOUNCE) {
        this.trigger('scroll', {
          x: this.x,
          y: this.y
        });
      }
    }

    if (this.options.probeType > PROBE_DEBOUNCE) {
      this.trigger('scroll', {
        x: this.x,
        y: this.y
      });
    }

    var scrollLeft = document.documentElement.scrollLeft || window.pageXOffset || document.body.scrollLeft;
    var scrollTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;

    var pX = this.pointX - scrollLeft;
    var pY = this.pointY - scrollTop;

    if (pX > document.documentElement.clientWidth - this.options.momentumLimitDistance || pX < this.options.momentumLimitDistance || pY < this.options.momentumLimitDistance || pY > document.documentElement.clientHeight - this.options.momentumLimitDistance) {
      this._end(e);
    }
  };

  BScroll.prototype._end = function (e) {
    if (!this.enabled || this.destroyed || eventType[e.type] !== this.initiated) {
      return;
    }
    this.initiated = false;

    if (this.options.preventDefault && !preventDefaultException(e.target, this.options.preventDefaultException)) {
      e.preventDefault();
    }
    if (this.options.stopPropagation) {
      e.stopPropagation();
    }

    this.trigger('touchEnd', {
      x: this.x,
      y: this.y
    });

    this.isInTransition = false;

    // ensures that the last position is rounded
    var newX = Math.round(this.x);
    var newY = Math.round(this.y);

    var deltaX = newX - this.absStartX;
    var deltaY = newY - this.absStartY;
    this.directionX = deltaX > 0 ? DIRECTION_RIGHT : deltaX < 0 ? DIRECTION_LEFT : 0;
    this.directionY = deltaY > 0 ? DIRECTION_DOWN : deltaY < 0 ? DIRECTION_UP : 0;

    // if configure pull down refresh, check it first
    if (this.options.pullDownRefresh && this._checkPullDown()) {
      return;
    }

    // check if it is a click operation
    if (this._checkClick(e)) {
      this.trigger('scrollCancel');
      return;
    }

    // reset if we are outside of the boundaries
    if (this.resetPosition(this.options.bounceTime, ease.bounce)) {
      return;
    }

    this.scrollTo(newX, newY);

    this.endTime = getNow();
    var duration = this.endTime - this.startTime;
    var absDistX = Math.abs(newX - this.startX);
    var absDistY = Math.abs(newY - this.startY);

    // flick
    if (this._events.flick && duration < this.options.flickLimitTime && absDistX < this.options.flickLimitDistance && absDistY < this.options.flickLimitDistance) {
      this.trigger('flick');
      return;
    }

    var time = 0;
    // start momentum animation if needed
    if (this.options.momentum && duration < this.options.momentumLimitTime && (absDistY > this.options.momentumLimitDistance || absDistX > this.options.momentumLimitDistance)) {
      var top = false;
      var bottom = false;
      var left = false;
      var right = false;
      var bounce = this.options.bounce;
      if (bounce !== false) {
        top = bounce.top === undefined ? true : bounce.top;
        bottom = bounce.bottom === undefined ? true : bounce.bottom;
        left = bounce.left === undefined ? true : bounce.left;
        right = bounce.right === undefined ? true : bounce.right;
      }
      var wrapperWidth = this.directionX === DIRECTION_RIGHT && left || this.directionX === DIRECTION_LEFT && right ? this.wrapperWidth : 0;
      var wrapperHeight = this.directionY === DIRECTION_DOWN && top || this.directionY === DIRECTION_UP && bottom ? this.wrapperHeight : 0;
      var momentumX = this.hasHorizontalScroll ? momentum(this.x, this.startX, duration, this.maxScrollX, this.minScrollX, wrapperWidth, this.options) : { destination: newX, duration: 0 };
      var momentumY = this.hasVerticalScroll ? momentum(this.y, this.startY, duration, this.maxScrollY, this.minScrollY, wrapperHeight, this.options) : { destination: newY, duration: 0 };
      newX = momentumX.destination;
      newY = momentumY.destination;
      time = Math.max(momentumX.duration, momentumY.duration);
      this.isInTransition = true;
    } else {
      if (this.options.wheel) {
        newY = Math.round(newY / this.itemHeight) * this.itemHeight;
        time = this.options.wheel.adjustTime || 400;
      }
    }

    var easing = ease.swipe;
    if (this.options.snap) {
      var snap = this._nearestSnap(newX, newY);
      this.currentPage = snap;
      time = this.options.snapSpeed || Math.max(Math.max(Math.min(Math.abs(newX - snap.x), 1000), Math.min(Math.abs(newY - snap.y), 1000)), 300);
      newX = snap.x;
      newY = snap.y;

      this.directionX = 0;
      this.directionY = 0;
      easing = this.options.snap.easing || ease.bounce;
    }

    if (newX !== this.x || newY !== this.y) {
      // change easing function when scroller goes out of the boundaries
      if (newX > this.minScrollX || newX < this.maxScrollX || newY > this.minScrollY || newY < this.maxScrollY) {
        easing = ease.swipeBounce;
      }
      this.scrollTo(newX, newY, time, easing);
      return;
    }

    if (this.options.wheel) {
      this.selectedIndex = Math.round(Math.abs(this.y / this.itemHeight));
    }
    this.trigger('scrollEnd', {
      x: this.x,
      y: this.y
    });
  };

  BScroll.prototype._checkClick = function (e) {
    // when in the process of pulling down, it should not prevent click
    var preventClick = this.stopFromTransition && !this.pulling;
    this.stopFromTransition = false;

    // we scrolled less than 15 pixels
    if (!this.moved) {
      if (this.options.wheel) {
        if (this.target && this.target.className === this.options.wheel.wheelWrapperClass) {
          var index = Math.abs(Math.round(this.y / this.itemHeight));
          var _offset = Math.round((this.pointY + offsetToBody(this.wrapper).top - this.wrapperHeight / 2) / this.itemHeight);
          this.target = this.items[index + _offset];
        }
        this.scrollToElement(this.target, this.options.wheel.adjustTime || 400, true, true, ease.swipe);
        return true;
      } else {
        if (!preventClick) {
          var _dblclick = this.options.dblclick;
          var dblclickTrigged = false;
          if (_dblclick && this.lastClickTime) {
            var _dblclick$delay = _dblclick.delay,
                delay = _dblclick$delay === undefined ? 300 : _dblclick$delay;

            if (getNow() - this.lastClickTime < delay) {
              dblclickTrigged = true;
              dblclick(e);
            }
          }
          if (this.options.tap) {
            tap(e, this.options.tap);
          }

          if (this.options.click && !preventDefaultException(e.target, this.options.preventDefaultException)) {
            click(e);
          }
          this.lastClickTime = dblclickTrigged ? null : getNow();
          return true;
        }
        return false;
      }
    }
    return false;
  };

  BScroll.prototype._resize = function () {
    var _this = this;

    if (!this.enabled) {
      return;
    }
    // fix a scroll problem under Android condition
    if (isAndroid) {
      this.wrapper.scrollTop = 0;
    }
    clearTimeout(this.resizeTimeout);
    this.resizeTimeout = setTimeout(function () {
      _this.refresh();
    }, this.options.resizePolling);
  };

  BScroll.prototype._startProbe = function () {
    cancelAnimationFrame(this.probeTimer);
    this.probeTimer = requestAnimationFrame(probe);

    var me = this;

    function probe() {
      var pos = me.getComputedPosition();
      me.trigger('scroll', pos);
      if (!me.isInTransition) {
        me.trigger('scrollEnd', pos);
        return;
      }
      me.probeTimer = requestAnimationFrame(probe);
    }
  };

  BScroll.prototype._transitionTime = function () {
    var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

    this.scrollerStyle[style.transitionDuration] = time + 'ms';

    if (this.options.wheel) {
      for (var i = 0; i < this.items.length; i++) {
        this.items[i].style[style.transitionDuration] = time + 'ms';
      }
    }

    if (this.indicators) {
      for (var _i = 0; _i < this.indicators.length; _i++) {
        this.indicators[_i].transitionTime(time);
      }
    }
  };

  BScroll.prototype._transitionTimingFunction = function (easing) {
    this.scrollerStyle[style.transitionTimingFunction] = easing;

    if (this.options.wheel) {
      for (var i = 0; i < this.items.length; i++) {
        this.items[i].style[style.transitionTimingFunction] = easing;
      }
    }

    if (this.indicators) {
      for (var _i2 = 0; _i2 < this.indicators.length; _i2++) {
        this.indicators[_i2].transitionTimingFunction(easing);
      }
    }
  };

  BScroll.prototype._transitionEnd = function (e) {
    if (e.target !== this.scroller || !this.isInTransition) {
      return;
    }

    this._transitionTime();
    var needReset = !this.pulling || this.movingDirectionY === DIRECTION_UP;
    if (needReset && !this.resetPosition(this.options.bounceTime, ease.bounce)) {
      this.isInTransition = false;
      if (this.options.probeType !== PROBE_REALTIME) {
        this.trigger('scrollEnd', {
          x: this.x,
          y: this.y
        });
      }
    }
  };

  BScroll.prototype._translate = function (x, y, scale) {
    assert(!isUndef(x) && !isUndef(y), 'Translate x or y is null or undefined.');
    if (isUndef(scale)) {
      scale = this.scale;
    }
    if (this.options.useTransform) {
      this.scrollerStyle[style.transform] = 'translate(' + x + 'px,' + y + 'px) scale(' + scale + ')' + this.translateZ;
    } else {
      x = Math.round(x);
      y = Math.round(y);
      this.scrollerStyle.left = x + 'px';
      this.scrollerStyle.top = y + 'px';
    }

    if (this.options.wheel) {
      var _options$wheel$rotate = this.options.wheel.rotate,
          rotate = _options$wheel$rotate === undefined ? 25 : _options$wheel$rotate;

      for (var i = 0; i < this.items.length; i++) {
        var deg = rotate * (y / this.itemHeight + i);
        this.items[i].style[style.transform] = 'rotateX(' + deg + 'deg)';
      }
    }

    this.x = x;
    this.y = y;
    this.setScale(scale);

    if (this.indicators) {
      for (var _i3 = 0; _i3 < this.indicators.length; _i3++) {
        this.indicators[_i3].updatePosition();
      }
    }
  };

  BScroll.prototype._animate = function (destX, destY, duration, easingFn) {
    var me = this;
    var startX = this.x;
    var startY = this.y;
    var startScale = this.lastScale;
    var destScale = this.scale;
    var startTime = getNow();
    var destTime = startTime + duration;

    function step() {
      var now = getNow();

      if (now >= destTime) {
        me.isAnimating = false;
        me._translate(destX, destY, destScale);

        if (!me.pulling && !me.resetPosition(me.options.bounceTime)) {
          me.trigger('scrollEnd', {
            x: me.x,
            y: me.y
          });
        }
        return;
      }
      now = (now - startTime) / duration;
      var easing = easingFn(now);
      var newX = (destX - startX) * easing + startX;
      var newY = (destY - startY) * easing + startY;
      var newScale = (destScale - startScale) * easing + startScale;

      me._translate(newX, newY, newScale);

      if (me.isAnimating) {
        me.animateTimer = requestAnimationFrame(step);
      }

      if (me.options.probeType === PROBE_REALTIME) {
        me.trigger('scroll', {
          x: me.x,
          y: me.y
        });
      }
    }

    this.isAnimating = true;
    cancelAnimationFrame(this.animateTimer);
    step();
  };

  BScroll.prototype.scrollBy = function (x, y) {
    var time = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var easing = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : ease.bounce;

    x = this.x + x;
    y = this.y + y;

    this.scrollTo(x, y, time, easing);
  };

  BScroll.prototype.scrollTo = function (x, y) {
    var time = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var easing = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : ease.bounce;

    this.isInTransition = this.options.useTransition && time > 0 && (x !== this.x || y !== this.y);

    if (!time || this.options.useTransition) {
      this._transitionTimingFunction(easing.style);
      this._transitionTime(time);
      this._translate(x, y);

      if (time && this.options.probeType === PROBE_REALTIME) {
        this._startProbe();
      }

      if (this.options.wheel) {
        if (y > this.minScrollY) {
          this.selectedIndex = 0;
        } else if (y < this.maxScrollY) {
          this.selectedIndex = this.items.length - 1;
        } else {
          this.selectedIndex = Math.round(Math.abs(y / this.itemHeight));
        }
      }
    } else {
      this._animate(x, y, time, easing.fn);
    }
  };

  BScroll.prototype.scrollToElement = function (el, time, offsetX, offsetY, easing) {
    if (!el) {
      return;
    }
    el = el.nodeType ? el : this.scroller.querySelector(el);

    if (this.options.wheel && el.className !== this.options.wheel.wheelItemClass) {
      return;
    }

    var pos = offset(el);
    pos.left -= this.wrapperOffset.left;
    pos.top -= this.wrapperOffset.top;

    // if offsetX/Y are true we center the element to the screen
    if (offsetX === true) {
      offsetX = Math.round(el.offsetWidth / 2 - this.wrapper.offsetWidth / 2);
    }
    if (offsetY === true) {
      offsetY = Math.round(el.offsetHeight / 2 - this.wrapper.offsetHeight / 2);
    }

    pos.left -= offsetX || 0;
    pos.top -= offsetY || 0;
    pos.left = pos.left > this.minScrollX ? this.minScrollX : pos.left < this.maxScrollX ? this.maxScrollX : pos.left;
    pos.top = pos.top > this.minScrollY ? this.minScrollY : pos.top < this.maxScrollY ? this.maxScrollY : pos.top;

    if (this.options.wheel) {
      pos.top = Math.round(pos.top / this.itemHeight) * this.itemHeight;
    }

    this.scrollTo(pos.left, pos.top, time, easing);
  };

  BScroll.prototype.resetPosition = function () {
    var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var easeing = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ease.bounce;

    var x = this.x;
    var roundX = Math.round(x);
    if (!this.hasHorizontalScroll || roundX > this.minScrollX) {
      x = this.minScrollX;
    } else if (roundX < this.maxScrollX) {
      x = this.maxScrollX;
    }

    var y = this.y;
    var roundY = Math.round(y);
    if (!this.hasVerticalScroll || roundY > this.minScrollY) {
      y = this.minScrollY;
    } else if (roundY < this.maxScrollY) {
      y = this.maxScrollY;
    }

    if (x === this.x && y === this.y) {
      return false;
    }

    this.scrollTo(x, y, time, easeing);

    return true;
  };

  BScroll.prototype.getComputedPosition = function () {
    var matrix = window.getComputedStyle(this.scroller, null);
    var x = void 0;
    var y = void 0;

    if (this.options.useTransform) {
      matrix = matrix[style.transform].split(')')[0].split(', ');
      x = +(matrix[12] || matrix[4]);
      y = +(matrix[13] || matrix[5]);
    } else {
      x = +matrix.left.replace(/[^-\d.]/g, '');
      y = +matrix.top.replace(/[^-\d.]/g, '');
    }

    return {
      x: x,
      y: y
    };
  };

  BScroll.prototype.stop = function () {
    if (this.options.useTransition && this.isInTransition) {
      this.isInTransition = false;
      cancelAnimationFrame(this.probeTimer);
      var pos = this.getComputedPosition();
      this._translate(pos.x, pos.y);
      if (this.options.wheel) {
        this.target = this.items[Math.round(-pos.y / this.itemHeight)];
      } else {
        this.trigger('scrollEnd', {
          x: this.x,
          y: this.y
        });
      }
      this.stopFromTransition = true;
    } else if (!this.options.useTransition && this.isAnimating) {
      this.isAnimating = false;
      cancelAnimationFrame(this.animateTimer);
      this.trigger('scrollEnd', {
        x: this.x,
        y: this.y
      });
      this.stopFromTransition = true;
    }
  };

  BScroll.prototype.destroy = function () {
    this.destroyed = true;
    this.trigger('destroy');
    if (this.options.useTransition) {
      cancelAnimationFrame(this.probeTimer);
    } else {
      cancelAnimationFrame(this.animateTimer);
    }
    this._removeDOMEvents();
    // remove custom events
    this._events = {};
  };
}

function snapMixin(BScroll) {
  BScroll.prototype._initSnap = function () {
    var _this = this;

    this.currentPage = {};
    var snap = this.options.snap;

    if (snap.loop) {
      var children = this.scroller.children;
      if (children.length > 1) {
        prepend(children[children.length - 1].cloneNode(true), this.scroller);
        this.scroller.appendChild(children[1].cloneNode(true));
      } else {
        // Loop does not make any sense if there is only one child.
        snap.loop = false;
      }
    }

    var el = snap.el;
    if (typeof el === 'string') {
      el = this.scroller.querySelectorAll(el);
    }

    this.on('refresh', function () {
      _this.pages = [];

      if (!_this.wrapperWidth || !_this.wrapperHeight || !_this.scrollerWidth || !_this.scrollerHeight) {
        return;
      }

      var stepX = snap.stepX || _this.wrapperWidth;
      var stepY = snap.stepY || _this.wrapperHeight;

      var x = 0;
      var y = void 0;
      var cx = void 0;
      var cy = void 0;
      var i = 0;
      var l = void 0;
      var m = 0;
      var n = void 0;
      var rect = void 0;
      if (!el) {
        cx = Math.round(stepX / 2);
        cy = Math.round(stepY / 2);

        while (x > -_this.scrollerWidth) {
          _this.pages[i] = [];
          l = 0;
          y = 0;

          while (y > -_this.scrollerHeight) {
            _this.pages[i][l] = {
              x: Math.max(x, _this.maxScrollX),
              y: Math.max(y, _this.maxScrollY),
              width: stepX,
              height: stepY,
              cx: x - cx,
              cy: y - cy
            };

            y -= stepY;
            l++;
          }

          x -= stepX;
          i++;
        }
      } else {
        l = el.length;
        n = -1;

        for (; i < l; i++) {
          rect = getRect(el[i]);
          if (i === 0 || rect.left <= getRect(el[i - 1]).left) {
            m = 0;
            n++;
          }

          if (!_this.pages[m]) {
            _this.pages[m] = [];
          }

          x = Math.max(-rect.left, _this.maxScrollX);
          y = Math.max(-rect.top, _this.maxScrollY);
          cx = x - Math.round(rect.width / 2);
          cy = y - Math.round(rect.height / 2);

          _this.pages[m][n] = {
            x: x,
            y: y,
            width: rect.width,
            height: rect.height,
            cx: cx,
            cy: cy
          };

          if (x > _this.maxScrollX) {
            m++;
          }
        }
      }

      _this._checkSnapLoop();

      var initPageX = snap._loopX ? 1 : 0;
      var initPageY = snap._loopY ? 1 : 0;
      _this._goToPage(_this.currentPage.pageX || initPageX, _this.currentPage.pageY || initPageY, 0);

      // Update snap threshold if needed.
      var snapThreshold = snap.threshold;
      if (snapThreshold % 1 === 0) {
        _this.snapThresholdX = snapThreshold;
        _this.snapThresholdY = snapThreshold;
      } else {
        _this.snapThresholdX = Math.round(_this.pages[_this.currentPage.pageX][_this.currentPage.pageY].width * snapThreshold);
        _this.snapThresholdY = Math.round(_this.pages[_this.currentPage.pageX][_this.currentPage.pageY].height * snapThreshold);
      }
    });

    this.on('scrollEnd', function () {
      if (snap.loop) {
        if (snap._loopX) {
          if (_this.currentPage.pageX === 0) {
            _this._goToPage(_this.pages.length - 2, _this.currentPage.pageY, 0);
          }
          if (_this.currentPage.pageX === _this.pages.length - 1) {
            _this._goToPage(1, _this.currentPage.pageY, 0);
          }
        } else {
          if (_this.currentPage.pageY === 0) {
            _this._goToPage(_this.currentPage.pageX, _this.pages[0].length - 2, 0);
          }
          if (_this.currentPage.pageY === _this.pages[0].length - 1) {
            _this._goToPage(_this.currentPage.pageX, 1, 0);
          }
        }
      }
    });

    if (snap.listenFlick !== false) {
      this.on('flick', function () {
        var time = snap.speed || Math.max(Math.max(Math.min(Math.abs(_this.x - _this.startX), 1000), Math.min(Math.abs(_this.y - _this.startY), 1000)), 300);

        _this._goToPage(_this.currentPage.pageX + _this.directionX, _this.currentPage.pageY + _this.directionY, time);
      });
    }

    this.on('destroy', function () {
      if (snap.loop) {
        var _children = _this.scroller.children;
        if (_children.length > 2) {
          removeChild(_this.scroller, _children[_children.length - 1]);
          removeChild(_this.scroller, _children[0]);
        }
      }
    });
  };

  BScroll.prototype._checkSnapLoop = function () {
    var snap = this.options.snap;

    if (!snap.loop || !this.pages || !this.pages.length) {
      return;
    }

    if (this.pages.length > 1) {
      snap._loopX = true;
    }
    if (this.pages[0] && this.pages[0].length > 1) {
      snap._loopY = true;
    }
    if (snap._loopX && snap._loopY) {
      warn('Loop does not support two direction at the same time.');
    }
  };

  BScroll.prototype._nearestSnap = function (x, y) {
    if (!this.pages.length) {
      return { x: 0, y: 0, pageX: 0, pageY: 0 };
    }

    var i = 0;
    // Check if we exceeded the snap threshold
    if (Math.abs(x - this.absStartX) <= this.snapThresholdX && Math.abs(y - this.absStartY) <= this.snapThresholdY) {
      return this.currentPage;
    }

    if (x > this.minScrollX) {
      x = this.minScrollX;
    } else if (x < this.maxScrollX) {
      x = this.maxScrollX;
    }

    if (y > this.minScrollY) {
      y = this.minScrollY;
    } else if (y < this.maxScrollY) {
      y = this.maxScrollY;
    }

    var l = this.pages.length;
    for (; i < l; i++) {
      if (x >= this.pages[i][0].cx) {
        x = this.pages[i][0].x;
        break;
      }
    }

    l = this.pages[i].length;

    var m = 0;
    for (; m < l; m++) {
      if (y >= this.pages[0][m].cy) {
        y = this.pages[0][m].y;
        break;
      }
    }

    if (i === this.currentPage.pageX) {
      i += this.directionX;

      if (i < 0) {
        i = 0;
      } else if (i >= this.pages.length) {
        i = this.pages.length - 1;
      }

      x = this.pages[i][0].x;
    }

    if (m === this.currentPage.pageY) {
      m += this.directionY;

      if (m < 0) {
        m = 0;
      } else if (m >= this.pages[0].length) {
        m = this.pages[0].length - 1;
      }

      y = this.pages[0][m].y;
    }

    return {
      x: x,
      y: y,
      pageX: i,
      pageY: m
    };
  };

  BScroll.prototype._goToPage = function (x) {
    var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var time = arguments[2];
    var easing = arguments[3];

    var snap = this.options.snap;

    if (!snap || !this.pages || !this.pages.length) {
      return;
    }

    easing = easing || snap.easing || ease.bounce;

    if (x >= this.pages.length) {
      x = this.pages.length - 1;
    } else if (x < 0) {
      x = 0;
    }

    if (!this.pages[x]) {
      return;
    }

    if (y >= this.pages[x].length) {
      y = this.pages[x].length - 1;
    } else if (y < 0) {
      y = 0;
    }

    var posX = this.pages[x][y].x;
    var posY = this.pages[x][y].y;

    time = time === undefined ? snap.speed || Math.max(Math.max(Math.min(Math.abs(posX - this.x), 1000), Math.min(Math.abs(posY - this.y), 1000)), 300) : time;

    this.currentPage = {
      x: posX,
      y: posY,
      pageX: x,
      pageY: y
    };
    this.scrollTo(posX, posY, time, easing);
  };

  BScroll.prototype.goToPage = function (x, y, time, easing) {
    var snap = this.options.snap;
    if (!snap || !this.pages || !this.pages.length) {
      return;
    }

    if (snap.loop) {
      var len = void 0;
      if (snap._loopX) {
        len = this.pages.length - 2;
        if (x >= len) {
          x = len - 1;
        } else if (x < 0) {
          x = 0;
        }
        x += 1;
      } else {
        len = this.pages[0].length - 2;
        if (y >= len) {
          y = len - 1;
        } else if (y < 0) {
          y = 0;
        }
        y += 1;
      }
    }
    this._goToPage(x, y, time, easing);
  };

  BScroll.prototype.next = function (time, easing) {
    var snap = this.options.snap;
    if (!snap) {
      return;
    }

    var x = this.currentPage.pageX;
    var y = this.currentPage.pageY;

    x++;
    if (x >= this.pages.length && this.hasVerticalScroll) {
      x = 0;
      y++;
    }

    this._goToPage(x, y, time, easing);
  };

  BScroll.prototype.prev = function (time, easing) {
    var snap = this.options.snap;
    if (!snap) {
      return;
    }

    var x = this.currentPage.pageX;
    var y = this.currentPage.pageY;

    x--;
    if (x < 0 && this.hasVerticalScroll) {
      x = 0;
      y--;
    }

    this._goToPage(x, y, time, easing);
  };

  BScroll.prototype.getCurrentPage = function () {
    var snap = this.options.snap;
    if (!snap) {
      return null;
    }

    if (snap.loop) {
      var currentPage = void 0;
      if (snap._loopX) {
        currentPage = extend({}, this.currentPage, {
          pageX: this.currentPage.pageX - 1
        });
      } else {
        currentPage = extend({}, this.currentPage, {
          pageY: this.currentPage.pageY - 1
        });
      }
      return currentPage;
    }
    return this.currentPage;
  };
}

function wheelMixin(BScroll) {
  BScroll.prototype.wheelTo = function () {
    var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

    if (this.options.wheel) {
      this.y = -index * this.itemHeight;
      this.scrollTo(0, this.y);
    }
  };

  BScroll.prototype.getSelectedIndex = function () {
    return this.options.wheel && this.selectedIndex;
  };

  BScroll.prototype._initWheel = function () {
    var wheel = this.options.wheel;
    if (!wheel.wheelWrapperClass) {
      wheel.wheelWrapperClass = 'wheel-scroll';
    }
    if (!wheel.wheelItemClass) {
      wheel.wheelItemClass = 'wheel-item';
    }
    if (wheel.selectedIndex === undefined) {
      wheel.selectedIndex = 0;
      warn('wheel option selectedIndex is required!');
    }
  };
}

var INDICATOR_MIN_LEN = 8;

function scrollbarMixin(BScroll) {
  BScroll.prototype._initScrollbar = function () {
    var _this = this;

    var _options$scrollbar = this.options.scrollbar,
        _options$scrollbar$fa = _options$scrollbar.fade,
        fade = _options$scrollbar$fa === undefined ? true : _options$scrollbar$fa,
        _options$scrollbar$in = _options$scrollbar.interactive,
        interactive = _options$scrollbar$in === undefined ? false : _options$scrollbar$in;

    this.indicators = [];
    var indicator = void 0;

    if (this.options.scrollX) {
      indicator = {
        el: createScrollbar('horizontal'),
        direction: 'horizontal',
        fade: fade,
        interactive: interactive
      };
      this._insertScrollBar(indicator.el);

      this.indicators.push(new Indicator(this, indicator));
    }

    if (this.options.scrollY) {
      indicator = {
        el: createScrollbar('vertical'),
        direction: 'vertical',
        fade: fade,
        interactive: interactive
      };
      this._insertScrollBar(indicator.el);
      this.indicators.push(new Indicator(this, indicator));
    }

    this.on('refresh', function () {
      for (var i = 0; i < _this.indicators.length; i++) {
        _this.indicators[i].refresh();
      }
    });

    if (fade) {
      this.on('scrollEnd', function () {
        for (var i = 0; i < _this.indicators.length; i++) {
          _this.indicators[i].fade();
        }
      });

      this.on('scrollCancel', function () {
        for (var i = 0; i < _this.indicators.length; i++) {
          _this.indicators[i].fade();
        }
      });

      this.on('scrollStart', function () {
        for (var i = 0; i < _this.indicators.length; i++) {
          _this.indicators[i].fade(true);
        }
      });

      this.on('beforeScrollStart', function () {
        for (var i = 0; i < _this.indicators.length; i++) {
          _this.indicators[i].fade(true, true);
        }
      });
    }

    this.on('destroy', function () {
      _this._removeScrollBars();
    });
  };

  BScroll.prototype._insertScrollBar = function (scrollbar) {
    this.wrapper.appendChild(scrollbar);
  };

  BScroll.prototype._removeScrollBars = function () {
    for (var i = 0; i < this.indicators.length; i++) {
      this.indicators[i].destroy();
    }
  };
}

function createScrollbar(direction) {
  var scrollbar = document.createElement('div');
  var indicator = document.createElement('div');

  scrollbar.style.cssText = 'position:absolute;z-index:9999;pointerEvents:none';
  indicator.style.cssText = 'box-sizing:border-box;position:absolute;background:rgba(0,0,0,0.5);border:1px solid rgba(255,255,255,0.9);border-radius:3px;';

  indicator.className = 'bscroll-indicator';

  if (direction === 'horizontal') {
    scrollbar.style.cssText += ';height:7px;left:2px;right:2px;bottom:0';
    indicator.style.height = '100%';
    scrollbar.className = 'bscroll-horizontal-scrollbar';
  } else {
    scrollbar.style.cssText += ';width:7px;bottom:2px;top:2px;right:1px';
    indicator.style.width = '100%';
    scrollbar.className = 'bscroll-vertical-scrollbar';
  }

  scrollbar.style.cssText += ';overflow:hidden';
  scrollbar.appendChild(indicator);

  return scrollbar;
}

function Indicator(scroller, options) {
  this.wrapper = options.el;
  this.wrapperStyle = this.wrapper.style;
  this.indicator = this.wrapper.children[0];
  this.indicatorStyle = this.indicator.style;
  this.scroller = scroller;
  this.direction = options.direction;
  if (options.fade) {
    this.visible = 0;
    this.wrapperStyle.opacity = '0';
  } else {
    this.visible = 1;
  }

  this.sizeRatioX = 1;
  this.sizeRatioY = 1;
  this.maxPosX = 0;
  this.maxPosY = 0;
  this.x = 0;
  this.y = 0;

  if (options.interactive) {
    this._addDOMEvents();
  }
}

Indicator.prototype.handleEvent = function (e) {
  switch (e.type) {
    case 'touchstart':
    case 'mousedown':
      this._start(e);
      break;
    case 'touchmove':
    case 'mousemove':
      this._move(e);
      break;
    case 'touchend':
    case 'mouseup':
    case 'touchcancel':
    case 'mousecancel':
      this._end(e);
      break;
  }
};

Indicator.prototype.refresh = function () {
  if (this._shouldShow()) {
    this.transitionTime();
    this._calculate();
    this.updatePosition();
  }
};

Indicator.prototype.fade = function (visible, hold) {
  var _this2 = this;

  if (hold && !this.visible) {
    return;
  }

  var time = visible ? 250 : 500;

  visible = visible ? '1' : '0';

  this.wrapperStyle[style.transitionDuration] = time + 'ms';

  clearTimeout(this.fadeTimeout);
  this.fadeTimeout = setTimeout(function () {
    _this2.wrapperStyle.opacity = visible;
    _this2.visible = +visible;
  }, 0);
};

Indicator.prototype.updatePosition = function () {
  if (this.direction === 'vertical') {
    var y = Math.round(this.sizeRatioY * this.scroller.y);

    if (y < 0) {
      this.transitionTime(500);
      var height = Math.max(this.indicatorHeight + y * 3, INDICATOR_MIN_LEN);
      this.indicatorStyle.height = height + 'px';
      y = 0;
    } else if (y > this.maxPosY) {
      this.transitionTime(500);
      var _height = Math.max(this.indicatorHeight - (y - this.maxPosY) * 3, INDICATOR_MIN_LEN);
      this.indicatorStyle.height = _height + 'px';
      y = this.maxPosY + this.indicatorHeight - _height;
    } else {
      this.indicatorStyle.height = this.indicatorHeight + 'px';
    }
    this.y = y;

    if (this.scroller.options.useTransform) {
      this.indicatorStyle[style.transform] = 'translateY(' + y + 'px)' + this.scroller.translateZ;
    } else {
      this.indicatorStyle.top = y + 'px';
    }
  } else {
    var x = Math.round(this.sizeRatioX * this.scroller.x);

    if (x < 0) {
      this.transitionTime(500);
      var width = Math.max(this.indicatorWidth + x * 3, INDICATOR_MIN_LEN);
      this.indicatorStyle.width = width + 'px';
      x = 0;
    } else if (x > this.maxPosX) {
      this.transitionTime(500);
      var _width = Math.max(this.indicatorWidth - (x - this.maxPosX) * 3, INDICATOR_MIN_LEN);
      this.indicatorStyle.width = _width + 'px';
      x = this.maxPosX + this.indicatorWidth - _width;
    } else {
      this.indicatorStyle.width = this.indicatorWidth + 'px';
    }

    this.x = x;

    if (this.scroller.options.useTransform) {
      this.indicatorStyle[style.transform] = 'translateX(' + x + 'px)' + this.scroller.translateZ;
    } else {
      this.indicatorStyle.left = x + 'px';
    }
  }
};

Indicator.prototype.transitionTime = function () {
  var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

  this.indicatorStyle[style.transitionDuration] = time + 'ms';
};

Indicator.prototype.transitionTimingFunction = function (easing) {
  this.indicatorStyle[style.transitionTimingFunction] = easing;
};

Indicator.prototype.destroy = function () {
  this._removeDOMEvents();
  this.wrapper.parentNode.removeChild(this.wrapper);
};

Indicator.prototype._start = function (e) {
  var point = e.touches ? e.touches[0] : e;

  e.preventDefault();
  e.stopPropagation();

  this.transitionTime();

  this.initiated = true;
  this.moved = false;
  this.lastPointX = point.pageX;
  this.lastPointY = point.pageY;

  this.startTime = getNow();

  this._handleMoveEvents(addEvent);
  this.scroller.trigger('beforeScrollStart');
};

Indicator.prototype._move = function (e) {
  var point = e.touches ? e.touches[0] : e;

  e.preventDefault();
  e.stopPropagation();

  if (!this.moved) {
    this.scroller.trigger('scrollStart');
  }

  this.moved = true;

  var deltaX = point.pageX - this.lastPointX;
  this.lastPointX = point.pageX;

  var deltaY = point.pageY - this.lastPointY;
  this.lastPointY = point.pageY;

  var newX = this.x + deltaX;
  var newY = this.y + deltaY;

  this._pos(newX, newY);
};

Indicator.prototype._end = function (e) {
  if (!this.initiated) {
    return;
  }
  this.initiated = false;

  e.preventDefault();
  e.stopPropagation();

  this._handleMoveEvents(removeEvent);

  var snapOption = this.scroller.options.snap;
  if (snapOption) {
    var speed = snapOption.speed,
        _snapOption$easing = snapOption.easing,
        easing = _snapOption$easing === undefined ? ease.bounce : _snapOption$easing;

    var snap = this.scroller._nearestSnap(this.scroller.x, this.scroller.y);

    var time = speed || Math.max(Math.max(Math.min(Math.abs(this.scroller.x - snap.x), 1000), Math.min(Math.abs(this.scroller.y - snap.y), 1000)), 300);

    if (this.scroller.x !== snap.x || this.scroller.y !== snap.y) {
      this.scroller.directionX = 0;
      this.scroller.directionY = 0;
      this.scroller.currentPage = snap;
      this.scroller.scrollTo(snap.x, snap.y, time, easing);
    }
  }

  if (this.moved) {
    this.scroller.trigger('scrollEnd', {
      x: this.scroller.x,
      y: this.scroller.y
    });
  }
};

Indicator.prototype._pos = function (x, y) {
  if (x < 0) {
    x = 0;
  } else if (x > this.maxPosX) {
    x = this.maxPosX;
  }

  if (y < 0) {
    y = 0;
  } else if (y > this.maxPosY) {
    y = this.maxPosY;
  }

  x = Math.round(x / this.sizeRatioX);
  y = Math.round(y / this.sizeRatioY);

  this.scroller.scrollTo(x, y);
  this.scroller.trigger('scroll', {
    x: this.scroller.x,
    y: this.scroller.y
  });
};

Indicator.prototype._shouldShow = function () {
  if (this.direction === 'vertical' && this.scroller.hasVerticalScroll || this.direction === 'horizontal' && this.scroller.hasHorizontalScroll) {
    this.wrapper.style.display = '';
    return true;
  }
  this.wrapper.style.display = 'none';
  return false;
};

Indicator.prototype._calculate = function () {
  if (this.direction === 'vertical') {
    var wrapperHeight = this.wrapper.clientHeight;
    this.indicatorHeight = Math.max(Math.round(wrapperHeight * wrapperHeight / (this.scroller.scrollerHeight || wrapperHeight || 1)), INDICATOR_MIN_LEN);
    this.indicatorStyle.height = this.indicatorHeight + 'px';

    this.maxPosY = wrapperHeight - this.indicatorHeight;

    this.sizeRatioY = this.maxPosY / this.scroller.maxScrollY;
  } else {
    var wrapperWidth = this.wrapper.clientWidth;
    this.indicatorWidth = Math.max(Math.round(wrapperWidth * wrapperWidth / (this.scroller.scrollerWidth || wrapperWidth || 1)), INDICATOR_MIN_LEN);
    this.indicatorStyle.width = this.indicatorWidth + 'px';

    this.maxPosX = wrapperWidth - this.indicatorWidth;

    this.sizeRatioX = this.maxPosX / this.scroller.maxScrollX;
  }
};

Indicator.prototype._addDOMEvents = function () {
  var eventOperation = addEvent;
  this._handleDOMEvents(eventOperation);
};

Indicator.prototype._removeDOMEvents = function () {
  var eventOperation = removeEvent;
  this._handleDOMEvents(eventOperation);
  this._handleMoveEvents(eventOperation);
};

Indicator.prototype._handleMoveEvents = function (eventOperation) {
  if (!this.scroller.options.disableTouch) {
    eventOperation(window, 'touchmove', this);
  }
  if (!this.scroller.options.disableMouse) {
    eventOperation(window, 'mousemove', this);
  }
};

Indicator.prototype._handleDOMEvents = function (eventOperation) {
  if (!this.scroller.options.disableTouch) {
    eventOperation(this.indicator, 'touchstart', this);
    eventOperation(window, 'touchend', this);
  }
  if (!this.scroller.options.disableMouse) {
    eventOperation(this.indicator, 'mousedown', this);
    eventOperation(window, 'mouseup', this);
  }
};

function pullDownMixin(BScroll) {
  BScroll.prototype._initPullDown = function () {
    // must watch scroll in real time
    this.options.probeType = PROBE_REALTIME;
  };

  BScroll.prototype._checkPullDown = function () {
    var _options$pullDownRefr = this.options.pullDownRefresh,
        _options$pullDownRefr2 = _options$pullDownRefr.threshold,
        threshold = _options$pullDownRefr2 === undefined ? 90 : _options$pullDownRefr2,
        _options$pullDownRefr3 = _options$pullDownRefr.stop,
        stop = _options$pullDownRefr3 === undefined ? 40 : _options$pullDownRefr3;

    // check if a real pull down action

    if (this.directionY !== DIRECTION_DOWN || this.y < threshold) {
      return false;
    }

    if (!this.pulling) {
      this.pulling = true;
      this.trigger('pullingDown');
    }
    this.scrollTo(this.x, stop, this.options.bounceTime, ease.bounce);

    return this.pulling;
  };

  BScroll.prototype.finishPullDown = function () {
    this.pulling = false;
    this.resetPosition(this.options.bounceTime, ease.bounce);
  };

  BScroll.prototype.openPullDown = function () {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

    this.options.pullDownRefresh = config;
    this._initPullDown();
  };

  BScroll.prototype.closePullDown = function () {
    this.options.pullDownRefresh = false;
  };
}

function pullUpMixin(BScroll) {
  BScroll.prototype._initPullUp = function () {
    // must watch scroll in real time
    this.options.probeType = PROBE_REALTIME;

    this.pullupWatching = false;
    this._watchPullUp();
  };

  BScroll.prototype._watchPullUp = function () {
    if (this.pullupWatching) {
      return;
    }
    this.pullupWatching = true;
    this.on('scroll', this._checkToEnd);
  };

  BScroll.prototype._checkToEnd = function (pos) {
    var _this = this;

    var _options$pullUpLoad$t = this.options.pullUpLoad.threshold,
        threshold = _options$pullUpLoad$t === undefined ? 0 : _options$pullUpLoad$t;

    if (this.movingDirectionY === DIRECTION_UP && pos.y <= this.maxScrollY + threshold) {
      // reset pullupWatching status after scroll end.
      this.once('scrollEnd', function () {
        _this.pullupWatching = false;
      });
      this.trigger('pullingUp');
      this.off('scroll', this._checkToEnd);
    }
  };

  BScroll.prototype.finishPullUp = function () {
    var _this2 = this;

    if (this.pullupWatching) {
      this.once('scrollEnd', function () {
        _this2._watchPullUp();
      });
    } else {
      this._watchPullUp();
    }
  };

  BScroll.prototype.openPullUp = function () {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

    this.options.pullUpLoad = config;
    this._initPullUp();
  };

  BScroll.prototype.closePullUp = function () {
    this.options.pullUpLoad = false;
    if (!this.pullupWatching) {
      return;
    }
    this.pullupWatching = false;
    this.off('scroll', this._checkToEnd);
  };
}

function mouseWheelMixin(BScroll) {
  BScroll.prototype._initMouseWheel = function () {
    var _this = this;

    this._handleMouseWheelEvent(addEvent);

    this.on('destroy', function () {
      clearTimeout(_this.mouseWheelTimer);
      _this._handleMouseWheelEvent(removeEvent);
    });

    this.firstWheelOpreation = true;
  };

  BScroll.prototype._handleMouseWheelEvent = function (eventOperation) {
    eventOperation(this.wrapper, 'wheel', this);
    eventOperation(this.wrapper, 'mousewheel', this);
    eventOperation(this.wrapper, 'DOMMouseScroll', this);
  };

  BScroll.prototype._onMouseWheel = function (e) {
    var _this2 = this;

    if (!this.enabled) {
      return;
    }
    e.preventDefault();

    if (this.options.stopPropagation) {
      e.stopPropagation();
    }

    if (this.firstWheelOpreation) {
      this.trigger('scrollStart');
    }
    this.firstWheelOpreation = false;

    var _options$mouseWheel = this.options.mouseWheel,
        _options$mouseWheel$s = _options$mouseWheel.speed,
        speed = _options$mouseWheel$s === undefined ? 20 : _options$mouseWheel$s,
        _options$mouseWheel$i = _options$mouseWheel.invert,
        invert = _options$mouseWheel$i === undefined ? false : _options$mouseWheel$i,
        _options$mouseWheel$e = _options$mouseWheel.easeTime,
        easeTime = _options$mouseWheel$e === undefined ? 300 : _options$mouseWheel$e;


    clearTimeout(this.mouseWheelTimer);
    this.mouseWheelTimer = setTimeout(function () {
      if (!_this2.options.snap && !easeTime) {
        _this2.trigger('scrollEnd', {
          x: _this2.x,
          y: _this2.y
        });
      }
      _this2.firstWheelOpreation = true;
    }, 400);

    var wheelDeltaX = void 0;
    var wheelDeltaY = void 0;

    switch (true) {
      case 'deltaX' in e:
        if (e.deltaMode === 1) {
          wheelDeltaX = -e.deltaX * speed;
          wheelDeltaY = -e.deltaY * speed;
        } else {
          wheelDeltaX = -e.deltaX;
          wheelDeltaY = -e.deltaY;
        }
        break;
      case 'wheelDeltaX' in e:
        wheelDeltaX = e.wheelDeltaX / 120 * speed;
        wheelDeltaY = e.wheelDeltaY / 120 * speed;
        break;
      case 'wheelDelta' in e:
        wheelDeltaX = wheelDeltaY = e.wheelDelta / 120 * speed;
        break;
      case 'detail' in e:
        wheelDeltaX = wheelDeltaY = -e.detail / 3 * speed;
        break;
      default:
        return;
    }

    var direction = invert ? -1 : 1;
    wheelDeltaX *= direction;
    wheelDeltaY *= direction;

    if (!this.hasVerticalScroll) {
      wheelDeltaX = wheelDeltaY;
      wheelDeltaY = 0;
    }

    var newX = void 0;
    var newY = void 0;
    if (this.options.snap) {
      newX = this.currentPage.pageX;
      newY = this.currentPage.pageY;

      if (wheelDeltaX > 0) {
        newX--;
      } else if (wheelDeltaX < 0) {
        newX++;
      }

      if (wheelDeltaY > 0) {
        newY--;
      } else if (wheelDeltaY < 0) {
        newY++;
      }

      this._goToPage(newX, newY);
      return;
    }

    newX = this.x + Math.round(this.hasHorizontalScroll ? wheelDeltaX : 0);
    newY = this.y + Math.round(this.hasVerticalScroll ? wheelDeltaY : 0);

    this.movingDirectionX = this.directionX = wheelDeltaX > 0 ? -1 : wheelDeltaX < 0 ? 1 : 0;
    this.movingDirectionY = this.directionY = wheelDeltaY > 0 ? -1 : wheelDeltaY < 0 ? 1 : 0;

    if (newX > this.minScrollX) {
      newX = this.minScrollX;
    } else if (newX < this.maxScrollX) {
      newX = this.maxScrollX;
    }

    if (newY > this.minScrollY) {
      newY = this.minScrollY;
    } else if (newY < this.maxScrollY) {
      newY = this.maxScrollY;
    }

    this.scrollTo(newX, newY, easeTime, ease.swipe);
    this.trigger('scroll', {
      x: this.x,
      y: this.y
    });
  };
}

function zoomMixin(BScroll) {
  BScroll.prototype._initZoom = function () {
    var _options$zoom = this.options.zoom,
        _options$zoom$start = _options$zoom.start,
        start = _options$zoom$start === undefined ? 1 : _options$zoom$start,
        _options$zoom$min = _options$zoom.min,
        min = _options$zoom$min === undefined ? 1 : _options$zoom$min,
        _options$zoom$max = _options$zoom.max,
        max = _options$zoom$max === undefined ? 4 : _options$zoom$max;

    this.scale = Math.min(Math.max(start, min), max);
    this.setScale(this.scale);
    this.scrollerStyle[style.transformOrigin] = '0 0';
  };

  BScroll.prototype._zoomTo = function (scale, originX, originY, startScale) {
    this.scaled = true;

    var lastScale = scale / (startScale || this.scale);
    this.setScale(scale);

    this.refresh();

    var newX = Math.round(this.startX - (originX - this.relativeX) * (lastScale - 1));
    var newY = Math.round(this.startY - (originY - this.relativeY) * (lastScale - 1));

    if (newX > this.minScrollX) {
      newX = this.minScrollX;
    } else if (newX < this.maxScrollX) {
      newX = this.maxScrollX;
    }

    if (newY > this.minScrollY) {
      newY = this.minScrollY;
    } else if (newY < this.maxScrollY) {
      newY = this.maxScrollY;
    }

    if (this.x !== newX || this.y !== newY) {
      this.scrollTo(newX, newY, this.options.bounceTime);
    }

    this.scaled = false;
  };

  BScroll.prototype.zoomTo = function (scale, x, y) {
    var _offsetToBody = offsetToBody(this.wrapper),
        left = _offsetToBody.left,
        top = _offsetToBody.top;

    var originX = x + left - this.x;
    var originY = y + top - this.y;
    this._zoomTo(scale, originX, originY);
  };

  BScroll.prototype._zoomStart = function (e) {
    var firstFinger = e.touches[0];
    var secondFinger = e.touches[1];
    var deltaX = Math.abs(firstFinger.pageX - secondFinger.pageX);
    var deltaY = Math.abs(firstFinger.pageY - secondFinger.pageY);

    this.startDistance = getDistance(deltaX, deltaY);
    this.startScale = this.scale;

    var _offsetToBody2 = offsetToBody(this.wrapper),
        left = _offsetToBody2.left,
        top = _offsetToBody2.top;

    this.originX = Math.abs(firstFinger.pageX + secondFinger.pageX) / 2 + left - this.x;
    this.originY = Math.abs(firstFinger.pageY + secondFinger.pageY) / 2 + top - this.y;

    this.trigger('zoomStart');
  };

  BScroll.prototype._zoom = function (e) {
    if (!this.enabled || this.destroyed || eventType[e.type] !== this.initiated) {
      return;
    }

    if (this.options.preventDefault) {
      e.preventDefault();
    }

    if (this.options.stopPropagation) {
      e.stopPropagation();
    }

    var firstFinger = e.touches[0];
    var secondFinger = e.touches[1];
    var deltaX = Math.abs(firstFinger.pageX - secondFinger.pageX);
    var deltaY = Math.abs(firstFinger.pageY - secondFinger.pageY);
    var distance = getDistance(deltaX, deltaY);
    var scale = distance / this.startDistance * this.startScale;

    this.scaled = true;

    var _options$zoom2 = this.options.zoom,
        _options$zoom2$min = _options$zoom2.min,
        min = _options$zoom2$min === undefined ? 1 : _options$zoom2$min,
        _options$zoom2$max = _options$zoom2.max,
        max = _options$zoom2$max === undefined ? 4 : _options$zoom2$max;


    if (scale < min) {
      scale = 0.5 * min * Math.pow(2.0, scale / min);
    } else if (scale > max) {
      scale = 2.0 * max * Math.pow(0.5, max / scale);
    }

    var lastScale = scale / this.startScale;

    var x = this.startX - (this.originX - this.relativeX) * (lastScale - 1);
    var y = this.startY - (this.originY - this.relativeY) * (lastScale - 1);

    this.setScale(scale);

    this.scrollTo(x, y, 0);
  };

  BScroll.prototype._zoomEnd = function (e) {
    if (!this.enabled || this.destroyed || eventType[e.type] !== this.initiated) {
      return;
    }

    if (this.options.preventDefault) {
      e.preventDefault();
    }

    if (this.options.stopPropagation) {
      e.stopPropagation();
    }

    this.isInTransition = false;
    this.isAnimating = false;
    this.initiated = 0;

    var _options$zoom3 = this.options.zoom,
        _options$zoom3$min = _options$zoom3.min,
        min = _options$zoom3$min === undefined ? 1 : _options$zoom3$min,
        _options$zoom3$max = _options$zoom3.max,
        max = _options$zoom3$max === undefined ? 4 : _options$zoom3$max;


    var scale = this.scale > max ? max : this.scale < min ? min : this.scale;

    this._zoomTo(scale, this.originX, this.originY, this.startScale);

    this.trigger('zoomEnd');
  };
}

// import { ease } from '../util/ease'

// Number of items to instantiate beyond current view in the scroll direction.
var RUNWAY_ITEMS = 30;

// Number of items to instantiate beyond current view in the opposite direction.
var RUNWAY_ITEMS_OPPOSITE = 10;

// The animation interval (in ms) for fading in content from tombstones.
var ANIMATION_DURATION_MS = 200;

// The number of pixels of default additional length to allow scrolling to.
var DEFAULT_SCROLL_RUNWAY = 2000;

function infiniteMixin(BScroll) {
  BScroll.prototype._initInfinite = function () {
    this.options.probeType = 3;
    this.maxScrollY = -DEFAULT_SCROLL_RUNWAY;
    this.infiniteScroller = new InfiniteScroller(this, this.options.infinity);
  };
}

function isTombstoneNode(node) {
  if (node && node.classList) {
    return node.classList.contains('tombstone');
  }
}

function InfiniteScroller(scroller, options) {
  var _this = this;

  this.options = options;
  assert(typeof this.options.createTombstone === 'function', 'Infinite scroll need createTombstone Function to create tombstone');

  assert(typeof this.options.fetch === 'function', 'Infinite scroll need fetch Function to fetch new data.');

  assert(typeof this.options.render === 'function', 'Infinite scroll need render Function to render each item.');

  this.firstAttachedItem = 0;
  this.lastAttachedItem = 0;

  this.anchorScrollTop = 0;
  this.anchorItem = {
    index: 0,
    offset: 0
  };
  this.tombstoneHeight = 0;
  this.tombstoneWidth = 0;
  this.tombstones = [];

  this.items = [];
  this.loadedItems = 0;
  this.requestInProgress = false;
  this.hasMore = true;

  this.scroller = scroller;
  this.wrapperEl = this.scroller.wrapper;
  this.scrollerEl = this.scroller.scroller;
  this.scroller.on('scroll', function () {
    _this.onScroll();
  });
  this.scroller.on('resize', function () {
    _this.onResize();
  });

  this.onResize();
}

InfiniteScroller.prototype.onScroll = function () {
  var scrollTop = -this.scroller.y;
  var delta = scrollTop - this.anchorScrollTop;
  if (scrollTop === 0) {
    this.anchorItem = {
      index: 0,
      offset: 0
    };
  } else {
    this.anchorItem = this._calculateAnchoredItem(this.anchorItem, delta);
  }

  this.anchorScrollTop = scrollTop;
  var lastScreenItem = this._calculateAnchoredItem(this.anchorItem, this.wrapperEl.offsetHeight);

  var start = this.anchorItem.index;
  var end = lastScreenItem.index;
  if (delta < 0) {
    start -= RUNWAY_ITEMS;
    end += RUNWAY_ITEMS_OPPOSITE;
  } else {
    start -= RUNWAY_ITEMS_OPPOSITE;
    end += RUNWAY_ITEMS;
  }
  this.fill(start, end);
  this.maybeRequestContent();
};

InfiniteScroller.prototype.onResize = function () {
  var tombstone = this.options.createTombstone();
  tombstone.style.position = 'absolute';
  this.scrollerEl.appendChild(tombstone);
  tombstone.style.display = '';
  this.tombstoneHeight = tombstone.offsetHeight;
  this.tombstoneWidth = tombstone.offsetWidth;
  this.scrollerEl.removeChild(tombstone);

  for (var i = 0; i < this.items.length; i++) {
    this.items[i].height = this.items[i].width = 0;
  }

  this.onScroll();
};

InfiniteScroller.prototype.fill = function (start, end) {
  this.firstAttachedItem = Math.max(0, start);
  if (!this.hasMore) {
    end = Math.min(end, this.items.length);
  }
  this.lastAttachedItem = end;
  this.attachContent();
};

InfiniteScroller.prototype.maybeRequestContent = function () {
  var _this2 = this;

  if (this.requestInProgress || !this.hasMore) {
    return;
  }
  var itemsNeeded = this.lastAttachedItem - this.loadedItems;
  if (itemsNeeded <= 0) {
    return;
  }
  this.requestInProgress = true;
  this.options.fetch(itemsNeeded).then(function (items) {
    if (items) {
      _this2.addContent(items);
    } else {
      _this2.hasMore = false;
      var tombstoneLen = _this2._removeTombstones();
      var curPos = 0;
      if (_this2.anchorItem.index <= _this2.items.length) {
        curPos = _this2._fixScrollPosition();
        _this2._setupAnimations({}, curPos);
        _this2.scroller.resetPosition(_this2.scroller.options.bounceTime);
      } else {
        _this2.anchorItem.index -= tombstoneLen;
        curPos = _this2._fixScrollPosition();
        _this2._setupAnimations({}, curPos);
        _this2.scroller.stop();
        _this2.scroller.resetPosition();
        _this2.onScroll();
      }
    }
  });
};

InfiniteScroller.prototype.addContent = function (items) {
  this.requestInProgress = false;
  for (var i = 0; i < items.length; i++) {
    if (this.items.length <= this.loadedItems) {
      this._addItem();
    }
    this.items[this.loadedItems++].data = items[i];
  }
  this.attachContent();
  this.maybeRequestContent();
};

InfiniteScroller.prototype.attachContent = function () {
  var unusedNodes = this._collectUnusedNodes();
  var tombstoneAnimations = this._createDOMNodes(unusedNodes);
  this._cleanupUnusedNodes(unusedNodes);
  this._cacheNodeSize();
  var curPos = this._fixScrollPosition();
  this._setupAnimations(tombstoneAnimations, curPos);
};

InfiniteScroller.prototype._removeTombstones = function () {
  var markIndex = void 0;
  var tombstoneLen = 0;
  var itemLen = this.items.length;
  for (var i = 0; i < itemLen; i++) {
    var currentNode = this.items[i].node;
    var currentData = this.items[i].data;
    if ((!currentNode || isTombstoneNode(currentNode)) && !currentData) {
      if (!markIndex) {
        markIndex = i;
      }
      if (currentNode) {
        this.scrollerEl.removeChild(currentNode);
      }
    }
  }
  tombstoneLen = itemLen - markIndex;
  this.items.splice(markIndex);
  this.lastAttachedItem = Math.min(this.lastAttachedItem, this.items.length);
  return tombstoneLen;
};

InfiniteScroller.prototype._collectUnusedNodes = function () {
  var unusedNodes = [];
  for (var i = 0; i < this.items.length; i++) {
    // Skip the items which should be visible.
    if (i === this.firstAttachedItem) {
      i = this.lastAttachedItem - 1;
      continue;
    }
    var currentNode = this.items[i].node;
    if (currentNode) {
      if (isTombstoneNode(currentNode)) {
        // Cache tombstones for reuse
        this.tombstones.push(currentNode);
        this.tombstones[this.tombstones.length - 1].style.display = 'none';
      } else {
        unusedNodes.push(currentNode);
      }
    }
    this.items[i].node = null;
  }
  return unusedNodes;
};

InfiniteScroller.prototype._createDOMNodes = function (unusedNodes) {
  var tombstoneAnimations = {};
  for (var i = this.firstAttachedItem; i < this.lastAttachedItem; i++) {
    while (this.items.length <= i) {
      this._addItem();
    }
    var currentNode = this.items[i].node;
    var currentData = this.items[i].data;
    if (currentNode) {
      if (isTombstoneNode(currentNode) && currentData) {
        currentNode.style.zIndex = 1;
        tombstoneAnimations[i] = [currentNode, this.items[i].top - this.anchorScrollTop];
        this.items[i].node = null;
      } else {
        continue;
      }
    }
    var node = currentData ? this.options.render(currentData, unusedNodes.pop()) : this._getTombStone();
    node.style.position = 'absolute';
    this.items[i].top = -1;
    this.scrollerEl.appendChild(node);
    this.items[i].node = node;
  }
  return tombstoneAnimations;
};

InfiniteScroller.prototype._cleanupUnusedNodes = function (unusedNodes) {
  while (unusedNodes.length) {
    this.scrollerEl.removeChild(unusedNodes.pop());
  }
};

InfiniteScroller.prototype._cacheNodeSize = function () {
  for (var i = this.firstAttachedItem; i < this.lastAttachedItem; i++) {
    // Only cache the height if we have the real contents, not a placeholder.
    if (this.items[i].data && !this.items[i].height) {
      this.items[i].height = this.items[i].node.offsetHeight;
      this.items[i].width = this.items[i].node.offsetWidth;
    }
  }
};

InfiniteScroller.prototype._fixScrollPosition = function () {
  this.anchorScrollTop = 0;
  for (var _i = 0; _i < this.anchorItem.index; _i++) {
    this.anchorScrollTop += this.items[_i].height || this.tombstoneHeight;
  }
  this.anchorScrollTop += this.anchorItem.offset;

  // Position all nodes.
  var curPos = this.anchorScrollTop - this.anchorItem.offset;
  var i = this.anchorItem.index;
  while (i > this.firstAttachedItem) {
    curPos -= this.items[i - 1].height || this.tombstoneHeight;
    i--;
  }

  return curPos;
};

InfiniteScroller.prototype._setupAnimations = function (tombstoneAnimations, curPos) {
  var _this3 = this;

  for (var i in tombstoneAnimations) {
    var animation = tombstoneAnimations[i];
    this.items[i].node.style.transform = 'translateY(' + (this.anchorScrollTop + animation[1]) + 'px) scale(' + this.tombstoneWidth / this.items[i].width + ', ' + this.tombstoneHeight / this.items[i].height + ')';
    // Call offsetTop on the nodes to be animated to force them to apply current transforms.
    /* eslint-disable no-unused-expressions */
    this.items[i].node.offsetTop;
    animation[0].offsetTop;
    this.items[i].node.style.transition = 'transform ' + ANIMATION_DURATION_MS + 'ms';
  }

  for (var _i2 = this.firstAttachedItem; _i2 < this.lastAttachedItem; _i2++) {
    var _animation = tombstoneAnimations[_i2];
    if (_animation) {
      var tombstoneNode = _animation[0];
      tombstoneNode.style.transition = 'transform ' + ANIMATION_DURATION_MS + 'ms, opacity ' + ANIMATION_DURATION_MS + 'ms';
      tombstoneNode.style.transform = 'translateY(' + curPos + 'px) scale(' + this.items[_i2].width / this.tombstoneWidth + ', ' + this.items[_i2].height / this.tombstoneHeight + ')';
      tombstoneNode.style.opacity = 0;
    }
    if (curPos !== this.items[_i2].top) {
      if (!_animation) {
        this.items[_i2].node.style.transition = '';
      }
      this.items[_i2].node.style.transform = 'translateY(' + curPos + 'px)';
    }
    this.items[_i2].top = curPos;
    curPos += this.items[_i2].height || this.tombstoneHeight;
  }

  this.scroller.maxScrollY = -(curPos - this.wrapperEl.offsetHeight + (this.hasMore ? DEFAULT_SCROLL_RUNWAY : 0));

  setTimeout(function () {
    for (var _i3 in tombstoneAnimations) {
      var _animation2 = tombstoneAnimations[_i3];
      _animation2[0].style.display = 'none';
      // Tombstone can be recycled now.
      _this3.tombstones.push(_animation2[0]);
    }
  }, ANIMATION_DURATION_MS);
};

InfiniteScroller.prototype._getTombStone = function () {
  var tombstone = this.tombstones.pop();
  if (tombstone) {
    tombstone.style.display = '';
    tombstone.style.opacity = 1;
    tombstone.style.transform = '';
    tombstone.style.transition = '';
    return tombstone;
  }
  return this.options.createTombstone();
};

InfiniteScroller.prototype._addItem = function () {
  this.items.push({
    data: null,
    node: null,
    height: 0,
    width: 0,
    top: 0
  });
};

InfiniteScroller.prototype._calculateAnchoredItem = function (initialAnchor, delta) {
  if (delta === 0) {
    return initialAnchor;
  }
  var i = initialAnchor.index;
  var tombstones = 0;

  delta += initialAnchor.offset;
  if (delta < 0) {
    while (delta < 0 && i > 0 && this.items[i - 1].height) {
      delta += this.items[i - 1].height;
      i--;
    }
    tombstones = Math.max(-i, Math.ceil(Math.min(delta, 0) / this.tombstoneHeight));
  } else {
    while (delta > 0 && i < this.items.length && this.items[i].height && this.items[i].height < delta) {
      delta -= this.items[i].height;
      i++;
    }
    if (i >= this.items.length || !this.items[i].height) {
      tombstones = Math.floor(Math.max(delta, 0) / this.tombstoneHeight);
    }
  }
  i += tombstones;
  delta -= tombstones * this.tombstoneHeight;

  return {
    index: i,
    offset: delta
  };
};

function BScroll(el, options) {
  this.wrapper = typeof el === 'string' ? document.querySelector(el) : el;
  if (!this.wrapper) {
    warn('Can not resolve the wrapper DOM.');
  }
  this.scroller = this.wrapper.children[0];
  if (!this.scroller) {
    warn('The wrapper need at least one child element to be scroller.');
  }
  // cache style for better performance
  this.scrollerStyle = this.scroller.style;

  this._init(el, options);
}

initMixin(BScroll);
coreMixin(BScroll);
eventMixin(BScroll);
snapMixin(BScroll);
wheelMixin(BScroll);
scrollbarMixin(BScroll);
pullDownMixin(BScroll);
pullUpMixin(BScroll);
mouseWheelMixin(BScroll);
zoomMixin(BScroll);
infiniteMixin(BScroll);

BScroll.Version = '1.12.0';

/* harmony default export */ var bscroll_esm = (BScroll);

// CONCATENATED MODULE: ./node_modules/_babel-loader@8.1.0@babel-loader/lib!./node_modules/_vue-loader@15.9.3@vue-loader/lib??vue-loader-options!./src/wheel/src/wheel.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var wheelvue_type_script_lang_js_ = ({
  name: 'zaWheel',
  props: {
    prefixCls: {
      type: String,
      default: 'za-wheel'
    },
    dataSource: {
      type: Array,
      required: true
    },
    valueMember: {
      type: String,
      default: 'value'
    },
    itemRender: {
      type: Function,
      default: function _default(item) {
        return item.label;
      }
    },
    selectedValue: {
      type: [String, Number],
      default: ''
    },
    defaultValue: {
      type: [String, Number],
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    index: {
      type: Number,
      required: true
    }
  },
  data: function data() {
    return {
      BScroll: bscroll_esm,
      wrapper: null,
      value: this.getValue()
    };
  },
  mounted: function mounted() {
    var _this = this;

    var prefixCls = this.prefixCls;
    this.BScroll = new bscroll_esm(this.$refs.wrapper, {
      wheel: {
        selectedIndex: 0,
        wheelWrapperClass: "".concat(prefixCls, "__content"),
        wheelItemClass: "".concat(prefixCls, "__item"),
        adjustTime: 100
      },
      mouseWheel: {
        speed: 20,
        invert: false,
        easeTime: 300
      },
      probeType: 3
    });

    if (this.disabled) {
      this.BScroll.disable();
    }

    var initIndex = this.getWheelSelectedIndex(this.value, this.dataSource);
    this.BScroll.wheelTo(initIndex);
    this.BScroll.on('scroll', function () {
      _this.$emit('transition', true);
    });
    this.BScroll.on('scrollEnd', function () {
      _this.scollEnd();
    });
  },
  watch: {
    selectedValue: function selectedValue(val) {
      if (val === this.value) return;

      if (this.disabled) {
        this.BScroll.disable();
      }

      var newIndex = this.getWheelSelectedIndex(val, this.dataSource);
      this.BScroll.wheelTo(newIndex);
      this.value = val;
      this.$emit('reset', val, this.index);
    },
    dataSource: function dataSource(val) {
      var newIndex = this.getWheelSelectedIndex(this.value, val);
      this.BScroll.wheelTo(newIndex);
    }
  },
  updated: function updated() {
    this.BScroll.refresh();
  },
  destroy: function destroy() {
    this.BScroll.destroy();
  },
  methods: {
    getValue: function getValue() {
      // eslint-disable-next-line
      return this.defaultValue || this.selectedValue || this.data && this.data.length && this.data[0][this.valueMember];
    },
    fireValueChange: function fireValueChange(value) {
      if (value === this.value) {
        return;
      }

      if ('value' in this) {
        this.value = value;
      }

      this.$emit('change', value, this.index);
    },
    getWheelSelectedIndex: function getWheelSelectedIndex(value, dataSource) {
      var valueMember = this.valueMember;
      var _index = 0; // if (!dataSource) return _index;

      dataSource.filter(function (item, index) {
        if (item[valueMember] === value) {
          _index = index;
          return true;
        }

        return false;
      });
      return _index;
    },
    scollEnd: function scollEnd() {
      var dataSource = this.dataSource,
          valueMember = this.valueMember;
      var index = this.BScroll.getSelectedIndex();
      var child = dataSource[index];

      if (child) {
        this.fireValueChange(child[valueMember]);
        this.$emit('transition', this.BScroll.isInTransition);
      } else if (console.warn) {
        // eslint-disable-line
        console.warn('child not found', dataSource, index); // eslint-disable-line
      }
    }
  }
});
// CONCATENATED MODULE: ./src/wheel/src/wheel.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_wheelvue_type_script_lang_js_ = (wheelvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(0);

// CONCATENATED MODULE: ./src/wheel/src/wheel.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  src_wheelvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var wheel = __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

var arrayWithoutHoles = __webpack_require__(161);

var iterableToArray = __webpack_require__(162);

var unsupportedIterableToArray = __webpack_require__(149);

var nonIterableSpread = __webpack_require__(163);

function _toConsumableArray(arr) {
  return arrayWithoutHoles(arr) || iterableToArray(arr) || unsupportedIterableToArray(arr) || nonIterableSpread();
}

module.exports = _toConsumableArray;

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(63);
__webpack_require__(49);
__webpack_require__(56);
__webpack_require__(99);
__webpack_require__(106);
__webpack_require__(109);
__webpack_require__(111);
module.exports = __webpack_require__(1).Set;


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(100);
var validate = __webpack_require__(82);
var SET = 'Set';

// 23.2 Set Objects
module.exports = __webpack_require__(102)(SET, function (get) {
  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value) {
    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
  }
}, strong);


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP = __webpack_require__(5).f;
var create = __webpack_require__(30);
var redefineAll = __webpack_require__(80);
var ctx = __webpack_require__(19);
var anInstance = __webpack_require__(81);
var forOf = __webpack_require__(54);
var $iterDefine = __webpack_require__(35);
var step = __webpack_require__(53);
var setSpecies = __webpack_require__(101);
var DESCRIPTORS = __webpack_require__(4);
var fastKey = __webpack_require__(43).fastKey;
var validate = __webpack_require__(82);
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(2);
var core = __webpack_require__(1);
var dP = __webpack_require__(5);
var DESCRIPTORS = __webpack_require__(4);
var SPECIES = __webpack_require__(3)('species');

module.exports = function (KEY) {
  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(2);
var $export = __webpack_require__(9);
var meta = __webpack_require__(43);
var fails = __webpack_require__(12);
var hide = __webpack_require__(8);
var redefineAll = __webpack_require__(80);
var forOf = __webpack_require__(54);
var anInstance = __webpack_require__(81);
var isObject = __webpack_require__(7);
var setToStringTag = __webpack_require__(24);
var dP = __webpack_require__(5).f;
var each = __webpack_require__(103)(0);
var DESCRIPTORS = __webpack_require__(4);

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  if (!DESCRIPTORS || typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    C = wrapper(function (target, iterable) {
      anInstance(target, C, NAME, '_c');
      target._c = new Base();
      if (iterable != undefined) forOf(iterable, IS_MAP, target[ADDER], target);
    });
    each('add,clear,delete,forEach,get,has,set,keys,values,entries,toJSON'.split(','), function (KEY) {
      var IS_ADDER = KEY == 'add' || KEY == 'set';
      if (KEY in proto && !(IS_WEAK && KEY == 'clear')) hide(C.prototype, KEY, function (a, b) {
        anInstance(this, C, KEY);
        if (!IS_ADDER && IS_WEAK && !isObject(a)) return KEY == 'get' ? undefined : false;
        var result = this._c[KEY](a === 0 ? 0 : a, b);
        return IS_ADDER ? this : result;
      });
    });
    IS_WEAK || dP(C.prototype, 'size', {
      get: function () {
        return this._c.size;
      }
    });
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F, O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__(19);
var IObject = __webpack_require__(38);
var toObject = __webpack_require__(21);
var toLength = __webpack_require__(31);
var asc = __webpack_require__(104);
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(105);

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(7);
var isArray = __webpack_require__(48);
var SPECIES = __webpack_require__(3)('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(9);

$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(107)('Set') });


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var classof = __webpack_require__(57);
var from = __webpack_require__(108);
module.exports = function (NAME) {
  return function toJSON() {
    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
    return from(this);
  };
};


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

var forOf = __webpack_require__(54);

module.exports = function (iter, ITERATOR) {
  var result = [];
  forOf(iter, false, result.push, result, ITERATOR);
  return result;
};


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
__webpack_require__(110)('Set');


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(9);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { of: function of() {
    var length = arguments.length;
    var A = new Array(length);
    while (length--) A[length] = arguments[length];
    return new this(A);
  } });
};


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
__webpack_require__(112)('Set');


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(9);
var aFunction = __webpack_require__(39);
var ctx = __webpack_require__(19);
var forOf = __webpack_require__(54);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
    var mapFn = arguments[1];
    var mapping, A, n, cb;
    aFunction(this);
    mapping = mapFn !== undefined;
    if (mapping) aFunction(mapFn);
    if (source == undefined) return new this();
    A = [];
    if (mapping) {
      n = 0;
      cb = ctx(mapFn, arguments[2], 2);
      forOf(source, false, function (nextItem) {
        A.push(cb(nextItem, n++));
      });
    } else {
      forOf(source, false, A.push, A);
    }
    return new this(A);
  } });
};


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(138);

/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/_vue-loader@15.9.3@vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/_vue-loader@15.9.3@vue-loader/lib??vue-loader-options!./src/button/src/button.vue?vue&type=template&id=79f881d8&lang=html&
var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{class:( _obj = {}, _obj[("" + _vm.prefixCls)] = true, _obj[(_vm.prefixCls + "--" + _vm.theme)] = !!_vm.theme, _obj[(_vm.prefixCls + "--" + _vm.shape)] = !!_vm.shape, _obj[(_vm.prefixCls + "--" + _vm.size)] = !!_vm.size, _obj[(_vm.prefixCls + "--block")] = !!_vm.block, _obj[(_vm.prefixCls + "--bordered")] = !!_vm.ghost, _obj[(_vm.prefixCls + "--disabled")] = !!_vm.disabled, _obj ),on:{"click":_vm.handleClick}},[_c('span',{class:(_vm.prefixCls + "__content")},[(_vm.loading)?_c('za-activity-indicator',{staticClass:"rotate360"}):_vm._t("icon"),_vm._v(" "),_c('span',[_vm._t("default")],2)],2)])}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/button/src/button.vue?vue&type=template&id=79f881d8&lang=html&

// EXTERNAL MODULE: ./src/activity-indicator/index.js + 5 modules
var activity_indicator = __webpack_require__(93);

// EXTERNAL MODULE: ./src/utils/validator.js
var validator = __webpack_require__(13);

// CONCATENATED MODULE: ./node_modules/_babel-loader@8.1.0@babel-loader/lib!./node_modules/_vue-loader@15.9.3@vue-loader/lib??vue-loader-options!./src/button/src/button.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var buttonvue_type_script_lang_js_ = ({
  name: 'zaButton',
  components: {
    zaActivityIndicator: activity_indicator["default"]
  },
  props: {
    prefixCls: {
      type: String,
      default: 'za-button'
    },
    theme: {
      type: String,
      validator: validator["a" /* defaultThemeValidator */],
      default: 'default'
    },
    size: {
      type: String,
      validator: Object(validator["b" /* enumGenerator */])(['xl', 'lg', 'sm', 'xs']),
      default: null
    },
    shape: {
      type: String,
      validator: Object(validator["b" /* enumGenerator */])(['rect', 'radius', 'round', 'circle']),
      default: 'radius'
    },
    block: {
      type: Boolean,
      default: false
    },
    ghost: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleClick: function handleClick(event) {
      if (!this.disabled) {
        this.$emit('click', event);
      }
    }
  }
});
// CONCATENATED MODULE: ./src/button/src/button.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_buttonvue_type_script_lang_js_ = (buttonvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(0);

// CONCATENATED MODULE: ./src/button/src/button.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  src_buttonvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var src_button = (component.exports);
// CONCATENATED MODULE: ./src/button/index.js

/* istanbul ignore next */

src_button.install = function (Vue) {
  Vue.component(src_button.name, src_button);
};

/* harmony default export */ var src_button_0 = __webpack_exports__["default"] = (src_button);

/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_corejs2_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97);
/* harmony import */ var _babel_runtime_corejs2_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_corejs2_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__);


function _broadcast(componentName, eventName, params) {
  this.$children.forEach(function (child) {
    var name = child.$options.name;

    if (name === componentName) {
      child.$emit.apply(child, _babel_runtime_corejs2_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_0___default()([eventName].concat(params)));
    } else {
      _broadcast.apply(child, [componentName, eventName].concat([params]));
    }
  });
}

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    dispatch: function dispatch(componentName, eventName, params) {
      var parent = this.$parent || this.$root;
      var name = parent.$options.name;

      while (parent && (!name || name !== componentName)) {
        parent = parent.$parent;

        if (parent) {
          name = parent.$options.name;
        }
      }

      if (parent) {
        var _parent;

        (_parent = parent).$emit.apply(_parent, _babel_runtime_corejs2_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_0___default()([eventName].concat(params)));
      }
    },
    broadcast: function broadcast(componentName, eventName, params) {
      _broadcast.call(this, componentName, eventName, params);
    }
  }
});

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(164);

/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isThenable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return warn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return guid; });
function isThenable(obj) {
  return obj && typeof obj.then === 'function';
}
function warn(msg) {
  console && console.warn && console.warn(msg); // eslint-disable-line
}
function guid() {
  return ((1 + Math.random()) * 0x10000 | 0).toString(16).substring(1); // eslint-disable-line
}

/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return deepCloneVNode; });
/* harmony import */ var _babel_runtime_corejs2_helpers_typeof__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(58);
/* harmony import */ var _babel_runtime_corejs2_helpers_typeof__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_corejs2_helpers_typeof__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils_misc__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(117);


/* harmony default export */ __webpack_exports__["b"] = (function (node) {
  return _babel_runtime_corejs2_helpers_typeof__WEBPACK_IMPORTED_MODULE_0___default()(node) === 'object' && Object.prototype.hasOwnProperty.call(node, 'componentOptions');
});
var deepCloneVNode = function deepCloneVNode(h, vnode) {
  if (!vnode) return;
  var clonedChildren = vnode.children && vnode.children.map(function (vd) {
    return deepCloneVNode(vd);
  });
  var cloned = h(vnode.tag, vnode.data, clonedChildren);
  cloned.text = vnode.text;
  cloned.isComment = vnode.isComment;
  cloned.componentOptions = vnode.componentOptions;
  cloned.elm = vnode.elm;
  cloned.context = vnode.context;
  cloned.ns = vnode.ns;
  cloned.isStatic = vnode.isStatic;
  cloned.key = vnode.key + Object(_utils_misc__WEBPACK_IMPORTED_MODULE_1__[/* guid */ "a"])();
  return cloned;
};

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(120);

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(49);
__webpack_require__(56);
module.exports = __webpack_require__(42).f('iterator');


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(177);

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(123);
var $Object = __webpack_require__(1).Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(9);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(4), 'Object', { defineProperty: __webpack_require__(5).f });


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(67);
module.exports = __webpack_require__(1).Object.getOwnPropertySymbols;


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(151);

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(174);

/***/ }),
/* 127 */
/***/ (function(module, exports) {

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

module.exports = _arrayLikeToArray;

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(153);

/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _utils_events__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78);


var addClickoutSide = function addClickoutSide(_ref) {
  var _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      handle = _ref.handle;

  if (!disabled) {
    _utils_events__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].on(document.body, 'touchstart', handle);
    _utils_events__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].on(document.body, 'click', handle);
  }
};

var removeClickoutSide = function removeClickoutSide(_ref2) {
  var _ref2$disabled = _ref2.disabled,
      disabled = _ref2$disabled === void 0 ? false : _ref2$disabled,
      handle = _ref2.handle;

  if (!disabled) {
    _utils_events__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].off(document.body, 'touchstart', handle);
    _utils_events__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].off(document.body, 'click', handle);
  }
};

var clickoutSideHandle = function clickoutSideHandle(event, _ref3) {
  var onClickoutSide = _ref3.onClickoutSide,
      ignorenode = _ref3.ignorenode,
      el = _ref3.el;
  if (ignorenode && ignorenode.contains(event.target)) return;
  if (el && !el.contains(event.target)) onClickoutSide(event);
};

/* harmony default export */ __webpack_exports__["a"] = ({
  addClickoutSide: addClickoutSide,
  removeClickoutSide: removeClickoutSide,
  clickoutSideHandle: clickoutSideHandle
});

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(49);
__webpack_require__(131);
module.exports = __webpack_require__(1).Array.from;


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(19);
var $export = __webpack_require__(9);
var toObject = __webpack_require__(21);
var call = __webpack_require__(75);
var isArrayIter = __webpack_require__(76);
var toLength = __webpack_require__(31);
var createProperty = __webpack_require__(94);
var getIterFn = __webpack_require__(73);

$export($export.S + $export.F * !__webpack_require__(132)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(3)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(225);

/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/_vue-loader@15.9.3@vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/_vue-loader@15.9.3@vue-loader/lib??vue-loader-options!./src/date-picker/src/date-picker.vue?vue&type=template&id=79ce9f4b&lang=html&
var render = function () {
var _obj, _obj$1, _obj$2;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:( _obj = {}, _obj[("" + _vm.prefixCls)] = true, _obj[(_vm.prefixCls + "--block")] = _vm.isSelect, _obj ),on:{"click":_vm.handleClick}},[(_vm.isSelect)?_c('div',{class:( _obj$1 = {}, _obj$1[(_vm.prefixCls + "--input")] = true, _obj$1[(_vm.prefixCls + "--placeholder")] = !_vm.date, _obj$1[(_vm.prefixCls + "--disabled")] = !!_vm.disabled, _obj$1 )},[_c('input',{attrs:{"type":"hidden"},domProps:{"value":_vm.date}}),_vm._v("\n    "+_vm._s(_vm.date ? _vm.formatFn(_vm.date) : _vm.placeholder)+"\n  ")]):_vm._e(),_vm._v(" "),_c('div',{class:( _obj$2 = {}, _obj$2[(_vm.prefixCls + "__container")] = true, _obj$2[_vm.customCls] = !!_vm.customCls, _obj$2 ),on:{"click":function($event){$event.stopPropagation();return (function () {})($event)}}},[_c('za-popup',{attrs:{"visible":_vm.currentVisible,"get-container":_vm.getContainer,"direction":"bottom"},on:{"maskClick":_vm.onMaskClick}},[_c('div',{class:(_vm.prefixCls + "__wrapper")},[_c('div',{class:(_vm.prefixCls + "__header")},[_c('div',{class:(_vm.prefixCls + "__cancel"),on:{"click":_vm.onCancel}},[_vm._v(_vm._s(_vm.cancelText))]),_vm._v(" "),_c('div',{class:(_vm.prefixCls + "__title")},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('div',{class:(_vm.prefixCls + "__submit"),on:{"click":_vm.onOk}},[_vm._v(_vm._s(_vm.okText))])]),_vm._v(" "),_c('za-date-picker-view',{attrs:{"title":_vm.title,"placeholder":_vm.placeholder,"mode":_vm.mode,"min":_vm.min,"max":_vm.max,"value":_vm.date,"minuteStep":_vm.minuteStep},on:{"init":_vm.onInit,"cancel":_vm.onCancel,"change":_vm.onValueChange,"transition":_vm.onTransition}})],1)])],1)])}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/date-picker/src/date-picker.vue?vue&type=template&id=79ce9f4b&lang=html&

// EXTERNAL MODULE: ./src/popup/index.js + 3 modules
var popup = __webpack_require__(74);

// EXTERNAL MODULE: ./src/date-picker-view/index.js + 6 modules
var date_picker_view = __webpack_require__(157);

// EXTERNAL MODULE: ./node_modules/_@babel_runtime-corejs2@7.11.2@@babel/runtime-corejs2/helpers/typeof.js
var helpers_typeof = __webpack_require__(58);
var typeof_default = /*#__PURE__*/__webpack_require__.n(helpers_typeof);

// EXTERNAL MODULE: ./node_modules/_@babel_runtime-corejs2@7.11.2@@babel/runtime-corejs2/core-js/object/keys.js
var keys = __webpack_require__(46);
var keys_default = /*#__PURE__*/__webpack_require__.n(keys);

// CONCATENATED MODULE: ./src/date-picker-view/src/util.js



function getFormatter(type) {
  var formatter;

  if (type === 'year') {
    formatter = 'yyyy年';
  } else if (type === 'month') {
    formatter = 'yyyy-MM';
  } else if (type === 'time') {
    formatter = 'HH:mm';
  } else if (type === 'datetime') {
    formatter = 'yyyy-MM-dd HH:mm';
  } else {
    formatter = 'yyyy-MM-dd';
  }

  return formatter;
}

function util_formatDate(date, fmt) {
  if (!date || !fmt) {
    return date;
  }

  date = new Date(date.toString().replace(/-/g, '/'));
  var o = {
    'M+': date.getMonth() + 1,
    // 月份
    'd+': date.getDate(),
    // 日
    'H+': date.getHours(),
    // 小时
    'm+': date.getMinutes(),
    // 分
    's+': date.getSeconds(),
    // 秒
    'q+': Math.floor((date.getMonth() + 3) / 3),
    // 季度
    S: date.getMilliseconds() // 毫秒

  };

  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, "".concat(date.getFullYear()).substr(4 - RegExp.$1.length));
  }

  keys_default()(o).forEach(function (k) {
    if (new RegExp("(".concat(k, ")")).test(fmt)) {
      fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : "00".concat(o[k]).substr("".concat(o[k]).length));
    }
  });

  return fmt;
}

function util_formatFn(instance, value) {
  var format = instance.format;

  var type = typeof_default()(format);

  if (format && type === 'string') {
    return util_formatDate(value, format) || '';
  }

  if (type === 'function') {
    return format(value) || '';
  }

  return util_formatDate(value, getFormatter(instance.mode)) || '';
}
function formatValue(instance, value) {
  var valueFormat = instance.valueFormat;

  var type = typeof_default()(valueFormat);

  if (valueFormat && type === 'string') {
    return util_formatDate(value, valueFormat) || '';
  }

  if (type === 'function') {
    return valueFormat(value) || '';
  }

  return util_formatDate(value, getFormatter(instance.mode)) || '';
}
// CONCATENATED MODULE: ./node_modules/_babel-loader@8.1.0@babel-loader/lib!./node_modules/_vue-loader@15.9.3@vue-loader/lib??vue-loader-options!./src/date-picker/src/date-picker.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var isExtendDate = function isExtendDate(date) {
  if (date instanceof Date) {
    return date;
  }

  if (!date) {
    return '';
  }

  return new Date(date.toString().replace(/-/g, '/'));
};

/* harmony default export */ var date_pickervue_type_script_lang_js_ = ({
  name: 'zaDatePicker',
  components: {
    zaPopup: popup["default"],
    zaDatePickerView: date_picker_view["default"]
  },
  props: {
    prefixCls: {
      type: String,
      default: 'za-datepicker'
    },
    title: {
      type: String,
      default: '请选择'
    },
    placeholder: {
      type: String,
      default: '请选择'
    },
    cancelText: {
      type: String,
      default: '取消'
    },
    okText: {
      type: String,
      default: '确定'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    visible: {
      type: Boolean,
      default: false
    },
    displayMember: {
      type: String,
      default: 'label'
    },
    valueMember: {
      type: String,
      default: 'value'
    },
    minuteStep: {
      type: Number,
      default: 1
    },
    defaultValue: '',
    value: '',
    mode: String,
    format: [String, Function],
    valueFormat: String,
    min: {},
    max: {},
    customCls: String
  },
  data: function data() {
    return {
      getContainer: function getContainer() {
        return document.body;
      },
      isSelect: this.$options.name === 'zaDateSelect',
      currentVisible: this.visible,
      date: '',
      oldDate: ''
    };
  },
  created: function created() {
    var date = this.value && isExtendDate(this.value);
    var defaultDate = this.defaultValue && isExtendDate(this.defaultValue);
    this.date = defaultDate || date;
    this.oldDate = this.date;
  },
  watch: {
    visible: function visible(val, oldVal) {
      // eslint-disable-line no-unused-vars
      if (this.currentVisible === val) return;
      this.currentVisible = val;
    },
    value: function value(val, oldVal) {
      // eslint-disable-line no-unused-vars
      if (this.date === val) return;
      this.date = isExtendDate(val);
      this.oldDate = this.date;
    }
  },
  methods: {
    handleClick: function handleClick(event) {
      if (this.disabled) return;
      this.$emit('click', event);
      this.toggle();
    },
    // 点击遮罩层
    onMaskClick: function onMaskClick(event) {
      this.$emit('maskClick', event);
      this.onCancel();
    },
    // 点击取消
    onCancel: function onCancel() {
      this.toggle();
      this.date = this.value || this.oldDate;
      this.$emit('cancel', this.date);
    },
    // 点击确定
    onOk: function onOk() {
      if (this.isScrolling) {
        return false;
      }

      var value = this.date || this.initDate;
      var formatDate = formatValue(this, value);
      this.date = value;
      this.oldDate = this.date;
      this.$emit('ok', this.valueFormat ? formatDate : value);
      this.$emit('input', this.valueFormat ? formatDate : value);
      this.toggle();
    },
    // 切换显示状态
    toggle: function toggle() {
      if (this.disabled) {
        return;
      } // eslint-disable-next-line


      this.currentVisible = !this.currentVisible;
      this.$emit('update:visible', this.currentVisible);
    },
    formatFn: function formatFn(date) {
      return util_formatFn(this, date);
    },
    onTransition: function onTransition(isScrolling) {
      this.isScrolling = isScrolling;
    },
    close: function close(key) {
      this["".concat(key)] = false;
    },
    onInit: function onInit(selected) {
      this.initDate = selected;
      this.$emit('init', selected);
    },
    onValueChange: function onValueChange(newValue) {
      this.date = newValue;
      var formatDate = formatValue(this, newValue);
      this.$emit('change', this.valueFormat ? formatDate : newValue);
    }
  }
});
// CONCATENATED MODULE: ./src/date-picker/src/date-picker.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_date_pickervue_type_script_lang_js_ = (date_pickervue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(0);

// CONCATENATED MODULE: ./src/date-picker/src/date-picker.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  src_date_pickervue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var date_picker = __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/_vue-loader@15.9.3@vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/_vue-loader@15.9.3@vue-loader/lib??vue-loader-options!./src/picker/src/picker.vue?vue&type=template&id=458d9e7a&lang=html&
var render = function () {
var _obj, _obj$1, _obj$2;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:( _obj = {}, _obj[("" + _vm.prefixCls)] = true, _obj[(_vm.prefixCls + "--block")] = _vm.isSelect, _obj ),on:{"click":_vm.handleClick}},[(_vm.isSelect)?_c('div',{class:( _obj$1 = {}, _obj$1[(_vm.prefixCls + "--input")] = true, _obj$1[(_vm.prefixCls + "--placeholder")] = !_vm.selectedValue.join(_vm.displayAddon), _obj$1[(_vm.prefixCls + "--disabled")] = !!_vm.disabled, _obj$1 )},[_c('input',{attrs:{"type":"hidden"},domProps:{"value":_vm.currentValue}}),_vm._v("\n      "+_vm._s(_vm.display() || _vm.placeholder)+"\n    ")]):_vm._e(),_vm._v(" "),_c('div',{class:( _obj$2 = {}, _obj$2[(_vm.prefixCls + "__container")] = true, _obj$2[_vm.customCls] = !!_vm.customCls, _obj$2 ),on:{"click":function($event){$event.stopPropagation();return (function () {})($event)}}},[_c('za-popup',{attrs:{"visible":_vm.currentVisible,"get-container":_vm.getContainer,"direction":"bottom"},on:{"maskClick":_vm.onMaskClick}},[_c('div',{class:(_vm.prefixCls + "__wrapper")},[_c('div',{class:(_vm.prefixCls + "__header")},[_c('div',{class:(_vm.prefixCls + "__cancel"),on:{"click":_vm.handleCancel}},[_vm._v(_vm._s(_vm.cancelText))]),_vm._v(" "),_c('div',{class:(_vm.prefixCls + "__title")},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('div',{class:(_vm.prefixCls + "__submit"),on:{"click":_vm.handleOk}},[_vm._v(_vm._s(_vm.okText))])]),_vm._v(" "),_c('za-picker-view',{attrs:{"value":_vm.selectedValue,"valueMember":_vm.valueMember,"dataSource":_vm.dataSource,"cols":_vm.cols,"selectedValue":_vm.selectedValue,"itemRender":_vm.itemRender},on:{"change":_vm.onChange,"transition":_vm.onTransition}})],1)])],1)])}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/picker/src/picker.vue?vue&type=template&id=458d9e7a&lang=html&

// CONCATENATED MODULE: ./src/picker/src/utils.js
function isEmptyArray(a) {
  return !a || !a.length;
}

function isChildrenEqual(c1, c2, pure) {
  if (isEmptyArray(c1) && isEmptyArray(c2)) {
    return true;
  }

  if (pure) {
    return c1 === c2;
  }

  if (c1.length !== c2.length) {
    return false;
  }

  var len = c1.length;

  for (var i = 0; i < len; i += 1) {
    if (c1[i].value !== c2[i].value || c1[i].label !== c2[i].label) {
      return false;
    }
  }

  return true;
}
function arrayTreeFilter(data, filterFn, options) {
  options = options || {};
  options.childrenKeyName = options.childrenKeyName || 'children';
  var children = data || [];
  var result = [];
  var level = 0;

  var filterInnerFn = function filterInnerFn(item) {
    return filterFn(item, level);
  };

  do {
    var foundItem = children.filter(filterInnerFn)[0];

    if (!foundItem) {
      break;
    }

    result.push(foundItem);
    children = foundItem[options.childrenKeyName] || [];
    level += 1;
  } while (children.length > 0);

  return result;
}
function formatToInit(data, member, cols) {
  var _data = data || [];

  var result = [];
  var level = 0;

  while (_data) {
    var foundValue = _data[member];

    if (!foundValue) {
      break;
    }

    if (cols && level >= cols) {
      break;
    }

    result.push(foundValue);

    if (Object.prototype.hasOwnProperty.call(_data, 'children')) {
      _data = _data.children[0];
    } else {
      break;
    }

    level += 1;
  }

  return result;
}

var filterValue = function filterValue(dataSource, value, member, level) {
  return dataSource.filter(function (item) {
    return item[member] === value[level];
  })[0];
};

function formatBackToObject(data, value, cascade, member, cols) {
  if (!cascade) {
    var _result = data.map(function (item, index) {
      return item.filter(function (itemInner) {
        return itemInner[member] === value[index];
      })[0];
    });

    return value.length === 1 ? _result[0] : _result;
  }

  var _data = data || [];

  var result = [];
  var level = 0;

  while (_data) {
    var curValue = filterValue(_data, value, member, level);

    if (!curValue) {
      break;
    }

    if (cols && level >= cols) {
      break;
    }

    result.push(curValue);

    if (Object.prototype.hasOwnProperty.call(curValue, 'children')) {
      _data = curValue.children;
    } else {
      break;
    }

    level += 1;
  }

  return result;
}
function isArray(data) {
  return Object.prototype.toString.call(data) === '[object Array]';
}
function hasChildrenObject(data) {
  return Object.prototype.hasOwnProperty.call(data, 'children') && Object.prototype.toString.call(data.children) !== '[object String]';
}
// EXTERNAL MODULE: ./src/popup/index.js + 3 modules
var popup = __webpack_require__(74);

// EXTERNAL MODULE: ./src/picker-view/index.js + 5 modules
var picker_view = __webpack_require__(159);

// CONCATENATED MODULE: ./node_modules/_babel-loader@8.1.0@babel-loader/lib!./node_modules/_vue-loader@15.9.3@vue-loader/lib??vue-loader-options!./src/picker/src/picker.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var pickervue_type_script_lang_js_ = ({
  name: 'zaPicker',
  components: {
    zaPopup: popup["default"],
    zaPickerView: picker_view["default"]
  },
  props: {
    prefixCls: {
      type: String,
      default: 'za-picker'
    },
    title: {
      type: String,
      default: '请选择'
    },
    placeholder: {
      type: String,
      default: '请选择'
    },
    visible: {
      type: Boolean,
      default: false
    },
    cancelText: {
      type: String,
      default: '取消'
    },
    okText: {
      type: String,
      default: '确定'
    },
    dataSource: {
      type: Array,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    displayMember: {
      type: String,
      default: 'label'
    },
    valueMember: {
      type: String,
      default: 'value'
    },
    defaultValue: [String, Array, Number],
    value: [String, Array, Number],
    displayAddon: {
      type: String,
      default: ''
    },
    displayRender: Function,
    customCls: String,
    cols: Number,
    itemRender: {
      type: Function,
      default: function _default(data) {
        return data.label;
      }
    }
  },
  data: function data() {
    var defaultValue = this.getInitValue();
    return {
      getContainer: function getContainer() {
        return document.body;
      },
      isSelect: this.$options.name === 'zaSelect',
      currentValue: defaultValue,
      currentVisible: this.visible,
      oldValue: defaultValue
    };
  },
  computed: {
    cascade: function cascade() {
      var dataSource = this.dataSource;
      return dataSource.length && !isArray(dataSource[0]) && hasChildrenObject(dataSource[0]);
    },
    data: function data() {
      var dataSource = this.dataSource; // 针对单列数据源[{}]，转换为[[{}]]

      if (this.isSingleColumn) {
        return [this.dataSource];
      }

      return dataSource;
    },
    selectedValue: function selectedValue() {
      // eslint-disable-next-line
      return !isArray(this.currentValue) ? [this.currentValue] : this.currentValue;
    },
    isSingleColumn: function isSingleColumn() {
      var dataSource = this.dataSource;
      return dataSource.length && !isArray(dataSource[0]) && !hasChildrenObject(dataSource[0]);
    }
  },
  watch: {
    visible: function visible(val, oldVal) {
      // eslint-disable-line no-unused-vars
      if (this.currentVisible === val) return;
      this.currentVisible = val;
    },
    value: function value(val, oldVal) {
      // eslint-disable-line no-unused-vars
      // console.log(val, oldVal) // eslint-disable-line
      if (this.currentValue === val) return;
      this.currentValue = isArray(val) ? val : [val];
      this.oldValue = this.currentValue;
    }
  },
  methods: {
    getInitValue: function getInitValue() {
      var initValue = this.value || this.defaultValue || []; // 针对单列数据源{}，转换为[{}]

      if (this.isSingleColumn) {
        return isArray(initValue) ? initValue : [initValue];
      }

      return initValue;
    },
    onChange: function onChange(selected) {
      var valueMember = this.valueMember;
      var value = selected.map(function (item) {
        return item[valueMember];
      });
      this.currentValue = value;
      this.$emit('change', this.currentValue);
    },
    handleCancel: function handleCancel() {
      this.toggle();
      this.currentValue = this.oldValue;
    },
    handleOk: function handleOk() {
      if (this.isScrolling) {
        return false;
      }

      this.toggle();
      var valueMember = this.valueMember,
          cols = this.cols,
          data = this.data,
          cascade = this.cascade;
      this.currentValue = this.getValue();
      this.oldValue = this.currentValue;
      var selectedValue = this.currentValue;

      if (!isArray(selectedValue)) {
        selectedValue = [selectedValue];
      }

      var _value = formatBackToObject(data, selectedValue, cascade, valueMember, cols);

      this.$emit('ok', _value);
      this.$emit('input', this.currentValue);
    },
    getValue: function getValue() {
      var valueMember = this.valueMember,
          data = this.data,
          currentValue = this.currentValue,
          cols = this.cols;

      if (!currentValue || !currentValue.length) {
        if (this.cascade) {
          return formatToInit(data[0], valueMember, cols);
        }

        return data.map(function (d) {
          return d[0][valueMember];
        });
      }

      return currentValue;
    },
    display: function display() {
      var _this = this;

      var currentValue = this.currentValue,
          data = this.data;

      if (this.cascade) {
        if (currentValue.length) {
          var treeChildren = arrayTreeFilter(data, function (item, level) {
            return item[_this.valueMember] === currentValue[level];
          });
          return this.displayGenerator(treeChildren);
        }
      } // FIXED


      var treeChildren2 = data.map(function (d, index) {
        if (!isArray(currentValue)) {
          return d.filter(function (obj) {
            return currentValue === obj[_this.valueMember];
          })[0];
        }

        if (isArray(currentValue) && currentValue[index]) {
          return d.filter(function (obj) {
            return currentValue[index] === obj[_this.valueMember];
          })[0];
        }

        return undefined;
      }).filter(function (t) {
        return !!t;
      });
      return this.displayGenerator(treeChildren2);
    },
    displayGenerator: function displayGenerator(value) {
      var displayRender = this.displayRender,
          displayMember = this.displayMember,
          displayAddon = this.displayAddon;

      if (typeof displayRender === 'function') {
        return displayRender(value);
      }

      return value.map(function (v) {
        return v && v[displayMember];
      }).join(displayAddon);
    },
    handleClick: function handleClick(event) {
      if (this.disabled) return;
      this.$emit('click', event);
      this.toggle();
    },
    onMaskClick: function onMaskClick(e) {
      this.$emit('maskClick', e);
      this.handleCancel();
    },
    // 切换显示状态
    toggle: function toggle() {
      if (this.disabled) {
        return;
      } // eslint-disable-next-line


      this.currentVisible = !this.currentVisible;
      this.$emit('update:visible', this.currentVisible);
    },
    onTransition: function onTransition(isScrolling) {
      this.isScrolling = isScrolling;
    }
  }
});
// CONCATENATED MODULE: ./src/picker/src/picker.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_pickervue_type_script_lang_js_ = (pickervue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(0);

// CONCATENATED MODULE: ./src/picker/src/picker.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  src_pickervue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var picker = __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/_vue-loader@15.9.3@vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/_vue-loader@15.9.3@vue-loader/lib??vue-loader-options!./src/input/src/input.vue?vue&type=template&id=4b517050&lang=html&
var render = function () {
var _obj, _obj$1;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:( _obj = {}, _obj[("" + _vm.prefixCls)] = true, _obj[(_vm.prefixCls + "--disabled")] = !!_vm.disabled, _obj[(_vm.prefixCls + "__clearable")] = !!_vm.clearable, _obj )},[(_vm.type === "date")?_c('div',{class:(_vm.prefixCls + "__placeholder")},[_vm._v(_vm._s(_vm.placeholder))]):_vm._e(),_vm._v(" "),(_vm.type === "textarea")?_c('textarea',{ref:"input",attrs:{"readonly":_vm.readonly,"placeholder":_vm.placeholder,"disabled":_vm.disabled,"maxLength":_vm.maxLength,"rows":_vm.rows},domProps:{"value":_vm.currentValue},on:{"input":_vm.onInput,"focus":_vm.onFocus,"blur":_vm.onBlur}}):_c('input',{ref:"input",attrs:{"readonly":_vm.readonly,"type":_vm.type,"placeholder":_vm.placeholder,"disabled":_vm.disabled,"maxLength":_vm.maxLength},domProps:{"value":_vm.currentValue},on:{"input":_vm.onInput,"focus":_vm.onFocus,"blur":_vm.onBlur,"compositionStart":_vm.handleComposition,"compositionUpdate":_vm.handleComposition,"compositionEnd":_vm.handleComposition}}),_vm._v(" "),_c('za-icon',{class:( _obj$1 = {}, _obj$1[(_vm.prefixCls + "__clear")] = true, _obj$1[(_vm.prefixCls + "__clear--show")] = !!(_vm.focused && _vm.currentValue && _vm.currentValue.length > 0), _obj$1 ),attrs:{"type":"wrong-round-fill"},on:{"click":_vm.onClear}}),_vm._v(" "),(_vm.showLength && _vm.maxLength)?_c('div',{class:(_vm.prefixCls + "__length")},[_vm._v(_vm._s((_vm.length + "/" + _vm.maxLength)))]):_vm._e()],1)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/input/src/input.vue?vue&type=template&id=4b517050&lang=html&

// EXTERNAL MODULE: external "autosize"
var external_autosize_ = __webpack_require__(150);
var external_autosize_default = /*#__PURE__*/__webpack_require__.n(external_autosize_);

// EXTERNAL MODULE: ./src/icon/src/icon.vue + 4 modules
var icon = __webpack_require__(33);

// CONCATENATED MODULE: ./node_modules/_babel-loader@8.1.0@babel-loader/lib!./node_modules/_vue-loader@15.9.3@vue-loader/lib??vue-loader-options!./src/input/src/input.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var inputvue_type_script_lang_js_ = ({
  name: 'zaInput',
  components: {
    zaIcon: icon["a" /* default */]
  },
  props: {
    prefixCls: {
      type: String,
      default: 'za-input'
    },
    placeholder: String,
    type: {
      type: String,
      default: 'text'
    },
    value: [String, Number],
    maxLength: [String, Number],
    rows: {
      type: [String, Number],
      default: 2
    },
    disabled: {
      type: Boolean,
      default: false
    },
    autoHeight: {
      type: Boolean,
      default: false
    },
    showLength: {
      type: Boolean,
      default: false
    },
    readonly: Boolean,
    clearable: Boolean
  },
  data: function data() {
    return {
      focused: this.focused || false,
      currentValue: this.value || ''
    };
  },
  computed: {
    length: function length() {
      return this.currentValue.length;
    }
  },
  watch: {
    'value': function value(val, oldValue) {
      // eslint-disable-line no-unused-vars, object-shorthand
      this.setCurrentValue(val);
    }
  },
  methods: {
    onInput: function onInput(event) {
      var value = event.target.value;

      if (this.clearable && this.currentValue) {
        this.focused = true;
      }

      this.currentValue = value;
      this.$emit('input', value);
      this.$emit('change', value);
    },
    setCurrentValue: function setCurrentValue(value) {
      var _this = this;

      if (value === this.currentValue) return;

      if (this.type === 'textarea') {
        this.$nextTick(function (_) {
          // eslint-disable-line no-unused-vars, arrow-parens
          _this.updateAutosize();
        });
      }

      this.currentValue = value;
    },
    onFocus: function onFocus(event) {
      if (this.clearable && this.currentValue) {
        this.focused = true;
      }

      this.$emit('focus', event);
    },
    onBlur: function onBlur(event) {
      var _this2 = this;

      this.onBlurTimeout = setTimeout(function () {
        if (_this2.clearable) {
          _this2.focused = false;
        }

        _this2.$emit('blur', event);
      }, 200);
    },
    handleComposition: function handleComposition(e) {
      if (e.type === 'compositionstart') {
        this.isOnComposition = true;
        this.$emit('compositionStart', e);
      }

      if (e.type === 'compositionupdate') {
        this.$emit('compositionUpdate', e);
      }

      if (e.type === 'compositionend') {
        // composition is end
        this.isOnComposition = false;
        var value = e.target.value;
        this.$emit('compositionEnd', e);
        this.$emit('change', value);
      }
    },
    initAutosize: function initAutosize() {
      if (this.autoHeight) {
        external_autosize_default()(this.$refs.input);
      }
    },
    destroyAutosize: function destroyAutosize() {
      if (this.autoHeight) {
        external_autosize_default.a.destroy(this.$refs.input);
      }
    },
    updateAutosize: function updateAutosize() {
      if (this.autoHeight) {
        external_autosize_default.a.update(this.$refs.input);
      }
    },
    onClear: function onClear() {
      this.blurFromClear = true;
      this.currentValue = '';

      if (!this.isOnComposition) {
        this.focus();
      }

      this.$emit('clear', this.currentValue);
    },
    blur: function blur() {
      this.$refs.input.blur();
    },
    focus: function focus() {
      this.$refs.input.focus();
    }
  },
  mounted: function mounted() {
    if (this.type === 'textarea') {
      this.initAutosize();
    }
  },
  beforeDestroy: function beforeDestroy() {
    var onBlurTimeout = this.onBlurTimeout;
    onBlurTimeout && clearTimeout(onBlurTimeout);
    this.onBlurTimeout = null;

    if (this.type === 'textarea') {
      this.destroyAutosize();
    }
  }
});
// CONCATENATED MODULE: ./src/input/src/input.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_inputvue_type_script_lang_js_ = (inputvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(0);

// CONCATENATED MODULE: ./src/input/src/input.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  src_inputvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var input = __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/_vue-loader@15.9.3@vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/_vue-loader@15.9.3@vue-loader/lib??vue-loader-options!./src/stack-picker/src/stack-picker.vue?vue&type=template&id=7e61fbfc&lang=html&
var render = function () {
var _obj, _obj$1;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.prefixCls,on:{"click":_vm.handleClick}},[(_vm.isSelect)?_c('div',{class:( _obj = {}, _obj[(_vm.prefixCls + "__input")] = true, _obj[(_vm.prefixCls + "__placeholder")] = !_vm.displayLabel, _obj[(_vm.prefixCls + "--disabled")] = _vm.disabled, _obj )},[_c('input',{attrs:{"type":"hidden"},domProps:{"value":_vm.value}}),_vm._v("\n      "+_vm._s(_vm.displayLabel || _vm.placeholder)+"\n    ")]):_vm._e(),_vm._v(" "),_c('div',{class:( _obj$1 = {}, _obj$1[(_vm.prefixCls + "__container")] = true, _obj$1 ),on:{"click":function($event){$event.stopPropagation();return (function () {})($event)}}},[_c('za-popup',{attrs:{"visible":_vm.currentVisible,"get-container":_vm.getContainer,"direction":"bottom"},on:{"maskClick":_vm.onMaskClick}},[_c('div',{class:(_vm.prefixCls + "__wrapper")},[_c('div',{class:(_vm.prefixCls + "__header")},[_c('div',{class:(_vm.prefixCls + "__cancel"),on:{"click":_vm.handleCancel}},[_vm._v(_vm._s(_vm.cancelText))]),_vm._v(" "),_c('div',{class:(_vm.prefixCls + "__title")},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('div',{class:(_vm.prefixCls + "__submit"),on:{"click":_vm.handleOk}},[_vm._v(_vm._s(_vm.okText))])]),_vm._v(" "),_c('div',{class:(_vm.prefixCls + "__crumbs")},[_c('p',[_vm._v("选择："+_vm._s(_vm.currentValue.map(function (item) { return _vm.itemRender(item); }).join(_vm.labelAddon)))]),_vm._v(" "),(_vm.errorMsg)?_c('p',{class:(_vm.prefixCls + "__crumbs-error")},[_vm._v(_vm._s(_vm.errorMsg))]):_vm._e()]),_vm._v(" "),_c('div',{class:(_vm.prefixCls + "__group")},_vm._l((_vm.renderGroup()),function(group,index){
    var _obj;
return _c('div',{key:index,class:( _obj = {}, _obj[(_vm.prefixCls + "__stack-column za-stack-picker-stack-column")] = true, _obj[(_vm.prefixCls + "__stack-column--active")] = _vm.currentValue, _obj[(_vm.prefixCls + "__stack-column--hidden")] = !_vm.currentValue[index] || !_vm.currentValue[index][_vm.valueMember], _obj ),on:{"click":function($event){$event.stopPropagation();return (function (e) { return _vm.handleChange(index - 1); })($event)}}},[_c('div',{ref:"columns",refInFor:true,class:(_vm.prefixCls + "__stack-column-wrapper"),on:{"click":function($event){$event.stopPropagation();return (function () {})($event)}}},_vm._l((group),function(item,i){
              var _obj;
return _c('div',{key:("item" + i),class:( _obj = {}, _obj[(_vm.prefixCls + "__stack-column-item")] = true, _obj[(_vm.prefixCls + "__stack-column-item--active")] = _vm.currentValue[index] && _vm.currentValue[index][_vm.valueMember] === item[_vm.valueMember], _obj ),on:{"click":function($event){$event.stopPropagation();return (function (e) { return _vm.handleChange(index, item, index === _vm.renderGroup().length - 1); })($event)}}},[_vm._v("\n                    "+_vm._s(_vm.itemRender(item))+"\n                ")])}),0)])}),0)])])],1)])}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/stack-picker/src/stack-picker.vue?vue&type=template&id=7e61fbfc&lang=html&

// EXTERNAL MODULE: ./src/popup/index.js + 3 modules
var popup = __webpack_require__(74);

// CONCATENATED MODULE: ./node_modules/_babel-loader@8.1.0@babel-loader/lib!./node_modules/_vue-loader@15.9.3@vue-loader/lib??vue-loader-options!./src/stack-picker/src/stack-picker.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var stack_pickervue_type_script_lang_js_ = ({
  name: 'zaStackPicker',
  components: {
    zaPopup: popup["default"]
  },
  props: {
    prefixCls: {
      type: String,
      default: 'za-stackpicker'
    },
    dataSource: {
      type: Array,
      required: true
    },
    defaultValue: Array,
    value: Array,
    displayMember: {
      type: String,
      default: 'label'
    },
    valueMember: {
      type: String,
      default: 'value'
    },
    title: {
      type: String,
      default: '请选择'
    },
    placeholder: {
      type: String,
      default: '请选择'
    },
    visible: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    cols: {
      type: Number,
      default: Infinity
    },
    labelAddon: {
      type: String,
      default: ' > '
    },
    displayItems: {
      type: Number,
      default: 8
    },
    itemHeight: {
      type: Number,
      default: 50
    },
    displayRender: {
      type: Function,
      default: function _default(datas) {
        return datas.map(function (_ref) {
          var label = _ref.label;
          return label;
        }).join('');
      }
    },
    itemRender: {
      type: Function,
      default: function _default(d) {
        return d.label;
      }
    },
    validate: {
      type: Function,
      default: function _default() {}
    },
    cancelText: {
      type: String,
      default: '取消'
    },
    okText: {
      type: String,
      default: '确定'
    }
  },
  watch: {
    visible: function visible(val, oldVal) {
      // eslint-disable-line no-unused-vars
      if (this.currentVisible === val) return;
      this.currentVisible = val;

      if (val) {
        this.reposition();
      }
    },
    value: function value(val, oldVal) {
      // eslint-disable-line no-unused-vars
      var param = {
        value: val,
        defaultValue: '',
        dataSource: this.dataSource,
        validate: this.validate
      };
      var newCurrentValue = this.resolveProps(param).currentValue;
      if (this.currentValue === val) return;
      this.currentValue = newCurrentValue;
    }
  },
  computed: {
    displayLabel: function displayLabel() {
      return this.displayRender(this.currentValue);
    }
  },
  data: function data() {
    var data = this.resolveProps(this);

    data.getContainer = function () {
      return document.body;
    };

    data.currentVisible = this.visible;
    data.oldValue = data.currentValue;
    data.isSelect = this.$options.name === 'zaStackSelect';
    return data;
  },
  methods: {
    resolveProps: function resolveProps(_ref2) {
      var _this = this;

      var value = _ref2.value,
          defaultValue = _ref2.defaultValue,
          dataSource = _ref2.dataSource,
          validate = _ref2.validate;
      var resolveValue = [];
      var v = value || defaultValue || [];
      v.reduce(function (list, item) {
        var valueItem = _this.obtainItem(list, item);

        if (valueItem) {
          resolveValue.push(valueItem);
          return valueItem.children || [];
        }

        return [];
      }, dataSource);
      return {
        currentValue: resolveValue,
        errorMsg: validate(v)
      };
    },
    obtainItem: function obtainItem(list, value) {
      var valueMember = this.valueMember;
      return list.filter(function (item) {
        return item[valueMember] === value;
      })[0];
    },
    reposition: function reposition() {
      var _this2 = this;

      var dataSource = this.dataSource,
          valueMember = this.valueMember,
          disabled = this.disabled,
          displayItems = this.displayItems,
          itemHeight = this.itemHeight,
          cols = this.cols,
          currentValue = this.currentValue;
      if (disabled) return;
      currentValue.reduce(function (data, item, index) {
        var value = item[valueMember];
        var valIndex = data.map(function (dataItem) {
          return dataItem[valueMember];
        }).indexOf(value);

        if (index < cols && valIndex >= 0) {
          var target = _this2.$refs.columns[index];

          if (target) {
            var position = target.scrollTop;
            var viewTopIndex = valIndex - displayItems;

            if (position < (viewTopIndex + 1) * itemHeight || position > valIndex * itemHeight) {
              target.scrollTop = valIndex * itemHeight;
            }
          }

          return data[valIndex].children || [];
        }

        return [];
      }, dataSource);
    },
    handleClick: function handleClick(event) {
      if (this.disabled) return;
      this.$emit('click', event);
      this.toggle();
    },
    toggle: function toggle() {
      if (this.disabled) {
        return;
      }

      this.currentVisible = !this.currentVisible;
      this.$emit('update:visible', this.currentVisible);
    },
    onMaskClick: function onMaskClick() {
      this.currentValue = this.oldValue;
      this.currentVisible = !this.currentVisible;
      this.$emit('update:visible', this.currentVisible);
    },
    handleCancel: function handleCancel(event) {
      this.toggle();
      this.currentValue = this.oldValue;
      this.$emit('cancel', event);
    },
    renderGroup: function renderGroup() {
      var valueMember = this.valueMember,
          cols = this.cols,
          currentValue = this.currentValue;
      var group = [];
      var dataSource = this.dataSource;
      var i = 0;

      while (dataSource) {
        group.push(dataSource);
        var colVal = currentValue[i];
        var childrenData = ((colVal ? this.obtainItem(dataSource, colVal[valueMember]) : dataSource[0]) || {}).children;

        if (childrenData && childrenData.length && i < cols - 1) {
          dataSource = childrenData;
        } else {
          dataSource = null;
        }

        i += 1;
      }

      return group;
    },
    handleChange: function handleChange(index, item, isLast) {
      var _this3 = this;

      var validate = this.validate;
      var value = this.currentValue.slice(0, index);
      var errorMsg = null;

      if (item) {
        value[index] = item;
      }

      errorMsg = validate(value);

      if (isLast && !errorMsg) {
        this.currentValue = value;
        this.errorMsg = errorMsg;
        this.$emit('change', value.map(function (v) {
          return v[_this3.valueMember];
        }));
      } else {
        this.currentValue = value;
        this.errorMsg = errorMsg;
        this.$emit('change', value.map(function (v) {
          return v[_this3.valueMember];
        }));
      }
    },
    handleOk: function handleOk() {
      var _this4 = this;

      var validate = this.validate;
      var value = this.currentValue;
      var errorMsg = null;
      errorMsg = validate(value);

      if (!errorMsg) {
        this.errorMsg = errorMsg;
        this.oldValue = this.currentValue;
        this.$emit('input', value.map(function (v) {
          return v[_this4.valueMember];
        }));
        this.$emit('change', value.map(function (v) {
          return v[_this4.valueMember];
        }));
        this.$emit('ok', value);
        this.toggle();
      } else {
        this.errorMsg = errorMsg;
        this.$emit('input', value.map(function (v) {
          return v[_this4.valueMember];
        }));
        this.$emit('change', value.map(function (v) {
          return v[_this4.valueMember];
        }));
      }
    }
  },
  mounted: function mounted() {
    this.reposition();
  },
  updated: function updated() {
    this.reposition();
  }
});
// CONCATENATED MODULE: ./src/stack-picker/src/stack-picker.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_stack_pickervue_type_script_lang_js_ = (stack_pickervue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(0);

// CONCATENATED MODULE: ./src/stack-picker/src/stack-picker.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  src_stack_pickervue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var stack_picker = __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(139);
var $Object = __webpack_require__(1).Object;
module.exports = function defineProperties(T, D) {
  return $Object.defineProperties(T, D);
};


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(9);
// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
$export($export.S + $export.F * !__webpack_require__(4), 'Object', { defineProperties: __webpack_require__(47) });


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(141);
module.exports = __webpack_require__(1).Object.getOwnPropertyDescriptors;


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-getownpropertydescriptors
var $export = __webpack_require__(9);
var ownKeys = __webpack_require__(142);
var toIObject = __webpack_require__(10);
var gOPD = __webpack_require__(55);
var createProperty = __webpack_require__(94);

$export($export.S, 'Object', {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = toIObject(object);
    var getDesc = gOPD.f;
    var keys = ownKeys(O);
    var result = {};
    var i = 0;
    var key, desc;
    while (keys.length > i) {
      desc = getDesc(O, key = keys[i++]);
      if (desc !== undefined) createProperty(result, key, desc);
    }
    return result;
  }
});


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

// all object keys, includes non-enumerable and symbols
var gOPN = __webpack_require__(45);
var gOPS = __webpack_require__(41);
var anObject = __webpack_require__(11);
var Reflect = __webpack_require__(2).Reflect;
module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
  var keys = gOPN.f(anObject(it));
  var getSymbols = gOPS.f;
  return getSymbols ? keys.concat(getSymbols(it)) : keys;
};


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(144);
var $Object = __webpack_require__(1).Object;
module.exports = function getOwnPropertyDescriptor(it, key) {
  return $Object.getOwnPropertyDescriptor(it, key);
};


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject = __webpack_require__(10);
var $getOwnPropertyDescriptor = __webpack_require__(55).f;

__webpack_require__(70)('getOwnPropertyDescriptor', function () {
  return function getOwnPropertyDescriptor(it, key) {
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});


/***/ }),
/* 145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/_vue-loader@15.9.3@vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/_vue-loader@15.9.3@vue-loader/lib??vue-loader-options!./src/modal/src/modal.vue?vue&type=template&id=622951de&lang=html&
var render = function () {
var _obj, _obj$1;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:( _obj = {}, _obj[("" + _vm.prefixCls)] = true, _obj[(_vm.prefixCls + "--radius")] = !!_vm.radius, _obj[("fade-" + _vm.animationState)] = true, _obj ),style:(_vm.modalStyle)},[_c('div',{class:(_vm.prefixCls + "__wrapper")},[_c('div',{class:( _obj$1 = {}, _obj$1[(_vm.prefixCls + "__dialog")] = true, _obj$1[(_vm.animationType + "-" + _vm.animationState)] = true, _obj$1[("fade-" + _vm.animationState)] = true, _obj$1 ),style:(_vm.dialogStyle),on:{"click":function (e) { return e.stopPropagation(); }}},[(_vm.$slots.title || _vm.title)?_c('div',{class:(_vm.prefixCls + "__header")},[_c('div',{class:(_vm.prefixCls + "__header-title")},[_vm._t("title"),_vm._v(" "),(!_vm.$slots.header)?[_vm._v(_vm._s(_vm.title))]:_vm._e()],2),_vm._v(" "),(_vm.showClose)?_c('div',{class:(_vm.prefixCls + "__header-close"),on:{"click":_vm.handleClose}},[_c('za-icon',{attrs:{"type":"wrong"}})],1):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{class:(_vm.prefixCls + "__body")},[_vm._t("default")],2),_vm._v(" "),(_vm.$slots.footer)?_c('div',{class:(_vm.prefixCls + "__footer")},[_vm._t("footer")],2):_vm._e()])]),_vm._v(" "),_c('za-mask',{attrs:{"visible":_vm.maskVisible,"type":_vm.maskType},on:{"click":_vm.onMaskClick}})],1)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/modal/src/modal.vue?vue&type=template&id=622951de&lang=html&

// EXTERNAL MODULE: ./src/mask/index.js + 6 modules
var mask = __webpack_require__(59);

// EXTERNAL MODULE: ./src/icon/index.js
var icon = __webpack_require__(68);

// EXTERNAL MODULE: ./src/mixins/get-container.js
var get_container = __webpack_require__(69);

// CONCATENATED MODULE: ./node_modules/_babel-loader@8.1.0@babel-loader/lib!./node_modules/_vue-loader@15.9.3@vue-loader/lib??vue-loader-options!./src/modal/src/modal.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * Should use za-popup instead of reapply mask.
 * but as css is depend on zarm-react version,
 * use popup may have potential problem
 */



/* harmony default export */ var modalvue_type_script_lang_js_ = ({
  name: 'zaModal',
  components: {
    zaMask: mask["default"],
    zaIcon: icon["default"]
  },
  mixins: [get_container["a" /* default */]],
  props: {
    prefixCls: {
      type: String,
      default: 'za-modal'
    },
    visible: {
      type: Boolean,
      default: false
    },
    radius: {
      type: Boolean,
      default: false
    },
    animationType: {
      type: String,
      validator: function validator(v) {
        // eslint-disable-line object-shorthand
        return ['fade', 'door', 'flip', 'rotate', 'zoom', 'moveUp', 'moveDown', 'moveLeft', 'moveRight', 'slideUp', 'slideDown', 'slideLeft', 'slideRight'].indexOf(v) >= 0;
      },
      default: 'zoom'
    },
    maskType: {
      type: String,
      validator: function validator(v) {
        // eslint-disable-line object-shorthand
        return ['transparent', 'light', 'normal', 'dark'].indexOf(v) >= 0;
      },
      default: 'normal'
    },
    animationDuration: {
      type: Number,
      default: 200
    },
    width: {
      type: [String, Number],
      default: '70%'
    },
    minWidth: {
      type: Number,
      default: 270
    },
    title: String,
    showClose: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    modalStyle: function modalStyle() {
      return {
        display: !this.currentVisible ? 'none' : '',
        WebkitAnimationDuration: "".concat(this.animationDuration, "ms"),
        animationDuration: "".concat(this.animationDuration, "ms")
      };
    },
    dialogStyle: function dialogStyle() {
      return {
        width: this.width,
        minWidth: this.minWidth,
        WebkitAnimationDuration: "".concat(this.animationDuration, "ms"),
        animationDuration: "".concat(this.animationDuration, "ms")
      };
    }
  },
  watch: {
    visible: function visible(value, oldValue) {
      var _this = this;

      // eslint-disable-line no-unused-vars, object-shorthand
      if (value === this.currentVisible) return;

      if (this.timer) {
        clearTimeout(this.timer);
      }

      if (value) {
        this.enter();
      } else {
        this.animationState = 'leave';
        this.timer = setTimeout(function () {
          _this.currentVisible = value;
          _this.maskVisible = false;
        }, this.animationDuration);
      }
    }
  },
  data: function data() {
    return {
      currentVisible: this.visible,
      animationState: 'enter',
      maskVisible: this.visible
    };
  },
  methods: {
    enter: function enter() {
      this.currentVisible = true;
      this.maskVisible = true;
      this.animationState = 'enter';
    },
    leave: function leave(reason, event) {
      var _this2 = this;

      // mask start leaving
      this.animationState = 'leave';
      this.$emit('update:visible', false);
      this.$emit('close', reason, event);

      if (this.timer) {
        clearTimeout(this.timer);
      } // remove mask after animationDuration


      this.timer = setTimeout(function () {
        _this2.currentVisible = false;
        _this2.maskVisible = false;
      }, this.animationDuration);
    },
    onMaskClick: function onMaskClick(event) {
      this.$emit('maskClick', event);
    },
    handleClose: function handleClose(event) {
      this.leave('close', event);
    }
  },
  mounted: function mounted() {
    if (this.currentVisible) {
      this.enter();
    }
  },
  beforeDestroy: function beforeDestroy() {
    clearTimeout(this.timer);
  }
});
// CONCATENATED MODULE: ./src/modal/src/modal.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_modalvue_type_script_lang_js_ = (modalvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(0);

// CONCATENATED MODULE: ./src/modal/src/modal.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  src_modalvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var modal = (component.exports);
// CONCATENATED MODULE: ./src/modal/index.js

/* istanbul ignore next */

modal.install = function (Vue) {
  Vue.component(modal.name, modal);
};

/* harmony default export */ var src_modal = __webpack_exports__["default"] = (modal);

/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/_vue-loader@15.9.3@vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/_vue-loader@15.9.3@vue-loader/lib??vue-loader-options!./src/cell/src/cell.vue?vue&type=template&id=2116b9d5&lang=html&
var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:( _obj = {}, _obj[("" + _vm.prefixCls)] = true, _obj[(_vm.prefixCls + "--disabled")] = !!_vm.disabled, _obj[(_vm.prefixCls + "--" + _vm.theme)] = !!_vm.theme, _obj[(_vm.prefixCls + "--is-link")] = !_vm.disabled && !!_vm.isLink, _obj[(_vm.prefixCls + "--has-icon")] = !!_vm.hasIcon, _obj[(_vm.prefixCls + "--has-arrow")] = _vm.hasArrow, _obj ),on:{"click":_vm.handleClick}},[_c('div',{class:(_vm.prefixCls + "__inner")},[_c('div',{class:(_vm.prefixCls + "__header")},[(_vm.$slots.icon)?_c('div',{class:(_vm.prefixCls + "__icon")},[_vm._t("icon")],2):_vm._e()]),_vm._v(" "),_c('div',{class:(_vm.prefixCls + "__body")},[(_vm.$slots.title || _vm.title)?_c('div',{class:(_vm.prefixCls + "__title")},[_vm._t("title"),_vm._v(" "),(!_vm.$slots.title)?[_vm._v(_vm._s(_vm.title))]:_vm._e()],2):_vm._e(),_vm._v(" "),_c('div',{class:(_vm.prefixCls + "__content")},[_vm._t("default")],2)]),_vm._v(" "),(_vm.$slots.description || _vm.description)?_c('div',{class:(_vm.prefixCls + "__footer")},[_vm._t("description"),_vm._v(" "),(!_vm.$slots.description)?[_vm._v(_vm._s(_vm.description))]:_vm._e()],2):_vm._e(),_vm._v(" "),(_vm.hasArrow)?_c('div',{class:(_vm.prefixCls + "__arrow")}):_vm._e()]),_vm._v(" "),(_vm.$slots.help || _vm.help)?_c('div',{class:(_vm.prefixCls + "__help")},[_vm._t("help"),_vm._v(" "),(!_vm.$slots.help)?[_vm._v(_vm._s(_vm.help))]:_vm._e()],2):_vm._e()])}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/cell/src/cell.vue?vue&type=template&id=2116b9d5&lang=html&

// CONCATENATED MODULE: ./node_modules/_babel-loader@8.1.0@babel-loader/lib!./node_modules/_vue-loader@15.9.3@vue-loader/lib??vue-loader-options!./src/cell/src/cell.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var cellvue_type_script_lang_js_ = ({
  name: 'zaCell',
  props: {
    prefixCls: {
      type: String,
      default: 'za-cell'
    },
    hasArrow: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    isLink: {
      type: Boolean,
      default: false
    },
    theme: String,
    title: String,
    help: String,
    description: String
  },
  computed: {
    hasIcon: function hasIcon() {
      return this.$slots && this.$slots.icon && this.$slots.icon.length > 0;
    }
  },
  methods: {
    handleClick: function handleClick(event) {
      this.$emit('click', event);
    }
  }
});
// CONCATENATED MODULE: ./src/cell/src/cell.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_cellvue_type_script_lang_js_ = (cellvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(0);

// CONCATENATED MODULE: ./src/cell/src/cell.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  src_cellvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var cell = (component.exports);
// CONCATENATED MODULE: ./src/cell/index.js

/* istanbul ignore next */

cell.install = function (Vue) {
  Vue.component(cell.name, cell);
};

/* harmony default export */ var src_cell = __webpack_exports__["default"] = (cell);

/***/ }),
/* 147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  getLocaleByComponent: function getLocaleByComponent(localeProvider) {
    var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var key = arguments.length > 2 ? arguments[2] : undefined;
    if (!localeProvider) return '';
    var currentLang = localeProvider.lang;

    if (currentLang) {
      var currentProvider = localeProvider.locale[currentLang];
      return currentProvider[name][key];
    }

    return '';
  }
});

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(155);

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

var _Array$from = __webpack_require__(92);

var arrayLikeToArray = __webpack_require__(127);

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return _Array$from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return arrayLikeToArray(o, minLen);
}

module.exports = _unsupportedIterableToArray;

/***/ }),
/* 150 */
/***/ (function(module, exports) {

module.exports = require("autosize");

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(152);
var $Object = __webpack_require__(1).Object;
module.exports = function create(P, D) {
  return $Object.create(P, D);
};


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(9);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(30) });


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(154);
module.exports = __webpack_require__(1).Array.isArray;


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
var $export = __webpack_require__(9);

$export($export.S, 'Array', { isArray: __webpack_require__(48) });


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(56);
__webpack_require__(49);
module.exports = __webpack_require__(156);


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(57);
var ITERATOR = __webpack_require__(3)('iterator');
var Iterators = __webpack_require__(16);
module.exports = __webpack_require__(1).isIterable = function (it) {
  var O = Object(it);
  return O[ITERATOR] !== undefined
    || '@@iterator' in O
    // eslint-disable-next-line no-prototype-builtins
    || Iterators.hasOwnProperty(classof(O));
};


/***/ }),
/* 157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/_vue-loader@15.9.3@vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/_vue-loader@15.9.3@vue-loader/lib??vue-loader-options!./src/date-picker-view/src/date-picker-view.vue?vue&type=template&id=220d5504&lang=html&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:(_vm.prefixCls + "__panel")},[_c('div',{class:(_vm.prefixCls + "__mask-top")}),_vm._v(" "),_c('div',{class:(_vm.prefixCls + "__view")},_vm._l((_vm.getColsValue().dataSource),function(item,index){return _c('Wheel',{key:index+1,attrs:{"index":index,"dataSource":item,"selectedValue":_vm.getColsValue().value[index],"defaultValue":_vm.getColsValue().value[index],"valueMember":_vm.valueMember,"disabled":_vm.disabled},on:{"change":_vm.onValueChange,"transition":_vm.onTransition}})}),1),_vm._v(" "),_c('div',{class:(_vm.prefixCls + "__mask-bottom")})])}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/date-picker-view/src/date-picker-view.vue?vue&type=template&id=220d5504&lang=html&

// EXTERNAL MODULE: ./node_modules/_@babel_runtime-corejs2@7.11.2@@babel/runtime-corejs2/core-js/date/now.js
var now = __webpack_require__(126);
var now_default = /*#__PURE__*/__webpack_require__.n(now);

// EXTERNAL MODULE: ./src/wheel/src/wheel.vue + 5 modules
var wheel = __webpack_require__(96);

// CONCATENATED MODULE: ./src/date-picker-view/locale/zh_CN.js
/* istanbul ignore next */
/* harmony default export */ var zh_CN = ({
  year: '年',
  month: '月',
  day: '日',
  hour: '时',
  minute: '分'
});
// CONCATENATED MODULE: ./node_modules/_babel-loader@8.1.0@babel-loader/lib!./node_modules/_vue-loader@15.9.3@vue-loader/lib??vue-loader-options!./src/date-picker-view/src/date-picker-view.vue?vue&type=script&lang=js&

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var DATETIME = 'datetime';
var DATE = 'date';
var TIME = 'time';
var MONTH = 'month';
var YEAR = 'year';
var ONE_DAY = 24 * 60 * 60 * 1000; // 获取当月天数

var getDaysInMonth = function getDaysInMonth(date) {
  return new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();
}; // 补齐格式


var pad = function pad(n) {
  return n < 10 ? "0".concat(n) : "".concat(n);
};

var cloneDate = function cloneDate(date) {
  return new Date(+date);
}; // 设置月份


var setMonth = function setMonth(date, month) {
  date.setDate(Math.min(date.getDate(), getDaysInMonth(new Date(date.getFullYear(), month))));
  date.setMonth(month);
}; // 转成Date格式


var getGregorianCalendar = function getGregorianCalendar(year, month, day, hour, minutes, seconds) {
  return new Date(year, month, day, hour, minutes, seconds);
};

var isExtendDate = function isExtendDate(date) {
  if (date instanceof Date) {
    return date;
  }

  if (!date) {
    return '';
  }

  return new Date(date.toString().replace(/-/g, '/'));
};

/* harmony default export */ var date_picker_viewvue_type_script_lang_js_ = ({
  name: 'zaDatePickerView',
  components: {
    Wheel: wheel["a" /* default */]
  },
  props: {
    prefixCls: {
      type: String,
      default: 'za-datepicker-view'
    },
    title: {
      type: String,
      default: '请选择'
    },
    placeholder: {
      type: String,
      default: '请选择'
    },
    cancelText: {
      type: String,
      default: '取消'
    },
    okText: {
      type: String,
      default: '确定'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    displayMember: {
      type: String,
      default: 'label'
    },
    valueMember: {
      type: String,
      default: 'value'
    },
    defaultValue: '',
    value: '',
    displayAddon: {
      type: String,
      default: ''
    },
    displayGenerator: Function,
    customCls: String,
    cols: Number,
    mode: {
      type: String,
      validator: function validator(v) {
        // eslint-disable-line object-shorthand
        return [YEAR, MONTH, DATE, TIME, DATETIME].indexOf(v) >= 0;
      },
      default: DATE
    },
    locale: {
      type: Object,
      default: function _default() {
        return zh_CN;
      }
    },
    minuteStep: {
      type: Number,
      default: 1
    },
    // wheelDefaultValue: {},
    min: {},
    max: {}
  },
  watch: {
    value: function value(val, oldVal) {
      // eslint-disable-line no-unused-vars
      if (this.date === val) return;
      this.date = isExtendDate(val);
    }
  },
  data: function data() {
    return {
      date: ''
    };
  },
  created: function created() {
    var date = this.value && isExtendDate(this.value);
    var defaultDate = this.defaultValue && isExtendDate(this.defaultValue);
    this.date = defaultDate || date;
    this.$emit('init', this.getDate());
  },
  methods: {
    onValueChange: function onValueChange(selected, index) {
      var mode = this.mode;
      var newValue = cloneDate(this.getDate());

      if (mode === YEAR || mode === MONTH || mode === DATE || mode === DATETIME) {
        switch (index) {
          case 0:
            newValue.setFullYear(selected);
            break;

          case 1:
            setMonth(newValue, selected);
            break;

          case 2:
            newValue.setDate(selected);
            break;

          case 3:
            newValue.setHours(selected);
            break;

          case 4:
            newValue.setMinutes(selected);
            break;

          default:
            break;
        }
      } else {
        switch (index) {
          case 0:
            newValue.setHours(selected);
            break;

          case 1:
            newValue.setMinutes(selected);
            break;

          default:
            break;
        }
      }

      newValue = this.clipDate(newValue);
      this.date = newValue;
      this.$emit('change', newValue);
    },
    clipDate: function clipDate(date) {
      var mode = this.mode;
      var minDate = this.getMinDate();
      var maxDate = this.getMaxDate();

      if (mode === DATETIME) {
        if (date < minDate) {
          return cloneDate(minDate);
        }

        if (date > maxDate) {
          return cloneDate(maxDate);
        }
      } else if (mode === DATE) {
        if (+date + ONE_DAY <= +minDate) {
          return cloneDate(minDate);
        }

        if (date >= +maxDate + ONE_DAY) {
          return cloneDate(maxDate);
        }
      } else {
        var maxHour = maxDate.getHours();
        var maxMinutes = maxDate.getMinutes();
        var minHour = minDate.getHours();
        var minMinutes = minDate.getMinutes();
        var hour = date.getHours();
        var minutes = date.getMinutes();

        if (hour < minHour || hour === minHour && minutes < minMinutes) {
          return cloneDate(minDate);
        }

        if (hour > maxHour || hour === maxHour && minutes > maxMinutes) {
          return cloneDate(maxDate);
        }
      }

      return date;
    },
    getColsValue: function getColsValue() {
      var mode = this.mode;
      var date = this.getDate();
      var dataSource = [];
      var value = [];

      if (mode === YEAR) {
        dataSource = this.getDateData();
        value = ["".concat(date.getFullYear())];
      }

      if (mode === MONTH) {
        dataSource = this.getDateData();
        value = ["".concat(date.getFullYear()), "".concat(date.getMonth())];
      }

      if (mode === DATE || mode === DATETIME) {
        dataSource = this.getDateData();
        value = ["".concat(date.getFullYear()), "".concat(date.getMonth()), "".concat(date.getDate())];
      }

      if (mode === DATETIME) {
        dataSource = dataSource.concat(this.getTimeData());
        value = value.concat(["".concat(date.getHours()), "".concat(date.getMinutes())]);
      }

      if (mode === TIME) {
        dataSource = this.getTimeData();
        value = ["".concat(date.getHours()), "".concat(date.getMinutes())];
      }

      return {
        dataSource: dataSource,
        value: value
      };
    },
    getDateData: function getDateData() {
      var locale = this.locale,
          mode = this.mode;
      var date = this.getDate();
      var yearCol = [];
      var monthCol = [];
      var dayCol = [];
      var selectYear = date.getFullYear();
      var selectMonth = date.getMonth();
      var minYear = this.getMinYear();
      var maxYear = this.getMaxYear();

      for (var i = minYear; i <= maxYear; i += 1) {
        yearCol.push({
          label: "".concat(i + locale.year),
          value: "".concat(i)
        });
      }

      if (mode === YEAR) {
        return [yearCol];
      }

      var minMonth = 0;
      var maxMonth = 11;

      if (selectYear === minYear) {
        minMonth = this.getMinMonth();
      }

      if (selectYear === maxYear) {
        maxMonth = this.getMaxMonth();
      }

      for (var _i = minMonth; _i <= maxMonth; _i += 1) {
        monthCol.push({
          label: "".concat(_i + 1 + locale.month),
          value: "".concat(_i)
        });
      }

      if (mode === MONTH) {
        return [yearCol, monthCol];
      }

      var minDay = 1;
      var maxDay = getDaysInMonth(date);

      if (selectYear === minYear && selectMonth === minMonth) {
        minDay = this.getMinDay();
      }

      if (selectYear === maxYear && selectMonth === maxMonth) {
        maxDay = this.getMaxDay();
      }

      for (var _i2 = minDay; _i2 <= maxDay; _i2 += 1) {
        dayCol.push({
          label: "".concat(_i2 + locale.day),
          value: "".concat(_i2)
        });
      }

      if (mode === DATE) {
        return [yearCol, monthCol, dayCol];
      }

      return [yearCol, monthCol, dayCol];
    },
    getTimeData: function getTimeData() {
      var locale = this.locale,
          mode = this.mode,
          minuteStep = this.minuteStep;
      var date = this.getDate();
      var hourCol = [];
      var minuteCol = [];
      var minHour = 0;
      var maxHour = 23;
      var minMinute = 0;
      var maxMinute = 59;
      var minDateHour = this.getMinHour();
      var maxDateHour = this.getMaxHour();
      var minDateMinute = this.getMinMinute();
      var maxDateMinute = this.getMaxMinute();
      var selectHour = date.getHours();

      if (mode === DATETIME) {
        var selectYear = date.getFullYear();
        var selectMonth = date.getMonth();
        var selectDay = date.getDate();
        var minYear = this.getMinYear();
        var maxYear = this.getMaxYear();
        var minMonth = this.getMinMonth();
        var maxMonth = this.getMaxMonth();
        var minDay = this.getMinDay();
        var maxDay = this.getMaxDay();

        if (selectYear === minYear && selectMonth === minMonth && selectDay === minDay) {
          minHour = minDateHour;

          if (selectHour === minHour) {
            minMinute = minDateMinute;
          }
        }

        if (selectYear === maxYear && selectMonth === maxMonth && selectDay === maxDay) {
          maxHour = maxDateHour;

          if (selectHour === maxHour) {
            maxMinute = maxDateMinute;
          }
        }
      } else {
        minHour = minDateHour;

        if (selectHour === minHour) {
          minMinute = minDateMinute;
        }

        maxHour = maxDateHour;

        if (selectHour === maxHour) {
          maxMinute = maxDateMinute;
        }
      }

      for (var i = minHour; i <= maxHour; i += 1) {
        hourCol.push({
          label: locale.hour ? "".concat(i + locale.hour) : pad(i),
          value: "".concat(i)
        });
      }

      for (var _i3 = minMinute; _i3 <= maxMinute; _i3 += minuteStep) {
        minuteCol.push({
          label: locale.minute ? "".concat(_i3 + locale.minute) : pad(_i3),
          value: "".concat(_i3)
        });
      }

      return [hourCol, minuteCol];
    },
    getDate: function getDate() {
      return this.date || this.getDefaultDate();
    },
    getDefaultDate: function getDefaultDate() {
      var min = this.min,
          mode = this.mode,
          minuteStep = this.minuteStep; // 存在最小值且毫秒数大于现在

      if (min && this.getMinDate().getTime() >= now_default()()) {
        return this.getMinDate();
      }

      if (minuteStep && minuteStep > 1 && (mode === DATETIME || mode === TIME)) {
        return new Date(new Date().setMinutes(0));
      }

      return new Date();
    },
    getMinYear: function getMinYear() {
      return this.getMinDate().getFullYear();
    },
    getMaxYear: function getMaxYear() {
      return this.getMaxDate().getFullYear();
    },
    getMinMonth: function getMinMonth() {
      return this.getMinDate().getMonth();
    },
    getMaxMonth: function getMaxMonth() {
      return this.getMaxDate().getMonth();
    },
    getMinDay: function getMinDay() {
      return this.getMinDate().getDate();
    },
    getMaxDay: function getMaxDay() {
      return this.getMaxDate().getDate();
    },
    getMinHour: function getMinHour() {
      return this.getMinDate().getHours();
    },
    getMaxHour: function getMaxHour() {
      return this.getMaxDate().getHours();
    },
    getMinMinute: function getMinMinute() {
      return this.getMinDate().getMinutes();
    },
    getMaxMinute: function getMaxMinute() {
      return this.getMaxDate().getMinutes();
    },
    getMinDate: function getMinDate() {
      var minDate = isExtendDate(this.min);
      return minDate || this.getDefaultMinDate();
    },
    getMaxDate: function getMaxDate() {
      var maxDate = isExtendDate(this.max);
      return maxDate || this.getDefaultMaxDate();
    },
    getDefaultMinDate: function getDefaultMinDate() {
      return getGregorianCalendar(2000, 0, 1, 0, 0, 0);
    },
    getDefaultMaxDate: function getDefaultMaxDate() {
      return getGregorianCalendar(2030, 11, 30, 23, 59, 59);
    },
    onTransition: function onTransition(isScrolling) {
      // if (typeof this.onTransition === 'function') {
      //   this.onTransition!(isScrolling);
      // }
      this.$emit('transition', isScrolling);
    }
  }
});
// CONCATENATED MODULE: ./src/date-picker-view/src/date-picker-view.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_date_picker_viewvue_type_script_lang_js_ = (date_picker_viewvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(0);

// CONCATENATED MODULE: ./src/date-picker-view/src/date-picker-view.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  src_date_picker_viewvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var date_picker_view = (component.exports);
// CONCATENATED MODULE: ./src/date-picker-view/index.js

/* istanbul ignore next */

date_picker_view.install = function (Vue) {
  Vue.component(date_picker_view.name, date_picker_view);
};

/* harmony default export */ var src_date_picker_view = __webpack_exports__["default"] = (date_picker_view);

/***/ }),
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/_vue-loader@15.9.3@vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/_vue-loader@15.9.3@vue-loader/lib??vue-loader-options!./src/keyboard/src/keyboard.vue?vue&type=template&id=19f4ab90&
var render = function () {
var _obj, _obj$1;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.prefixCls,on:{"click":function($event){$event.stopPropagation();return (function () {})($event)}}},[_c('div',{class:(_vm.prefixCls + "__keys")},_vm._l((_vm.getKeys()),function(text,index){
var _obj;
return _c('div',{key:index,class:( _obj = {}, _obj[(_vm.prefixCls + "__item")] = true, _obj[(_vm.prefixCls + "__item--disabled")] = text.length === 0, _obj ),on:{"click":function($event){return _vm.onKeyClick(text)}}},[(text === 'close')?[_c('za-icon',{attrs:{"type":"keyboard"}})]:[_vm._v("\n        "+_vm._s(text)+"\n      ")]],2)}),0),_vm._v(" "),_c('div',{class:(_vm.prefixCls + "__handle")},[_c('div',{class:( _obj = {}, _obj[(_vm.prefixCls + "__item")] = true, _obj[(_vm.prefixCls + "__item--delete")] = true, _obj ),on:{"touchstart":function($event){return _vm.onLongPressIn('delete')},"touchend":_vm.onLongPressOut}},[_c('za-icon',{attrs:{"type":"deletekey"}})],1),_vm._v(" "),_c('div',{class:( _obj$1 = {}, _obj$1[(_vm.prefixCls + "__item")] = true, _obj$1[(_vm.prefixCls + "__item--ok")] = true, _obj$1 ),on:{"click":function($event){return _vm.onKeyClick('ok')}}},[_vm._v("确定")])])])}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/keyboard/src/keyboard.vue?vue&type=template&id=19f4ab90&

// EXTERNAL MODULE: ./src/icon/index.js
var icon = __webpack_require__(68);

// EXTERNAL MODULE: ./src/utils/validator.js
var validator = __webpack_require__(13);

// CONCATENATED MODULE: ./node_modules/_babel-loader@8.1.0@babel-loader/lib!./node_modules/_vue-loader@15.9.3@vue-loader/lib??vue-loader-options!./src/keyboard/src/keyboard.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var NUMBER_KEYS = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '', '0', 'close'];
var PRICE_KEYS = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '.', '0', 'close'];
var IDCARD_KEYS = ['1', '2', '3', '4', '5', '6', '7', '8', '9', 'x', '0', 'close'];
/* harmony default export */ var keyboardvue_type_script_lang_js_ = ({
  name: 'zaKeyboard',
  props: {
    prefixCls: {
      type: String,
      default: 'za-keyboard'
    },
    type: {
      type: String,
      validator: Object(validator["b" /* enumGenerator */])(['number', 'price', 'idcard']),
      default: 'number'
    }
  },
  data: function data() {
    return {
      longPressTimer: null,
      pressBegin: 0,
      pressEnd: 800,
      longPressClick: null
    };
  },
  components: {
    zaIcon: icon["default"]
  },
  methods: {
    onLongPressIn: function onLongPressIn(key) {
      var self = this;
      self.$emit('keyClick', key);
      self.longPressTimer = setTimeout(function () {
        self.longPressTimer = setInterval(function () {
          self.$emit('keyClick', key);
        }, 100);
      }, 800);
    },
    onLongPressOut: function onLongPressOut() {
      clearInterval(this.longPressTimer);
    },
    onKeyClick: function onKeyClick(key) {
      if (key.length === 0) {
        return;
      }

      this.$emit('keyClick', key);
    },
    getKeys: function getKeys() {
      var type = this.type;

      switch (type) {
        case 'price':
          return PRICE_KEYS;

        case 'idcard':
          return IDCARD_KEYS;

        default:
          return NUMBER_KEYS;
      }
    }
  }
});
// CONCATENATED MODULE: ./src/keyboard/src/keyboard.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_keyboardvue_type_script_lang_js_ = (keyboardvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(0);

// CONCATENATED MODULE: ./src/keyboard/src/keyboard.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  src_keyboardvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var keyboard = (component.exports);
// CONCATENATED MODULE: ./src/keyboard/index.js

/* istanbul ignore next */

keyboard.install = function (Vue) {
  Vue.component(keyboard.name, keyboard);
};

/* harmony default export */ var src_keyboard = __webpack_exports__["default"] = (keyboard);

/***/ }),
/* 159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/_vue-loader@15.9.3@vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/_vue-loader@15.9.3@vue-loader/lib??vue-loader-options!./src/picker-view/src/picker-view.vue?vue&type=template&id=c3d087aa&lang=html&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:(_vm.prefixCls + "__panel")},[_c('div',{class:(_vm.prefixCls + "__mask-top")}),_vm._v(" "),_c('div',{class:(_vm.prefixCls + "__view")},_vm._l((_vm.data),function(item,index){return _c('Wheel',{key:index+1,attrs:{"index":index,"dataSource":item,"selectedValue":_vm.getValue()[index],"defaultValue":_vm.defaultValue[index],"valueMember":_vm.valueMember,"itemRender":_vm.itemRender,"disabled":_vm.disabled},on:{"reset":_vm.resetCols,"transition":_vm.onTransition,"change":_vm.onValueChange}})}),1),_vm._v(" "),_c('div',{class:(_vm.prefixCls + "__mask-bottom")})])}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/picker-view/src/picker-view.vue?vue&type=template&id=c3d087aa&lang=html&

// EXTERNAL MODULE: ./node_modules/_@babel_runtime-corejs2@7.11.2@@babel/runtime-corejs2/helpers/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(167);
var objectWithoutProperties_default = /*#__PURE__*/__webpack_require__.n(objectWithoutProperties);

// EXTERNAL MODULE: ./node_modules/_@babel_runtime-corejs2@7.11.2@@babel/runtime-corejs2/core-js/object/assign.js
var object_assign = __webpack_require__(116);
var assign_default = /*#__PURE__*/__webpack_require__.n(object_assign);

// EXTERNAL MODULE: ./src/utils/validator.js
var validator = __webpack_require__(13);

// EXTERNAL MODULE: ./src/wheel/src/wheel.vue + 5 modules
var wheel = __webpack_require__(96);

// CONCATENATED MODULE: ./node_modules/_babel-loader@8.1.0@babel-loader/lib!./node_modules/_vue-loader@15.9.3@vue-loader/lib??vue-loader-options!./src/picker-view/src/picker-view.vue?vue&type=script&lang=js&


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var picker_viewvue_type_script_lang_js_ = ({
  name: 'zaPickerView',
  components: {
    Wheel: wheel["a" /* default */]
  },
  props: {
    prefixCls: {
      type: String,
      default: 'za-picker-view'
    },
    dataSource: {
      type: Array,
      required: true
    },
    defaultValue: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    cols: {
      type: Number,
      default: Infinity
    },
    valueMember: {
      type: String,
      default: 'value'
    },
    itemRender: {
      type: Function,
      default: function _default(item) {
        return item.label;
      }
    },
    disabled: {
      type: Boolean,
      default: false
    },
    selectedValue: Array
  },
  data: function data() {
    this.value = this.getValue();
    var newObj = this.getState();
    return assign_default()({
      isManual: false
    }, newObj);
  },
  watch: {
    dataSource: function dataSource() {
      var newObj = this.getState();
      this.data = newObj.data;
      this.value = newObj.value;
      this.oldValue = newObj.oldValue;
    }
  },
  methods: {
    getInitValue: function getInitValue(defaultValue) {
      if ('value' in this && this.value.length > 0) {
        return [].concat(this.value);
      }

      if ('defaultValue' in this && this.defaultValue.length > 0) {
        return [].concat(this.defaultValue);
      }

      return defaultValue;
    },
    isCascader: function isCascader() {
      return this.dataSource && this.dataSource[0] && !Object(validator["c" /* isArray */])(this.dataSource[0]);
    },
    // fixed two or more wheels default data bug
    resetCols: function resetCols(value, level) {
      var valueMember = this.valueMember,
          data = this.data,
          selectedValue = this.selectedValue;
      var hasObj = data[level].some(function (item) {
        return item[valueMember] === value;
      }); // console.log(value, hasObj) // eslint-disable-line

      if (selectedValue && !selectedValue.length && this.isCascader()) {
        this.value = selectedValue;
        var newObj = this.cascaderState();
        this.data = newObj.data;
      }

      if (!hasObj && this.isCascader()) {
        var _newObj = this.cascaderState(selectedValue);

        this.$set(data, level, _newObj.data[level]);
      }
    },
    getState: function getState() {
      var state = this.isCascader() ? this.cascaderState() : this.normalState();
      return state;
    },
    getValue: function getValue() {
      var _this = this;

      var data = this.data,
          selectedValue = this.selectedValue;

      if (selectedValue && selectedValue.length) {
        return selectedValue;
      }

      if (!data) {
        return [];
      }

      return data.map(function (c) {
        return c && c[0] && c[0][_this.valueMember];
      });
    },
    normalState: function normalState() {
      var valueMember = this.valueMember,
          dataSource = this.dataSource;
      var value = this.getInitValue(dataSource.map(function (item) {
        return item[0] && item[0][valueMember];
      })); // console.log(value,this.selectedValue) // eslint-disable-line

      return {
        value: value,
        // eslint-disable-next-line
        objValue: this.dataSource.map(function (item, index) {
          return item.filter(function (d) {
            return d[valueMember] === value[index];
          })[0];
        }),
        data: dataSource
      };
    },
    cascaderState: function cascaderState(selected) {
      var valueMember = this.valueMember,
          cols = this.cols; // eslint-disable-next-line

      var newValues = selected ? selected : this.getInitValue([]);
      var newObjValues = [];
      var newDateSource = [];

      var parseLevel = function parseLevel(_ref) {
        var _ref$level = _ref.level,
            level = _ref$level === void 0 ? 0 : _ref$level,
            dataSource = _ref.dataSource;
        newDateSource[level] = dataSource.map(function (item, index) {
          var children = item.children,
              others = objectWithoutProperties_default()(item, ["children"]); // eslint-disable-next-line


          if (newValues[level] && item[valueMember] === newValues[level] || !newValues[level] && index === 0) {
            newValues[level] = item[valueMember];
            newObjValues[level] = others;

            if (Object(validator["c" /* isArray */])(children) && children.length > 0 && level + 1 < cols) {
              parseLevel({
                dataSource: children,
                level: level + 1
              });
            }
          }

          return others;
        });
        return newValues;
      };

      newValues = parseLevel({
        dataSource: this.dataSource
      });
      return {
        value: newValues,
        objValue: newObjValues,
        data: newDateSource
      };
    },
    onValueChange: function onValueChange(selected, level) {
      var value = this.value;
      value[level] = selected;

      if (this.isCascader()) {
        value.length = level + 1;
      } // console.log(value) // eslint-disable-line


      var newObj = this.getState();
      this.value = newObj.value;
      this.objValue = newObj.objValue;
      this.data = newObj.data;
      this.isManual = true;
      this.$emit('change', newObj.objValue, level);
    },
    onTransition: function onTransition(isScrolling) {
      this.$emit('transition', isScrolling);
    }
  }
});
// CONCATENATED MODULE: ./src/picker-view/src/picker-view.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_picker_viewvue_type_script_lang_js_ = (picker_viewvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(0);

// CONCATENATED MODULE: ./src/picker-view/src/picker-view.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  src_picker_viewvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var picker_view = (component.exports);
// CONCATENATED MODULE: ./src/picker-view/index.js

/* istanbul ignore next */

picker_view.install = function (Vue) {
  Vue.component(picker_view.name, picker_view);
};

/* harmony default export */ var src_picker_view = __webpack_exports__["default"] = (picker_view);

/***/ }),
/* 160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/_@babel_runtime-corejs2@7.11.2@@babel/runtime-corejs2/core-js/object/keys.js
var keys = __webpack_require__(46);
var keys_default = /*#__PURE__*/__webpack_require__.n(keys);

// EXTERNAL MODULE: ./node_modules/_@babel_runtime-corejs2@7.11.2@@babel/runtime-corejs2/helpers/typeof.js
var helpers_typeof = __webpack_require__(58);
var typeof_default = /*#__PURE__*/__webpack_require__.n(helpers_typeof);

// EXTERNAL MODULE: external "vue"
var external_vue_ = __webpack_require__(64);
var external_vue_default = /*#__PURE__*/__webpack_require__.n(external_vue_);

// CONCATENATED MODULE: ./node_modules/_vue-loader@15.9.3@vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/_vue-loader@15.9.3@vue-loader/lib??vue-loader-options!./src/tooltip/src/tooltip.vue?vue&type=template&id=43972a9d&lang=html&
var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.currentVisible)?_c('div',{ref:"tooltip",class:( _obj = {}, _obj[("" + _vm.prefixCls)] = true, _obj[(_vm.prefixCls + "--" + _vm.theme)] = !!_vm.theme, _obj ),style:(_vm.styleCls)},[_c('div',{class:(_vm.prefixCls + "__inner")},[_vm._v(_vm._s(_vm.message))]),_vm._v(" "),_vm._t("default")],2):_vm._e()}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/tooltip/src/tooltip.vue?vue&type=template&id=43972a9d&lang=html&

// EXTERNAL MODULE: ./src/utils/validator.js
var validator = __webpack_require__(13);

// CONCATENATED MODULE: ./node_modules/_babel-loader@8.1.0@babel-loader/lib!./node_modules/_vue-loader@15.9.3@vue-loader/lib??vue-loader-options!./src/tooltip/src/tooltip.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var tooltipvue_type_script_lang_js_ = ({
  name: 'zaTooltip',
  props: {
    prefixCls: {
      type: String,
      default: 'za-tooltip'
    },
    visible: {
      type: Boolean,
      default: false
    },
    theme: {
      type: String,
      validator: validator["a" /* defaultThemeValidator */],
      default: 'default'
    },
    message: {
      type: [String, Number]
    }
  },
  data: function data() {
    return {
      currentVisible: this.visible,
      styleCls: undefined
    };
  },
  watch: {
    currentVisible: function currentVisible(value, oldValue) {
      // eslint-disable-line no-unused-vars, object-shorthand
      this.show();
    }
  },
  methods: {
    show: function show() {
      var _this = this;

      this.$nextTick(function () {
        if (_this.$refs.tooltip && !_this.styleCls) {
          var rect = _this.$refs.tooltip.getBoundingClientRect();

          var scrollTop = document.documentElement.scrollTop + document.body.scrollTop;
          var top = rect.top + scrollTop;
          _this.styleCls = {
            left: "".concat(rect.left, "px"),
            top: "".concat(top, "px"),
            width: "".concat(rect.width)
          };
        }
      });
    },
    close: function close() {
      this.currentVisible = false;
    }
  }
});
// CONCATENATED MODULE: ./src/tooltip/src/tooltip.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_tooltipvue_type_script_lang_js_ = (tooltipvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(0);

// CONCATENATED MODULE: ./src/tooltip/src/tooltip.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  src_tooltipvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var tooltip = (component.exports);
// CONCATENATED MODULE: ./src/tooltip/index.js




/* istanbul ignore next */

tooltip.install = function (Vue) {
  // eslint-disable-line
  Vue.component(tooltip.name, tooltip);
};

var instance;
var TooltipConstructor = external_vue_default.a.extend(tooltip);

var initInstance = function initInstance() {
  instance = new TooltipConstructor({
    el: document.createElement('div')
  });
};

tooltip.root = function (message, options) {
  /* istanbul ignore if */
  if (external_vue_default.a.prototype.$isServer) return;
  options = options || {};

  if (typeof_default()(message) === 'object') {
    options = message;
    message = '';
  } else {
    options.message = message;
  }

  if (!instance) {
    initInstance();
  }

  keys_default()(options).forEach(function (key) {
    instance[key] = options[key];
  });

  document.body.appendChild(instance.$el);
  external_vue_default.a.nextTick(function () {
    instance.currentVisible = true;
  });
  return instance;
};

/* harmony default export */ var src_tooltip = __webpack_exports__["default"] = (tooltip);

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

var _Array$isArray = __webpack_require__(128);

var arrayLikeToArray = __webpack_require__(127);

function _arrayWithoutHoles(arr) {
  if (_Array$isArray(arr)) return arrayLikeToArray(arr);
}

module.exports = _arrayWithoutHoles;

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

var _Array$from = __webpack_require__(92);

var _isIterable = __webpack_require__(148);

var _Symbol = __webpack_require__(86);

function _iterableToArray(iter) {
  if (typeof _Symbol !== "undefined" && _isIterable(Object(iter))) return _Array$from(iter);
}

module.exports = _iterableToArray;

/***/ }),
/* 163 */
/***/ (function(module, exports) {

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

module.exports = _nonIterableSpread;

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(165);
module.exports = __webpack_require__(1).Object.assign;


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(9);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(166) });


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS = __webpack_require__(4);
var getKeys = __webpack_require__(18);
var gOPS = __webpack_require__(41);
var pIE = __webpack_require__(32);
var toObject = __webpack_require__(21);
var IObject = __webpack_require__(38);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(12)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

var _Object$getOwnPropertySymbols = __webpack_require__(77);

var objectWithoutPropertiesLoose = __webpack_require__(179);

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (_Object$getOwnPropertySymbols) {
    var sourceSymbolKeys = _Object$getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

module.exports = _objectWithoutProperties;

/***/ }),
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/_@babel_runtime-corejs2@7.11.2@@babel/runtime-corejs2/core-js/object/keys.js
var keys = __webpack_require__(46);
var keys_default = /*#__PURE__*/__webpack_require__.n(keys);

// EXTERNAL MODULE: ./node_modules/_@babel_runtime-corejs2@7.11.2@@babel/runtime-corejs2/helpers/typeof.js
var helpers_typeof = __webpack_require__(58);
var typeof_default = /*#__PURE__*/__webpack_require__.n(helpers_typeof);

// EXTERNAL MODULE: external "vue"
var external_vue_ = __webpack_require__(64);
var external_vue_default = /*#__PURE__*/__webpack_require__.n(external_vue_);

// CONCATENATED MODULE: ./node_modules/_vue-loader@15.9.3@vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/_vue-loader@15.9.3@vue-loader/lib??vue-loader-options!./src/toast/src/toast.vue?vue&type=template&id=6bbda78d&lang=html&
var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:( _obj = {}, _obj[("" + _vm.prefixCls)] = true, _obj[(_vm.prefixCls + "--open")] = _vm.currentVisible, _obj )},[_c('div',{class:(_vm.prefixCls + "__container")},[_vm._t("default",[_vm._v(_vm._s(_vm.message))])],2),_vm._v(" "),_c('za-mask',{attrs:{"type":"transparent","visible":_vm.currentVisible},on:{"click":_vm.onMaskClick}})],1)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/toast/src/toast.vue?vue&type=template&id=6bbda78d&lang=html&

// EXTERNAL MODULE: ./src/mask/index.js + 6 modules
var mask = __webpack_require__(59);

// CONCATENATED MODULE: ./node_modules/_babel-loader@8.1.0@babel-loader/lib!./node_modules/_vue-loader@15.9.3@vue-loader/lib??vue-loader-options!./src/toast/src/toast.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var toastvue_type_script_lang_js_ = ({
  name: 'zaToast',
  components: {
    zaMask: mask["default"]
  },
  props: {
    prefixCls: {
      type: String,
      default: 'za-toast'
    },
    visible: {
      type: Boolean,
      default: false
    },
    duration: {
      type: Number,
      default: 3000
    }
  },
  methods: {
    onMaskClick: function onMaskClick(event) {
      this.$emit('maskClick', event);
    },
    enter: function enter() {
      var _this = this;

      if (this.duration === 0) return;

      if (this.timer) {
        clearTimeout(this.timer);
      }

      this.timer = setTimeout(function () {
        _this.currentVisible = false;
        _this.event = undefined;
        _this.reason = 'timeout';
      }, this.duration);
    },
    leave: function leave() {
      this.$emit('update:visible', false);
      this.$emit('close', this.reason, this.event);
    }
  },
  watch: {
    visible: function visible(value, oldValue) {
      // eslint-disable-line no-unused-vars, object-shorthand
      if (value === this.currentVisible) return;

      if (this.timer) {
        clearTimeout(this.timer);
      }

      this.currentVisible = value;
    },
    currentVisible: function currentVisible(value) {
      if (value) {
        this.enter();
      } else {
        this.leave();
      }
    }
  },
  data: function data() {
    return {
      currentVisible: this.visible,
      message: ''
    };
  },
  mounted: function mounted() {
    if (this.currentVisible) {
      this.enter();
    }
  },
  beforeDestroy: function beforeDestroy() {
    clearTimeout(this.timer);
  }
});
// CONCATENATED MODULE: ./src/toast/src/toast.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_toastvue_type_script_lang_js_ = (toastvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(0);

// CONCATENATED MODULE: ./src/toast/src/toast.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  src_toastvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var toast = (component.exports);
// CONCATENATED MODULE: ./src/toast/index.js




/* istanbul ignore next */

toast.install = function (Vue) {
  // eslint-disable-line
  Vue.component(toast.name, toast);
};

var instance;
var ToastConstructor = external_vue_default.a.extend(toast);

var initInstance = function initInstance() {
  instance = new ToastConstructor({
    el: document.createElement('div')
  });
};

toast.root = function (message, options) {
  /* istanbul ignore if */
  if (external_vue_default.a.prototype.$isServer) return;
  options = options || {};

  if (typeof_default()(message) === 'object') {
    options = message;
    message = '';
  } else {
    options.message = message;
  }

  if (!instance) {
    initInstance();
  }

  keys_default()(options).forEach(function (key) {
    instance[key] = options[key];
  });

  document.body.appendChild(instance.$el);
  external_vue_default.a.nextTick(function () {
    instance.currentVisible = true;
  });
};

/* harmony default export */ var src_toast = __webpack_exports__["default"] = (toast);

/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/_vue-loader@15.9.3@vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/_vue-loader@15.9.3@vue-loader/lib??vue-loader-options!./src/carousel/src/carousel-item.vue?vue&type=template&id=2db3b2ea&lang=html&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:(_vm.prefixCls + "__item")},[_vm._t("default")],2)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/carousel/src/carousel-item.vue?vue&type=template&id=2db3b2ea&lang=html&

// CONCATENATED MODULE: ./node_modules/_babel-loader@8.1.0@babel-loader/lib!./node_modules/_vue-loader@15.9.3@vue-loader/lib??vue-loader-options!./src/carousel/src/carousel-item.vue?vue&type=script&lang=js&
//
//
//
//
//
//
/* harmony default export */ var carousel_itemvue_type_script_lang_js_ = ({
  name: 'zaCarouselItem',
  props: {
    prefixCls: {
      type: String,
      default: 'za-carousel' // naming different from zarm

    }
  }
});
// CONCATENATED MODULE: ./src/carousel/src/carousel-item.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_carousel_itemvue_type_script_lang_js_ = (carousel_itemvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(0);

// CONCATENATED MODULE: ./src/carousel/src/carousel-item.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  src_carousel_itemvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var carousel_item = (component.exports);
// CONCATENATED MODULE: ./src/carousel-item/index.js

/* istanbul ignore next */

carousel_item.install = function (Vue) {
  Vue.component(carousel_item.name, carousel_item);
};

/* harmony default export */ var src_carousel_item = __webpack_exports__["default"] = (carousel_item);

/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/_vue-loader@15.9.3@vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/_vue-loader@15.9.3@vue-loader/lib??vue-loader-options!./src/keyboard-picker/src/keyboard-picker.vue?vue&type=template&id=8b327140&lang=html&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"prefixCls":_vm.prefixCls},on:{"click":function($event){$event.stopPropagation();return _vm.stopPropagation($event)}}},[_c('za-popup',{ref:"popup",attrs:{"visible":_vm.currentVisible,"get-container":_vm.getContainer,"direction":"bottom","hasMask":false}},[_c('za-keyboard',{attrs:{"type":_vm.type},on:{"keyClick":_vm.onKeyClick}})],1)],1)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/keyboard-picker/src/keyboard-picker.vue?vue&type=template&id=8b327140&lang=html&

// EXTERNAL MODULE: ./src/utils/events.js
var events = __webpack_require__(78);

// EXTERNAL MODULE: ./src/popup/index.js + 3 modules
var popup = __webpack_require__(74);

// EXTERNAL MODULE: ./src/keyboard/index.js + 5 modules
var keyboard = __webpack_require__(158);

// CONCATENATED MODULE: ./node_modules/_babel-loader@8.1.0@babel-loader/lib!./node_modules/_vue-loader@15.9.3@vue-loader/lib??vue-loader-options!./src/keyboard-picker/src/keyboard-picker.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var keyboard_pickervue_type_script_lang_js_ = ({
  name: 'zaKeyboardPicker',
  props: {
    prefixCls: {
      type: String,
      default: 'za-keyboard'
    },
    type: String,
    visible: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      currentVisible: this.visible,
      getContainer: function getContainer() {
        return document.body;
      }
    };
  },
  watch: {
    visible: function visible(val, oldVal) {
      // eslint-disable-line no-unused-vars
      if (this.currentVisible === val) return;
      this.currentVisible = val;
    }
  },
  components: {
    zaPopup: popup["default"],
    zaKeyboard: keyboard["default"]
  },
  methods: {
    stopPropagation: function stopPropagation(e) {
      events["a" /* default */].stopPropagation(e);
    },
    onKeyClick: function onKeyClick(key) {
      if (['ok', 'close'].indexOf(key) > -1) {
        this.onCancel();
      }

      this.$emit('keyClick', key);
    },
    // 切换显示状态
    onCancel: function onCancel() {
      // eslint-disable-next-line
      this.currentVisible = !this.currentVisible;
      this.$emit('update:visible', this.currentVisible);
    }
  }
});
// CONCATENATED MODULE: ./src/keyboard-picker/src/keyboard-picker.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_keyboard_pickervue_type_script_lang_js_ = (keyboard_pickervue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(0);

// CONCATENATED MODULE: ./src/keyboard-picker/src/keyboard-picker.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  src_keyboard_pickervue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var keyboard_picker = (component.exports);
// CONCATENATED MODULE: ./src/keyboard-picker/index.js

/* istanbul ignore next */

keyboard_picker.install = function (Vue) {
  Vue.component(keyboard_picker.name, keyboard_picker);
};

/* harmony default export */ var src_keyboard_picker = __webpack_exports__["default"] = (keyboard_picker);

/***/ }),
/* 171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/_vue-loader@15.9.3@vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/_vue-loader@15.9.3@vue-loader/lib??vue-loader-options!./src/message/src/message.vue?vue&type=template&id=263b747c&lang=html&
var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.currentVisible)?_c('div',{class:( _obj = {}, _obj[("" + _vm.prefixCls)] = true, _obj[(_vm.prefixCls + "--" + _vm.theme)] = !!_vm.theme, _obj[(_vm.prefixCls + "--" + _vm.size)] = !!_vm.size, _obj ),on:{"click":_vm.handleClick}},[_c('div',{class:(_vm.prefixCls + "__header")},[(_vm.$slots.icon || _vm.icon)?_c('div',{class:(_vm.prefixCls + "__icon")},[_vm._t("icon"),_vm._v(" "),(!_vm.$slots.icon)?_c('za-icon',{attrs:{"type":_vm.icon}}):_vm._e()],2):_vm._e()]),_vm._v(" "),_c('div',{class:(_vm.prefixCls + "__body")},[_vm._t("default")],2),_vm._v(" "),(_vm.closable || _vm.hasArrow)?_c('div',{class:(_vm.prefixCls + "__footer")},[(_vm.hasArrow)?_c('za-icon',{attrs:{"type":"arrow-right"}}):_vm._e(),_vm._v(" "),(_vm.closable)?_c('za-icon',{attrs:{"type":"wrong"},on:{"click":_vm.wrongIconClick}}):_vm._e()],1):_vm._e()]):_vm._e()}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/message/src/message.vue?vue&type=template&id=263b747c&lang=html&

// EXTERNAL MODULE: ./src/utils/validator.js
var validator = __webpack_require__(13);

// EXTERNAL MODULE: ./src/icon/index.js
var icon = __webpack_require__(68);

// CONCATENATED MODULE: ./node_modules/_babel-loader@8.1.0@babel-loader/lib!./node_modules/_vue-loader@15.9.3@vue-loader/lib??vue-loader-options!./src/message/src/message.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var messagevue_type_script_lang_js_ = ({
  name: 'zaMessage',
  components: {
    zaIcon: icon["default"]
  },
  props: {
    prefixCls: {
      type: String,
      default: 'za-message'
    },
    theme: {
      type: String,
      validator: validator["a" /* defaultThemeValidator */],
      default: 'primary'
    },
    size: {},
    closable: {
      type: Boolean,
      default: false
    },
    hasArrow: {
      type: Boolean,
      default: false
    },
    visible: {
      type: Boolean,
      default: true
    },
    icon: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      currentVisible: this.visible
    };
  },
  watch: {
    visible: function visible(val) {
      if (val !== this.currentVisible) return;
      this.currentVisible = val;
    }
  },
  methods: {
    handleClick: function handleClick(event) {
      this.$emit('click', event);
    },
    wrongIconClick: function wrongIconClick() {
      this.currentVisible = false;
      this.$emit('update:visible', false);
    }
  }
});
// CONCATENATED MODULE: ./src/message/src/message.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_messagevue_type_script_lang_js_ = (messagevue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(0);

// CONCATENATED MODULE: ./src/message/src/message.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  src_messagevue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var message = (component.exports);
// CONCATENATED MODULE: ./src/message/index.js

/* istanbul ignore next */

message.install = function (Vue) {
  Vue.component(message.name, message);
};

/* harmony default export */ var src_message = __webpack_exports__["default"] = (message);

/***/ }),
/* 172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./src/utils/vdom.js
var vdom = __webpack_require__(118);

// EXTERNAL MODULE: ./src/drag/index.js + 3 modules
var drag = __webpack_require__(95);

// CONCATENATED MODULE: ./node_modules/_babel-loader@8.1.0@babel-loader/lib!./node_modules/_vue-loader@15.9.3@vue-loader/lib??vue-loader-options!./src/carousel/src/carousel.vue?vue&type=script&lang=js&


/* harmony default export */ var carouselvue_type_script_lang_js_ = ({
  name: 'zaCarousel',
  components: {
    zaDrag: drag["default"]
  },
  props: {
    prefixCls: {
      type: String,
      default: 'za-carousel' // naming different from zarm

    },
    direction: {
      type: String,
      validator: function validator(v) {
        // eslint-disable-line object-shorthand
        return ['left', 'right', 'top', 'bottom'].indexOf(v) >= 0;
      },
      default: 'left'
    },
    height: {
      type: [Number, String],
      default: '100%'
    },
    loop: {
      type: Boolean,
      default: false
    },
    activeIndex: {
      type: Number,
      default: 0
    },
    speed: {
      type: Number,
      default: 300
    },
    swipeable: {
      type: Boolean,
      default: true
    },
    autoPlay: {
      type: Boolean,
      default: false
    },
    autoPlayIntervalTime: {
      type: Number,
      default: 3000
    },
    moveDistanceRatio: {
      type: Number,
      default: 0.5
    },
    moveTimeSpan: {
      type: Number,
      default: 300
    },
    showPagination: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    itemsStyle: function itemsStyle() {
      return {
        height: !this.isX && "".concat(this.height),
        whiteSpace: this.isX && 'nowrap'
      };
    },
    paginationStyle: function paginationStyle() {
      return {
        display: this.isX && 'inline-block'
      };
    },
    isX: function isX() {
      return ['left', 'right'].indexOf(this.direction) > -1;
    }
  },
  data: function data() {
    return {
      currentActiveIndex: this.activeIndex
    };
  },
  watch: {
    activeIndex: function activeIndex(val, oldval) {
      // eslint-disable-line no-unused-vars
      if (val === this.currentActiveIndex) return;
      this.currentActiveIndex = val;
      this.onSlideTo(this.currentActiveIndex);
    }
  },
  mounted: function mounted() {
    this.startAutoPlay();
    window.addEventListener('resize', this.resize);
    this.$refs.carouselItems.addEventListener('webkitTransitionEnd', this.transitionEnd);
    this.$refs.carouselItems.addEventListener('transitionend', this.transitionEnd); // 设置起始位置编号

    this.onJumpTo(this.currentActiveIndex);
  },
  created: function created() {
    // this.dragState = {};
    this.scrolling = false; // is user scrolling page instead of dragging

    this.translateX = 0;
    this.translateY = 0;
    this.moveInterval = null;
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.resize);
    this.$refs.carouselItems.removeEventListener('webkitTransitionEnd', this.transitionEnd);
    this.$refs.carouselItems.removeEventListener('transitionend', this.transitionEnd);
  },
  methods: {
    onDragStart: function onDragStart() {
      // 如果禁用滑动，屏蔽drag行为
      if (!this.swipeable) return;
      this.scrolling = false; // 如果正好在transition动画中，跳转到头尾

      var activeIndex = this.currentActiveIndex;
      var maxLength = this.validSlotLength();

      if (activeIndex <= 0) {
        this.onJumpTo(0);
      } else if (activeIndex >= maxLength - 1) {
        this.onJumpTo(maxLength - 1);
      } // 暂停自动轮播


      this.pauseAutoPlay();
    },
    onDragMove: function onDragMove(event, _ref) {
      var offsetX = _ref.offsetX,
          offsetY = _ref.offsetY;
      // 如果禁用滑动，屏蔽drag行为
      if (!this.swipeable) return;
      var distanceX = Math.abs(offsetX);
      var distanceY = Math.abs(offsetY);

      if (this.isX && (distanceX < 5 || distanceX >= 5 && distanceY >= 1.73 * distanceX)) {
        this.scrolling = true;
        return;
      }

      if (!this.isX && (distanceY < 5 || distanceY >= 5 && distanceX >= 1.73 * distanceY)) {
        this.scrolling = true;
        return;
      }

      this.scrolling = false; // 设置不循环的时候

      if (!this.loop) {
        // 在尾页时禁止拖动
        if (this.isLastIndex()) {
          if (this.isX && offsetX < 0) return;
          if (!this.isX && offsetY < 0) return;
        } // 在首页时禁止拖动


        if (this.isFirstIndex()) {
          if (this.isX && offsetX > 0) return;
          if (!this.isX && offsetY > 0) return;
        }
      }

      event.preventDefault();
      this.doTransition({
        x: this.translateX + offsetX,
        y: this.translateY + offsetY
      }, 0);
      return true;
    },
    onDragEnd: function onDragEnd(event, _ref2) {
      var offsetX = _ref2.offsetX,
          offsetY = _ref2.offsetY,
          startTime = _ref2.startTime;
      // eslint-disable-line no-unused-vars
      // 如果禁用滑动，屏蔽drag行为
      if (!this.swipeable) return;

      if (this.scrolling || !offsetX && !offsetY) {
        this.scrolling = false;
        return;
      }

      var dom = this.$refs.carouselItems;
      var moveDistanceRatio = this.isX ? Math.abs(offsetX / dom.offsetWidth) : Math.abs(offsetY / dom.offsetHeight);
      var timeSpan = new Date().getTime() - startTime.getTime();
      var activeIndex = this.currentActiveIndex; // 判断滑动临界点
      // 1.滑动距离超过0，且滑动距离和父容器长度之比超过moveDistanceRatio
      // 2.滑动释放时间差低于moveTimeSpan =>快速滑动

      if (moveDistanceRatio >= this.moveDistanceRatio || timeSpan <= this.moveTimeSpan) {
        activeIndex = this.isX && offsetX > 0 || !this.isX && offsetY > 0 ? this.currentActiveIndex - 1 : this.currentActiveIndex + 1;
      }

      this.onSlideTo(activeIndex); // change from here

      this.$emit('change', activeIndex); // 恢复自动轮播

      this.startAutoPlay();
    },
    // 自动轮播开始
    startAutoPlay: function startAutoPlay() {
      var _this = this;

      this.moveInterval = this.autoPlay && setInterval(function () {
        var activeIndex = _this.currentActiveIndex;

        var maxLength = _this.validSlotLength();

        var isLeftTop = ['left', 'top'].indexOf(_this.direction) > -1;
        activeIndex = isLeftTop ? activeIndex + 1 : activeIndex - 1;
        var isEnd = isLeftTop && activeIndex === maxLength || !isLeftTop && activeIndex === -1; // 不循环暂停轮播

        if (!_this.loop && isEnd) {
          _this.pauseAutoPlay();

          return;
        }

        _this.onSlideTo(activeIndex);
      }, this.autoPlayIntervalTime);
    },
    // 暂停自动轮播
    pauseAutoPlay: function pauseAutoPlay() {
      if (this.moveInterval) {
        clearInterval(this.moveInterval);
      }
    },
    // 滑动到指定编号
    onSlideTo: function onSlideTo(index) {
      this.$emit('changeStart', this.currentActiveIndex);
      this.onMoveTo(index, this.speed);
    },
    // 静默跳到指定编号
    onJumpTo: function onJumpTo(index) {
      this.onMoveTo(index, 0);
      this.$emit('change', index);
    },
    // 移动到指定编号的位置
    onMoveTo: function onMoveTo(index, speed) {
      var dom = this.$refs.carouselItems;
      if (!dom) return;
      this.translateX = -dom.offsetWidth * (index + this.loop);
      this.translateY = -dom.offsetHeight * (index + this.loop);
      this.doTransition({
        x: this.translateX,
        y: this.translateY
      }, speed);
      var maxLength = this.validSlotLength();

      if (index > maxLength - 1) {
        index = 0;
      } else if (index < 0) {
        index = maxLength - 1;
      }

      this.currentActiveIndex = index;
    },
    // 执行过渡动画
    doTransition: function doTransition(offset, duration) {
      var dom = this.$refs.carouselItems;
      var x = 0;
      var y = 0;

      if (this.isX) {
        x = offset.x;
      } else {
        y = offset.y;
      }

      dom.style.webkitTransitionDuration = "".concat(duration, "ms");
      dom.style.transitionDuration = "".concat(duration, "ms");
      dom.style.webkitTransform = "translate3d(".concat(x, "px, ").concat(y, "px, 0)");
      dom.style.transform = "translate3d(".concat(x, "px, ").concat(y, "px, 0)");
    },
    transitionEnd: function transitionEnd() {
      var activeIndex = this.currentActiveIndex;
      var dom = this.$refs.carouselItems;
      this.translateX = -dom.offsetWidth * (activeIndex + this.loop);
      this.translateY = -dom.offsetHeight * (activeIndex + this.loop);
      this.doTransition({
        x: this.translateX,
        y: this.translateY
      }, 0);
      this.$emit('changeEnd', this.currentActiveIndex); // this.$emit('change', this.currentActiveIndex);
    },
    resize: function resize() {
      this.onJumpTo(this.currentActiveIndex);
    },
    isLastIndex: function isLastIndex() {
      return this.currentActiveIndex >= this.validSlotLength() - 1;
    },
    isFirstIndex: function isFirstIndex() {
      return this.currentActiveIndex <= 0;
    },
    // remove text vnode
    validSlotLength: function validSlotLength() {
      // carousel use carousel-item as direct children
      return this.validSlots().length;
    },
    validSlots: function validSlots() {
      // fix tabs use cancarousel bug
      return this.$slots.default.filter(function (d) {
        return d.componentOptions && (d.componentOptions.tag === 'za-carousel-item' || d.componentOptions.tag === 'za-tab-panel');
      });
    }
  },
  render: function render(h) {
    var prefixCls = this.prefixCls,
        itemsStyle = this.itemsStyle,
        onDragStart = this.onDragStart,
        onDragMove = this.onDragMove,
        onDragEnd = this.onDragEnd,
        currentActiveIndex = this.currentActiveIndex,
        paginationStyle = this.paginationStyle,
        loop = this.loop,
        isX = this.isX,
        showPagination = this.showPagination,
        validSlots = this.validSlots;
    var directionCls = isX ? "".concat(prefixCls, " ").concat(prefixCls, "--horizontal") : "".concat(prefixCls, " ").concat(prefixCls, "--vertical");
    var pagination = this.$slots.default.map(function (item, index) {
      return h("li", {
        attrs: {
          role: 'tab'
        },
        key: "pagination-".concat(index),
        "class": index === currentActiveIndex ? "".concat(prefixCls, "__pagination--active") : '',
        style: paginationStyle
      });
    });
    var validChildren = validSlots();

    if (loop && !this.firstItem && !this.lastItem) {
      this.firstItem = Object(vdom["a" /* deepCloneVNode */])(h, this.$slots.default[0]);
      this.lastItem = Object(vdom["a" /* deepCloneVNode */])(h, validChildren[validChildren.length - 1]);
    }

    return h("div", {
      "class": directionCls
    }, [h("za-drag", {
      attrs: {
        dragStart: onDragStart,
        dragMove: onDragMove,
        dragEnd: onDragEnd
      }
    }, [h("div", {
      ref: 'carouselItems',
      "class": "".concat(prefixCls, "__items"),
      style: itemsStyle
    }, [this.lastItem, this.$slots.default, this.firstItem])]), showPagination && h("div", {
      "class": "".concat(prefixCls, "__pagination")
    }, [h("ul", [pagination])])]);
  }
});
// CONCATENATED MODULE: ./src/carousel/src/carousel.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_carouselvue_type_script_lang_js_ = (carouselvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(0);

// CONCATENATED MODULE: ./src/carousel/src/carousel.vue
var carousel_render, staticRenderFns




/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  src_carouselvue_type_script_lang_js_,
  carousel_render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var carousel = (component.exports);
// CONCATENATED MODULE: ./src/carousel/index.js

/* istanbul ignore next */

carousel.install = function (Vue) {
  Vue.component(carousel.name, carousel);
};

/* harmony default export */ var src_carousel = __webpack_exports__["default"] = (carousel);

/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * find parent component by name
 */
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      parent: null
    };
  },
  methods: {
    findParent: function findParent(name) {
      var parent = this.$parent;

      while (parent) {
        if (parent.$options.name === name) {
          this.parent = parent;
          break;
        }

        parent = parent.$parent;
      }
    }
  }
});

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(175);
module.exports = __webpack_require__(1).Date.now;


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.3.1 / 15.9.4.4 Date.now()
var $export = __webpack_require__(9);

$export($export.S, 'Date', { now: function () { return new Date().getTime(); } });


/***/ }),
/* 176 */
/***/ (function(module, exports) {

module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(178);
module.exports = __webpack_require__(1).Number.isNaN;


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.4 Number.isNaN(number)
var $export = __webpack_require__(9);

$export($export.S, 'Number', {
  isNaN: function isNaN(number) {
    // eslint-disable-next-line no-self-compare
    return number != number;
  }
});


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

var _Object$keys = __webpack_require__(46);

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};

  var sourceKeys = _Object$keys(source);

  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

module.exports = _objectWithoutPropertiesLoose;

/***/ }),
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: external "vue"
var external_vue_ = __webpack_require__(64);
var external_vue_default = /*#__PURE__*/__webpack_require__.n(external_vue_);

// CONCATENATED MODULE: ./node_modules/_vue-loader@15.9.3@vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/_vue-loader@15.9.3@vue-loader/lib??vue-loader-options!./src/loading/src/loading.vue?vue&type=template&id=225ca1d4&lang=html&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('za-toast',{attrs:{"prefixCls":_vm.prefixCls,"visible":_vm.currentVisible,"duration":0},on:{"update:visible":function($event){_vm.currentVisible=$event}}},[_c('za-activity-indicator',{staticClass:"rotate360",attrs:{"size":"lg"}})],1)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/loading/src/loading.vue?vue&type=template&id=225ca1d4&lang=html&

// EXTERNAL MODULE: ./src/toast/index.js + 5 modules
var toast = __webpack_require__(168);

// EXTERNAL MODULE: ./src/activity-indicator/index.js + 5 modules
var activity_indicator = __webpack_require__(93);

// CONCATENATED MODULE: ./node_modules/_babel-loader@8.1.0@babel-loader/lib!./node_modules/_vue-loader@15.9.3@vue-loader/lib??vue-loader-options!./src/loading/src/loading.vue?vue&type=script&lang=js&
//
//
//
//
//
//


/* harmony default export */ var loadingvue_type_script_lang_js_ = ({
  name: 'zaLoading',
  components: {
    zaToast: toast["default"],
    zaActivityIndicator: activity_indicator["default"]
  },
  props: {
    prefixCls: {
      type: String,
      default: 'za-loading'
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    currentVisible: {
      get: function get() {
        return this.visible;
      },
      set: function set(val) {
        this.$emit('update:visible', val);
      }
    }
  }
});
// CONCATENATED MODULE: ./src/loading/src/loading.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_loadingvue_type_script_lang_js_ = (loadingvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(0);

// CONCATENATED MODULE: ./src/loading/src/loading.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  src_loadingvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var loading = (component.exports);
// CONCATENATED MODULE: ./src/loading/src/directive.js


var directive_install = function install(Vue) {
  var LoadingConstructor = Vue.extend(loading);

  var toggleLoading = function toggleLoading(el, binding) {
    if (binding.value) {
      Vue.nextTick(function () {
        document.body.appendChild(el.instance.$el);
        el.domInserted = true;
        Vue.nextTick(function () {
          el.instance.visible = true;
        });
      });
    } else {
      el.instance.visible = false;
    }
  };

  Vue.directive('zaLoading', {
    bind: function bind(el, binding) {
      // eslint-disable-line
      var loading = new LoadingConstructor({
        el: document.createElement('div'),
        props: {
          visible: binding.value
        }
      });
      el.instance = loading;
      toggleLoading(el, binding);
    },
    update: function update(el, binding) {
      if (binding.oldValue !== binding.value) {
        toggleLoading(el, binding);
      }
    },
    unbind: function unbind(el, binding) {
      // eslint-disable-line
      if (el.domInserted) {
        document.body.removeChild(el.instance.$el);
      }
    }
  });
};

/* harmony default export */ var directive = (directive_install);
// CONCATENATED MODULE: ./src/loading/index.js



/* istanbul ignore next */

loading.install = function (Vue) {
  // eslint-disable-line
  Vue.component(loading.name, loading);
};

var instance;
var loading_LoadingConstructor = external_vue_default.a.extend(loading);

var initInstance = function initInstance() {
  instance = new loading_LoadingConstructor({
    el: document.createElement('div')
  });
};

loading.root = function () {
  /* istanbul ignore if */
  if (external_vue_default.a.prototype.$isServer) return;

  if (!instance) {
    initInstance();

    instance.close = function () {
      instance.visible = false;
    };
  }

  document.body.appendChild(instance.$el);
  external_vue_default.a.nextTick(function () {
    instance.visible = true;
  });
  return instance;
};

loading.directive = directive;
/* harmony default export */ var src_loading = __webpack_exports__["default"] = (loading);

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(237);

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(9);
var defined = __webpack_require__(20);
var fails = __webpack_require__(12);
var spaces = __webpack_require__(176);
var space = '[' + spaces + ']';
var non = '\u200b\u0085';
var ltrim = RegExp('^' + space + space + '*');
var rtrim = RegExp(space + space + '*$');

var exporter = function (KEY, exec, ALIAS) {
  var exp = {};
  var FORCE = fails(function () {
    return !!spaces[KEY]() || non[KEY]() != non;
  });
  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
  if (ALIAS) exp[ALIAS] = fn;
  $export($export.P + $export.F * FORCE, 'String', exp);
};

// 1 -> String#trimLeft
// 2 -> String#trimRight
// 3 -> String#trim
var trim = exporter.trim = function (string, TYPE) {
  string = String(defined(string));
  if (TYPE & 1) string = string.replace(ltrim, '');
  if (TYPE & 2) string = string.replace(rtrim, '');
  return string;
};

module.exports = exporter;


/***/ }),
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/_@babel_runtime-corejs2@7.11.2@@babel/runtime-corejs2/core-js/object/keys.js
var keys = __webpack_require__(46);
var keys_default = /*#__PURE__*/__webpack_require__.n(keys);

// EXTERNAL MODULE: ./node_modules/_@babel_runtime-corejs2@7.11.2@@babel/runtime-corejs2/helpers/typeof.js
var helpers_typeof = __webpack_require__(58);
var typeof_default = /*#__PURE__*/__webpack_require__.n(helpers_typeof);

// EXTERNAL MODULE: external "vue"
var external_vue_ = __webpack_require__(64);
var external_vue_default = /*#__PURE__*/__webpack_require__.n(external_vue_);

// EXTERNAL MODULE: ./src/utils/vdom.js
var vdom = __webpack_require__(118);

// CONCATENATED MODULE: ./node_modules/_vue-loader@15.9.3@vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/_vue-loader@15.9.3@vue-loader/lib??vue-loader-options!./src/alert/src/alert.vue?vue&type=template&id=8ea3dd1e&lang=html&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('za-modal',{ref:"modal",attrs:{"get-container":_vm.getContainer,"closeOnClickModal":false,"visible":_vm.currentVisible,"radius":_vm.radius,"animationDuration":_vm.animationDuration,"title":_vm.title}},[_c('div',{class:_vm.prefixCls},[(!_vm.$slots.default)?[_vm._v(_vm._s(_vm.message))]:_vm._e(),_vm._v(" "),_vm._t("default")],2),_vm._v(" "),_c('template',{slot:"footer"},[_c('za-button',{attrs:{"block":"","ghost":""},on:{"click":_vm.handleClose}},[_vm._v(_vm._s(_vm.cancelText || _vm.cancelBtnText))])],1)],2)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/alert/src/alert.vue?vue&type=template&id=8ea3dd1e&lang=html&

// EXTERNAL MODULE: ./src/utils/locale.js
var locale = __webpack_require__(147);

// EXTERNAL MODULE: ./src/modal/index.js + 5 modules
var modal = __webpack_require__(145);

// EXTERNAL MODULE: ./src/button/index.js + 5 modules
var src_button = __webpack_require__(114);

// CONCATENATED MODULE: ./node_modules/_babel-loader@8.1.0@babel-loader/lib!./node_modules/_vue-loader@15.9.3@vue-loader/lib??vue-loader-options!./src/alert/src/alert.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var alertvue_type_script_lang_js_ = ({
  name: 'zaAlert',
  inject: {
    localeProvider: {
      default: ''
    }
  },
  components: {
    zaModal: modal["default"],
    zaButton: src_button["default"]
  },
  props: {
    prefixCls: {
      type: String,
      default: 'za-alert'
    },
    message: String,
    title: String,
    cancelText: {
      type: String,
      default: ''
    },
    visible: {
      type: Boolean,
      default: false
    },
    radius: {
      type: Boolean,
      default: false
    },
    animationDuration: {
      type: Number,
      default: 200
    }
  },
  computed: {
    cancelBtnText: function cancelBtnText() {
      return this.localeProvider.lang ? this.getLocales('cancelText') : '关闭';
    }
  },
  methods: {
    // 国际化
    getLocales: function getLocales(key) {
      return locale["a" /* default */].getLocaleByComponent(this.localeProvider, 'Alert', key);
    },
    handleClose: function handleClose(event) {
      this.$refs.modal.leave('modal-close', event);
      this.$emit('update:visible', false);
      this.$emit('close', event); // for prototype alert

      this.currentVisible = false;
    }
  },
  watch: {
    visible: function visible(value, oldValue) {
      // eslint-disable-line no-unused-vars, object-shorthand
      if (value === this.currentVisible) return;
      this.currentVisible = value;
    }
  },
  data: function data() {
    return {
      currentVisible: this.visible,
      getContainer: function getContainer() {
        return document.body;
      }
    };
  }
});
// CONCATENATED MODULE: ./src/alert/src/alert.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_alertvue_type_script_lang_js_ = (alertvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(0);

// CONCATENATED MODULE: ./src/alert/src/alert.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  src_alertvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var src_alert = (component.exports);
// CONCATENATED MODULE: ./src/alert/index.js





/* istanbul ignore next */

src_alert.install = function (Vue) {
  // eslint-disable-line
  Vue.component(src_alert.name, src_alert);
};

var instance;
var AlertConstructor = external_vue_default.a.extend(src_alert);

var initInstance = function initInstance() {
  instance = new AlertConstructor({
    el: document.createElement('div')
  });
};

src_alert.root = function (message, options) {
  /* istanbul ignore if */
  if (external_vue_default.a.prototype.$isServer) return;
  options = options || {};

  if (typeof_default()(message) === 'object' && !Object(vdom["b" /* default */])(message)) {
    options = message;
    message = '';
  } else {
    options.message = message;
  }

  if (!instance) {
    initInstance();
  }

  keys_default()(options).forEach(function (key) {
    instance[key] = options[key];
  });

  if (Object(vdom["b" /* default */])(instance.message)) {
    instance.$slots.default = [instance.message];
    instance.message = null;
  } else {
    delete instance.$slots.default;
  }

  document.body.appendChild(instance.$el);
  instance.$off();
  instance.$on('close', function (event) {
    instance.callback && instance.callback.call(instance, event);
  });
  external_vue_default.a.nextTick(function () {
    instance.currentVisible = true;
  });
};

/* harmony default export */ var src_alert_0 = __webpack_exports__["default"] = (src_alert);

/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/_@babel_runtime-corejs2@7.11.2@@babel/runtime-corejs2/core-js/object/keys.js
var keys = __webpack_require__(46);
var keys_default = /*#__PURE__*/__webpack_require__.n(keys);

// EXTERNAL MODULE: ./node_modules/_@babel_runtime-corejs2@7.11.2@@babel/runtime-corejs2/helpers/typeof.js
var helpers_typeof = __webpack_require__(58);
var typeof_default = /*#__PURE__*/__webpack_require__.n(helpers_typeof);

// EXTERNAL MODULE: external "vue"
var external_vue_ = __webpack_require__(64);
var external_vue_default = /*#__PURE__*/__webpack_require__.n(external_vue_);

// EXTERNAL MODULE: ./src/utils/vdom.js
var vdom = __webpack_require__(118);

// CONCATENATED MODULE: ./node_modules/_vue-loader@15.9.3@vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/_vue-loader@15.9.3@vue-loader/lib??vue-loader-options!./src/confirm/src/confirm.vue?vue&type=template&id=287bb7e3&lang=html&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('za-modal',{ref:"modal",attrs:{"get-container":_vm.getContainer,"closeOnClickModal":false,"visible":_vm.currentVisible,"radius":_vm.radius,"animationDuration":_vm.animationDuration,"title":_vm.title}},[_c('div',{class:_vm.prefixCls},[(!_vm.$slots.default)?[_vm._v(_vm._s(_vm.message))]:_vm._e(),_vm._v(" "),_vm._t("default")],2),_vm._v(" "),_c('template',{slot:"footer"},[_c('za-button',{attrs:{"block":"","ghost":""},on:{"click":_vm.cancel}},[_vm._v(_vm._s(_vm.cancelText || _vm.cancelBtnText))]),_vm._v(" "),_c('za-button',{attrs:{"block":"","ghost":"","theme":"primary"},on:{"click":_vm.ok}},[_vm._v(_vm._s(_vm.okText || _vm.okBtnText))])],1)],2)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/confirm/src/confirm.vue?vue&type=template&id=287bb7e3&lang=html&

// EXTERNAL MODULE: ./src/utils/locale.js
var locale = __webpack_require__(147);

// EXTERNAL MODULE: ./src/modal/index.js + 5 modules
var modal = __webpack_require__(145);

// EXTERNAL MODULE: ./src/button/index.js + 5 modules
var src_button = __webpack_require__(114);

// CONCATENATED MODULE: ./node_modules/_babel-loader@8.1.0@babel-loader/lib!./node_modules/_vue-loader@15.9.3@vue-loader/lib??vue-loader-options!./src/confirm/src/confirm.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var confirmvue_type_script_lang_js_ = ({
  name: 'zaConfirm',
  components: {
    zaModal: modal["default"],
    zaButton: src_button["default"]
  },
  inject: {
    localeProvider: {
      default: ''
    }
  },
  props: {
    prefixCls: {
      type: String,
      default: 'za-confirm'
    },
    message: String,
    title: String,
    cancelText: {
      type: String,
      default: ''
    },
    okText: {
      type: String,
      default: ''
    },
    visible: {
      type: Boolean,
      default: false
    },
    radius: {
      type: Boolean,
      default: true
    },
    animationDuration: {
      type: Number,
      default: 200
    },
    ok: {
      type: Function,
      default: function _default() {}
    },
    cancel: {
      type: Function,
      default: function _default() {}
    }
  },
  computed: {
    cancelBtnText: function cancelBtnText() {
      return this.localeProvider.lang ? this.getLocales('cancelText') : '关闭';
    },
    okBtnText: function okBtnText() {
      return this.localeProvider.lang ? this.getLocales('okText') : '确定';
    }
  },
  watch: {
    visible: function visible(value, oldValue) {
      // eslint-disable-line
      if (value === this.currentVisible) return;
      this.currentVisible = value;
    }
  },
  data: function data() {
    return {
      currentVisible: this.visible,
      getContainer: function getContainer() {
        return document.body;
      }
    };
  },
  methods: {
    // 国际化
    getLocales: function getLocales(key) {
      return locale["a" /* default */].getLocaleByComponent(this.localeProvider, 'Confirm', key);
    }
  }
});
// CONCATENATED MODULE: ./src/confirm/src/confirm.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_confirmvue_type_script_lang_js_ = (confirmvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(0);

// CONCATENATED MODULE: ./src/confirm/src/confirm.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  src_confirmvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var src_confirm = (component.exports);
// CONCATENATED MODULE: ./src/confirm/index.js





/* istanbul ignore next */

src_confirm.install = function (Vue) {
  // eslint-disable-line
  Vue.component(src_confirm.name, src_confirm);
};

var instance;
var ConfirmConstructor = external_vue_default.a.extend(src_confirm);

var noop = function noop() {
  return true;
};

var initInstance = function initInstance() {
  instance = new ConfirmConstructor({
    el: document.createElement('div')
  });
};

src_confirm.root = function (message, options) {
  /* istanbul ignore if */
  if (external_vue_default.a.prototype.$isServer) return;
  options = options || {};

  if (typeof_default()(message) === 'object' && !Object(vdom["b" /* default */])(message)) {
    options = message;
    message = '';
  } else {
    options.message = message;
  }

  if (!instance) {
    initInstance();
  }

  keys_default()(options).forEach(function (key) {
    instance[key] = options[key];
  });

  if (Object(vdom["b" /* default */])(instance.message)) {
    instance.$slots.default = [instance.message];
    instance.message = null;
  } else {
    delete instance.$slots.default;
  }

  document.body.appendChild(instance.$el);
  var ok = instance.ok || noop;
  var cancel = instance.cancel || noop;

  instance.ok = function (evt) {
    var shouldClose = ok(evt);

    if (shouldClose) {
      instance.visible = false;
      instance.ok = noop;
    }
  };

  instance.cancel = function (evt) {
    instance.visible = false;
    cancel(evt);
    instance.cancel = noop;
  };

  external_vue_default.a.nextTick(function () {
    instance.visible = true;
  });
};

/* harmony default export */ var src_confirm_0 = __webpack_exports__["default"] = (src_confirm);

/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _src_date_picker__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(134);

/* istanbul ignore next */

_src_date_picker__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].install = function (Vue) {
  Vue.component(_src_date_picker__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].name, _src_date_picker__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"]);
};

/* harmony default export */ __webpack_exports__["default"] = (_src_date_picker__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"]);

/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_corejs2_core_js_object_assign__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(116);
/* harmony import */ var _babel_runtime_corejs2_core_js_object_assign__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_corejs2_core_js_object_assign__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _date_picker_src_date_picker__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(134);



var DateSelect = _babel_runtime_corejs2_core_js_object_assign__WEBPACK_IMPORTED_MODULE_0___default()({}, _date_picker_src_date_picker__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"]);

DateSelect.name = 'zaDateSelect';
/* istanbul ignore next */

DateSelect.install = function (Vue) {
  Vue.component(DateSelect.name, DateSelect);
};

/* harmony default export */ __webpack_exports__["default"] = (DateSelect);

/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _src_input__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(136);

/* istanbul ignore next */

_src_input__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].install = function (Vue) {
  Vue.component(_src_input__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].name, _src_input__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"]);
};

/* harmony default export */ __webpack_exports__["default"] = (_src_input__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"]);

/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _src_picker__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(135);

/* istanbul ignore next */

_src_picker__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].install = function (Vue) {
  Vue.component(_src_picker__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].name, _src_picker__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"]);
};

/* harmony default export */ __webpack_exports__["default"] = (_src_picker__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"]);

/***/ }),
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_corejs2_core_js_object_assign__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(116);
/* harmony import */ var _babel_runtime_corejs2_core_js_object_assign__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_corejs2_core_js_object_assign__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _picker_src_picker__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(135);



var Select = _babel_runtime_corejs2_core_js_object_assign__WEBPACK_IMPORTED_MODULE_0___default()({}, _picker_src_picker__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"]);

Select.name = 'zaSelect';
/* istanbul ignore next */

Select.install = function (Vue) {
  Vue.component(Select.name, Select);
};

/* harmony default export */ __webpack_exports__["default"] = (Select);

/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _src_stack_picker__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(137);

/* istanbul ignore next */

_src_stack_picker__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].install = function (Vue) {
  Vue.component(_src_stack_picker__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].name, _src_stack_picker__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"]);
};

/* harmony default export */ __webpack_exports__["default"] = (_src_stack_picker__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"]);

/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_corejs2_core_js_object_assign__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(116);
/* harmony import */ var _babel_runtime_corejs2_core_js_object_assign__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_corejs2_core_js_object_assign__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _stack_picker_src_stack_picker__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(137);



var StackSelect = _babel_runtime_corejs2_core_js_object_assign__WEBPACK_IMPORTED_MODULE_0___default()({}, _stack_picker_src_stack_picker__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"]);

StackSelect.name = 'zaStackSelect';
/* istanbul ignore next */

StackSelect.install = function (Vue) {
  Vue.component(StackSelect.name, StackSelect);
};

/* harmony default export */ __webpack_exports__["default"] = (StackSelect);

/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/_vue-loader@15.9.3@vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/_vue-loader@15.9.3@vue-loader/lib??vue-loader-options!./src/locale-provider/src/locale-provider.vue?vue&type=template&id=8da7ecaa&
var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:( _obj = {}, _obj[("" + _vm.prefixCls)] = true, _obj )},[_vm._t("default")],2)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/locale-provider/src/locale-provider.vue?vue&type=template&id=8da7ecaa&

// CONCATENATED MODULE: ./src/alert/locale/zh_CN.js
/* istanbul ignore next */
var localeProps = {
  cancelText: '关闭'
};
/* harmony default export */ var zh_CN = (localeProps);
// CONCATENATED MODULE: ./src/confirm/locale/zh_CN.js
/* istanbul ignore next */
var zh_CN_localeProps = {
  cancelText: '关闭',
  okText: '确定'
};
/* harmony default export */ var locale_zh_CN = (zh_CN_localeProps);
// CONCATENATED MODULE: ./src/search-bar/locale/zh_CN.js
/* istanbul ignore next */
var locale_zh_CN_localeProps = {
  placeholder: '搜索',
  cancelText: '取消'
};
/* harmony default export */ var search_bar_locale_zh_CN = (locale_zh_CN_localeProps);
// CONCATENATED MODULE: ./src/locale-provider/locale/zh_CN.js



var Locale = {
  Alert: zh_CN,
  Confirm: locale_zh_CN,
  SearchBar: search_bar_locale_zh_CN
};
/* harmony default export */ var locale_provider_locale_zh_CN = (Locale);
// CONCATENATED MODULE: ./src/alert/locale/en_US.js
/* istanbul ignore next */
var en_US_localeProps = {
  cancelText: 'Close'
};
/* harmony default export */ var en_US = (en_US_localeProps);
// CONCATENATED MODULE: ./src/confirm/locale/en_US.js
/* istanbul ignore next */
var locale_en_US_localeProps = {
  cancelText: 'Close',
  okText: 'Ok'
};
/* harmony default export */ var locale_en_US = (locale_en_US_localeProps);
// CONCATENATED MODULE: ./src/search-bar/locale/en_US.js
/* istanbul ignore next */
var search_bar_locale_en_US_localeProps = {
  placeholder: 'Search',
  cancelText: 'Cancel'
};
/* harmony default export */ var search_bar_locale_en_US = (search_bar_locale_en_US_localeProps);
// CONCATENATED MODULE: ./src/locale-provider/locale/en_US.js



var en_US_Locale = {
  Alert: en_US,
  Confirm: locale_en_US,
  SearchBar: search_bar_locale_en_US
};
/* harmony default export */ var locale_provider_locale_en_US = (en_US_Locale);
// CONCATENATED MODULE: ./src/locale-provider/src/default.js

 // 父级组件提供 'locale'

var LocaleProvider = {
  zh_CN: locale_provider_locale_zh_CN,
  en_US: locale_provider_locale_en_US
};
/* harmony default export */ var src_default = (LocaleProvider);
// CONCATENATED MODULE: ./node_modules/_babel-loader@8.1.0@babel-loader/lib!./node_modules/_vue-loader@15.9.3@vue-loader/lib??vue-loader-options!./src/locale-provider/src/locale-provider.vue?vue&type=script&lang=js&
//
//
//
//
//

/* harmony default export */ var locale_providervue_type_script_lang_js_ = ({
  name: 'zaLocaleProvider',
  props: {
    prefixCls: {
      type: String,
      default: 'za-locale-provider'
    },
    locale: {
      type: Object,
      default: function _default() {
        return src_default;
      }
    },
    lang: {
      type: String,
      default: 'zh_CN'
    }
  },
  provide: function provide() {
    return {
      localeProvider: this
    };
  }
});
// CONCATENATED MODULE: ./src/locale-provider/src/locale-provider.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_locale_providervue_type_script_lang_js_ = (locale_providervue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(0);

// CONCATENATED MODULE: ./src/locale-provider/src/locale-provider.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  src_locale_providervue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var locale_provider = (component.exports);
// CONCATENATED MODULE: ./src/locale-provider/index.js

/* istanbul ignore next */

locale_provider.install = function (Vue) {
  Vue.component(locale_provider.name, locale_provider);
};

/* harmony default export */ var src_locale_provider = __webpack_exports__["default"] = (locale_provider);

/***/ }),
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/_@babel_runtime-corejs2@7.11.2@@babel/runtime-corejs2/core-js/array/from.js
var from = __webpack_require__(92);
var from_default = /*#__PURE__*/__webpack_require__.n(from);

// EXTERNAL MODULE: ./node_modules/_@babel_runtime-corejs2@7.11.2@@babel/runtime-corejs2/core-js/object/keys.js
var keys = __webpack_require__(46);
var keys_default = /*#__PURE__*/__webpack_require__.n(keys);

// CONCATENATED MODULE: ./src/calendar/src/utils.js


var ONEDAYTIMESTAP = 24 * 60 * 60 * 1000;
var disabledFuc;

var getTodayBeginTime = function getTodayBeginTime(date) {
  date = new Date(date.getTime());
  date.setHours(0);
  date.setMinutes(0);
  date.setSeconds(0);
  date.setMilliseconds(0);
  return date;
};

var getNumMouthBeginDate = function getNumMouthBeginDate(date) {
  var nextNum = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  date = new Date(date.getTime());
  date.setDate(1);
  date.setMonth(date.getMonth() + nextNum);
  return date;
};

var getMonthDateCount = function getMonthDateCount(date) {
  var currentMonthBeginDate = getNumMouthBeginDate(date, 0);
  var nextMonthBeginDate = getNumMouthBeginDate(date, 1);
  return (nextMonthBeginDate.getTime() - currentMonthBeginDate.getTime()) / ONEDAYTIMESTAP;
};

var availableDate = function availableDate(date) {
  return date.toString() !== 'Invalid Date';
};

var utils_dateFormat = function dateFormat(date, fmt) {
  if (!date || !fmt) {
    return date;
  }

  date = new Date(date.toString().replace(/-/g, '/'));
  var o = {
    'M+': date.getMonth() + 1,
    // 月份
    'd+': date.getDate(),
    // 日
    'H+': date.getHours(),
    // 小时
    'm+': date.getMinutes(),
    // 分
    's+': date.getSeconds(),
    // 秒
    'q+': Math.floor((date.getMonth() + 3) / 3),
    // 季度
    S: date.getMilliseconds() // 毫秒

  };

  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, "".concat(date.getFullYear()).substr(4 - RegExp.$1.length));
  }

  keys_default()(o).forEach(function (k) {
    if (new RegExp("(".concat(k, ")")).test(fmt)) {
      fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : "00".concat(o[k]).substr("".concat(o[k]).length));
    }
  });

  return fmt;
};

var setDisabledFuc = function setDisabledFuc(fuc) {
  disabledFuc = fuc;
};
var getNextYear = function getNextYear(date) {
  date = new Date(date.getTime());
  date.setFullYear(date.getFullYear() + 1);
  return date;
};

var utils_datePartGerator = function datePartGerator(length, beginDate, value) {
  if (!length) return [];
  return from_default()({
    length: length
  }, function (val, index) {
    var date = new Date(beginDate + index * ONEDAYTIMESTAP);
    return {
      date: date,
      disabled: value || disabledFuc(date),
      active: false,
      inrange: false
    };
  });
};

var generatorCurrentMouthDates = function generatorCurrentMouthDates(min, max) {
  var beginDate = getNumMouthBeginDate(min);
  var dateCount = getMonthDateCount(beginDate);
  var beginDateStamp = beginDate.getTime();
  var maxIndex = max ? max.getDate() : dateCount;
  var beginDisabledLen = min.getDate() - 1;
  var beginDisabled = utils_datePartGerator(beginDisabledLen, beginDateStamp, true);
  beginDateStamp += beginDisabledLen * ONEDAYTIMESTAP;
  var availabelDateLen = maxIndex - beginDisabledLen;
  var rangeAvailabel = utils_datePartGerator(availabelDateLen, beginDateStamp, false);
  beginDateStamp += availabelDateLen * ONEDAYTIMESTAP;
  var endDisabledLen = dateCount - maxIndex;
  var endDisabled = utils_datePartGerator(endDisabledLen, beginDateStamp, true);
  return [].concat(beginDisabled, rangeAvailabel, endDisabled);
};
var generatorRangeDates = function generatorRangeDates(min, max) {
  if (min.getTime() > max.getTime()) {
    var temp = min;
    min = max;
    max = temp;
  }

  var begin = min;
  var result = [];
  var nextMonthBeginDate = getNumMouthBeginDate(begin, 1);

  var pushMouthToResult = function pushMouthToResult(maxDate) {
    result.push({
      title: utils_dateFormat(begin, 'yyyy年MM月'),
      dates: generatorCurrentMouthDates(begin, maxDate)
    });
    result[result.length - 1].maxIndex = (result[result.length - 2] ? result[result.length - 2].maxIndex : 0) + result[result.length - 1].dates.length;
  };

  while (nextMonthBeginDate.getTime() < max.getTime()) {
    pushMouthToResult();
    begin = nextMonthBeginDate;
    nextMonthBeginDate = getNumMouthBeginDate(begin, 1);
  }

  pushMouthToResult(max);
  return result;
};
var normalizeDate = function normalizeDate(date) {
  if (typeof date === 'string') date = date.replace(/(\d{4}).+?(\d{2}).+?(\d{2})/, '$1/$2/$3');
  date = date instanceof Date ? date : new Date(date);
  return availableDate(date) ? getTodayBeginTime(date) : null;
};
var makeMinDateInfront = function makeMinDateInfront(dateArr) {
  return dateArr[0].getTime() > dateArr[1].getTime() ? [dateArr[1], dateArr[0]] : dateArr;
};
// CONCATENATED MODULE: ./src/calendar/src/sigleMode.js

var sigleDateClean = function sigleDateClean() {
  this.selectedDate && (this.selectedDate.active = false);
};
var sigleMode_sigleValueNormalize = function sigleValueNormalize() {
  this.normalizeValue = normalizeDate(this.defaultValue || this.value);
};
var sigleValueInit = function sigleValueInit() {
  sigleMode_sigleValueNormalize.call(this);

  if (this.normalizeValue) {
    var date = this._findDateInMonthList(this.normalizeValue);

    if (!date) {
      this._dateEmit(null);

      return console.error('your value is not in range');
    }

    this._dateClick(date.dateModel);
  } else {
    this._dateEmit(null);
  }
};
var clickSingleHandle = function clickSingleHandle(dateConfig) {
  if (dateConfig.disabled) return false;
  this.clean();

  if (this.selectedDate !== dateConfig) {
    this.selectedDate = dateConfig;
    dateConfig.active = !dateConfig.active;
  } else {
    this.selectedDate = null;
  }

  this._dateEmit(this.selectedDate && this.selectedDate.date);
};
// CONCATENATED MODULE: ./src/calendar/src/multipleMode.js


var selectedClean = function selectedClean() {
  this.selectedDate.forEach(function (val) {
    val && (val.active = false);
  });
  this.selectedDate = null;
};

var rangeClean = function rangeClean() {
  this.rangeArr && this.rangeArr.forEach(function (val) {
    val.inrange = false;
  });
  this.rangeArr = null;
  selectedClean.call(this);
};
var multipleMode_setRange = function setRange(dateArray) {
  var _this = this;

  dateArray = makeMinDateInfront(dateArray);

  var minIndex = this._findDateInAllDatesIndex(dateArray[0]);

  var minInListIndex = this._findDateMonthIndex(minIndex);

  var maxIndex = this._findDateInAllDatesIndex(dateArray[1]);

  var maxInListIndex = this._findDateMonthIndex(maxIndex);

  this.rangeArr = [];
  var currentArrayIndex;

  var concatRangeArr = function concatRangeArr(max) {
    currentArrayIndex = _this.monthList[minInListIndex].dates.length - (_this.monthList[minInListIndex].maxIndex - minIndex);
    _this.rangeArr = _this.rangeArr.concat(_this.monthList[minInListIndex].dates.slice(currentArrayIndex, max));
  };

  while (minInListIndex !== maxInListIndex) {
    concatRangeArr();
    minIndex = this.monthList[minInListIndex].maxIndex;
    minInListIndex += 1;
  }

  maxIndex = this.monthList[maxInListIndex].dates.length - (this.monthList[maxInListIndex].maxIndex - maxIndex);
  concatRangeArr(maxIndex + 1);
  this.rangeArr.forEach(function (val) {
    val.inrange = true;
  });
  return true;
};
var multipleMode_multipleValueNormalize = function multipleValueNormalize() {
  var value = this.defaultValue || this.value;
  value = value instanceof Array ? [normalizeDate(value[0]), normalizeDate(value[1])] : [];
  this.normalizeValue = value[0] && value[1] ? value : null;
};
var multipleValueInit = function multipleValueInit() {
  multipleMode_multipleValueNormalize.call(this);

  if (this.normalizeValue) {
    var date = [];
    date[0] = this._findDateInMonthList(this.normalizeValue[0]);

    if (!date[0] || date[0].dateModel.disabled) {
      this._dateEmit(null);

      return console.error('your value is not in range');
    }

    date[1] = this._findDateInMonthList(this.normalizeValue[1]);

    if (!date[1] || date[1].dateModel.disabled) {
      this._dateEmit(null);

      return console.error('your value is not in range');
    }

    this._dateClick(date[0].dateModel);

    this._dateClick(date[1].dateModel);
  } else {
    this._dateEmit(null);
  }
};
var clickMultipleHandleOne = function clickMultipleHandleOne(dateConfig) {
  if (dateConfig.disabled) return false;

  if (this.rangeArr) {
    rangeClean.call(this);

    this._dateEmit(null);
  }

  dateConfig.active = true;
  this.selectedDate = [dateConfig];
  this._dateClick = clickMultipleHandleTwo; // eslint-disable-line
};
var clickMultipleHandleTwo = function clickMultipleHandleTwo(dateConfig) {
  if (dateConfig.disabled) return false;

  if (this.selectedDate[0] === dateConfig) {
    selectedClean.call(this);
  } else {
    dateConfig.active = true;
    this.selectedDate[1] = dateConfig;
    multipleMode_setRange.call(this, [this.selectedDate[0].date, this.selectedDate[1].date]);

    this._dateEmit([this.selectedDate[0].date, this.selectedDate[1].date]);
  }

  this._dateClick = clickMultipleHandleOne;
};
// CONCATENATED MODULE: ./node_modules/_babel-loader@8.1.0@babel-loader/lib!./node_modules/_vue-loader@15.9.3@vue-loader/lib??vue-loader-options!./src/calendar/src/dateItem.vue?vue&type=script&lang=js&
/* harmony default export */ var dateItemvue_type_script_lang_js_ = ({
  name: 'zaCalendar-item',
  props: {
    data: Object,
    prefixCls: String,
    dateRender: Function
  },
  render: function render() {
    var h = arguments[0];
    return h("li", {
      "class": "".concat(this.prefixCls, "__dates-item").concat(this.data.active ? ' active' : '').concat(this.data.inrange ? ' inrange' : '').concat(this.data.disabled ? ' disabled' : '')
    }, [h("div", {
      "class": "".concat(this.prefixCls, "__warp")
    }, [this.dateRender(this.data.date, this.data.disabled)])]);
  }
});
// CONCATENATED MODULE: ./src/calendar/src/dateItem.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_dateItemvue_type_script_lang_js_ = (dateItemvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(0);

// CONCATENATED MODULE: ./src/calendar/src/dateItem.vue
var dateItem_render, staticRenderFns




/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  src_dateItemvue_type_script_lang_js_,
  dateItem_render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var dateItem = (component.exports);
// CONCATENATED MODULE: ./node_modules/_babel-loader@8.1.0@babel-loader/lib!./node_modules/_vue-loader@15.9.3@vue-loader/lib??vue-loader-options!./src/calendar/src/calendar.vue?vue&type=script&lang=js&





var today = new Date();
var weekList = ['日', '一', '二', '三', '四', '五', '六'];
var dateType = [Date, String, Number];
var valueType = [Date, String, Number, Array];
var doWeigth = ['clean', '_rangeInit', '_choiceInitType', 'valueInit'];
var changeBySelf = false;
/* harmony default export */ var calendarvue_type_script_lang_js_ = ({
  name: 'zaCalendar',
  components: {
    DateItem: dateItem
  },
  props: {
    prefixCls: {
      type: String,
      default: 'za-calendar'
    },
    defaultValue: {
      type: valueType
    },
    value: {
      type: valueType
    },
    min: {
      type: dateType,
      default: function _default() {
        return today;
      }
    },
    max: {
      type: dateType,
      default: function _default() {
        return getNextYear(normalizeDate(this.$options.propsData.min) || today);
      }
    },
    multiple: {
      type: Boolean,
      default: false
    },
    dateRender: {
      type: Function,
      default: function _default(date) {
        var h = this.$createElement;
        return h("div", {
          "class": "".concat(this.prefixCls, "_date-num")
        }, [date.getDate()]);
      }
    },
    className: {
      type: String,
      default: ''
    },
    styles: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    disabledDate: {
      type: Function,
      default: function _default() {
        return false;
      }
    }
  },
  data: function data() {
    return {
      monthList: [],
      waitingFuc: {}
    };
  },
  methods: {
    _findDateInAllDatesIndex: function _findDateInAllDatesIndex(date) {
      return Math.ceil((date.getTime() - this.monthList[0].dates[0].date.getTime()) / ONEDAYTIMESTAP);
    },
    _findDateMonthIndex: function _findDateMonthIndex(index) {
      var monthIndex = Math.floor(index / 30);
      monthIndex = this.monthList[monthIndex - 1] && this.monthList[monthIndex - 1].maxIndex >= index ? monthIndex - 1 : monthIndex;

      if (!this.monthList[monthIndex]) {
        return -1;
      }

      return monthIndex;
    },
    _findDateInMonthList: function _findDateInMonthList(date) {
      var index = this._findDateInAllDatesIndex(date);

      var monthIndex = this._findDateMonthIndex(index);

      if (monthIndex === -1) return null;
      var dateIndex = this.monthList[monthIndex].dates.length - (this.monthList[monthIndex].maxIndex - index);
      return {
        index: index,
        dateModel: this.monthList[monthIndex].dates[dateIndex]
      };
    },
    _dateEmit: function _dateEmit(value) {
      changeBySelf = true;
      this.$emit('change', value);
      this.$emit('input', value);
    },
    _componentInit: function _componentInit() {
      this._rangeInit();

      this._choiceInitType();

      this.valueInit();
      this.normalizeValue = null;
    },
    _rangeInit: function _rangeInit() {
      setDisabledFuc(this.disabledDate);
      this.monthList = generatorRangeDates(normalizeDate(this.min), normalizeDate(this.max));
    },
    _choiceInitType: function _choiceInitType() {
      this.multiple ? this._multipleInit() : this._singleInit();
    },
    _singleInit: function _singleInit() {
      this.clean = sigleDateClean;
      this._dateClick = clickSingleHandle;
      this.valueInit = sigleValueInit;
    },
    _multipleInit: function _multipleInit() {
      this.clean = rangeClean;
      this._dateClick = clickMultipleHandleOne;
      this.valueInit = multipleValueInit;
    },
    _pushWaitingStack: function _pushWaitingStack() {
      var _this = this;

      for (var _len = arguments.length, arg = new Array(_len), _key = 0; _key < _len; _key++) {
        arg[_key] = arguments[_key];
      }

      arg.forEach(function (val) {
        _this.waitingFuc[val] = true;
      });

      this._activeWaitingRun();
    },
    _activeWaitingRun: function _activeWaitingRun() {
      var _this2 = this;

      this.timer && clearTimeout(this.timer);
      this.timer = setTimeout(function () {
        doWeigth.forEach(function (val) {
          _this2.waitingFuc[val] && _this2[val]();
        });
        _this2.waitingFuc = {};
      }, 10);
    }
  },
  render: function render() {
    var _this3 = this;

    var h = arguments[0];
    return h("div", {
      "class": "".concat(this.prefixCls, " ").concat(this.className),
      style: this.styles
    }, [h("ul", {
      "class": "".concat(this.prefixCls, "__week")
    }, [weekList.map(function (item) {
      return h("li", {
        "class": "".concat(_this3.prefixCls, "__week-item")
      }, [item]);
    })]), h("ul", {
      "class": "".concat(this.prefixCls, "__month")
    }, [this.monthList.map(function (month) {
      return h("li", [h("h3", {
        "class": "".concat(_this3.prefixCls, "__month-head")
      }, [month.title]), h("ul", {
        "class": "".concat(_this3.prefixCls, "__dates")
      }, [from_default()({
        length: month.dates[0].date.getDay()
      }, function () {
        return h("li", {
          "class": "".concat(_this3.prefixCls, "__dates-item")
        });
      }), month.dates.map(function (dateItem) {
        return h("date-item", {
          nativeOn: {
            "click": function click() {
              return _this3._dateClick(dateItem);
            }
          },
          attrs: {
            data: dateItem,
            prefixCls: _this3.prefixCls,
            dateRender: _this3.dateRender
          }
        });
      })])]);
    })])]);
  },
  created: function created() {
    this._componentInit();
  },
  watch: {
    multiple: function multiple() {
      this._pushWaitingStack('clean', '_choiceInitType');
    },
    max: function max() {
      this._pushWaitingStack('_rangeInit', 'valueInit');
    },
    min: function min() {
      this._pushWaitingStack('_rangeInit', 'valueInit');
    },
    defaultValue: function defaultValue() {
      this._pushWaitingStack('valueInit');
    },
    value: function value() {
      !changeBySelf && !this.defaultValue && this._pushWaitingStack('valueInit');
      changeBySelf = false;
    }
  }
});
// CONCATENATED MODULE: ./src/calendar/src/calendar.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_calendarvue_type_script_lang_js_ = (calendarvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/calendar/src/calendar.vue
var calendar_render, calendar_staticRenderFns




/* normalize component */

var calendar_component = Object(componentNormalizer["a" /* default */])(
  src_calendarvue_type_script_lang_js_,
  calendar_render,
  calendar_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var calendar = (calendar_component.exports);
// CONCATENATED MODULE: ./src/calendar/index.js

/* istanbul ignore next */

calendar.install = function (Vue) {
  Vue.component(calendar.name, calendar);
};

/* harmony default export */ var src_calendar = __webpack_exports__["default"] = (calendar); // import Vue from "vue"
// const calendarConstructor = Vue.extend(require('./calendar.vue'));
// let calendarPool = [];
// let getAnInstance = () => {
//     if (calendarPool.length > 0) {
//         let instance = calendarPool[0];
//         calendarPool.splice(0, 1);
//     }
//     return new calendarConstructor({
//         el: document.createElement('div')
//     });
// };
// let returnAnInstance = instance => {
//     if (instance) {
//         calendarPool.push(instance);
//     }
// };
// let removeDom = event => {
//     if (event.target.parentNode) {
//         event.target.parentNode.removeChild(event.target);
//     }
// };
// calendarConstructor.prototype.close = function() {
//     this.visible = false;
//     returnAnInstance(this);
// };
// const preventDomDefault = (ev) => {
//     ev.preventDefault();
// }
// let calendar = (options = {}) => {
//     let instance = getAnInstance();
//     instance.multiSelected = options.multiSelected || false;
//     instance.minDate = options.minDate || "";
//     instance.maxDate = options.maxDate || "";
//     instance.selectedSuffix = options.selectedSuffix || "";
//     instance.months = options.months || 12;
//     instance.visible = true;
//     instance.callback = options.callback;
//     instance.onClick = options.onClick;
//     document.body.appendChild(instance.$el);
//     document.body.scrollTop = 0;
//     Vue.nextTick(function() {
//         instance.selected = options.selectedValue ? options.selectedValue.split(",") : []
//         instance.$el.querySelector(".ok-btn").addEventListener("click", function() {
//             instance.close();
//             if (options.callback) options.callback(instance.selected);
//         });
//         instance.$el.querySelector(".cancel-btn").addEventListener("click", function() {
//             instance.close();
//         });
//     });
//     return instance;
// };
// export default calendar;

/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/_vue-loader@15.9.3@vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/_vue-loader@15.9.3@vue-loader/lib??vue-loader-options!./src/file-picker/src/filePicker.vue?vue&type=template&id=1a27230e&lang=html&
var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:( _obj = {}, _obj[_vm.prefixCls] = true, _obj[(_vm.prefixCls + "--disabled")] = !!_vm.disabled, _obj )},[_c('input',{ref:"file",class:(_vm.prefixCls + "__input"),attrs:{"type":"file","accept":_vm.accept,"multiple":_vm.multiple,"capture":_vm.capture},on:{"click":_vm.handleDefaultInput,"change":_vm.handleChange}}),_vm._v(" "),_c('span',{class:(_vm.prefixCls + "__trigger"),on:{"click":_vm.handleClick}}),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/file-picker/src/filePicker.vue?vue&type=template&id=1a27230e&lang=html&

// EXTERNAL MODULE: ./node_modules/_@babel_runtime-corejs2@7.11.2@@babel/runtime-corejs2/core-js/array/from.js
var from = __webpack_require__(92);
var from_default = /*#__PURE__*/__webpack_require__.n(from);

// CONCATENATED MODULE: ./src/file-picker/src/changeImageSize.js
/**
 * change img size or quality todo change size
 *
 * @param img
 * @param quality
 * @param fileType
 * @returns {string}
 */
function changeImageSize(img, quality, fileType) {
  var canvas = document.createElement('canvas');
  var ctx = canvas.getContext('2d');
  var width = img.width;
  var height = img.height;
  canvas.width = width;
  canvas.height = height; // 在canvas绘制前填充白色背景

  ctx.fillStyle = '#fff';
  ctx.fillRect(0, 0, canvas.width, canvas.height);
  ctx.drawImage(img, 0, 0, width, height); // 是否有效的压缩比例（0 - 1）

  if (!(quality > 0 && quality <= 1 && production === 'development')) {
    console.error('请输入有效的压缩比例, 没有将默认使用 0.92'); // eslint-disable-line no-console
  }

  return canvas.toDataURL(fileType, quality);
}
// CONCATENATED MODULE: ./src/file-picker/src/util.js


function isImage(fileType) {
  var imageType = /image.*/;
  return !!fileType.match(imageType);
}

function getFileDetail(file) {
  var fileSize = file.size;
  var fileName = file.name;
  var fileType = file.type || fileName.substr(fileName.lastIndexOf('.') + 1);
  var isPic = isImage(fileType);
  return {
    fileName: fileName,
    fileSize: fileSize,
    fileType: fileType,
    isPic: isPic
  };
}

function createThumbnail(_ref, callback) {
  var file = _ref.file,
      quality = _ref.quality,
      fileType = _ref.fileType,
      maxWidth = _ref.maxWidth,
      maxHeight = _ref.maxHeight;
  var img = document.createElement('img');
  window.URL = window.URL || window.webkitURL;

  try {
    img.src = window.URL.createObjectURL(file);
  } catch (err) {
    return;
  }

  img.onload = function () {
    var imgUrl;

    if (quality || maxWidth || maxHeight) {
      imgUrl = changeImageSize(img, quality, fileType);
    } else {
      imgUrl = img.src;
    }

    callback(imgUrl);
  };
}
/**
 * handle single file and get file info
 *
 * @param file
 * @param quality
 * @param callback
 */


function handleFileInfo(_ref2, callback) {
  var file = _ref2.file,
      quality = _ref2.quality;

  var _getFileDetail = getFileDetail(file),
      fileSize = _getFileDetail.fileSize,
      fileType = _getFileDetail.fileType,
      isPic = _getFileDetail.isPic,
      fileName = _getFileDetail.fileName;

  var fileDetail = {
    file: file,
    fileType: fileType,
    fileSize: fileSize,
    fileName: fileName
  };

  var callbackFunc = function callbackFunc(url) {
    fileDetail.thumbnail = url;
    callback(fileDetail);
  };

  if (isPic) {
    createThumbnail({
      file: file,
      quality: quality,
      fileType: fileType
    }, callbackFunc);
  } else {
    callback(fileDetail);
  }
}
// CONCATENATED MODULE: ./node_modules/_babel-loader@8.1.0@babel-loader/lib!./node_modules/_vue-loader@15.9.3@vue-loader/lib??vue-loader-options!./src/file-picker/src/filePicker.vue?vue&type=script&lang=js&

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * 设置选择前的方法，获取选择文件的相关信息，需要时可以对图片进行压缩、改变图片尺寸。
 *
 * multiple: 默认为 false，设置为 true 之后一次可以选择多张，onChange 事件调用之后返回一个数组，
 *           不设置或者设置为 false，onChange 事件调用之后返回一个对象。
 * disabled: 传递之后不可以点击上传，整个选择组件会设置为半透明状态，透明度为 0.5。
 * quality: 没有默认值，不设置不会进行压缩。
 * accept: 设置选择的文件类型，默认为所有类型，只有文件类型为图片（image/*）的时候会有本地预览图。
 * onChange: () => { file, fileType, fileSize, fileName, thumbnail }。
 * onBeforeSelect: () => boolean，返回 false 的时候阻止后续的选择事件。
 */

/* harmony default export */ var filePickervue_type_script_lang_js_ = ({
  name: 'zaFilePicker',
  props: {
    prefixCls: {
      type: String,
      default: 'za-filepicker'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: false
    },
    accept: String,
    capture: String,
    quality: Number,
    beforeSelect: {
      type: Function,
      default: function _default() {}
    }
  },
  methods: {
    handleClick: function handleClick() {
      this.$refs.file.click();
    },
    handleDefaultInput: function handleDefaultInput(event) {
      var beforeSelect = this.beforeSelect,
          disabled = this.disabled; // 防止选择同一张图片两次造成 onChange 事件不触发

      event.target.value = null; // eslint-disable-line no-param-reassign
      // 阻止 input onChange 默认事件

      if (beforeSelect(event) === false || disabled) {
        event.preventDefault();
      }
    },
    handleChange: function handleChange(e) {
      var _this = this;

      var quality = this.quality,
          multiple = this.multiple;

      var files = from_default()(e.target.files);

      var fileList = [];

      var getFileInfoCb = function getFileInfoCb(data) {
        if (multiple) {
          fileList.push(data);

          if (files.length === fileList.length) {
            _this.$emit('change', fileList);
          }
        } else {
          _this.$emit('change', data);
        }
      };

      if (files) {
        files.map(function (file) {
          return handleFileInfo({
            file: file,
            quality: quality
          }, getFileInfoCb);
        });
      }
    }
  }
});
// CONCATENATED MODULE: ./src/file-picker/src/filePicker.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_filePickervue_type_script_lang_js_ = (filePickervue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(0);

// CONCATENATED MODULE: ./src/file-picker/src/filePicker.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  src_filePickervue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var filePicker = (component.exports);
// CONCATENATED MODULE: ./src/file-picker/index.js

/* istanbul ignore next */

filePicker.install = function (Vue) {
  Vue.component(filePicker.name, filePicker);
};

/* harmony default export */ var file_picker = __webpack_exports__["default"] = (filePicker);

/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/_@babel_runtime-corejs2@7.11.2@@babel/runtime-corejs2/core-js/object/define-property.js
var define_property = __webpack_require__(79);
var define_property_default = /*#__PURE__*/__webpack_require__.n(define_property);

// EXTERNAL MODULE: ./node_modules/_@babel_runtime-corejs2@7.11.2@@babel/runtime-corejs2/core-js/object/define-properties.js
var define_properties = __webpack_require__(113);
var define_properties_default = /*#__PURE__*/__webpack_require__.n(define_properties);

// EXTERNAL MODULE: ./node_modules/_@babel_runtime-corejs2@7.11.2@@babel/runtime-corejs2/core-js/object/get-own-property-descriptors.js
var get_own_property_descriptors = __webpack_require__(87);
var get_own_property_descriptors_default = /*#__PURE__*/__webpack_require__.n(get_own_property_descriptors);

// EXTERNAL MODULE: ./node_modules/_@babel_runtime-corejs2@7.11.2@@babel/runtime-corejs2/core-js/object/get-own-property-descriptor.js
var get_own_property_descriptor = __webpack_require__(88);
var get_own_property_descriptor_default = /*#__PURE__*/__webpack_require__.n(get_own_property_descriptor);

// EXTERNAL MODULE: ./node_modules/_@babel_runtime-corejs2@7.11.2@@babel/runtime-corejs2/core-js/object/get-own-property-symbols.js
var get_own_property_symbols = __webpack_require__(77);
var get_own_property_symbols_default = /*#__PURE__*/__webpack_require__.n(get_own_property_symbols);

// EXTERNAL MODULE: ./node_modules/_@babel_runtime-corejs2@7.11.2@@babel/runtime-corejs2/core-js/object/keys.js
var object_keys = __webpack_require__(46);
var keys_default = /*#__PURE__*/__webpack_require__.n(object_keys);

// EXTERNAL MODULE: ./node_modules/_@babel_runtime-corejs2@7.11.2@@babel/runtime-corejs2/core-js/parse-float.js
var parse_float = __webpack_require__(133);
var parse_float_default = /*#__PURE__*/__webpack_require__.n(parse_float);

// EXTERNAL MODULE: ./node_modules/_@babel_runtime-corejs2@7.11.2@@babel/runtime-corejs2/helpers/slicedToArray.js
var slicedToArray = __webpack_require__(222);
var slicedToArray_default = /*#__PURE__*/__webpack_require__.n(slicedToArray);

// EXTERNAL MODULE: ./node_modules/_@babel_runtime-corejs2@7.11.2@@babel/runtime-corejs2/helpers/defineProperty.js
var defineProperty = __webpack_require__(37);
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// EXTERNAL MODULE: ./node_modules/_popper.js@1.16.1@popper.js/dist/esm/popper.js
var esm_popper = __webpack_require__(224);

// EXTERNAL MODULE: ./src/utils/clickoutside.js
var clickoutside = __webpack_require__(129);

// EXTERNAL MODULE: ./src/utils/events.js
var events = __webpack_require__(78);

// EXTERNAL MODULE: ./node_modules/_@babel_runtime-corejs2@7.11.2@@babel/runtime-corejs2/core-js/number/is-finite.js
var is_finite = __webpack_require__(223);
var is_finite_default = /*#__PURE__*/__webpack_require__.n(is_finite);

// EXTERNAL MODULE: ./node_modules/_@babel_runtime-corejs2@7.11.2@@babel/runtime-corejs2/core-js/number/is-nan.js
var is_nan = __webpack_require__(121);
var is_nan_default = /*#__PURE__*/__webpack_require__.n(is_nan);

// CONCATENATED MODULE: ./src/utils/dom.js




var domUtil = {
  // 获取元素的纵坐标（相对于窗口）
  getTop: function getTop(e) {
    var offset = e.offsetTop;

    if (e.offsetParent != null) {
      offset += domUtil.getTop(e.offsetParent);
    }

    return offset;
  },
  // 获取元素的横坐标（相对于窗口）
  getLeft: function getLeft(e) {
    var offset = e.offsetLeft;

    if (e.offsetParent != null) {
      offset += domUtil.getLeft(e.offsetParent);
    }

    return offset;
  },
  probTouch: function probTouch() {
    return 'ontouchend' in document;
  },
  // 获取元素大小以及相对窗口的位置
  getBoundingClientRect: function getBoundingClientRect(e) {
    var rect = e.getBoundingClientRect(); // 解决ie下的兼容问题

    var isIE = navigator.userAgent.indexOf('MSIE') !== -1;
    var rectTop = isIE && e.tagName === 'HTML' ? -e.scrollTop : rect.top;
    return {
      left: rect.left,
      top: rectTop,
      right: rect.right,
      bottom: rect.bottom,
      width: rect.right - rect.left,
      height: rect.bottom - rectTop
    };
  },
  // 设置元素行内样式
  setStyle: function setStyle(e, styles) {
    var isNumeric = function isNumeric(n) {
      return n !== '' && !is_nan_default()(parse_float_default()(n)) && is_finite_default()(n);
    };

    keys_default()(styles).forEach(function (prop) {
      var unit = '';

      if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && isNumeric(styles[prop])) {
        unit = 'px';
      }

      e.style[prop] = styles[prop] + unit;
    });
  },
  // 获取元素css的某一个计算后属性值
  getStyleComputedProperty: function getStyleComputedProperty(e, property) {
    var css = window.getComputedStyle(e, null);
    return css[property];
  },
  // 判断元素是否固定定位或者是否在固定定位元素内
  isFixed: function isFixed(e) {
    if (e === window.document.body) {
      return false;
    }

    if (domUtil.getStyleComputedProperty(e, 'position') === 'fixed') {
      return true;
    }

    return e.parentNode ? domUtil.isFixed(e.parentNode) : e;
  },
  // 获取元素完整尺寸(offset size + margin)
  getOuterSizes: function getOuterSizes(e) {
    var _display = e.style.display;
    var _visibility = e.style.visibility;
    e.style.display = 'block';
    e.style.visibility = 'hidden'; // const calcWidthToForceRepaint = e.offsetWidth;

    var styles = window.getComputedStyle(e);

    var x = parse_float_default()(styles.marginTop) + parse_float_default()(styles.marginBottom);

    var y = parse_float_default()(styles.marginLeft) + parse_float_default()(styles.marginRight);

    var result = {
      width: e.offsetWidth + y,
      height: e.offsetHeight + x
    }; // reset

    e.style.display = _display;
    e.style.visibility = _visibility;
    return result;
  },
  // 获取元素的offsetParent
  getOffsetParent: function getOffsetParent(e) {
    var offsetParent = e.offsetParent;
    return offsetParent === window.document.body || !offsetParent ? window.document.documentElement : offsetParent;
  },
  // 获取指定元素可滚动的父元素
  getScrollParent: function getScrollParent(e) {
    var parent = e.parentNode;

    if (!parent) {
      return e;
    }

    if (parent === window.document) {
      if (window.document.body.scrollTop) {
        return window.document.body;
      }

      return window.document.documentElement;
    }

    if (['scroll', 'auto'].indexOf(domUtil.getStyleComputedProperty(parent, 'overflow')) !== -1 || ['scroll', 'auto'].indexOf(domUtil.getStyleComputedProperty(parent, 'overflow-x')) !== -1 || ['scroll', 'auto'].indexOf(domUtil.getStyleComputedProperty(parent, 'overflow-y')) !== -1) {
      return parent;
    }

    return domUtil.getScrollParent(e.parentNode);
  },
  // 获取浏览器支持的带前缀属性名
  getSupportedPropertyName: function getSupportedPropertyName(property) {
    var prefixes = ['', 'ms', 'webkit', 'moz', 'o'];

    for (var i = 0; i < prefixes.length; i++) {
      var toCheck = prefixes[i] ? prefixes[i] + property.charAt(0).toUpperCase() + property.slice(1) : property;

      if (typeof window.document.body.style[toCheck] !== 'undefined') {
        return toCheck;
      }
    }

    return null;
  },
  // 获取元素scrollTop
  getScrollTopValue: function getScrollTopValue(e) {
    // tslint:disable-next-line
    return e === document.body ? Math.max(document.documentElement.scrollTop, document.body.scrollTop) : e.scrollTop;
  },
  getScrollLeftValue: function getScrollLeftValue(e) {
    return e === document.body ? Math.max(document.documentElement.scrollLeft, document.body.scrollLeft) : e.scrollLeft;
  }
};
/* harmony default export */ var dom = (domUtil);
// EXTERNAL MODULE: ./src/utils/validator.js
var validator = __webpack_require__(13);

// EXTERNAL MODULE: ./src/mixins/get-container.js
var get_container = __webpack_require__(69);

// CONCATENATED MODULE: ./node_modules/_babel-loader@8.1.0@babel-loader/lib!./node_modules/_vue-loader@15.9.3@vue-loader/lib??vue-loader-options!./src/popper/src/popper-container.vue?vue&type=script&lang=js&


/* harmony default export */ var popper_containervue_type_script_lang_js_ = ({
  name: 'zaPopperRef',
  mixins: [get_container["a" /* default */]],
  props: {
    prefixCls: {
      type: String,
      default: 'za-popper'
    },
    className: {
      type: String,
      default: ''
    },
    visible: {
      type: Boolean,
      default: false
    },
    hasArrow: {
      type: Boolean,
      default: false
    },
    arrowPointAtCenter: {
      type: Boolean,
      default: false
    },
    isPending: {
      type: Boolean,
      default: false
    },
    trigger: {
      type: String,
      default: 'click'
    },
    animationState: {
      type: String,
      default: 'click'
    },
    animationType: {
      type: String,
      default: 'zoom-fade'
    },
    animationDuration: {
      type: Number,
      default: 200
    },
    direction: {
      type: String,
      default: 'top'
    },
    getContainer: {
      type: Function,
      default: function _default() {
        return document.body;
      }
    },
    content: null
  },
  render: function render() {
    var _innerCls;

    var h = arguments[0];
    var prefixCls = this.prefixCls,
        trigger = this.trigger,
        content = this.content,
        hasArrow = this.hasArrow,
        visible = this.visible,
        animationType = this.animationType,
        animationDuration = this.animationDuration,
        direction = this.direction,
        className = this.className,
        animationState = this.animationState,
        isPending = this.isPending;
    var innerCls = (_innerCls = {}, defineProperty_default()(_innerCls, "".concat(className), true), defineProperty_default()(_innerCls, "".concat(prefixCls, "__wrapper"), true), defineProperty_default()(_innerCls, "".concat(prefixCls, "--").concat(direction), true), defineProperty_default()(_innerCls, "".concat(prefixCls, "--hidden"), animationState === 'leave'), defineProperty_default()(_innerCls, "za-".concat(animationType, "-").concat(animationState), isPending), _innerCls);
    return visible && h("div", {
      "class": "popper-container",
      attrs: {
        disabled: trigger === 'manual'
      }
    }, [h("div", {
      ref: "popperNode",
      style: {
        position: 'absolute',
        animationDuration: "".concat(animationDuration, "ms")
      },
      "class": innerCls
    }, [h("div", {
      "class": "".concat(prefixCls, "__content")
    }, [content]), hasArrow && h("span", {
      "class": "".concat(prefixCls, "__arrow"),
      ref: "arrowRef"
    })])]);
  }
});
// CONCATENATED MODULE: ./src/popper/src/popper-container.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_popper_containervue_type_script_lang_js_ = (popper_containervue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(0);

// CONCATENATED MODULE: ./src/popper/src/popper-container.vue
var popper_container_render, staticRenderFns




/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  src_popper_containervue_type_script_lang_js_,
  popper_container_render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var popper_container = (component.exports);
// CONCATENATED MODULE: ./node_modules/_babel-loader@8.1.0@babel-loader/lib!./node_modules/_vue-loader@15.9.3@vue-loader/lib??vue-loader-options!./src/popper/src/popper.vue?vue&type=script&lang=js&










function ownKeys(object, enumerableOnly) { var keys = keys_default()(object); if (get_own_property_symbols_default.a) { var symbols = get_own_property_symbols_default()(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return get_own_property_descriptor_default()(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty_default()(target, key, source[key]); }); } else if (get_own_property_descriptors_default.a) { define_properties_default()(target, get_own_property_descriptors_default()(source)); } else { ownKeys(Object(source)).forEach(function (key) { define_property_default()(target, key, get_own_property_descriptor_default()(source, key)); }); } } return target; }







var directionMap = {
  top: 'top',
  topLeft: 'top-start',
  topRight: 'top-end',
  right: 'right',
  rightTop: 'right-start',
  rightBottom: 'right-end',
  bottom: 'bottom',
  bottomLeft: 'bottom-start',
  bottomRight: 'bottom-end',
  left: 'left',
  leftTop: 'left-start',
  leftBottom: 'left-end'
};

var getPopperClientRect = function getPopperClientRect(popperOffsets) {
  var offsets = _objectSpread({}, popperOffsets);

  offsets.right = offsets.left + offsets.width;
  offsets.bottom = offsets.top + offsets.height;
  return offsets;
};

var poppervue_type_script_lang_js_customArrowOffsetFn = function customArrowOffsetFn(data) {
  var _data$placement$split = data.placement.split('-'),
      _data$placement$split2 = slicedToArray_default()(_data$placement$split, 2),
      placement = _data$placement$split2[0],
      placement1 = _data$placement$split2[1];

  var arrow = data.instance.options.modifiers && data.instance.options.modifiers.arrow.element;
  var reference = data.offsets.reference;
  var popper = getPopperClientRect(data.offsets.popper);
  var isVertical = ['left', 'right'].indexOf(placement) !== -1;
  var len = isVertical ? 'height' : 'width';
  var side = isVertical ? 'top' : 'left';
  var altSide = isVertical ? 'left' : 'top';
  var opSide = isVertical ? 'bottom' : 'right';
  var arrowSize = dom.getOuterSizes(arrow)[len];

  var offsetSize = parse_float_default()(getComputedStyle(data.instance.popper, null).paddingLeft);

  var hashMap = {
    start: side === 'top' || side === 'left' ? reference[side] + offsetSize : reference[opSide] - offsetSize - arrowSize,
    // eslint-disable-next-line no-mixed-operators
    center: reference[side] + reference[len] / 2 - arrowSize / 2,
    end: side === 'top' || side === 'left' ? reference[opSide] - offsetSize - arrowSize : reference[side] + offsetSize
  };
  var place = hashMap[placement1 || 'center'];
  var sideValue = place - popper[side];
  data.arrowElement = arrow;
  data.arrowStyles[side] = Math.floor(sideValue).toString();
  data.arrowStyles[altSide] = '';
  return data;
};

/* harmony default export */ var poppervue_type_script_lang_js_ = ({
  name: 'zaPopper',
  components: {
    PopperRef: popper_container
  },
  props: {
    prefixCls: {
      type: String,
      default: 'za-popper'
    },
    content: {
      type: String,
      default: ''
    },
    className: {
      type: String,
      default: ''
    },
    visible: {
      type: Boolean,
      default: false
    },
    hasArrow: {
      type: Boolean,
      default: false
    },
    arrowPointAtCenter: {
      type: Boolean,
      default: false
    },
    trigger: {
      type: String,
      validator: Object(validator["b" /* enumGenerator */])(['click', 'hover', 'focus', 'manual', 'contextMenu']),
      default: /(iPhone|iPad|iPod|iOS|Android)/i.test(navigator.userAgent) ? 'click' : 'hover'
    },
    animationType: {
      type: String,
      default: 'zoom-fade'
    },
    animationDuration: {
      type: Number,
      default: 200
    },
    direction: {
      type: String,
      validator: Object(validator["b" /* enumGenerator */])(['top', 'topLeft', 'topRight', 'right', 'rightTop', 'rightBottom', 'bottom', 'bottomLeft', 'bottomRight', 'left', 'leftTop', 'leftBottom']),
      default: 'top'
    },
    mouseEnterDelay: {
      type: Number,
      default: 100
    },
    mouseLeaveDelay: {
      type: Number,
      default: 100
    },
    getContainer: {
      type: Function,
      default: function _default() {
        return document.body;
      }
    }
  },
  data: function data() {
    return {
      currentVisible: this.visible,
      popper: null,
      arrowRef: null,
      mounted: false,
      isPending: false,
      animationState: 'leave'
    };
  },
  watch: {
    visible: function visible(value, oldValue) {
      // eslint-disable-line no-unused-vars, object-shorthand
      if (value === this.currentVisible) return;
      this.currentVisible = value;
    }
  },
  mounted: function mounted() {
    var popperRef = this.$refs.popperRef;

    if (popperRef.$refs.popperNode) {
      events["a" /* default */].off(popperRef.$refs.popperNode, 'webkitAnimationEnd', this.animationEnd);
      events["a" /* default */].off(popperRef.$refs.popperNode, 'animationend', this.animationEnd);
    } // this.destroy();


    this.handleTrigger();
    clearTimeout(this.enterTimer);
    clearTimeout(this.leaveTimer);
    clickoutside["a" /* default */].addClickoutSide({
      handle: this.onOutsideBlur
    });
  },
  beforeDestroy: function beforeDestroy() {
    clickoutside["a" /* default */].removeClickoutSide({
      handle: this.onOutsideBlur
    });
  },
  methods: {
    handleTrigger: function handleTrigger() {
      var trigger = this.trigger;
      var reference = this.$refs.reference;

      if (trigger === 'click') {
        reference.onclick = this.handleClick;
      }

      if (trigger === 'contextMenu') {
        reference.oncontextmenu = this.handleClick;
      }

      if (trigger === 'hover') {
        reference.onmouseover = this.handleEnter;
        reference.onmouseleave = this.handleLeave;
      }

      if (trigger === 'focus') {
        reference.onfocus = this.handleClick;
      }
    },
    onOutsideBlur: function onOutsideBlur(e) {
      var popperRef = this.$refs.popperRef;

      if (!this.currentVisible) {
        return;
      }

      var $el = popperRef.$refs.popperNode;
      var $container = this.$refs.container;
      clickoutside["a" /* default */].clickoutSideHandle(e, {
        onClickoutSide: this.handleClose,
        ignorenode: $container,
        el: $el
      });
    },
    handleClick: function handleClick(event) {
      var currentVisible = this.currentVisible,
          trigger = this.trigger;
      if (trigger === 'contextMenu') event.preventDefault();
      this.mounted = true;

      if (!currentVisible) {
        this.handleOpen();
      } else {
        this.handleClose();
      }
    },
    handleOpen: function handleOpen() {
      var _this = this;

      var direction = this.direction,
          hasArrow = this.hasArrow,
          arrowPointAtCenter = this.arrowPointAtCenter;
      var popperRef = this.$refs.popperRef;
      var reference = this.$refs.reference;
      var popperNode = popperRef.$refs.popperNode;

      if (!popperNode) {
        this.currentVisible = true;
        this.$nextTick(function () {
          _this.handleOpen();
        });
        return;
      }

      if (this.popper) {
        this.destroy();
      }

      this.popper = new esm_popper["a" /* default */](reference, popperNode, {
        placement: directionMap[direction],
        modifiers: {
          preventOverflow: {
            boundariesElement: 'window'
          },
          computeStyle: {
            gpuAcceleration: false
          },
          arrow: _objectSpread({
            enabled: popperRef.$refs.arrowRef,
            element: popperRef.$refs.arrowRef
          }, !(hasArrow && arrowPointAtCenter) && {
            fn: poppervue_type_script_lang_js_customArrowOffsetFn
          })
        },
        onCreate: this.handlePopperUpdate,
        onUpdate: this.handlePopperUpdate
      });
      events["a" /* default */].on(popperRef.$refs.popperNode, 'webkitAnimationEnd', this.animationEnd);
      events["a" /* default */].on(popperRef.$refs.popperNode, 'animationend', this.animationEnd);
      this.enter();
    },
    setTransformOrigin: function setTransformOrigin() {
      var popperRef = this.$refs.popperRef;
      var placementMap = {
        top: 'bottom',
        bottom: 'top',
        left: 'right',
        right: 'left'
      };
      var placement = popperRef.$refs.popperNode.getAttribute('x-placement').split('-')[0];
      var origin = placementMap[placement];
      popperRef.$refs.popperNode.style.transformOrigin = ['top', 'bottom'].indexOf(placement) > -1 ? "center ".concat(origin) : "".concat(origin, " center");
    },
    handlePopperUpdate: function handlePopperUpdate() {
      this.setTransformOrigin();
    },
    handleClose: function handleClose() {
      if (!this.popper) {
        return;
      }

      this.leave();
    },
    handleEnter: function handleEnter() {
      var _this2 = this;

      var mouseEnterDelay = this.mouseEnterDelay;
      clearTimeout(this.enterTimer);
      clearTimeout(this.leaveTimer);
      this.enterTimer = setTimeout(function () {
        _this2.mounted = true;

        _this2.$nextTick(function () {
          _this2.handleOpen();
        });
      }, mouseEnterDelay);
    },
    handleLeave: function handleLeave() {
      var _this3 = this;

      var mouseLeaveDelay = this.mouseLeaveDelay;
      clearTimeout(this.enterTimer);
      clearTimeout(this.leaveTimer);
      this.leaveTimer = setTimeout(function () {
        _this3.handleClose();
      }, mouseLeaveDelay);
    },
    enter: function enter() {
      this.currentVisible = true;
      this.isPending = true;
      this.animationState = 'enter';
    },
    leave: function leave() {
      this.currentVisible = false;
      this.isPending = true;
      this.animationState = 'leave';
      this.destroy();
    },
    animationEnd: function animationEnd(e) {
      var _this4 = this;

      e.stopPropagation();
      var destroy = this.destroy,
          animationState = this.animationState;

      if (animationState === 'leave') {
        this.currentVisible = false;
        this.isPending = false;
        this.mounted = !destroy;
        this.$nextTick(function () {
          _this4.destroy();

          _this4.$emit('visibleChange', false);
        });
      } else {
        this.$emit('visibleChange', true);
      }
    },
    destroy: function destroy() {
      if (this.popper) {
        this.popper.destroy();
        this.popper = null;
      }
    }
  },
  render: function render() {
    var h = arguments[0];
    var prefixCls = this.prefixCls,
        trigger = this.trigger,
        content = this.content,
        hasArrow = this.hasArrow,
        currentVisible = this.currentVisible,
        animationType = this.animationType,
        animationDuration = this.animationDuration,
        direction = this.direction,
        animationState = this.animationState,
        isPending = this.isPending,
        className = this.className;
    return h("div", {
      "class": prefixCls,
      ref: "container"
    }, [h("popper-ref", {
      ref: "popperRef",
      attrs: {
        prefixCls: prefixCls,
        trigger: trigger,
        className: className,
        visible: currentVisible,
        hasArrow: hasArrow,
        animationType: animationType,
        animationDuration: animationDuration,
        direction: direction,
        content: this.$slots.content || content,
        animationState: animationState,
        isPending: isPending
      }
    }), h("div", {
      ref: "reference",
      "class": "".concat(prefixCls, "__inner")
    }, [this.$slots.default])]);
  }
});
// CONCATENATED MODULE: ./src/popper/src/popper.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_poppervue_type_script_lang_js_ = (poppervue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/popper/src/popper.vue
var popper_render, popper_staticRenderFns




/* normalize component */

var popper_component = Object(componentNormalizer["a" /* default */])(
  src_poppervue_type_script_lang_js_,
  popper_render,
  popper_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var src_popper = (popper_component.exports);
// CONCATENATED MODULE: ./src/popper/index.js

/* istanbul ignore next */

src_popper.install = function (Vue) {
  Vue.component(src_popper.name, src_popper);
};

/* harmony default export */ var src_popper_0 = __webpack_exports__["default"] = (src_popper);

/***/ }),
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/_@babel_runtime-corejs2@7.11.2@@babel/runtime-corejs2/helpers/defineProperty.js
var defineProperty = __webpack_require__(37);
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// EXTERNAL MODULE: ./src/utils/validator.js
var validator = __webpack_require__(13);

// EXTERNAL MODULE: ./src/mixins/emitter.js
var emitter = __webpack_require__(115);

// CONCATENATED MODULE: ./node_modules/_babel-loader@8.1.0@babel-loader/lib!./node_modules/_vue-loader@15.9.3@vue-loader/lib??vue-loader-options!./src/tabs/src/tab-nav.vue?vue&type=script&lang=js&


/* harmony default export */ var tab_navvue_type_script_lang_js_ = ({
  name: 'zaTabItem',
  mixins: [emitter["a" /* default */]],
  props: {
    prefixCls: {
      type: String,
      default: 'za-tabs'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    label: String,
    name: [String, Number],
    currentName: {}
  },
  methods: {
    handleClick: function handleClick(event) {
      if (this.disabled) return;
      this.$emit('nav-click', this, event);
    }
  },
  render: function render(h) {
    var _cls;

    // eslint-disable-line no-unused-vars
    var disabled = this.disabled,
        currentName = this.currentName,
        label = this.label,
        prefixCls = this.prefixCls,
        handleClick = this.handleClick;
    var cls = (_cls = {}, defineProperty_default()(_cls, "".concat(prefixCls, "__header-item"), true), defineProperty_default()(_cls, "".concat(prefixCls, "__header-item--disabled"), !!disabled), defineProperty_default()(_cls, "".concat(prefixCls, "__header-item--active"), this.name === currentName), _cls);
    return h("div", {
      "class": cls,
      on: {
        "click": handleClick
      }
    }, [label]);
  }
});
// CONCATENATED MODULE: ./src/tabs/src/tab-nav.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_tab_navvue_type_script_lang_js_ = (tab_navvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(0);

// CONCATENATED MODULE: ./src/tabs/src/tab-nav.vue
var tab_nav_render, staticRenderFns




/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  src_tab_navvue_type_script_lang_js_,
  tab_nav_render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var tab_nav = (component.exports);
// EXTERNAL MODULE: ./src/carousel/index.js + 3 modules
var carousel = __webpack_require__(172);

// CONCATENATED MODULE: ./node_modules/_babel-loader@8.1.0@babel-loader/lib!./node_modules/_vue-loader@15.9.3@vue-loader/lib??vue-loader-options!./src/tabs/src/tabs.vue?vue&type=script&lang=js&

// change the name of this component to Tabs (zarm call it Tab)



/* harmony default export */ var tabsvue_type_script_lang_js_ = ({
  name: 'zaTabs',
  components: {
    TabNav: tab_nav,
    zaCarousel: carousel["default"]
  },
  props: {
    prefixCls: {
      type: String,
      default: 'za-tabs'
    },
    theme: {
      type: String,
      validator: validator["a" /* defaultThemeValidator */],
      default: 'primary'
    },
    lineWidth: [String, Number],
    value: {},
    slideable: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    currentIndex: function currentIndex() {
      var currentValue = this.currentValue; // trigger computing

      var panes = this.panes;
      var cur = 0;
      panes.some(function (child, index) {
        if (child.$options.name === 'zaTabPanel' && child.name === currentValue) {
          cur = index;
          return true;
        }

        return false;
      });
      return cur;
    },
    paneNum: function paneNum() {
      return this.panes.length;
    },
    lineStyle: function lineStyle() {
      return {
        width: "".concat(100 / this.paneNum, "%"),
        left: "".concat(this.currentIndex / this.paneNum * 100, "%"),
        backgroundColor: this.lineWidth ? 'transparent' : ''
      };
    }
  },
  watch: {
    value: function value(val, oldVal) {
      // eslint-disable-line no-unused-vars
      if (val === this.currentValue) return;
      this.currentValue = val;
    }
  },
  data: function data() {
    return {
      panes: [],
      currentValue: this.value
    };
  },
  methods: {
    handleNavClick: function handleNavClick(item, event) {
      // order matters
      this.$emit('input', item.name);

      if (!this.slideable) {
        this.$emit('change', item, event);
      }
    },
    notify: function notify(pane, flag) {
      var index = this.getNotifyPaneIndex(pane);

      if (!flag) {
        this.panes.splice(index, 1);
      } else if (index < 0) {
        this.panes.push(pane);
      } else {
        this.panes.splice(index, 1, pane);
      }
    },
    getNotifyPaneIndex: function getNotifyPaneIndex(pane) {
      var index = -1;
      this.panes.some(function (p, i) {
        if (p._panelIndex === pane._panelIndex) {
          index = i;
          return true;
        }

        return false;
      });
      return index;
    },
    handleSwipeChange: function handleSwipeChange(index) {
      var newName = this.findValueByIndex(index);
      this.currentValue = newName;
      this.$emit('input', newName);
      this.$emit('change', this.panes[index]);
    },
    findValueByIndex: function findValueByIndex(index) {
      return this.panes[index].name;
    }
  },
  render: function render(h) {
    var _cls;

    // eslint-disable-line no-unused-vars
    var panes = this.panes,
        handleNavClick = this.handleNavClick,
        currentValue = this.currentValue,
        lineStyle = this.lineStyle,
        lineWidth = this.lineWidth,
        currentIndex = this.currentIndex,
        slideable = this.slideable,
        prefixCls = this.prefixCls,
        theme = this.theme,
        handleSwipeChange = this.handleSwipeChange;
    var cls = (_cls = {}, defineProperty_default()(_cls, "".concat(prefixCls), true), defineProperty_default()(_cls, "".concat(prefixCls, "--").concat(theme), !!theme), _cls);
    return h("div", {
      "class": cls
    }, [h("div", {
      "class": "".concat(prefixCls, "__header")
    }, [h("ul", {
      attrs: {
        role: "tablist"
      }
    }, [panes.map(function (pane, index) {
      return h("tab-nav", {
        attrs: {
          label: pane.label,
          name: pane.name,
          disabled: pane.disabled,
          currentName: currentValue
        },
        key: index,
        on: {
          "nav-click": handleNavClick
        }
      });
    })]), h("div", {
      "class": "".concat(prefixCls, "__line"),
      style: lineStyle
    }, [lineWidth && h("span", {
      "class": "".concat(prefixCls, "__line-inner"),
      style: {
        width: "".concat(lineWidth, "px")
      }
    })])]), h("div", {
      "class": "".concat(prefixCls, "__container")
    }, [!slideable ? this.$slots.default : h("za-carousel", {
      attrs: {
        showPagination: false,
        activeIndex: currentIndex
      },
      ref: 'carousel',
      on: {
        "change": handleSwipeChange
      }
    }, [this.$slots.default])])]);
  }
});
// CONCATENATED MODULE: ./src/tabs/src/tabs.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_tabsvue_type_script_lang_js_ = (tabsvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/tabs/src/tabs.vue
var tabs_render, tabs_staticRenderFns




/* normalize component */

var tabs_component = Object(componentNormalizer["a" /* default */])(
  src_tabsvue_type_script_lang_js_,
  tabs_render,
  tabs_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var tabs = (tabs_component.exports);
// CONCATENATED MODULE: ./src/tabs/index.js

/* istanbul ignore next */

tabs.install = function (Vue) {
  Vue.component(tabs.name, tabs);
};

/* harmony default export */ var src_tabs = __webpack_exports__["default"] = (tabs);

/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/_vue-loader@15.9.3@vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/_vue-loader@15.9.3@vue-loader/lib??vue-loader-options!./src/actionsheet/src/actionsheet.vue?vue&type=template&id=6768ca50&lang=html&
var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('za-popup',{attrs:{"visible":_vm.currentVisible,"direction":"bottom","get-container":_vm.getContainer},on:{"maskClick":_vm.handlePopupClose}},[_c('div',{class:( _obj = {}, _obj[("" + _vm.prefixCls)] = true, _obj[(_vm.prefixCls + "--" + _vm.shape)] = !!_vm.shape, _obj[(_vm.prefixCls + "--spacing")] = _vm.spacing, _obj )},[_c('div',{class:(_vm.prefixCls + "__actions")},_vm._l((_vm.actions),function(action,index){
  var _obj;
return _c('a',{key:index,class:( _obj = {}, _obj[(_vm.prefixCls + "__item")] = true, _obj[(_vm.prefixCls + "__item--" + (action.theme))] = !!action.theme, _obj ),on:{"click":action.onClick}},[_vm._v(_vm._s(action.text))])}),0),_vm._v(" "),(_vm.showCancel)?_c('div',{class:(_vm.prefixCls + "__cancel")},[_c('a',{class:(_vm.prefixCls + "__item"),on:{"click":_vm.onCancel}},[_vm._v(_vm._s(_vm.cancelText))])]):_vm._e()])])}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/actionsheet/src/actionsheet.vue?vue&type=template&id=6768ca50&lang=html&

// EXTERNAL MODULE: ./src/popup/index.js + 3 modules
var popup = __webpack_require__(74);

// CONCATENATED MODULE: ./node_modules/_babel-loader@8.1.0@babel-loader/lib!./node_modules/_vue-loader@15.9.3@vue-loader/lib??vue-loader-options!./src/actionsheet/src/actionsheet.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var actionsheetvue_type_script_lang_js_ = ({
  name: 'zaActionsheet',
  components: {
    zaPopup: popup["default"]
  },
  props: {
    prefixCls: {
      type: String,
      default: 'za-actionsheet'
    },
    shape: {
      type: String,
      default: ''
    },
    spacing: {
      type: Boolean,
      default: false
    },
    actions: {
      type: Array,
      default: function _default() {
        // eslint-disable-line object-shorthand
        return [];
      }
    },
    cancelText: {
      type: String,
      default: '取消'
    },
    visible: {
      type: Boolean,
      default: false
    },
    showCancel: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      currentVisible: this.visible,
      getContainer: function getContainer() {
        return document.body;
      }
    };
  },
  watch: {
    visible: function visible(value, oldValue) {
      // eslint-disable-line no-unused-vars, object-shorthand
      if (value === this.currentVisible) return;
      this.currentVisible = value;
    }
  },
  methods: {
    onCancel: function onCancel(event) {
      this.currentVisible = false;
      this.$emit('cancel', event);
      this.$emit('update:visible', false);
    },
    handlePopupClose: function handlePopupClose(event) {
      this.$emit('cancel', event);
      this.$emit('update:visible', false);
    }
  }
});
// CONCATENATED MODULE: ./src/actionsheet/src/actionsheet.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_actionsheetvue_type_script_lang_js_ = (actionsheetvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(0);

// CONCATENATED MODULE: ./src/actionsheet/src/actionsheet.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  src_actionsheetvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var actionsheet = (component.exports);
// CONCATENATED MODULE: ./src/actionsheet/index.js

/* istanbul ignore next */

actionsheet.install = function (Vue) {
  Vue.component(actionsheet.name, actionsheet);
};

/* harmony default export */ var src_actionsheet = __webpack_exports__["default"] = (actionsheet);

/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/_vue-loader@15.9.3@vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/_vue-loader@15.9.3@vue-loader/lib??vue-loader-options!./src/badge/src/badge.vue?vue&type=template&id=502a7ec5&lang=html&
var render = function () {
var _obj, _obj$1;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:( _obj = {}, _obj[("" + _vm.prefixCls)] = true, _obj[("" + _vm.className)] = true, _obj[(_vm.prefixCls + "--" + _vm.shape)] = !!_vm.shape, _obj[(_vm.prefixCls + "--" + _vm.theme)] = !!_vm.theme, _obj )},[_vm._t("default"),_vm._v(" "),_c('sup',{class:( _obj$1 = {}, _obj$1[(_vm.prefixCls + "__sup")] = true, _obj$1[(_vm.prefixCls + "__sup--up")] = _vm.sup, _obj$1 ),on:{"click":_vm.supClick}},[_vm._v("\n    "+_vm._s(_vm.text)+"\n    "),_vm._t("text")],2)],2)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/badge/src/badge.vue?vue&type=template&id=502a7ec5&lang=html&

// EXTERNAL MODULE: ./src/utils/validator.js
var validator = __webpack_require__(13);

// CONCATENATED MODULE: ./node_modules/_babel-loader@8.1.0@babel-loader/lib!./node_modules/_vue-loader@15.9.3@vue-loader/lib??vue-loader-options!./src/badge/src/badge.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var badgevue_type_script_lang_js_ = ({
  name: 'zaBadge',
  props: {
    prefixCls: {
      type: String,
      default: 'za-badge'
    },
    className: {
      type: String,
      default: null
    },
    theme: {
      type: String,
      validator: validator["a" /* defaultThemeValidator */],
      default: 'error'
    },
    shape: {
      type: String,
      validator: Object(validator["b" /* enumGenerator */])(['dot', 'rect', 'radius', 'round', 'circle', 'leaf']),
      default: null
    },
    sup: {
      type: Boolean,
      default: false
    },
    text: [String, Number]
  },
  methods: {
    supClick: function supClick(event) {
      this.$emit('click', event);
    }
  }
});
// CONCATENATED MODULE: ./src/badge/src/badge.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_badgevue_type_script_lang_js_ = (badgevue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(0);

// CONCATENATED MODULE: ./src/badge/src/badge.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  src_badgevue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var badge = (component.exports);
// CONCATENATED MODULE: ./src/badge/index.js

/* istanbul ignore next */

badge.install = function (Vue) {
  Vue.component(badge.name, badge);
};

/* harmony default export */ var src_badge = __webpack_exports__["default"] = (badge);

/***/ }),
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/_vue-loader@15.9.3@vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/_vue-loader@15.9.3@vue-loader/lib??vue-loader-options!./src/checkbox/src/checkbox-group.vue?vue&type=template&id=4674f168&lang=html&
var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:( _obj = {}, _obj[("" + _vm.prefixCls)] = true, _obj[(_vm.prefixCls + "--" + _vm.shape)] = !!_vm.shape, _obj[(_vm.prefixCls + "--compact")] = _vm.compact, _obj[(_vm.prefixCls + "--block")] = _vm.block, _obj[(_vm.prefixCls + "--disabled")] = _vm.disabled, _obj )},[_vm._t("default")],2)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/checkbox/src/checkbox-group.vue?vue&type=template&id=4674f168&lang=html&

// EXTERNAL MODULE: ./src/utils/validator.js
var validator = __webpack_require__(13);

// CONCATENATED MODULE: ./node_modules/_babel-loader@8.1.0@babel-loader/lib!./node_modules/_vue-loader@15.9.3@vue-loader/lib??vue-loader-options!./src/checkbox/src/checkbox-group.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var checkbox_groupvue_type_script_lang_js_ = ({
  name: 'zaCheckboxGroup',
  props: {
    prefixCls: {
      type: String,
      default: 'za-checkbox-group'
    },
    theme: {
      type: String,
      validator: validator["a" /* defaultThemeValidator */],
      default: 'primary'
    },
    type: {
      type: String,
      validator: Object(validator["b" /* enumGenerator */])(['button', 'cell']),
      default: null
    },
    shape: {
      type: String,
      validator: Object(validator["b" /* enumGenerator */])(['rect', 'radius', 'round']),
      default: 'radius'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    compact: {
      type: Boolean,
      default: false
    },
    block: {
      type: Boolean,
      default: false
    },
    value: {}
  }
});
// CONCATENATED MODULE: ./src/checkbox/src/checkbox-group.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_checkbox_groupvue_type_script_lang_js_ = (checkbox_groupvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(0);

// CONCATENATED MODULE: ./src/checkbox/src/checkbox-group.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  src_checkbox_groupvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var checkbox_group = (component.exports);
// CONCATENATED MODULE: ./src/checkbox-group/index.js

/* istanbul ignore next */

checkbox_group.install = function (Vue) {
  Vue.component(checkbox_group.name, checkbox_group);
};

/* harmony default export */ var src_checkbox_group = __webpack_exports__["default"] = (checkbox_group);

/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/_vue-loader@15.9.3@vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/_vue-loader@15.9.3@vue-loader/lib??vue-loader-options!./src/checkbox/src/checkbox.vue?vue&type=template&id=5dafa464&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.checkboxType === "cell")?_c('za-cell',{attrs:{"disabled":_vm.checkboxDisabled,"isLink":""},on:{"click":_vm.handleClick}},[_c('div',{class:_vm.cls},[_c('div',{class:(_vm.prefixCls + "__wrapper")},[_c('span',{class:(_vm.prefixCls + "__inner")}),_vm._v(" "),_c('span',{class:(_vm.prefixCls + "__text")},[_vm._t("default")],2),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model),expression:"model"}],class:(_vm.prefixCls + "__input"),attrs:{"type":"checkbox","disabled":_vm.checkboxDisabled},domProps:{"value":_vm.value,"checked":Array.isArray(_vm.model)?_vm._i(_vm.model,_vm.value)>-1:(_vm.model)},on:{"change":function($event){var $$a=_vm.model,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=_vm.value,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.model=$$a.concat([$$v]))}else{$$i>-1&&(_vm.model=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.model=$$c}}}})])])]):(_vm.checkboxType === "button")?_c('za-button',{class:_vm.cls,attrs:{"theme":_vm.theme,"size":"xs","block":_vm.block || _vm.isBlock,"shape":_vm.shape || _vm.isShape,"disabled":_vm.checkboxDisabled,"ghost":!_vm.isChecked}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model),expression:"model"}],class:(_vm.prefixCls + "__input"),attrs:{"type":"checkbox","disabled":_vm.checkboxDisabled},domProps:{"value":_vm.value,"checked":Array.isArray(_vm.model)?_vm._i(_vm.model,_vm.value)>-1:(_vm.model)},on:{"change":[function($event){var $$a=_vm.model,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=_vm.value,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.model=$$a.concat([$$v]))}else{$$i>-1&&(_vm.model=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.model=$$c}},_vm.onValueChange]}}),_vm._v(" "),_vm._t("default")],2):_c('div',{class:_vm.cls},[_c('div',{class:(_vm.prefixCls + "__wrapper")},[_c('span',{class:(_vm.prefixCls + "__inner")}),_vm._v(" "),_c('span',{class:(_vm.prefixCls + "__text")},[_vm._t("default")],2),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model),expression:"model"}],class:(_vm.prefixCls + "__input"),attrs:{"type":"checkbox","disabled":_vm.checkboxDisabled},domProps:{"value":_vm.value,"checked":Array.isArray(_vm.model)?_vm._i(_vm.model,_vm.value)>-1:(_vm.model)},on:{"change":[function($event){var $$a=_vm.model,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=_vm.value,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.model=$$a.concat([$$v]))}else{$$i>-1&&(_vm.model=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.model=$$c}},_vm.onValueChange]}})])])}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/checkbox/src/checkbox.vue?vue&type=template&id=5dafa464&

// EXTERNAL MODULE: ./node_modules/_@babel_runtime-corejs2@7.11.2@@babel/runtime-corejs2/helpers/toConsumableArray.js
var toConsumableArray = __webpack_require__(97);
var toConsumableArray_default = /*#__PURE__*/__webpack_require__.n(toConsumableArray);

// EXTERNAL MODULE: ./node_modules/_@babel_runtime-corejs2@7.11.2@@babel/runtime-corejs2/helpers/defineProperty.js
var defineProperty = __webpack_require__(37);
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// EXTERNAL MODULE: ./node_modules/_@babel_runtime-corejs2@7.11.2@@babel/runtime-corejs2/core-js/array/is-array.js
var is_array = __webpack_require__(128);
var is_array_default = /*#__PURE__*/__webpack_require__.n(is_array);

// EXTERNAL MODULE: ./src/button/index.js + 5 modules
var src_button = __webpack_require__(114);

// EXTERNAL MODULE: ./src/cell/index.js + 5 modules
var cell = __webpack_require__(146);

// EXTERNAL MODULE: ./src/mixins/emitter.js
var emitter = __webpack_require__(115);

// EXTERNAL MODULE: ./src/utils/validator.js
var validator = __webpack_require__(13);

// CONCATENATED MODULE: ./node_modules/_babel-loader@8.1.0@babel-loader/lib!./node_modules/_vue-loader@15.9.3@vue-loader/lib??vue-loader-options!./src/checkbox/src/checkbox.vue?vue&type=script&lang=js&



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// necessary when used alone




/* harmony default export */ var checkboxvue_type_script_lang_js_ = ({
  name: 'zaCheckbox',
  mixins: [emitter["a" /* default */]],
  components: {
    zaButton: src_button["default"],
    zaCell: cell["default"]
  },
  props: {
    prefixCls: {
      type: String,
      default: 'za-checkbox'
    },
    theme: {
      type: String,
      validator: validator["a" /* defaultThemeValidator */],
      default: 'primary'
    },
    type: {
      type: String,
      validator: Object(validator["b" /* enumGenerator */])(['button', 'cell']),
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    value: {},
    block: {
      type: Boolean,
      default: false
    },
    checked: {
      type: Boolean,
      default: false
    },
    shape: {
      type: String,
      validator: Object(validator["b" /* enumGenerator */])(['rect', 'radius', 'round']),
      default: null
    }
  },
  data: function data() {
    return {
      currentChecked: this.checked || false
    };
  },
  computed: {
    model: {
      get: function get() {
        return this.isGroup ? this.store : this.value !== undefined ? this.value : this.currentChecked;
      },
      set: function set(val) {
        if (this.isGroup) {
          this.dispatch('zaCheckboxGroup', 'input', [val]);
        } else {
          this.$emit('input', val);
          this.currentChecked = val;
        }
      }
    },
    isGroup: function isGroup() {
      var parent = this.$parent;

      while (parent) {
        if (parent.$options.name !== 'zaCheckboxGroup') {
          parent = parent.$parent;
        } else {
          this._checkboxGroup = parent;
          return true;
        }
      }

      return false;
    },
    isChecked: function isChecked() {
      if ({}.toString.call(this.model) === '[object Boolean]') {
        return this.model;
      } else if (is_array_default()(this.model)) {
        return this.model.indexOf(this.value) > -1;
      }
    },
    store: function store() {
      return this.isGroup ? this._checkboxGroup.value : this.value;
    },
    checkboxType: function checkboxType() {
      return this.isGroup ? this._checkboxGroup.type : this.type;
    },
    checkboxDisabled: function checkboxDisabled() {
      return this.isGroup ? this._checkboxGroup.disabled || this.disabled : this.disabled;
    },
    isBlock: function isBlock() {
      return this.isGroup ? this._checkboxGroup.block : this.block;
    },
    isShape: function isShape() {
      return this.isGroup ? this._checkboxGroup.shape : this.shape;
    },
    cls: function cls() {
      var _ref;

      var prefixCls = this.prefixCls,
          theme = this.theme,
          shape = this.shape,
          size = this.size,
          checkboxDisabled = this.checkboxDisabled,
          isChecked = this.isChecked;
      return _ref = {}, defineProperty_default()(_ref, "".concat(prefixCls), true), defineProperty_default()(_ref, "".concat(prefixCls, "--").concat(theme), !!theme), defineProperty_default()(_ref, "".concat(prefixCls, "--").concat(shape), !!shape), defineProperty_default()(_ref, "".concat(prefixCls, "--").concat(size), !!size), defineProperty_default()(_ref, "".concat(prefixCls, "--checked"), !!isChecked), defineProperty_default()(_ref, "".concat(prefixCls, "--disabled"), !!checkboxDisabled), _ref;
    }
  },
  methods: {
    onValueChange: function onValueChange(event) {
      var _this = this;

      // first emit('input') to make the model up to date
      this.$nextTick(function (_) {
        // eslint-disable-line no-unused-vars
        if (_this.isGroup) {
          _this.dispatch('zaCheckboxGroup', 'change', [toConsumableArray_default()(_this.model), event]);
        } else {
          _this.$emit('change', _this.model, event);
        }
      });
    },
    handleClick: function handleClick(event) {
      if (this.checkboxDisabled) return;

      if (this.isGroup) {
        var index = this.model.indexOf(this.value);

        if (index >= 0) {
          this.model.splice(index, 1);
        } else {
          this.model.push(this.value);
        }

        this.onValueChange(event);
      } else {
        this.model = !this.model;
        this.onValueChange(event);
      }
    }
  }
});
// CONCATENATED MODULE: ./src/checkbox/src/checkbox.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_checkboxvue_type_script_lang_js_ = (checkboxvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(0);

// CONCATENATED MODULE: ./src/checkbox/src/checkbox.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  src_checkboxvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var src_checkbox = (component.exports);
// CONCATENATED MODULE: ./src/checkbox/index.js

/* istanbul ignore next */

src_checkbox.install = function (Vue) {
  Vue.component(src_checkbox.name, src_checkbox);
};

/* harmony default export */ var src_checkbox_0 = __webpack_exports__["default"] = (src_checkbox);

/***/ }),
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/_vue-loader@15.9.3@vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/_vue-loader@15.9.3@vue-loader/lib??vue-loader-options!./src/collapse/src/collapse.vue?vue&type=template&id=73cf6f8e&lang=html&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[_vm.prefixCls, _vm.className]},[_vm._t("default")],2)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/collapse/src/collapse.vue?vue&type=template&id=73cf6f8e&lang=html&

// EXTERNAL MODULE: ./node_modules/_@babel_runtime-corejs2@7.11.2@@babel/runtime-corejs2/helpers/typeof.js
var helpers_typeof = __webpack_require__(58);
var typeof_default = /*#__PURE__*/__webpack_require__.n(helpers_typeof);

// CONCATENATED MODULE: ./node_modules/_babel-loader@8.1.0@babel-loader/lib!./node_modules/_vue-loader@15.9.3@vue-loader/lib??vue-loader-options!./src/collapse/src/collapse.vue?vue&type=script&lang=js&

//
//
//
//
//
//
/* harmony default export */ var collapsevue_type_script_lang_js_ = ({
  name: 'zaCollapse',
  props: {
    prefixCls: {
      type: String,
      default: 'za-collapse'
    },
    className: {
      type: String
    },
    defaultActiveKey: {
      type: [String, Number, Array],
      default: function _default() {
        return [];
      }
    },
    activeKey: {
      type: [String, Number, Array],
      default: function _default() {
        return [];
      }
    },
    multiple: {
      type: Boolean,
      default: false
    },
    animated: {
      type: Boolean,
      default: false
    },
    open: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      currActiveKey: []
    };
  },
  watch: {
    activeKey: function activeKey(val) {
      var _this = this;

      this.$nextTick(function () {
        var currActiveKey = typeof_default()(val) === 'object' ? val : [val];
        _this.currActiveKey = _this.multiple ? currActiveKey : [currActiveKey[0]];
      });
    }
  },
  created: function created() {
    var multiple = this.multiple,
        activeKey = this.activeKey;
    var currActiveKey = typeof_default()(activeKey) === 'object' ? activeKey : [activeKey];

    if (currActiveKey.length > 0) {
      this.currActiveKey = multiple ? currActiveKey : [currActiveKey[0]];
    } else {
      this.currActiveKey = this.getActiveIndex();
    }
  },
  methods: {
    onItemChange: function onItemChange(key) {
      var multiple = this.multiple,
          currActiveKey = this.currActiveKey;
      var hasKey = currActiveKey.indexOf(key) > -1;
      var newActiveIndex = [];

      if (!multiple) {
        if (hasKey) {
          newActiveIndex = currActiveKey.filter(function (i) {
            return i !== key;
          });
        } else {
          newActiveIndex = currActiveKey.slice(0);
          newActiveIndex.push(key);
        }
      } else {
        newActiveIndex = hasKey ? [] : [key];
      }

      this.currActiveKey = newActiveIndex;
      this.$emit('change', key);
    },
    getActiveIndex: function getActiveIndex() {
      var defaultActiveKey = this.defaultActiveKey,
          multiple = this.multiple;
      var defaultIndex = typeof_default()(defaultActiveKey) === 'object' ? defaultActiveKey : [defaultActiveKey];
      return multiple ? defaultIndex : [defaultIndex[0]];
    }
  }
});
// CONCATENATED MODULE: ./src/collapse/src/collapse.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_collapsevue_type_script_lang_js_ = (collapsevue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(0);

// CONCATENATED MODULE: ./src/collapse/src/collapse.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  src_collapsevue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var collapse = (component.exports);
// CONCATENATED MODULE: ./src/collapse/index.js

/* istanbul ignore next */

collapse.install = function (Vue) {
  Vue.component(collapse.name, collapse);
};

/* harmony default export */ var src_collapse = __webpack_exports__["default"] = (collapse);

/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/_vue-loader@15.9.3@vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/_vue-loader@15.9.3@vue-loader/lib??vue-loader-options!./src/input/src/input-number.vue?vue&type=template&id=1546199a&lang=html&
var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"container",class:( _obj = {}, _obj[("" + _vm.prefixCls)] = true, _obj[(_vm.prefixCls + "__number")] = true, _obj[(_vm.prefixCls + "--disabled")] = _vm.disabled, _obj[(_vm.prefixCls + "--focus")] = _vm.visible, _obj ),on:{"click":_vm.onFocus}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.currentValue),expression:"!currentValue"}],class:(_vm.prefixCls + "__placeholder")},[_vm._v(_vm._s(_vm.placeholder))]),_vm._v(" "),_c('div',{ref:"content",class:(_vm.prefixCls + "__content")},[_vm._v(_vm._s(_vm.currentValue))]),_vm._v(" "),_c('input',{attrs:{"type":"hidden","disabled":_vm.disabled,"readonly":_vm.readonly},domProps:{"value":_vm.currentValue}}),_vm._v(" "),_c('KeyboardPicker',{ref:"picker",attrs:{"visible":_vm.visible,"type":_vm.type},on:{"update:visible":function($event){_vm.visible=$event},"keyClick":_vm.onKeyClick}})],1)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/input/src/input-number.vue?vue&type=template&id=1546199a&lang=html&

// EXTERNAL MODULE: ./src/utils/clickoutside.js
var clickoutside = __webpack_require__(129);

// EXTERNAL MODULE: ./src/keyboard-picker/index.js + 5 modules
var keyboard_picker = __webpack_require__(170);

// CONCATENATED MODULE: ./node_modules/_babel-loader@8.1.0@babel-loader/lib!./node_modules/_vue-loader@15.9.3@vue-loader/lib??vue-loader-options!./src/input/src/input-number.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var input_numbervue_type_script_lang_js_ = ({
  name: 'zaInputNumber',
  props: {
    prefixCls: {
      type: String,
      default: 'za-input'
    },
    placeholder: String,
    type: {
      type: String,
      default: 'number'
    },
    value: [String, Number],
    disabled: {
      type: Boolean,
      default: false
    },
    readonly: Boolean
  },
  data: function data() {
    return {
      currentValue: this.value || '',
      hideOnClickOutside: true,
      visible: false
    };
  },
  components: {
    KeyboardPicker: keyboard_picker["default"]
  },
  watch: {
    'value': function value(val, oldValue) {
      // eslint-disable-line no-unused-vars, object-shorthand
      this.setCurrentValue(val);
    }
  },
  mounted: function mounted() {
    clickoutside["a" /* default */].addClickoutSide({
      handle: this.onOutsideBlur
    });
  },
  beforeDestroy: function beforeDestroy() {
    clickoutside["a" /* default */].removeClickoutSide({
      handle: this.onOutsideBlur
    });
  },
  methods: {
    setCurrentValue: function setCurrentValue(value) {
      if (value === this.currentValue) return;
      this.currentValue = value;
    },
    onKeyClick: function onKeyClick(key) {
      if (['close', 'ok'].indexOf(key) > -1) {
        this.onBlur();
        return;
      }

      var value = this.value;
      var newValue = key === 'delete' ? value.slice(0, value.length - 1) : value + key;

      if (newValue !== value) {
        this.currentValue = newValue;
        this.scrollToEnd();
        this.$emit('input', newValue);
        this.$emit('change', newValue);
      }
    },
    scrollToStart: function scrollToStart() {
      if (!this.$refs.content) return;
      this.$refs.content.scrollLeft = 0;
    },
    scrollToEnd: function scrollToEnd() {
      if (!this.$refs.content) return;
      this.$refs.content.scrollLeft = this.$refs.content.scrollWidth;
    },
    onFocus: function onFocus() {
      if (this.disabled || this.visible) {
        return;
      }

      this.visible = true;
      this.scrollToEnd();
      this.$emit('focus', this.value);
    },
    onOutsideBlur: function onOutsideBlur(e) {
      if (!this.visible) {
        return;
      }

      var $el = this.$refs.picker.$refs.popup.$el;
      var $container = this.$refs.container;
      clickoutside["a" /* default */].clickoutSideHandle(e, {
        onClickoutSide: this.onBlur,
        ignorenode: $container,
        el: $el
      });
    },
    onBlur: function onBlur() {
      if (!this.visible) {
        return;
      }

      this.visible = false;
      this.scrollToStart();
      this.$emit('blur', this.value);
    }
  }
});
// CONCATENATED MODULE: ./src/input/src/input-number.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_input_numbervue_type_script_lang_js_ = (input_numbervue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(0);

// CONCATENATED MODULE: ./src/input/src/input-number.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  src_input_numbervue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var input_number = (component.exports);
// CONCATENATED MODULE: ./src/input-number/index.js

/* istanbul ignore next */

input_number.install = function (Vue) {
  Vue.component(input_number.name, input_number);
};

/* harmony default export */ var src_input_number = __webpack_exports__["default"] = (input_number);

/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/_vue-loader@15.9.3@vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/_vue-loader@15.9.3@vue-loader/lib??vue-loader-options!./src/nav-bar/src/nav-bar.vue?vue&type=template&id=61e1913c&lang=html&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:("" + _vm.prefixCls)},[_c('div',{class:(_vm.prefixCls + "__left")},[_vm._t("left")],2),_vm._v(" "),_c('div',{class:(_vm.prefixCls + "__title")},[_vm._t("title")],2),_vm._v(" "),_c('div',{class:(_vm.prefixCls + "__right")},[_vm._t("right")],2)])}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/nav-bar/src/nav-bar.vue?vue&type=template&id=61e1913c&lang=html&

// CONCATENATED MODULE: ./node_modules/_babel-loader@8.1.0@babel-loader/lib!./node_modules/_vue-loader@15.9.3@vue-loader/lib??vue-loader-options!./src/nav-bar/src/nav-bar.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var nav_barvue_type_script_lang_js_ = ({
  name: 'zaNavBar',
  props: {
    prefixCls: {
      type: String,
      default: 'za-navbar'
    }
  },
  data: function data() {
    return {};
  }
});
// CONCATENATED MODULE: ./src/nav-bar/src/nav-bar.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_nav_barvue_type_script_lang_js_ = (nav_barvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(0);

// CONCATENATED MODULE: ./src/nav-bar/src/nav-bar.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  src_nav_barvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var nav_bar = (component.exports);
// CONCATENATED MODULE: ./src/nav-bar/index.js

/* istanbul ignore next */

nav_bar.install = function (Vue) {
  Vue.component(nav_bar.name, nav_bar);
};

/* harmony default export */ var src_nav_bar = __webpack_exports__["default"] = (nav_bar);

/***/ }),
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/_vue-loader@15.9.3@vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/_vue-loader@15.9.3@vue-loader/lib??vue-loader-options!./src/panel/src/panel.vue?vue&type=template&id=87485ad0&lang=html&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.prefixCls},[_vm._t("default")],2)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/panel/src/panel.vue?vue&type=template&id=87485ad0&lang=html&

// CONCATENATED MODULE: ./node_modules/_babel-loader@8.1.0@babel-loader/lib!./node_modules/_vue-loader@15.9.3@vue-loader/lib??vue-loader-options!./src/panel/src/panel.vue?vue&type=script&lang=js&
//
//
//
//
//
//
/* harmony default export */ var panelvue_type_script_lang_js_ = ({
  name: 'zaPanel',
  props: {
    prefixCls: {
      type: String,
      default: 'za-panel'
    }
  },
  data: function data() {
    return {};
  },
  methods: {}
});
// CONCATENATED MODULE: ./src/panel/src/panel.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_panelvue_type_script_lang_js_ = (panelvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(0);

// CONCATENATED MODULE: ./src/panel/src/panel.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  src_panelvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var panel = (component.exports);
// CONCATENATED MODULE: ./src/panel/index.js

/* istanbul ignore next */

panel.install = function (Vue) {
  Vue.component(panel.name, panel);
};

/* harmony default export */ var src_panel = __webpack_exports__["default"] = (panel);

/***/ }),
/* 205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/_vue-loader@15.9.3@vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/_vue-loader@15.9.3@vue-loader/lib??vue-loader-options!./src/panel/src/panel-header.vue?vue&type=template&id=b754b3d8&lang=html&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:(_vm.prefixCls + "__header")},[(_vm.$slots.title || _vm.title)?_c('div',{class:(_vm.prefixCls + "__title")},[_vm._t("title"),_vm._v(" "),(!_vm.$slots.title)?[_vm._v(_vm._s(_vm.title))]:_vm._e()],2):_vm._e(),_vm._v(" "),(_vm.$slots.more || _vm.more)?_c('div',{class:(_vm.prefixCls + "__more")},[_vm._t("more"),_vm._v(" "),(!_vm.$slots.more)?[_vm._v(_vm._s(_vm.more))]:_vm._e()],2):_vm._e()])}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/panel/src/panel-header.vue?vue&type=template&id=b754b3d8&lang=html&

// CONCATENATED MODULE: ./node_modules/_babel-loader@8.1.0@babel-loader/lib!./node_modules/_vue-loader@15.9.3@vue-loader/lib??vue-loader-options!./src/panel/src/panel-header.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var panel_headervue_type_script_lang_js_ = ({
  name: 'zaPanelHeader',
  props: {
    prefixCls: {
      type: String,
      default: 'za-panel'
    },
    title: {},
    more: {}
  },
  data: function data() {
    return {};
  },
  methods: {}
});
// CONCATENATED MODULE: ./src/panel/src/panel-header.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_panel_headervue_type_script_lang_js_ = (panel_headervue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(0);

// CONCATENATED MODULE: ./src/panel/src/panel-header.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  src_panel_headervue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var panel_header = (component.exports);
// CONCATENATED MODULE: ./src/panel-header/index.js

/* istanbul ignore next */

panel_header.install = function (Vue) {
  Vue.component(panel_header.name, panel_header);
};

/* harmony default export */ var src_panel_header = __webpack_exports__["default"] = (panel_header);

/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/_vue-loader@15.9.3@vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/_vue-loader@15.9.3@vue-loader/lib??vue-loader-options!./src/panel/src/panel-body.vue?vue&type=template&id=398c9276&lang=html&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:(_vm.prefixCls + "__body")},[_vm._t("default")],2)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/panel/src/panel-body.vue?vue&type=template&id=398c9276&lang=html&

// CONCATENATED MODULE: ./node_modules/_babel-loader@8.1.0@babel-loader/lib!./node_modules/_vue-loader@15.9.3@vue-loader/lib??vue-loader-options!./src/panel/src/panel-body.vue?vue&type=script&lang=js&
//
//
//
//
//
//
/* harmony default export */ var panel_bodyvue_type_script_lang_js_ = ({
  name: 'zaPanelBody',
  props: {
    prefixCls: {
      type: String,
      default: 'za-panel'
    }
  },
  data: function data() {
    return {};
  },
  methods: {}
});
// CONCATENATED MODULE: ./src/panel/src/panel-body.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_panel_bodyvue_type_script_lang_js_ = (panel_bodyvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(0);

// CONCATENATED MODULE: ./src/panel/src/panel-body.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  src_panel_bodyvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var panel_body = (component.exports);
// CONCATENATED MODULE: ./src/panel-body/index.js

/* istanbul ignore next */

panel_body.install = function (Vue) {
  Vue.component(panel_body.name, panel_body);
};

/* harmony default export */ var src_panel_body = __webpack_exports__["default"] = (panel_body);

/***/ }),
/* 207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/_vue-loader@15.9.3@vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/_vue-loader@15.9.3@vue-loader/lib??vue-loader-options!./src/panel/src/panel-footer.vue?vue&type=template&id=5dbadfde&lang=html&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:(_vm.prefixCls + "__footer")},[(_vm.$slots.title || _vm.title)?_c('div',{class:(_vm.prefixCls + "__title")},[_vm._t("title"),_vm._v(" "),(!_vm.$slots.title)?[_vm._v(_vm._s(_vm.title))]:_vm._e()],2):_vm._e(),_vm._v(" "),(_vm.$slots.more || _vm.more)?_c('div',{class:(_vm.prefixCls + "__more")},[_vm._t("more"),_vm._v(" "),(!_vm.$slots.more)?[_vm._v(_vm._s(_vm.more))]:_vm._e()],2):_vm._e()])}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/panel/src/panel-footer.vue?vue&type=template&id=5dbadfde&lang=html&

// CONCATENATED MODULE: ./node_modules/_babel-loader@8.1.0@babel-loader/lib!./node_modules/_vue-loader@15.9.3@vue-loader/lib??vue-loader-options!./src/panel/src/panel-footer.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var panel_footervue_type_script_lang_js_ = ({
  name: 'zaPanelFooter',
  props: {
    prefixCls: {
      type: String,
      default: 'za-panel'
    },
    title: {},
    more: {}
  },
  data: function data() {
    return {};
  },
  methods: {}
});
// CONCATENATED MODULE: ./src/panel/src/panel-footer.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_panel_footervue_type_script_lang_js_ = (panel_footervue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(0);

// CONCATENATED MODULE: ./src/panel/src/panel-footer.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  src_panel_footervue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var panel_footer = (component.exports);
// CONCATENATED MODULE: ./src/panel-footer/index.js

/* istanbul ignore next */

panel_footer.install = function (Vue) {
  Vue.component(panel_footer.name, panel_footer);
};

/* harmony default export */ var src_panel_footer = __webpack_exports__["default"] = (panel_footer);

/***/ }),
/* 208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/_vue-loader@15.9.3@vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/_vue-loader@15.9.3@vue-loader/lib??vue-loader-options!./src/progress/src/progress.vue?vue&type=template&id=7526eff5&lang=html&
var render = function () {
var _obj, _obj$1;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:( _obj = {}, _obj[("" + _vm.prefixCls)] = true, _obj[(_vm.prefixCls + "--" + _vm.theme)] = !!_vm.theme, _obj[(_vm.prefixCls + "--" + _vm.type)] = !!_vm.type, _obj )},[(_vm.type==='circle' || _vm.type==='semi-circle')?_c('div',{class:(_vm.prefixCls + "__inner")},[_c('svg',{ref:"svg",class:( _obj$1 = {}, _obj$1[("" + _vm.prefixCls)] = true, _obj$1[(_vm.prefixCls + "__" + _vm.type)] = true, _obj$1[(_vm.prefixCls + "--" + _vm.theme)] = !!_vm.theme, _obj$1 ),attrs:{"viewBox":_vm.viewBox}},[_c('path',{class:(_vm.prefixCls + "__track"),attrs:{"d":_vm.path,"stroke-width":_vm.calStrokeWidth,"stroke-linecap":_vm.strokeLinecap}}),_vm._v(" "),_c('path',{class:(_vm.prefixCls + "__line"),attrs:{"d":_vm.path,"stroke-width":_vm.calStrokeWidth,"stroke-linecap":_vm.strokeLinecap,"stroke-dasharray":_vm.dasharray,"stroke-dashoffset":_vm.dashoffset}})])]):_c('div',{class:(_vm.prefixCls + "__inner"),style:({height: (_vm.strokeWidth + "px"), borderRadius: (_vm.borderR + "px")})},[_c('div',{class:(_vm.prefixCls + "__bg"),style:({ width: (_vm.percent + "%"), borderRadius: (_vm.borderR + "px")})})]),_vm._v(" "),_c('div',{class:(_vm.prefixCls + "__text")},[_vm._t("default")],2)])}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/progress/src/progress.vue?vue&type=template&id=7526eff5&lang=html&

// EXTERNAL MODULE: ./src/utils/validator.js
var validator = __webpack_require__(13);

// CONCATENATED MODULE: ./node_modules/_babel-loader@8.1.0@babel-loader/lib!./node_modules/_vue-loader@15.9.3@vue-loader/lib??vue-loader-options!./src/progress/src/progress.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var diameter = 62;
/* harmony default export */ var progressvue_type_script_lang_js_ = ({
  name: 'zaProgress',
  data: function data() {
    return {
      diameter: diameter,
      calStrokeWidth: 0
    };
  },
  props: {
    prefixCls: {
      type: String,
      default: 'za-progress'
    },
    shape: {
      type: String,
      validator: Object(validator["b" /* enumGenerator */])(['rect', 'round']),
      default: 'rect'
    },
    theme: {
      type: String,
      validator: validator["a" /* defaultThemeValidator */],
      default: 'primary'
    },
    weight: {
      type: [String, Number],
      default: 'normal'
    },
    percent: {
      type: Number,
      default: 0
    },
    type: {
      type: String,
      validator: function validator(v) {
        // eslint-disable-line object-shorthand
        return ['line', 'circle', 'semi-circle'].indexOf(v) >= 0;
      },
      default: 'line'
    }
  },
  mounted: function mounted() {
    if (this.type !== 'line') {
      this.calStrokeWidth = this.diameter / this.$refs.svg.clientWidth * this.strokeWidth;
    }
  },
  watch: {
    weight: function weight() {
      if (this.type !== 'line') {
        this.calStrokeWidth = this.diameter / this.$refs.svg.clientWidth * this.strokeWidth;
      }
    }
  },
  computed: {
    strokeWidth: function strokeWidth() {
      return typeof this.weight === 'number' ? this.weight : this.weight === 'normal' ? 8 : 4;
    },
    borderR: function borderR() {
      return this.shape === 'round' ? this.strokeWidth : 0;
    },
    half: function half() {
      return this.diameter / 2;
    },
    r: function r() {
      return this.half + this.calStrokeWidth / 2;
    },
    strokeLinecap: function strokeLinecap() {
      return this.shape === 'round' ? 'round' : 'butt';
    },
    viewBox: function viewBox() {
      return this.type === 'semi-circle' ? "\n      0 0 ".concat(this.diameter + this.calStrokeWidth, " ").concat((this.diameter + this.calStrokeWidth) / 2) : "\n      0 0 ".concat(this.diameter + this.calStrokeWidth, " ").concat(this.diameter + this.calStrokeWidth);
    },
    dasharray: function dasharray() {
      return this.type === 'circle' ? Math.PI * this.diameter : Math.PI * (this.diameter / 2);
    },
    dashoffset: function dashoffset() {
      return this.dasharray * (100 - this.percent) / 100;
    },
    path: function path() {
      return this.type === 'circle' ? "\n        M".concat(this.r, ", ").concat(this.r, "\n        m0 ").concat(-this.half, "\n        a").concat(this.half, " ").concat(this.half, " 0 1 1 0 ").concat(diameter, "\n        a").concat(this.half, " ").concat(this.half, " 0 1 1 0 ").concat(-diameter) : "\n        M".concat(this.r, ", ").concat(this.r, "\n        m").concat(-this.half, " 0\n        a").concat(this.half, " ").concat(this.half, " 0 0 1 ").concat(this.diameter, " 0");
    }
  }
});
// CONCATENATED MODULE: ./src/progress/src/progress.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_progressvue_type_script_lang_js_ = (progressvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(0);

// CONCATENATED MODULE: ./src/progress/src/progress.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  src_progressvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var progress = (component.exports);
// CONCATENATED MODULE: ./src/progress/index.js

/* istanbul ignore next */

progress.install = function (Vue) {
  Vue.component(progress.name, progress);
};

/* harmony default export */ var src_progress = __webpack_exports__["default"] = (progress);

/***/ }),
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/_vue-loader@15.9.3@vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/_vue-loader@15.9.3@vue-loader/lib??vue-loader-options!./src/search-bar/src/search-bar.vue?vue&type=template&id=7ef24192&lang=html&
var render = function () {
var _obj, _obj$1, _obj$2;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.prefixCls},[_c('form',{ref:"searchForm",class:( _obj = {}, _obj[(_vm.prefixCls + "__form")] = true, _obj[(_vm.prefixCls + "__form--focus")] = !!(_vm.focus || (_vm.currentValue && _vm.currentValue.length > 0)), _obj ),attrs:{"action":"#"},on:{"submit":_vm.onSubmit}},[_c('div',{class:( _obj$1 = {}, _obj$1[(_vm.prefixCls + "__content")] = true, _obj$1[(_vm.prefixCls + "__content--" + _vm.shape)] = !!_vm.shape, _obj$1 )},[_c('div',{class:(_vm.prefixCls + "__mock")},[_c('div',{ref:"searchContainer",class:(_vm.prefixCls + "__mock-container")},[_c('za-icon',{attrs:{"type":"search"}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.isVisibility),expression:"isVisibility"}],class:(_vm.prefixCls + "__mock-placeholder")},[_vm._v(_vm._s(_vm.placeholder || _vm.placeholderText))])],1)]),_vm._v(" "),_c('za-input',{ref:"inputRef",class:(_vm.prefixCls + "__input"),attrs:{"type":"search","placeholder":_vm.placeholder || _vm.placeholderText,"value":_vm.currentValue,"disabled":_vm.disabled,"clearable":_vm.clearable,"maxLength":_vm.maxLength},on:{"focus":_vm.onFocus,"compositionStart":_vm.handleComposition,"compositionUpdate":_vm.handleComposition,"compositionEnd":_vm.handleComposition,"change":_vm.onChange,"blur":_vm.onBlur,"clear":_vm.onClear}})],1),_vm._v(" "),_c('div',{ref:"cancelRef",class:( _obj$2 = {}, _obj$2[(_vm.prefixCls + "__cancel")] = true, _obj$2[(_vm.prefixCls + "__cancel-show")] = !!(_vm.showCancel || _vm.focusStatus || (_vm.currentValue && _vm.currentValue.length > 0)), _obj$2 ),on:{"click":_vm.onCancel}},[_vm._v(_vm._s(_vm.cancelText || _vm.cancelBtnText))])])])}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/search-bar/src/search-bar.vue?vue&type=template&id=7ef24192&lang=html&

// EXTERNAL MODULE: ./node_modules/_@babel_runtime-corejs2@7.11.2@@babel/runtime-corejs2/core-js/parse-int.js
var parse_int = __webpack_require__(181);
var parse_int_default = /*#__PURE__*/__webpack_require__.n(parse_int);

// EXTERNAL MODULE: ./src/utils/locale.js
var locale = __webpack_require__(147);

// EXTERNAL MODULE: ./src/input/src/input.vue + 4 modules
var input = __webpack_require__(136);

// CONCATENATED MODULE: ./node_modules/_babel-loader@8.1.0@babel-loader/lib!./node_modules/_vue-loader@15.9.3@vue-loader/lib??vue-loader-options!./src/search-bar/src/search-bar.vue?vue&type=script&lang=js&

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var search_barvue_type_script_lang_js_ = ({
  name: 'zaSearchBar',
  components: {
    zaInput: input["a" /* default */]
  },
  inject: {
    localeProvider: {
      default: ''
    }
  },
  props: {
    prefixCls: {
      type: String,
      default: 'za-search-bar'
    },
    placeholder: {
      type: String,
      default: ''
    },
    value: [String, Number],
    maxLength: [Number],
    shape: {
      type: String,
      default: 'raduis'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    cancelText: {
      type: String,
      default: ''
    },
    showCancel: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      focusStatus: false,
      currentValue: this.defaultValue || this.value || '',
      isOnComposition: false
    };
  },
  watch: {
    value: function value(_value) {
      if (_value === this.currentValue) return;
      this.currentValue = _value;
    }
  },
  computed: {
    isVisibility: function isVisibility() {
      return this.currentValue ? 0 : 1;
    },
    cancelBtnText: function cancelBtnText() {
      return this.localeProvider.lang ? this.getLocales('cancelText') : '取消';
    },
    placeholderText: function placeholderText() {
      return this.localeProvider.lang ? this.getLocales('placeholder') : '搜索';
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      _this.calculatePositon();
    });
  },
  methods: {
    // 国际化
    getLocales: function getLocales(key) {
      return locale["a" /* default */].getLocaleByComponent(this.localeProvider, 'SearchBar', key);
    },
    // 初始化搜索提示文字的位置
    calculatePositon: function calculatePositon() {
      var showCancel = this.showCancel;
      var formWidth = this.$refs.searchForm.getBoundingClientRect().width;
      var containerWidth = this.$refs.searchContainer.getBoundingClientRect().width;

      var ml = parse_int_default()(window.getComputedStyle(this.$refs.cancelRef, '')['margin-left'].split('px')[0], 10);

      this.cancelOuterWidth = Math.ceil(ml + parse_int_default()(this.$refs.cancelRef.getBoundingClientRect().width, 10));

      if (!showCancel) {
        this.$refs.cancelRef.style.cssText = "margin-right: -".concat(this.cancelOuterWidth, "px;");
        this.initPos = formWidth / 2 - containerWidth / 2;
      } else {
        this.initPos = formWidth / 2 - this.cancelOuterWidth / 2 - containerWidth / 2;
      }

      if (!this.currentValue) {
        this.$refs.searchContainer.style.transform = "translate3d(".concat(this.initPos, "px, 0, 0)");
        this.$refs.searchContainer.style.webkitTransform = "translate3d(".concat(this.initPos, "px, 0, 0)");
      } else {
        this.focusAnim(0);
      }
    },
    onFocus: function onFocus() {
      this.focusStatus = true;
      this.focusAnim();
      this.$emit('focus');
    },
    onChange: function onChange(value) {
      this.currentValue = value;

      if (!this.isOnComposition) {
        this.$emit('change', this.currentValue);
      }
    },
    handleComposition: function handleComposition(e) {
      if (e.type === 'compositionstart') {
        this.isOnComposition = true;
      }

      if (e.type === 'compositionend') {
        // composition is end
        this.isOnComposition = false;
        var value = e.target.value;
        this.$emit('change', value);
      }
    },
    onBlur: function onBlur() {
      this.focusStatus = false;

      if (!this.currentValue) {
        this.blurAnim();
      }

      this.$emit('blur');
    },
    onClear: function onClear() {
      this.currentValue = '';
      this.isOnComposition = false;
      this.focus();
      this.$emit('clear', this.currentValue);
    },
    onCancel: function onCancel() {
      var showCancel = this.showCancel;

      if (!showCancel) {
        this.currentValue = '';
        this.isOnComposition = false;
        this.onBlur();
      }

      this.$emit('cancel');
    },
    onSubmit: function onSubmit(e) {
      e.preventDefault();
      this.$refs.inputRef.blur();
      this.$emit('submit', this.currentValue);
    },
    focusAnim: function focusAnim() {
      var transition = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 300;
      this.$refs.searchContainer.style.cssText += "transform: translate3d(10px, 0, 0);transition: ".concat(transition, "ms;");
      this.$refs.cancelRef.style.cssText = 'margin-right: 0px;';
      this.$refs.cancelRef.classList.add('animation-ease');
    },
    blurAnim: function blurAnim() {
      var showCancel = this.showCancel;
      this.$refs.searchContainer.style.cssText += "transform: translate3d(".concat(this.initPos, "px, 0, 0);transition: 300ms;");

      if (!showCancel) {
        this.$refs.cancelRef.style.cssText = "margin-right: -".concat(this.cancelOuterWidth, "px;");
      }
    },
    focus: function focus() {
      this.$refs.inputRef.focus();
    }
  }
});
// CONCATENATED MODULE: ./src/search-bar/src/search-bar.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_search_barvue_type_script_lang_js_ = (search_barvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(0);

// CONCATENATED MODULE: ./src/search-bar/src/search-bar.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  src_search_barvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var search_bar = (component.exports);
// CONCATENATED MODULE: ./src/search-bar/index.js

/* istanbul ignore next */

search_bar.install = function (Vue) {
  Vue.component(search_bar.name, search_bar);
};

/* harmony default export */ var src_search_bar = __webpack_exports__["default"] = (search_bar);

/***/ }),
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/_vue-loader@15.9.3@vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/_vue-loader@15.9.3@vue-loader/lib??vue-loader-options!./src/slider/src/slider.vue?vue&type=template&id=e78caed8&lang=html&
var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:( _obj = {}, _obj[("" + _vm.prefixCls)] = true, _obj[(_vm.prefixCls + "--disabled")] = !!_vm.disabled, _obj )},[_c('input',{attrs:{"type":"hidden"},domProps:{"value":_vm.currentValue}}),_vm._v(" "),_c('za-drag',{attrs:{"dragStart":_vm.onDragStart,"dragMove":_vm.onDragMove,"dragEnd":_vm.onDragEnd}},[_c('div',{attrs:{"aria-valuemin":_vm.min,"aria-valuemax":_vm.max,"aria-valuenow":_vm.value}},[_c('div',{ref:"line",class:(_vm.prefixCls + "__line")},[_c('div',{class:(_vm.prefixCls + "__line-bg"),style:({width:(_vm.offset + "px")})})]),_vm._v(" "),_c('div',{class:(_vm.prefixCls + "__handle"),style:({left:(_vm.offset + "px")})},[_c('div',{ref:"shadow",class:(_vm.prefixCls + "__handle-shadow")})])])])],1)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/slider/src/slider.vue?vue&type=template&id=e78caed8&lang=html&

// EXTERNAL MODULE: ./node_modules/_@babel_runtime-corejs2@7.11.2@@babel/runtime-corejs2/core-js/number/is-nan.js
var is_nan = __webpack_require__(121);
var is_nan_default = /*#__PURE__*/__webpack_require__.n(is_nan);

// EXTERNAL MODULE: ./src/drag/index.js + 3 modules
var drag = __webpack_require__(95);

// EXTERNAL MODULE: ./src/tooltip/index.js + 5 modules
var tooltip = __webpack_require__(160);

// CONCATENATED MODULE: ./node_modules/_babel-loader@8.1.0@babel-loader/lib!./node_modules/_vue-loader@15.9.3@vue-loader/lib??vue-loader-options!./src/slider/src/slider.vue?vue&type=script&lang=js&

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var slidervue_type_script_lang_js_ = ({
  name: 'zaSlider',
  components: {
    zaDrag: drag["default"],
    zaTooltip: tooltip["default"]
  },
  props: {
    prefixCls: {
      type: String,
      default: 'za-slider'
    },
    visible: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    value: {},
    defaultValue: {
      type: Number,
      default: 0
    },
    step: {
      type: Number,
      default: 1
    },
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 100
    }
  },
  data: function data() {
    return {
      currentValue: this.getInitValue() || 0,
      offset: 0,
      tooltip: null,
      offsetStart: 0
    };
  },
  watch: {
    'value': function value(val, oldValue) {
      // eslint-disable-line no-unused-vars, object-shorthand
      if (val === oldValue) return;
      this.currentValue = val;
    }
  },
  mounted: function mounted() {
    this.init(); // fixed jest unit undefined $zaTooltip

    this.$zaTooltip = tooltip["default"].root;
  },
  methods: {
    getInitValue: function getInitValue() {
      var value = this.defaultValue ? this.defaultValue : this.value;

      if (value) {
        return value;
      }

      return false;
    },
    onDragStart: function onDragStart() {
      var disabled = this.disabled;
      if (disabled) return;
      this.tooltip = this.$zaTooltip({
        message: this.currentValue
      });
      this.setShadowPosition();
    },
    onDragMove: function onDragMove(event, _ref) {
      var offsetX = _ref.offsetX;
      var disabled = this.disabled;
      if (disabled || !this.tooltip || is_nan_default()(offsetX)) return;
      event.preventDefault();
      var offset = this.offsetStart + offsetX;

      if (offset < 0) {
        offset = 0;

        var _value = this.getValueByOffset(offset);

        this.offset = offset;
        this.$emit('input', _value);
        this.currentValue = _value;
        this.tooltip.message = _value;
        this.setShadowPosition();
        return false;
      }

      if (offset > this.maxOffset()) {
        offset = this.maxOffset();

        var _value2 = this.getValueByOffset(offset);

        this.offset = offset;
        this.$emit('input', _value2);
        this.currentValue = _value2;
        this.tooltip.message = _value2;
        this.setShadowPosition();
        return false;
      }

      var value = this.getValueByOffset(offset);
      offset = this.getOffsetByValue(value);
      this.offset = offset;
      this.$emit('input', value);
      this.currentValue = value;
      this.tooltip.message = value;
      this.setShadowPosition();
      return true;
    },
    onDragEnd: function onDragEnd(event, _ref2) {
      var offsetX = _ref2.offsetX;

      if (this.tooltip) {
        this.tooltip.close();
      }

      if (is_nan_default()(offsetX)) return;
      this.offsetStart += offsetX;
      this.$emit('change', event, this.currentValue);
    },

    /**
     * 通过偏移量确定值
     * @param  {number} offset 偏移量
     * @return {number}        值
     */
    getValueByOffset: function getValueByOffset(offset) {
      var min = this.min,
          max = this.max,
          step = this.step;
      var percent = offset / this.maxOffset();
      var value = Math.round((min + (max - min) * percent) / step) * step;
      return Math.max(Math.min(value, max), min);
    },

    /**
     * 通过值获取偏移量
     * @param  {number} value 值
     * @return {number}       偏移量
     */
    getOffsetByValue: function getOffsetByValue(value) {
      var min = this.min,
          max = this.max;
      return this.maxOffset() * ((value - min) / (max - min));
    },

    /**
     * 获取最大偏移量
     */
    maxOffset: function maxOffset() {
      // console.log(this.$refs.line.offsetWidth)// eslint-disable-line
      return this.$refs.line ? this.$refs.line.offsetWidth : 0;
    },

    /**
     * 初始化
     */
    init: function init() {
      var offset = this.getOffsetByValue(this.currentValue);
      this.offsetStart = offset;
      this.offset = offset;
    },
    getLineOffsetWidth: function getLineOffsetWidth() {
      return {
        width: "".concat(this.offset, "px")
      };
    },
    getDragOffsetWidth: function getDragOffsetWidth() {
      return {
        left: "".concat(this.offset, "px")
      };
    },
    setShadowPosition: function setShadowPosition() {
      var rect = this.$refs.shadow.getBoundingClientRect();
      var scrollTop = document.documentElement.scrollTop + document.body.scrollTop;
      var top = rect.top + scrollTop;
      this.tooltip.styleCls = {
        left: "".concat(rect.left, "px"),
        top: "".concat(top, "px"),
        width: "".concat(rect.width)
      };
    }
  }
});
// CONCATENATED MODULE: ./src/slider/src/slider.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_slidervue_type_script_lang_js_ = (slidervue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(0);

// CONCATENATED MODULE: ./src/slider/src/slider.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  src_slidervue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var slider = (component.exports);
// CONCATENATED MODULE: ./src/slider/index.js

/* istanbul ignore next */

slider.install = function (Vue) {
  Vue.component(slider.name, slider);
};

/* harmony default export */ var src_slider = __webpack_exports__["default"] = (slider);

/***/ }),
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/_vue-loader@15.9.3@vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/_vue-loader@15.9.3@vue-loader/lib??vue-loader-options!./src/stepper/src/stepper.vue?vue&type=template&id=121cdf3c&lang=html&
var render = function () {
var _obj, _obj$1, _obj$2;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:( _obj = {}, _obj[("" + _vm.prefixCls)] = true, _obj[(_vm.prefixCls + "--" + _vm.size)] = !!_vm.size, _obj[(_vm.prefixCls + "--" + _vm.shape)] = !!_vm.shape, _obj[(_vm.prefixCls + "--disabled")] = !!_vm.disabled, _obj )},[_c('span',{class:( _obj$1 = {}, _obj$1[(_vm.prefixCls + "__sub")] = true, _obj$1[(_vm.prefixCls + "__sub-disabled")] = _vm.subDisabled, _obj$1 ),on:{"click":_vm.handleSubClick}},[_c('za-icon',{attrs:{"type":"minus"}})],1),_vm._v(" "),_c('input',{ref:"stepper-input",class:(_vm.prefixCls + "__body"),attrs:{"maxlength":"22","type":"tel","disabled":_vm.disabled},domProps:{"value":_vm.currentValue},on:{"input":_vm.handleInput}}),_vm._v(" "),_c('span',{class:( _obj$2 = {}, _obj$2[(_vm.prefixCls + "__plus")] = true, _obj$2[(_vm.prefixCls + "__plus-disabled")] = _vm.plusDisabled, _obj$2 ),on:{"click":_vm.handlePlusClick}},[_c('za-icon',{attrs:{"type":"add"}})],1)])}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/stepper/src/stepper.vue?vue&type=template&id=121cdf3c&lang=html&

// EXTERNAL MODULE: ./node_modules/_@babel_runtime-corejs2@7.11.2@@babel/runtime-corejs2/core-js/number/is-nan.js
var is_nan = __webpack_require__(121);
var is_nan_default = /*#__PURE__*/__webpack_require__.n(is_nan);

// EXTERNAL MODULE: ./src/utils/validator.js
var validator = __webpack_require__(13);

// EXTERNAL MODULE: ./src/icon/index.js
var icon = __webpack_require__(68);

// CONCATENATED MODULE: ./node_modules/_babel-loader@8.1.0@babel-loader/lib!./node_modules/_vue-loader@15.9.3@vue-loader/lib??vue-loader-options!./src/stepper/src/stepper.vue?vue&type=script&lang=js&

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var steppervue_type_script_lang_js_ = ({
  components: {
    zaIcon: icon["default"]
  },
  name: 'zaStepper',
  props: {
    prefixCls: {
      type: String,
      default: 'za-stepper'
    },
    size: {
      type: String,
      validator: Object(validator["b" /* enumGenerator */])(['md', 'sm']),
      default: 'md'
    },
    shape: {
      type: String,
      validator: Object(validator["b" /* enumGenerator */])(['radius', 'circle']),
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    step: {
      type: Number,
      default: 1
    },
    min: {
      type: Number,
      default: null
    },
    max: {
      type: Number,
      default: null
    },
    value: {
      type: Number,
      default: 0
    }
  },
  computed: {
    subDisabled: function subDisabled() {
      return !!(typeof this.min === 'number' && this.currentValue <= this.min) || this.disabled;
    },
    plusDisabled: function plusDisabled() {
      return !!(typeof this.max === 'number' && this.currentValue >= this.max) || this.disabled;
    }
  },
  watch: {
    'value': function value(val, oldValue) {
      // eslint-disable-line no-unused-vars, object-shorthand
      if (val === this.currentValue) return;
      this.handleValue(val);
    }
  },
  data: function data() {
    return {
      currentValue: this.value || 0,
      lastValue: this.value || 0
    };
  },
  methods: {
    handleSubClick: function handleSubClick() {
      if (this.subDisabled) return;
      var value = this.currentValue - this.step;

      if (this.min !== null && value < this.min) {
        this.currentValue = this.min;
      } else {
        this.currentValue = value;
      }

      this.lastValue = this.currentValue;
      this.handleInputChange();
      this.handleAutoWidth(value);
    },
    handlePlusClick: function handlePlusClick() {
      if (this.plusDisabled) return;
      var value = this.currentValue + this.step;

      if (this.max !== null && value > this.max) {
        this.currentValue = this.max;
      } else {
        this.currentValue = value;
      }

      this.lastValue = this.currentValue;
      this.handleInputChange();
      this.handleAutoWidth(value);
    },
    handleInput: function handleInput(event) {
      var value = Number(event.target.value);
      this.handleValue(value, event);
    },
    handleValue: function handleValue(value) {
      var _this = this;

      if (is_nan_default()(value)) {
        if (value === '-') {
          this.currentValue = '-';
          return;
        }

        this.currentValue = value; // first sign the value, so nextTick will update

        this.$nextTick(function () {
          _this.currentValue = _this.lastValue;
        });
      } else if (this.min !== null && value < this.min) {
        this.currentValue = value;
        this.$nextTick(function () {
          _this.currentValue = _this.min;
          _this.lastValue = _this.currentValue;

          _this.handleInputChange();
        });
      } else if (this.max !== null && value > this.max) {
        this.currentValue = value;
        this.$nextTick(function () {
          _this.currentValue = _this.max;
          _this.lastValue = _this.currentValue;

          _this.handleInputChange();
        });
      } else {
        this.currentValue = value;
        this.lastValue = this.currentValue;
        this.handleInputChange();
      }

      this.handleAutoWidth(value);
    },
    handleInputChange: function handleInputChange() {
      this.$emit('inputChange', Number(this.currentValue));
      this.$emit('input', Number(this.currentValue));
      this.$emit('change', Number(this.currentValue));
    },
    handleAutoWidth: function handleAutoWidth(val) {
      var numLen = Number(val.toString().length);
      var nowLen = numLen * 10 + 20;

      if (numLen > 3) {
        this.$refs['stepper-input'].style.width = "".concat(nowLen, "px");
      } else {
        this.$refs['stepper-input'].style.width = '50px';
      }
    }
  }
});
// CONCATENATED MODULE: ./src/stepper/src/stepper.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_steppervue_type_script_lang_js_ = (steppervue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(0);

// CONCATENATED MODULE: ./src/stepper/src/stepper.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  src_steppervue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var stepper = (component.exports);
// CONCATENATED MODULE: ./src/stepper/index.js

/* istanbul ignore next */

stepper.install = function (Vue) {
  Vue.component(stepper.name, stepper);
};

/* harmony default export */ var src_stepper = __webpack_exports__["default"] = (stepper);

/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/_vue-loader@15.9.3@vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/_vue-loader@15.9.3@vue-loader/lib??vue-loader-options!./src/swipe-action/src/swipe-action.vue?vue&type=template&id=1b78485e&lang=html&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.left.length || _vm.right.length)?_c('div',{ref:"wrap",class:("" + _vm.prefixCls)},[(_vm.left.length)?_c('div',{ref:"left",class:(_vm.prefixCls + "__actions-left")},_vm._l((_vm.left),function(button,index){
var _obj;
return _c('div',{key:index,class:( _obj = {}, _obj[(_vm.prefixCls + "__button")] = true, _obj[(_vm.prefixCls + "__button--" + (button.theme))] = true, _obj ),on:{"click":function($event){return _vm.handleBtnClick(button, $event)}}},[_c('div',{class:(_vm.prefixCls + "__text")},[_vm._v(_vm._s(button.text || ('left' + index)))])])}),0):_vm._e(),_vm._v(" "),(_vm.right.length)?_c('div',{ref:"right",class:(_vm.prefixCls + "__actions-right")},_vm._l((_vm.right),function(button,index){
      var _obj;
return _c('div',{key:index,class:( _obj = {}, _obj[(_vm.prefixCls + "__button")] = true, _obj[(_vm.prefixCls + "__button--" + (button.theme))] = true, _obj ),on:{"click":function($event){return _vm.handleBtnClick(button, $event)}}},[_c('div',{class:(_vm.prefixCls + "__text")},[_vm._v(_vm._s(button.text || ('right' + index)))])])}),0):_vm._e(),_vm._v(" "),_c('za-drag',{attrs:{"dragStart":_vm.onDragStart,"dragMove":_vm.onDragMove,"dragEnd":_vm.onDragEnd}},[_c('div',{ref:"content",class:(_vm.prefixCls + "__content")},[_vm._t("default")],2)])],1):_c('div',{class:(_vm.prefixCls + "__wrap")},[_c('div',{class:(_vm.prefixCls + "__content")},[_vm._t("default")],2)])}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/swipe-action/src/swipe-action.vue?vue&type=template&id=1b78485e&lang=html&

// EXTERNAL MODULE: ./src/utils/validator.js
var validator = __webpack_require__(13);

// EXTERNAL MODULE: ./src/drag/index.js + 3 modules
var drag = __webpack_require__(95);

// CONCATENATED MODULE: ./node_modules/_babel-loader@8.1.0@babel-loader/lib!./node_modules/_vue-loader@15.9.3@vue-loader/lib??vue-loader-options!./src/swipe-action/src/swipe-action.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var swipe_actionvue_type_script_lang_js_ = ({
  name: 'zaSwipeAction',
  components: {
    zaDrag: drag["default"]
  },
  props: {
    prefixCls: {
      type: String,
      default: 'za-swipe-action' // naming different from zarm

    },
    theme: {
      type: String,
      validator: validator["a" /* defaultThemeValidator */],
      default: 'default'
    },
    left: {
      type: Array,
      default: function _default() {
        // eslint-disable-line object-shorthand
        return [];
      }
    },
    right: {
      type: Array,
      default: function _default() {
        // eslint-disable-line object-shorthand
        return [];
      }
    },
    moveTimeSpan: {
      type: Number,
      default: 300
    },
    moveDistanceRatio: {
      type: Number,
      default: 0.5
    },
    offset: {
      type: Number,
      default: 10
    },
    duration: {
      type: Number,
      default: 300
    },
    autoClose: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onDragStart: function onDragStart() {
      if (this.disabled || this.isClosing) {
        return;
      }

      if (this.isOpen) {
        this.close('close');
      }
    },
    onDragMove: function onDragMove(e, _ref) {
      var offsetX = _ref.offsetX,
          offsetY = _ref.offsetY;
      if (this.disabled || this.isClosing) return; // 拖动距离达到上限

      var offset = this.offset,
          offsetLeft = this.offsetLeft;
      var btnsLeftWidth = this.$refs.left && this.$refs.left.offsetWidth;
      var btnsRightWidth = this.$refs.right && this.$refs.right.offsetWidth;
      if (offsetX > 0 && (!btnsLeftWidth || offsetLeft >= btnsLeftWidth + offset)) return false;
      if (offsetX < 0 && (!btnsRightWidth || offsetLeft <= -btnsRightWidth - offset)) return false; // 判断滚屏情况

      var distanceX = Math.abs(offsetX);
      var distanceY = Math.abs(offsetY);
      if (distanceX < 5 || distanceX >= 5 && distanceY >= 0.3 * distanceX) return false;
      e.preventDefault(); // Fix Android touchcancel bug

      this.doTransition({
        offsetLeft: offsetX,
        duration: 0
      });
      return true;
    },
    onDragEnd: function onDragEnd(e, _ref2) {
      var offsetX = _ref2.offsetX,
          startTime = _ref2.startTime;

      if (this.disabled) {
        return;
      }

      var duration = this.duration,
          moveDistanceRatio = this.moveDistanceRatio,
          moveTimeSpan = this.moveTimeSpan;
      var timeSpan = new Date().getTime() - startTime.getTime();
      var btnsLeftWidth = this.$refs.left && this.$refs.left.offsetWidth;
      var btnsRightWidth = this.$refs.right && this.$refs.right.offsetWidth;
      var distanceX = 0;
      var isOpen = false;

      if (offsetX / btnsLeftWidth > moveDistanceRatio || offsetX > 0 && timeSpan <= moveTimeSpan) {
        distanceX = btnsLeftWidth;
        isOpen = true;
      } else if (offsetX / btnsRightWidth < -moveDistanceRatio || offsetX < 0 && timeSpan <= moveTimeSpan) {
        distanceX = -btnsRightWidth;
        isOpen = true;
      }

      if (isOpen && !this.isOpen) {
        // 打开
        this.open(distanceX);
      } else if (!isOpen && this.isOpen) {
        // 关闭
        this.close();
      } else {
        // 还原
        this.doTransition({
          offsetLeft: distanceX,
          duration: duration
        });
      }
    },
    doTransition: function doTransition(_ref3) {
      var offsetLeft = _ref3.offsetLeft,
          duration = _ref3.duration;
      var dom = this.$refs.content;
      if (!dom) return; // here operate on dom, zarm-react does re-render

      dom.style.webkitTransitionDuration = "".concat(duration, "ms");
      dom.style.transitionDuration = "".concat(duration, "ms");
      dom.style.webkitTransform = "translate3d(".concat(offsetLeft, "px, 0, 0)");
      dom.style.transform = "translate3d(".concat(offsetLeft, "px, 0, 0)");
    },
    handleBtnClick: function handleBtnClick(button, event) {
      event.preventDefault();

      if (typeof button.onClick === 'function') {
        button.onClick(event);
      }

      if (this.autoClose) {
        this.close('autoClose');
      }
    },
    open: function open(offsetLeft) {
      var duration = this.duration;
      this.$emit('open', offsetLeft > 0 ? 'left' : 'right');
      this.isOpen = true;
      this.doTransition({
        offsetLeft: offsetLeft,
        duration: duration
      });
    },
    // close(reason, duration = this.moveTimeDuration) {
    close: function close(reason) {
      var _this = this;

      this.isClosing = true;
      var duration = this.duration;
      this.isOpen = false;
      this.$emit('close', reason);
      this.timer = setTimeout(function () {
        _this.isClosing = false;
      }, duration);
      this.doTransition({
        offsetLeft: 0,
        duration: duration
      });
    },
    onTouchAway: function onTouchAway(e) {
      var _this2 = this;

      if (this.isOpen) {
        var pNode = function (node) {
          while (node.parentNode && node.parentNode !== document.body) {
            if (node === _this2.$refs.wrap) {
              return node;
            }

            node = node.parentNode; // eslint-disable-line no-param-reassign
          }
        }(e.target);

        if (!pNode) {
          e.preventDefault();
          this.close('touchaway');
        }
      }
    }
  },
  created: function created() {
    this.isOpen = false;
    this.isClosing = false;
    this.offsetLeft = 0;
  },
  mounted: function mounted() {
    document.body.addEventListener('touchstart', this.onTouchAway);
  },
  beforeDestroy: function beforeDestroy() {
    document.body.removeEventListener('touchstart', this.onTouchAway);
    clearTimeout(this.timer);
  }
});
// CONCATENATED MODULE: ./src/swipe-action/src/swipe-action.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_swipe_actionvue_type_script_lang_js_ = (swipe_actionvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(0);

// CONCATENATED MODULE: ./src/swipe-action/src/swipe-action.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  src_swipe_actionvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var swipe_action = (component.exports);
// CONCATENATED MODULE: ./src/swipe-action/index.js

/* istanbul ignore next */

swipe_action.install = function (Vue) {
  Vue.component(swipe_action.name, swipe_action);
};

/* harmony default export */ var src_swipe_action = __webpack_exports__["default"] = (swipe_action);

/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/_vue-loader@15.9.3@vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/_vue-loader@15.9.3@vue-loader/lib??vue-loader-options!./src/switch/src/switch.vue?vue&type=template&id=37d95251&lang=html&
var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:( _obj = {}, _obj[("" + _vm.prefixCls)] = true, _obj[(_vm.prefixCls + "--" + _vm.theme)] = !!_vm.theme, _obj[(_vm.prefixCls + "--checked")] = !!_vm.currentCheck, _obj[(_vm.prefixCls + "--disabled")] = _vm.disabled, _obj )},[_c('input',{ref:"input",class:(_vm.prefixCls + "__input"),attrs:{"type":"checkbox","disabled":_vm.disabled},domProps:{"checked":_vm.currentCheck,"value":_vm.getVal(_vm.currentCheck)},on:{"change":_vm.handleChange}})])}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/switch/src/switch.vue?vue&type=template&id=37d95251&lang=html&

// CONCATENATED MODULE: ./node_modules/_babel-loader@8.1.0@babel-loader/lib!./node_modules/_vue-loader@15.9.3@vue-loader/lib??vue-loader-options!./src/switch/src/switch.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var activeName = 'on';
var inActiveName = 'off';
/* harmony default export */ var switchvue_type_script_lang_js_ = ({
  name: 'zaSwitch',
  model: {
    prop: 'checked',
    event: 'change'
  },
  props: {
    prefixCls: {
      type: String,
      default: 'za-switch'
    },
    defaultChecked: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    checked: {
      type: Boolean,
      default: null
    }
  },
  data: function data() {
    return {
      currentCheck: this.getChecked(false),
      theme: 'primary'
    };
  },
  watch: {
    'checked': function checked(val, oldValue) {
      // eslint-disable-line no-unused-vars, object-shorthand
      if (val === this.currentCheck) return;
      this.currentCheck = val;
    }
  },
  methods: {
    getChecked: function getChecked(defaultChecked) {
      if (this.checked) {
        return !defaultChecked;
      }

      if (this.defaultChecked) {
        return !defaultChecked;
      }

      return defaultChecked;
    },
    getVal: function getVal(checked) {
      return checked ? activeName : inActiveName;
    },
    handleChange: function handleChange(event) {
      if (this.disabled) return;
      var checked = event.target.checked;
      this.currentCheck = checked;
      this.$emit('change', checked);
    }
  }
});
// CONCATENATED MODULE: ./src/switch/src/switch.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_switchvue_type_script_lang_js_ = (switchvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(0);

// CONCATENATED MODULE: ./src/switch/src/switch.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  src_switchvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var src_switch = (component.exports);
// CONCATENATED MODULE: ./src/switch/index.js

/* istanbul ignore next */

src_switch.install = function (Vue) {
  Vue.component(src_switch.name, src_switch);
};

/* harmony default export */ var src_switch_0 = __webpack_exports__["default"] = (src_switch);

/***/ }),
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/_vue-loader@15.9.3@vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/_vue-loader@15.9.3@vue-loader/lib??vue-loader-options!./src/radio/src/radio.vue?vue&type=template&id=542b5a26&lang=html&
var render = function () {
var _obj, _obj$1;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.radioType === "cell")?_c('za-cell',{attrs:{"disabled":_vm.radioDisabled,"isLink":""}},[(_vm.isChecked)?_c('za-icon',{attrs:{"slot":"description","type":"right","theme":_vm.radioDisabled ? null : _vm.groupTheme},slot:"description"}):_vm._e(),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model),expression:"model"}],class:(_vm.prefixCls + "__input"),attrs:{"type":"radio","disabled":_vm.radioDisabled},domProps:{"value":_vm.value,"checked":_vm._q(_vm.model,_vm.value)},on:{"change":[function($event){_vm.model=_vm.value},_vm.onValueChange]}}),_vm._v(" "),_vm._t("default")],2):(_vm.radioType === "button")?_c('za-button',{class:( _obj = {}, _obj[("" + _vm.prefixCls)] = true, _obj[(_vm.prefixCls + "--" + _vm.groupTheme)] = !!_vm.groupTheme, _obj[(_vm.prefixCls + "--" + _vm.groupShape)] = !!_vm.groupShape, _obj[(_vm.prefixCls + "--checked")] = _vm.isChecked, _obj[(_vm.prefixCls + "--disabled")] = _vm.radioDisabled, _obj[(_vm.prefixCls + "--block")] = _vm.isBlock, _obj ),attrs:{"theme":_vm.groupTheme,"size":"xs","block":_vm.isBlock,"disabled":_vm.radioDisabled,"ghost":!_vm.isChecked,"shape":_vm.groupShape}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model),expression:"model"}],class:(_vm.prefixCls + "__input"),attrs:{"type":"radio","disabled":_vm.radioDisabled},domProps:{"value":_vm.value,"checked":_vm._q(_vm.model,_vm.value)},on:{"change":[function($event){_vm.model=_vm.value},_vm.onValueChange]}}),_vm._v(" "),_vm._t("default")],2):_c('div',{class:( _obj$1 = {}, _obj$1[("" + _vm.prefixCls)] = true, _obj$1[(_vm.prefixCls + "--" + _vm.groupTheme)] = !!_vm.groupTheme, _obj$1[(_vm.prefixCls + "--checked")] = _vm.isChecked, _obj$1[(_vm.prefixCls + "--disabled")] = _vm.radioDisabled, _obj$1 )},[_c('div',{class:(_vm.prefixCls + "__wrapper")},[_c('span',{class:(_vm.prefixCls + "__inner")}),_vm._v(" "),(_vm.$slots.default)?_c('span',{class:(_vm.prefixCls + "__text")},[_vm._t("default")],2):_vm._e(),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model),expression:"model"}],class:(_vm.prefixCls + "__input"),attrs:{"type":"radio","disabled":_vm.radioDisabled},domProps:{"value":_vm.value,"checked":_vm._q(_vm.model,_vm.value)},on:{"change":[function($event){_vm.model=_vm.value},_vm.onValueChange]}})])])}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/radio/src/radio.vue?vue&type=template&id=542b5a26&lang=html&

// EXTERNAL MODULE: ./src/button/index.js + 5 modules
var src_button = __webpack_require__(114);

// EXTERNAL MODULE: ./src/icon/index.js
var icon = __webpack_require__(68);

// EXTERNAL MODULE: ./src/cell/index.js + 5 modules
var cell = __webpack_require__(146);

// EXTERNAL MODULE: ./src/mixins/emitter.js
var emitter = __webpack_require__(115);

// EXTERNAL MODULE: ./src/utils/validator.js
var validator = __webpack_require__(13);

// CONCATENATED MODULE: ./node_modules/_babel-loader@8.1.0@babel-loader/lib!./node_modules/_vue-loader@15.9.3@vue-loader/lib??vue-loader-options!./src/radio/src/radio.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// necessary when used alone





/* harmony default export */ var radiovue_type_script_lang_js_ = ({
  name: 'zaRadio',
  mixins: [emitter["a" /* default */]],
  components: {
    zaButton: src_button["default"],
    zaIcon: icon["default"],
    zaCell: cell["default"]
  },
  props: {
    prefixCls: {
      type: String,
      default: 'za-radio'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    value: {},
    type: {
      type: String,
      validator: Object(validator["b" /* enumGenerator */])(['button', 'cell']),
      default: null
    },
    checked: {
      type: Boolean,
      default: false
    },
    block: {
      type: Boolean,
      default: false
    },
    shape: {
      type: String,
      validator: Object(validator["b" /* enumGenerator */])(['rect', 'radius', 'round']),
      default: 'radius'
    }
  },
  data: function data() {
    return {
      currentChecked: this.checked || false
    };
  },
  computed: {
    model: {
      get: function get() {
        return this.isGroup ? this.store : this.value !== undefined ? this.value : this.currentChecked;
      },
      set: function set(val) {
        if (val === undefined) {
          val = true;
        }

        if (this.isGroup) {
          this.dispatch('zaRadioGroup', 'input', val);
        } else {
          this.$emit('input', val);
          this.currentChecked = val;
        }
      }
    },
    isGroup: function isGroup() {
      var parent = this.$parent;

      while (parent) {
        if (parent.$options.name !== 'zaRadioGroup') {
          parent = parent.$parent;
        } else {
          this._radioGroup = parent;
          return true;
        }
      }
    },
    isChecked: function isChecked() {
      if ({}.toString.call(this.model) === '[object Boolean]') {
        return this.model;
      }

      return this.model === this.value;
    },
    store: function store() {
      return this.isGroup ? this._radioGroup.value : this.value;
    },
    radioType: function radioType() {
      return this.isGroup ? this._radioGroup.type : this.type;
    },
    radioDisabled: function radioDisabled() {
      return this.isGroup ? this._radioGroup.disabled || this.disabled : this.disabled;
    },
    isBlock: function isBlock() {
      return this.isGroup ? this._radioGroup.block : this.block;
    },
    groupShape: function groupShape() {
      return this.isGroup ? this._radioGroup.shape : this.shape;
    },
    groupTheme: function groupTheme() {
      return this.isGroup ? this._radioGroup.theme : this.theme;
    }
  },
  methods: {
    onValueChange: function onValueChange(event) {
      var _this = this;

      // first emit('input') to make the model up to date
      this.$nextTick(function (_) {
        // eslint-disable-line no-unused-vars
        if (_this.isGroup) {
          _this.dispatch('zaRadioGroup', 'change', [_this.model, event]);
        } else {
          _this.$emit('change', _this.model, event);
        }
      });
    },
    handleClick: function handleClick(event) {
      if (this.radioDisabled) return;

      if (this.isGroup) {
        this.onValueChange(event);
      } else {
        this.model = !this.model;
        this.onValueChange(event);
      }
    }
  }
});
// CONCATENATED MODULE: ./src/radio/src/radio.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_radiovue_type_script_lang_js_ = (radiovue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(0);

// CONCATENATED MODULE: ./src/radio/src/radio.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  src_radiovue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var src_radio = (component.exports);
// CONCATENATED MODULE: ./src/radio/index.js

/* istanbul ignore next */

src_radio.install = function (Vue) {
  Vue.component(src_radio.name, src_radio);
};

/* harmony default export */ var src_radio_0 = __webpack_exports__["default"] = (src_radio);

/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/_vue-loader@15.9.3@vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/_vue-loader@15.9.3@vue-loader/lib??vue-loader-options!./src/radio/src/radio-group.vue?vue&type=template&id=44b8c44a&lang=html&
var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:( _obj = {}, _obj[("" + _vm.prefixCls)] = true, _obj[(_vm.prefixCls + "--" + _vm.shape)] = !!_vm.shape, _obj[(_vm.prefixCls + "--compact")] = _vm.compact, _obj[(_vm.prefixCls + "--block")] = _vm.block, _obj[(_vm.prefixCls + "--disabled")] = _vm.disabled, _obj )},[_vm._t("default")],2)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/radio/src/radio-group.vue?vue&type=template&id=44b8c44a&lang=html&

// EXTERNAL MODULE: ./src/utils/validator.js
var validator = __webpack_require__(13);

// CONCATENATED MODULE: ./node_modules/_babel-loader@8.1.0@babel-loader/lib!./node_modules/_vue-loader@15.9.3@vue-loader/lib??vue-loader-options!./src/radio/src/radio-group.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var radio_groupvue_type_script_lang_js_ = ({
  name: 'zaRadioGroup',
  props: {
    prefixCls: {
      type: String,
      default: 'za-radio-group'
    },
    theme: {
      type: String,
      validator: validator["a" /* defaultThemeValidator */],
      default: 'primary'
    },
    type: {
      type: String,
      validator: Object(validator["b" /* enumGenerator */])(['button', 'cell']),
      default: null
    },
    shape: {
      type: String,
      validator: Object(validator["b" /* enumGenerator */])(['rect', 'radius', 'round']),
      default: 'radius'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    compact: {
      type: Boolean,
      default: false
    },
    block: {
      type: Boolean,
      default: false
    },
    value: {}
  }
});
// CONCATENATED MODULE: ./src/radio/src/radio-group.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_radio_groupvue_type_script_lang_js_ = (radio_groupvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(0);

// CONCATENATED MODULE: ./src/radio/src/radio-group.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  src_radio_groupvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var radio_group = (component.exports);
// CONCATENATED MODULE: ./src/radio-group/index.js

/* istanbul ignore next */

radio_group.install = function (Vue) {
  Vue.component(radio_group.name, radio_group);
};

/* harmony default export */ var src_radio_group = __webpack_exports__["default"] = (radio_group);

/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/_@babel_runtime-corejs2@7.11.2@@babel/runtime-corejs2/core-js/number/is-nan.js
var is_nan = __webpack_require__(121);
var is_nan_default = /*#__PURE__*/__webpack_require__.n(is_nan);

// EXTERNAL MODULE: ./src/drag/index.js + 3 modules
var drag = __webpack_require__(95);

// EXTERNAL MODULE: ./src/icon/index.js
var icon = __webpack_require__(68);

// EXTERNAL MODULE: ./src/activity-indicator/index.js + 5 modules
var activity_indicator = __webpack_require__(93);

// EXTERNAL MODULE: ./src/utils/events.js
var events = __webpack_require__(78);

// EXTERNAL MODULE: ./src/utils/misc.js
var misc = __webpack_require__(117);

// EXTERNAL MODULE: ./node_modules/_@babel_runtime-corejs2@7.11.2@@babel/runtime-corejs2/core-js/date/now.js
var now = __webpack_require__(126);
var now_default = /*#__PURE__*/__webpack_require__.n(now);

// CONCATENATED MODULE: ./src/utils/throttle.js


var _arguments = arguments,
    throttle_this = undefined;

var throttle_throttle = function throttle(func, delay) {
  var timer;

  var startTime = now_default()();

  return function () {
    var curTime = now_default()();

    var remaining = delay - (curTime - startTime);
    var context = throttle_this;
    var args = _arguments;
    clearTimeout(timer);

    if (remaining <= 0) {
      func.apply(context, args);
      startTime = now_default()();
    } else {
      timer = setTimeout(func, remaining);
    }
  };
};

/* harmony default export */ var utils_throttle = (throttle_throttle);
// CONCATENATED MODULE: ./node_modules/_babel-loader@8.1.0@babel-loader/lib!./node_modules/_vue-loader@15.9.3@vue-loader/lib??vue-loader-options!./src/pull/src/pull.vue?vue&type=script&lang=js&







var REFRESH_STATE = {
  normal: 0,
  // 普通
  pull: 1,
  // 下拉状态（未满足刷新条件）
  drop: 2,
  // 释放立即刷新（满足刷新条件）
  loading: 3,
  // 加载中
  success: 4,
  // 加载成功
  failure: 5 // 加载失败

};
var LOAD_STATE = {
  normal: 0,
  // 普通
  abort: 1,
  // 中止
  loading: 2,
  // 加载中
  success: 3,
  // 加载成功
  failure: 4,
  // 加载失败
  complete: 5 // 加载完成（无新数据）

};
/* harmony default export */ var pullvue_type_script_lang_js_ = ({
  name: 'zaPull',
  components: {
    zaDrag: drag["default"],
    zaIcon: icon["default"],
    zaActivityIndicator: activity_indicator["default"]
  },
  props: {
    prefixCls: {
      type: String,
      default: 'za-pull'
    },
    refreshing: {
      type: Boolean,
      default: false
    },
    refreshDistance: {
      type: Number,
      default: 50
    },
    refreshInitDistance: {
      type: Number,
      default: 20
    },
    duration: {
      type: Number,
      default: 300
    },
    stayTime: {
      type: Number,
      default: 1000
    },
    loading: {
      type: Boolean,
      default: false
    },
    onRefresh: Function,
    onLoad: Function
  },
  data: function data() {
    return {
      offsetY: 0,
      currentDuration: 0,
      refreshState: '',
      loadState: ''
    };
  },
  created: function created() {
    this.refreshState = this.refreshing ? REFRESH_STATE.loading : REFRESH_STATE.normal;
    this.loadState = this.loading ? LOAD_STATE.loading : LOAD_STATE.normal;
    var onSrcoll = this.onSrcoll;
    this.throttledScroll = utils_throttle(onSrcoll, 250);
  },
  mounted: function mounted() {
    events["a" /* default */].on(window, 'scroll', this.throttledScroll);
  },
  beforeDestroy: function beforeDestroy() {
    events["a" /* default */].off(window, 'scroll', this.throttledScroll);
  },
  watch: {
    refreshing: function refreshing(val) {
      var refreshState = val ? REFRESH_STATE.loading : REFRESH_STATE.normal; // this.loadState = '';

      this.doRefreshAction(refreshState);
    },
    loading: function loading(val) {
      if (this.loadState === LOAD_STATE.complete) return; // stop if already complete

      var loadState = val ? LOAD_STATE.loading : LOAD_STATE.normal;
      this.doLoadAction(loadState);
    }
  },
  computed: {
    refreshStyle: function refreshStyle() {
      var height = is_nan_default()(this.offsetY) ? this.offsetY : "".concat(this.offsetY, "px");
      return {
        WebkitTransitionDuration: "".concat(this.currentDuration, "ms"),
        transitionDuration: "".concat(this.currentDuration, "ms"),
        height: height
      };
    },
    loadStyle: function loadStyle() {
      return {
        height: "".concat(this.loadState >= LOAD_STATE.loading ? 'auto' : 0)
      };
    }
  },
  methods: {
    onDragMove: function onDragMove(event, _ref) {
      var offsetY = _ref.offsetY;
      if (offsetY < 0) return; // 未滚动到顶部

      if (offsetY > 0 && document.documentElement.scrollTop + document.body.scrollTop > 0) return;
      if (this.refreshState >= REFRESH_STATE.loading) return; // fix touchmove bug on android

      event.preventDefault(); // move half the distance of drag

      var offset = offsetY / 2;
      var action = offset - this.refreshInitDistance < this.refreshDistance ? REFRESH_STATE.pull : REFRESH_STATE.drop;
      this.doRefreshAction(action, offset);
      return true;
    },
    onDragEnd: function onDragEnd(event, _ref2) {
      var _this = this;

      var offsetY = _ref2.offsetY;
      var onRefresh = this.onRefresh; // 没有产生位移

      if (!offsetY) {
        return;
      }

      if (this.refreshState === REFRESH_STATE.pull) {
        this.doRefreshAction(REFRESH_STATE.normal);
        return;
      }

      if (typeof onRefresh === 'function') {
        var P = onRefresh();

        if (!Object(misc["b" /* isThenable */])(P)) {
          return Object(misc["c" /* warn */])('on-refresh must return a Promise Object');
        }

        P.then(function (res) {
          var refreshState = res ? REFRESH_STATE.success : REFRESH_STATE.failure;

          _this.doRefreshAction(refreshState);
        }).catch(function () {
          _this.doRefreshAction(REFRESH_STATE.failure);
        });
      }
    },
    onSrcoll: function onSrcoll() {
      var _this2 = this;

      if (this.refreshState !== REFRESH_STATE.normal || this.loadState === LOAD_STATE.loading || this.loadState === LOAD_STATE.complete) {
        return;
      }

      var onLoad = this.onLoad;
      if (!onLoad) return;
      var bottom = this.$refs.pull.getBoundingClientRect().bottom;
      var scrollHeight = document.documentElement.scrollHeight;
      var clientHeight = document.documentElement.clientHeight;
      if (scrollHeight <= clientHeight) return;

      if (bottom <= clientHeight) {
        this.doLoadAction(LOAD_STATE.loading);

        if (typeof onLoad === 'function') {
          var P = onLoad();

          if (!Object(misc["b" /* isThenable */])(P)) {
            return Object(misc["c" /* warn */])('on-load must return a Promise Object');
          }

          P.then(function (res) {
            var loadState = res ? LOAD_STATE.success : LOAD_STATE.complete;

            _this2.doLoadAction(loadState);
          }).catch(function () {
            _this2.doLoadAction(LOAD_STATE.failure);
          });
        }
      }
    },
    doLoadAction: function doLoadAction(loadState) {
      var _this3 = this;

      this.loadState = loadState;

      switch (loadState) {
        case LOAD_STATE.success:
          this.doLoadAction(LOAD_STATE.normal);
          break;

        case LOAD_STATE.failure:
          setTimeout(function () {
            _this3.doLoadAction(LOAD_STATE.abort);
          }, this.stayTime);
          break;

        default:
          break;
      }
    },
    doRefreshAction: function doRefreshAction(refreshState, offset) {
      var _this4 = this;

      var duration = this.duration,
          stayTime = this.stayTime;
      this.refreshState = refreshState;

      switch (refreshState) {
        case REFRESH_STATE.pull:
        case REFRESH_STATE.drop:
          this.doTransition({
            offsetY: offset,
            duration: 0
          });
          break;

        case REFRESH_STATE.loading:
          this.doTransition({
            offsetY: 'auto',
            duration: duration
          });
          break;

        case REFRESH_STATE.success:
        case REFRESH_STATE.failure:
          this.doTransition({
            offsetY: 'auto',
            duration: 0
          });
          setTimeout(function () {
            _this4.doRefreshAction(REFRESH_STATE.normal);

            _this4.doLoadAction(LOAD_STATE.normal);
          }, stayTime);
          break;

        default:
          this.doTransition({
            offsetY: 0,
            duration: duration
          });
          break;
      }
    },
    doTransition: function doTransition(_ref3) {
      var offsetY = _ref3.offsetY,
          duration = _ref3.duration;
      this.offsetY = offsetY;
      this.currentDuration = duration;
    }
  },
  render: function render() {
    var _this5 = this;

    var h = arguments[0];
    var onDragMove = this.onDragMove,
        onDragEnd = this.onDragEnd,
        prefixCls = this.prefixCls,
        refreshStyle = this.refreshStyle,
        loadStyle = this.loadStyle,
        offsetY = this.offsetY,
        refreshDistance = this.refreshDistance,
        refreshInitDistance = this.refreshInitDistance,
        refreshState = this.refreshState,
        loadState = this.loadState;
    var percent = 0;

    if (offsetY >= refreshInitDistance) {
      percent = (offsetY - refreshInitDistance < refreshDistance ? offsetY - refreshInitDistance : refreshDistance) * 100 / (refreshDistance - refreshInitDistance);
    }

    var renderRefresh = function renderRefresh() {
      var refreshPull, refreshDrop, refreshLoading, refreshSuccess, refreshFailure; // eslint-disable-line

      switch (refreshState) {
        case REFRESH_STATE.pull:
          refreshPull = _this5.$scopedSlots.refreshPull && _this5.$scopedSlots.refreshPull({
            percent: percent
          });
          return refreshPull || h("div", {
            "class": "".concat(prefixCls, "__control")
          }, [h("za-activity-indicator", {
            attrs: {
              percent: percent
            }
          }), h("span", ["\u4E0B\u62C9\u5237\u65B0"])]);

        case REFRESH_STATE.drop:
          refreshDrop = _this5.$scopedSlots.refreshDrop && _this5.$scopedSlots.refreshDrop({
            percent: percent
          });
          return refreshDrop || h("div", {
            "class": "".concat(prefixCls, "__control")
          }, [h("za-activity-indicator", {
            attrs: {
              percent: 100
            }
          }), h("span", ["\u91CA\u653E\u7ACB\u5373\u5237\u65B0"])]);

        case REFRESH_STATE.loading:
          refreshLoading = _this5.$scopedSlots.refreshLoading && _this5.$scopedSlots.refreshLoading({
            percent: percent
          });
          return refreshLoading || h("div", {
            "class": "".concat(prefixCls, "__control")
          }, [h("za-activity-indicator", {
            "class": "rotate360"
          }), h("span", ["\u52A0\u8F7D\u4E2D"])]);

        case REFRESH_STATE.success:
          refreshSuccess = _this5.$scopedSlots.refreshSuccess && _this5.$scopedSlots.refreshSuccess({
            percent: percent
          });
          return refreshSuccess || h("div", {
            "class": "".concat(prefixCls, "__control")
          }, [h("za-icon", {
            attrs: {
              type: "right-round",
              theme: "success"
            }
          }), h("span", ["\u52A0\u8F7D\u6210\u529F"])]);

        case REFRESH_STATE.failure:
          refreshFailure = _this5.$scopedSlots.refreshFailure && _this5.$scopedSlots.refreshFailure({
            percent: percent
          });
          return refreshFailure || h("div", {
            "class": "".concat(prefixCls, "__control")
          }, [h("za-icon", {
            attrs: {
              type: "wrong-round",
              theme: "error"
            }
          }), h("span", ["\u52A0\u8F7D\u5931\u8D25"])]);

        default:
          return null;
      }
    };

    var renderLoad = function renderLoad() {
      var loadComplete, loadLoading, loadFailure; // eslint-disable-line

      switch (loadState) {
        case LOAD_STATE.loading:
          loadLoading = _this5.$scopedSlots.loadLoading && _this5.$scopedSlots.loadLoading({
            percent: percent
          });
          return loadLoading || h("div", {
            "class": "".concat(prefixCls, "__control")
          }, [h("za-activity-indicator", {
            "class": 'rotate360'
          }), h("span", ["\u52A0\u8F7D\u4E2D"])]);

        case LOAD_STATE.complete:
          loadComplete = _this5.$scopedSlots.loadComplete && _this5.$scopedSlots.loadComplete({
            percent: percent
          });
          return loadComplete || h("div", {
            "class": "".concat(prefixCls, "__control")
          }, [h("span", ["\u6211\u662F\u6709\u5E95\u7EBF\u7684"])]);

        case LOAD_STATE.failure:
          loadFailure = _this5.$scopedSlots.loadFailure && _this5.$scopedSlots.loadFailure({
            percent: percent
          });
          return loadFailure || h("div", {
            "class": "".concat(prefixCls, "__control")
          }, [h("za-icon", {
            attrs: {
              type: "wrong-round",
              theme: "error"
            }
          }), h("span", ["\u52A0\u8F7D\u5931\u8D25"])]);

        default:
          return null;
      }
    };

    return h("za-drag", {
      attrs: {
        dragMove: onDragMove,
        dragEnd: onDragEnd
      }
    }, [h("div", {
      ref: 'pull',
      "class": "".concat(prefixCls)
    }, [h("div", {
      "class": "".concat(prefixCls, "__refresh"),
      style: refreshStyle
    }, [renderRefresh()]), this.$slots.default, h("div", {
      "class": "".concat(prefixCls, "__load"),
      style: loadStyle
    }, [renderLoad()])])]);
  }
});
// CONCATENATED MODULE: ./src/pull/src/pull.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_pullvue_type_script_lang_js_ = (pullvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(0);

// CONCATENATED MODULE: ./src/pull/src/pull.vue
var render, staticRenderFns




/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  src_pullvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var pull = (component.exports);
// CONCATENATED MODULE: ./src/pull/index.js

/* istanbul ignore next */

pull.install = function (Vue) {
  Vue.component(pull.name, pull);
};

/* harmony default export */ var src_pull = __webpack_exports__["default"] = (pull);

/***/ }),
/* 217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/_@babel_runtime-corejs2@7.11.2@@babel/runtime-corejs2/helpers/defineProperty.js
var defineProperty = __webpack_require__(37);
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// EXTERNAL MODULE: ./src/mixins/emitter.js
var emitter = __webpack_require__(115);

// EXTERNAL MODULE: ./src/mixins/find-parent.js
var find_parent = __webpack_require__(173);

// CONCATENATED MODULE: ./node_modules/_babel-loader@8.1.0@babel-loader/lib!./node_modules/_vue-loader@15.9.3@vue-loader/lib??vue-loader-options!./src/collapse/src/collapseItem.vue?vue&type=script&lang=js&



/* harmony default export */ var collapseItemvue_type_script_lang_js_ = ({
  name: 'zaCollapseItem',
  mixins: [emitter["a" /* default */], find_parent["a" /* default */]],
  props: {
    itemKey: {
      type: [String, Number],
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      active: false,
      itemAnimated: false,
      animatedHeight: ''
    };
  },
  created: function created() {
    this.findParent('zaCollapse');
    this.setDefaultActive();
  },
  watch: {
    parantActiveKey: function parantActiveKey() {
      var _this = this;

      this.$nextTick(function () {
        _this.setDefaultActive();
      });
    }
  },
  computed: {
    itemActiveKey: function itemActiveKey() {
      var itemActiveKey;

      if (!this.itemKey) {
        itemActiveKey = -1;
      } else {
        itemActiveKey = this.itemKey;
      }

      return itemActiveKey;
    },
    parantActiveKey: function parantActiveKey() {
      return this.parent && this.parent.activeKey;
    }
  },
  methods: {
    isActive: function isActive(tag, activeKey) {
      var itemTag = tag || this.itemKey;
      this.itemActiveKeys = activeKey !== undefined ? activeKey : [];
      var result = this.itemActiveKeys.indexOf(itemTag) > -1;
      return result;
    },
    setDefaultActive: function setDefaultActive() {
      var _this2 = this;

      var parent = this.parent,
          itemActiveKey = this.itemActiveKey;
      this.itemAnimated = parent.animated;
      this.multiple = parent.multiple;
      this.prefixCls = parent.prefixCls;
      this.active = this.isActive(itemActiveKey, parent.currActiveKey);
      this.$nextTick(function () {
        if (_this2.itemAnimated) {
          _this2.setAnimateStyle(_this2.active);
        }
      });
    },
    setActive: function setActive() {
      var parent = this.parent,
          active = this.active,
          multiple = this.multiple,
          itemAnimated = this.itemAnimated,
          itemKey = this.itemKey;
      var activeStatus;

      if (!multiple) {
        var collapseItemRefs = parent.$children;
        collapseItemRefs.forEach(function (item) {
          if (item.active) {
            item.active = false;
            setTimeout(function () {
              item.animatedHeight = {
                height: '0px'
              };
            }, 0);
          }
        });
        activeStatus = active ? 1 : 0;
      } else {
        activeStatus = active ? 1 : 0;
      }

      this.active = !activeStatus;

      if (itemAnimated) {
        this.setAnimateStyle(!activeStatus);
      }

      this.$emit('item-change', itemKey);
    },
    onClickItem: function onClickItem() {
      var parent = this.parent,
          disabled = this.disabled;

      if (disabled) {
        return false;
      }

      this.setActive();
      parent.onItemChange(this.itemActiveKey);
    },
    setAnimateStyle: function setAnimateStyle(active) {
      var _this3 = this;

      var newActive = active;

      if (newActive) {
        this.animatedHeight = {
          height: '0px'
        };
        setTimeout(function () {
          _this3.animatedHeight = {
            height: "".concat(_this3.getContentHeight(), "px")
          };
        }, 0);
      } else {
        this.animatedHeight = {
          height: "".concat(this.getContentHeight(), "px")
        };
        setTimeout(function () {
          _this3.animatedHeight = {
            height: '0px'
          };
        }, 0);
      }
    },
    getContentHeight: function getContentHeight() {
      var content = this.$refs.animateRoom;
      var children = content.children;
      var height = 0;
      var childrenArray = [].slice.call(children);
      childrenArray.forEach(function (item) {
        height += item.offsetHeight;
      });
      return height;
    }
  },
  render: function render() {
    var _ref, _ref3;

    var h = arguments[0];
    var prefixCls = this.prefixCls,
        active = this.active,
        title = this.title,
        itemAnimated = this.itemAnimated,
        animatedHeight = this.animatedHeight,
        disabled = this.disabled;
    var itemCls = "".concat(prefixCls, "-item");
    return h("div", {
      "class": (_ref = {}, defineProperty_default()(_ref, "".concat(itemCls), true), defineProperty_default()(_ref, "".concat(itemCls, "--active"), !!active), defineProperty_default()(_ref, "".concat(itemCls, "--disabled"), !!disabled), _ref),
      ref: 'collapseItem'
    }, [h("div", {
      "class": "".concat(itemCls, "__title"),
      on: {
        "click": this.onClickItem
      }
    }, [h("div", [title]), h("div", {
      "class": defineProperty_default()({}, "".concat(itemCls, "__arrow"), true)
    })]), h("div", {
      "class": (_ref3 = {}, defineProperty_default()(_ref3, "".concat(itemCls, "__content"), true), defineProperty_default()(_ref3, "".concat(itemCls, "__content--anim"), itemAnimated), _ref3),
      ref: 'animateRoom',
      style: animatedHeight
    }, [h("div", {
      "class": "".concat(itemCls, "__content-inner")
    }, [this.$slots.default])])]);
  }
});
// CONCATENATED MODULE: ./src/collapse/src/collapseItem.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_collapseItemvue_type_script_lang_js_ = (collapseItemvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(0);

// CONCATENATED MODULE: ./src/collapse/src/collapseItem.vue
var collapseItem_render, staticRenderFns




/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  src_collapseItemvue_type_script_lang_js_,
  collapseItem_render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var collapseItem = (component.exports);
// CONCATENATED MODULE: ./src/collapse-item/index.js

/* istanbul ignore next */

collapseItem.install = function (Vue) {
  Vue.component(collapseItem.name, collapseItem);
};

/* harmony default export */ var collapse_item = __webpack_exports__["default"] = (collapseItem);

/***/ }),
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./src/utils/validator.js
var validator = __webpack_require__(13);

// EXTERNAL MODULE: ./src/message/index.js + 5 modules
var message = __webpack_require__(171);

// CONCATENATED MODULE: ./node_modules/_babel-loader@8.1.0@babel-loader/lib!./node_modules/_vue-loader@15.9.3@vue-loader/lib??vue-loader-options!./src/notice-bar/src/notice-bar.vue?vue&type=script&lang=js&


/* harmony default export */ var notice_barvue_type_script_lang_js_ = ({
  name: 'zaNoticeBar',
  components: {
    zaMessage: message["default"]
  },
  props: {
    prefixCls: {
      type: String,
      default: 'za-noticebar'
    },
    theme: {
      type: String,
      validator: validator["a" /* defaultThemeValidator */],
      default: 'warning'
    },
    closable: {
      type: Boolean,
      default: false
    },
    hasArrow: {
      type: Boolean,
      default: false
    },
    scrollable: {
      type: Boolean,
      default: false
    },
    visible: {
      type: Boolean,
      default: true
    },
    size: {},
    icon: {
      type: String,
      default: 'broadcast'
    }
  },
  computed: {
    currentVisible: {
      get: function get() {
        return this.visible;
      },
      set: function set(val) {
        this.$emit('update:visible', val);
      }
    },
    contentStyle: function contentStyle() {
      return {
        left: "".concat(this.offset, "px")
      };
    }
  },
  data: function data() {
    return {
      offset: 0
    };
  },
  methods: {
    handleClick: function handleClick(event) {
      this.currentVisible = false;
      this.$emit('click', event);
    },
    handleUpdate: function handleUpdate(val) {
      this.$emit('update:visible', val);
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (!this.scrollable) return;
    var distance = this.$refs.wrapper.offsetWidth - this.$refs.content.offsetWidth;
    if (distance > 0) return;
    var delay = 1000;
    this.moveInterval = setInterval(function () {
      var offset = _this.offset;

      if ((offset < distance || offset >= 0) && delay > 0) {
        delay -= 50;
        return;
      }

      delay = 1000;
      offset = offset < distance ? 0 : offset - 1;
      _this.offset = offset;
    }, 50);
  },
  beforeDestroy: function beforeDestroy() {
    if (this.moveInterval) {
      clearInterval(this.moveInterval);
    }
  },
  render: function render(h) {
    // eslint-disable-line no-unused-vars
    var prefixCls = this.prefixCls,
        theme = this.theme,
        currentVisible = this.currentVisible,
        closable = this.closable,
        hasArrow = this.hasArrow,
        handleClick = this.handleClick,
        handleUpdate = this.handleUpdate,
        contentStyle = this.contentStyle,
        icon = this.icon;
    return h("za-message", {
      attrs: {
        size: 'lg',
        visible: currentVisible,
        closable: closable,
        theme: theme,
        hasArrow: hasArrow,
        icon: icon
      },
      on: {
        "updatevisible": handleUpdate,
        "click": handleClick
      }
    }, [h("div", {
      "class": prefixCls,
      ref: 'wrapper'
    }, [h("div", {
      "class": "".concat(prefixCls, "__body"),
      ref: 'content',
      style: contentStyle
    }, [this.$slots.default])])]);
  }
});
// CONCATENATED MODULE: ./src/notice-bar/src/notice-bar.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_notice_barvue_type_script_lang_js_ = (notice_barvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(0);

// CONCATENATED MODULE: ./src/notice-bar/src/notice-bar.vue
var render, staticRenderFns




/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  src_notice_barvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var notice_bar = (component.exports);
// CONCATENATED MODULE: ./src/notice-bar/index.js

/* istanbul ignore next */

notice_bar.install = function (Vue) {
  Vue.component(notice_bar.name, notice_bar);
};

/* harmony default export */ var src_notice_bar = __webpack_exports__["default"] = (notice_bar);

/***/ }),
/* 219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/_@babel_runtime-corejs2@7.11.2@@babel/runtime-corejs2/helpers/defineProperty.js
var defineProperty = __webpack_require__(37);
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// EXTERNAL MODULE: ./src/carousel-item/index.js + 5 modules
var carousel_item = __webpack_require__(169);

// CONCATENATED MODULE: ./node_modules/_babel-loader@8.1.0@babel-loader/lib!./node_modules/_vue-loader@15.9.3@vue-loader/lib??vue-loader-options!./src/tabs/src/tab-panel.vue?vue&type=script&lang=js&


var paneIndex = 0;
/* harmony default export */ var tab_panelvue_type_script_lang_js_ = ({
  name: 'zaTabPanel',
  components: {
    zaCarouselItem: carousel_item["default"]
  },
  props: {
    prefixCls: {
      type: String,
      default: 'za-tabs'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    label: String,
    name: [String, Number]
  },
  computed: {
    currentName: function currentName() {
      return this.container && this.container.value;
    },
    slideable: function slideable() {
      return this.container && this.container.slideable;
    },
    container: function container() {
      var parent = this.$parent;

      while (parent) {
        if (parent.$options.name !== 'zaTabs') {
          parent = parent.$parent;
        } else {
          return parent;
        }
      }

      return false;
    }
  },
  watch: {
    label: function label() {
      this.notifyParent();
    },
    name: function name() {
      this.notifyParent();
    },
    disabled: function disabled() {
      this.notifyParent();
    }
  },
  created: function created() {
    this._panelIndex = paneIndex;
    paneIndex += 1; // for vue2.1.0+ can be scoped slot here

    this.notifyParent();
  },
  beforeDestroy: function beforeDestroy() {
    this.notifyParent(false);
  },
  methods: {
    notifyParent: function notifyParent() {
      var flag = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      if (this.container) {
        this.container.notify(this, flag);
      }
    }
  },
  render: function render(h) {
    var _cls;

    // eslint-disable-line no-unused-vars
    var prefixCls = this.prefixCls,
        currentName = this.currentName,
        name = this.name,
        slideable = this.slideable;
    var cls = (_cls = {}, defineProperty_default()(_cls, "".concat(prefixCls, "__panel-item"), true), defineProperty_default()(_cls, "".concat(prefixCls, "__panel-item--active"), name === currentName), _cls);
    var panel = slideable ? h("za-carousel-item", [this.$slots.default]) : h("div", {
      "class": "".concat(prefixCls, "__panel")
    }, [h("div", {
      "class": cls
    }, [this.$slots.default])]);
    return panel;
  }
});
// CONCATENATED MODULE: ./src/tabs/src/tab-panel.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_tab_panelvue_type_script_lang_js_ = (tab_panelvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(0);

// CONCATENATED MODULE: ./src/tabs/src/tab-panel.vue
var tab_panel_render, staticRenderFns




/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  src_tab_panelvue_type_script_lang_js_,
  tab_panel_render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var tab_panel = (component.exports);
// CONCATENATED MODULE: ./src/tab-panel/index.js

/* istanbul ignore next */

tab_panel.install = function (Vue) {
  Vue.component(tab_panel.name, tab_panel);
};

/* harmony default export */ var src_tab_panel = __webpack_exports__["default"] = (tab_panel);

/***/ }),
/* 220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/_babel-loader@8.1.0@babel-loader/lib!./node_modules/_vue-loader@15.9.3@vue-loader/lib??vue-loader-options!./src/tab-bar/src/tab-bar.vue?vue&type=script&lang=js&
/* harmony default export */ var tab_barvue_type_script_lang_js_ = ({
  name: 'zaTabBar',
  props: {
    prefixCls: {
      type: String,
      default: 'za-tab-bar'
    },
    visible: {
      type: Boolean,
      default: true
    },
    defaultActiveKey: {
      type: [String, Number],
      default: null
    },
    activeKey: {
      type: [String, Number],
      default: null
    },
    value: {}
  },
  data: function data() {
    return {
      currentValue: this.activeKey || this.defaultActiveKey || this.value
    };
  },
  methods: {
    onChildChange: function onChildChange(value) {
      this.currentValue = value;
      this.$emit('input', value);
      this.$emit('change', value);
    }
  },
  render: function render() {
    var h = arguments[0];
    var visible = this.visible,
        prefixCls = this.prefixCls;
    var cls = !visible ? "".concat(prefixCls, " ").concat(prefixCls, "--hidden") : "".concat(prefixCls);
    return h("div", {
      "class": cls
    }, [this.$slots.default]);
  }
});
// CONCATENATED MODULE: ./src/tab-bar/src/tab-bar.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_tab_barvue_type_script_lang_js_ = (tab_barvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(0);

// CONCATENATED MODULE: ./src/tab-bar/src/tab-bar.vue
var render, staticRenderFns




/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  src_tab_barvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var tab_bar = (component.exports);
// CONCATENATED MODULE: ./src/tab-bar/index.js

/* istanbul ignore next */

tab_bar.install = function (Vue) {
  Vue.component(tab_bar.name, tab_bar);
};

/* harmony default export */ var src_tab_bar = __webpack_exports__["default"] = (tab_bar);

/***/ }),
/* 221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./src/mixins/emitter.js
var emitter = __webpack_require__(115);

// EXTERNAL MODULE: ./src/mixins/find-parent.js
var find_parent = __webpack_require__(173);

// CONCATENATED MODULE: ./node_modules/_babel-loader@8.1.0@babel-loader/lib!./node_modules/_vue-loader@15.9.3@vue-loader/lib??vue-loader-options!./src/tab-bar/src/tab-bar-item.vue?vue&type=script&lang=js&


/* harmony default export */ var tab_bar_itemvue_type_script_lang_js_ = ({
  name: 'zaTabBarItem',
  mixins: [emitter["a" /* default */], find_parent["a" /* default */]],
  props: {
    prefixCls: {
      type: String,
      default: 'za-tab-bar'
    },
    title: {
      type: String,
      default: null
    },
    itemKey: {
      type: [String, Number],
      default: null
    }
  },
  computed: {
    selected: function selected() {
      return this.getSelected();
    }
  },
  created: function created() {
    this.findParent('zaTabBar');
  },
  methods: {
    getSelected: function getSelected() {
      var _this$parent = this.parent,
          activeKey = _this$parent.activeKey,
          currentValue = _this$parent.currentValue;
      return activeKey === this.itemKey || currentValue === this.itemKey;
    },
    handleChange: function handleChange() {
      var itemKey = this.itemKey;
      this.parent.onChildChange(itemKey);
    }
  },
  render: function render() {
    var h = arguments[0];
    var prefixCls = this.prefixCls,
        title = this.title,
        selected = this.selected,
        handleChange = this.handleChange;
    var cls = "".concat(prefixCls, "__item");

    if (selected) {
      cls = "".concat(prefixCls, "__item ").concat(prefixCls, "--active");
    }

    return h("div", {
      "class": cls,
      on: {
        "click": handleChange
      }
    }, [h("div", {
      "class": "".concat(prefixCls, "__icon")
    }, [!this.selected ? this.$slots.icon : this.$slots.activeIcon]), h("div", {
      "class": "".concat(prefixCls, "__title")
    }, [title])]);
  }
});
// CONCATENATED MODULE: ./src/tab-bar/src/tab-bar-item.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_tab_bar_itemvue_type_script_lang_js_ = (tab_bar_itemvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(0);

// CONCATENATED MODULE: ./src/tab-bar/src/tab-bar-item.vue
var render, staticRenderFns




/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  src_tab_bar_itemvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var tab_bar_item = (component.exports);
// CONCATENATED MODULE: ./src/tab-bar-item/index.js

/* istanbul ignore next */

tab_bar_item.install = function (Vue) {
  Vue.component(tab_bar_item.name, tab_bar_item);
};

/* harmony default export */ var src_tab_bar_item = __webpack_exports__["default"] = (tab_bar_item);

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

var arrayWithHoles = __webpack_require__(228);

var iterableToArrayLimit = __webpack_require__(229);

var unsupportedIterableToArray = __webpack_require__(149);

var nonIterableRest = __webpack_require__(233);

function _slicedToArray(arr, i) {
  return arrayWithHoles(arr) || iterableToArrayLimit(arr, i) || unsupportedIterableToArray(arr, i) || nonIterableRest();
}

module.exports = _slicedToArray;

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(234);

/***/ }),
/* 224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**!
 * @fileOverview Kickass library to create and place poppers near their reference elements.
 * @version 1.16.1
 * @license
 * Copyright (c) 2016 Federico Zivolo and contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && typeof navigator !== 'undefined';

var timeoutDuration = function () {
  var longerTimeoutBrowsers = ['Edge', 'Trident', 'Firefox'];
  for (var i = 0; i < longerTimeoutBrowsers.length; i += 1) {
    if (isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) {
      return 1;
    }
  }
  return 0;
}();

function microtaskDebounce(fn) {
  var called = false;
  return function () {
    if (called) {
      return;
    }
    called = true;
    window.Promise.resolve().then(function () {
      called = false;
      fn();
    });
  };
}

function taskDebounce(fn) {
  var scheduled = false;
  return function () {
    if (!scheduled) {
      scheduled = true;
      setTimeout(function () {
        scheduled = false;
        fn();
      }, timeoutDuration);
    }
  };
}

var supportsMicroTasks = isBrowser && window.Promise;

/**
* Create a debounced version of a method, that's asynchronously deferred
* but called in the minimum time possible.
*
* @method
* @memberof Popper.Utils
* @argument {Function} fn
* @returns {Function}
*/
var debounce = supportsMicroTasks ? microtaskDebounce : taskDebounce;

/**
 * Check if the given variable is a function
 * @method
 * @memberof Popper.Utils
 * @argument {Any} functionToCheck - variable to check
 * @returns {Boolean} answer to: is a function?
 */
function isFunction(functionToCheck) {
  var getType = {};
  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
}

/**
 * Get CSS computed property of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Eement} element
 * @argument {String} property
 */
function getStyleComputedProperty(element, property) {
  if (element.nodeType !== 1) {
    return [];
  }
  // NOTE: 1 DOM access here
  var window = element.ownerDocument.defaultView;
  var css = window.getComputedStyle(element, null);
  return property ? css[property] : css;
}

/**
 * Returns the parentNode or the host of the element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} parent
 */
function getParentNode(element) {
  if (element.nodeName === 'HTML') {
    return element;
  }
  return element.parentNode || element.host;
}

/**
 * Returns the scrolling parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} scroll parent
 */
function getScrollParent(element) {
  // Return body, `getScroll` will take care to get the correct `scrollTop` from it
  if (!element) {
    return document.body;
  }

  switch (element.nodeName) {
    case 'HTML':
    case 'BODY':
      return element.ownerDocument.body;
    case '#document':
      return element.body;
  }

  // Firefox want us to check `-x` and `-y` variations as well

  var _getStyleComputedProp = getStyleComputedProperty(element),
      overflow = _getStyleComputedProp.overflow,
      overflowX = _getStyleComputedProp.overflowX,
      overflowY = _getStyleComputedProp.overflowY;

  if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
    return element;
  }

  return getScrollParent(getParentNode(element));
}

/**
 * Returns the reference node of the reference object, or the reference object itself.
 * @method
 * @memberof Popper.Utils
 * @param {Element|Object} reference - the reference element (the popper will be relative to this)
 * @returns {Element} parent
 */
function getReferenceNode(reference) {
  return reference && reference.referenceNode ? reference.referenceNode : reference;
}

var isIE11 = isBrowser && !!(window.MSInputMethodContext && document.documentMode);
var isIE10 = isBrowser && /MSIE 10/.test(navigator.userAgent);

/**
 * Determines if the browser is Internet Explorer
 * @method
 * @memberof Popper.Utils
 * @param {Number} version to check
 * @returns {Boolean} isIE
 */
function isIE(version) {
  if (version === 11) {
    return isIE11;
  }
  if (version === 10) {
    return isIE10;
  }
  return isIE11 || isIE10;
}

/**
 * Returns the offset parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} offset parent
 */
function getOffsetParent(element) {
  if (!element) {
    return document.documentElement;
  }

  var noOffsetParent = isIE(10) ? document.body : null;

  // NOTE: 1 DOM access here
  var offsetParent = element.offsetParent || null;
  // Skip hidden elements which don't have an offsetParent
  while (offsetParent === noOffsetParent && element.nextElementSibling) {
    offsetParent = (element = element.nextElementSibling).offsetParent;
  }

  var nodeName = offsetParent && offsetParent.nodeName;

  if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') {
    return element ? element.ownerDocument.documentElement : document.documentElement;
  }

  // .offsetParent will return the closest TH, TD or TABLE in case
  // no offsetParent is present, I hate this job...
  if (['TH', 'TD', 'TABLE'].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty(offsetParent, 'position') === 'static') {
    return getOffsetParent(offsetParent);
  }

  return offsetParent;
}

function isOffsetContainer(element) {
  var nodeName = element.nodeName;

  if (nodeName === 'BODY') {
    return false;
  }
  return nodeName === 'HTML' || getOffsetParent(element.firstElementChild) === element;
}

/**
 * Finds the root node (document, shadowDOM root) of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} node
 * @returns {Element} root node
 */
function getRoot(node) {
  if (node.parentNode !== null) {
    return getRoot(node.parentNode);
  }

  return node;
}

/**
 * Finds the offset parent common to the two provided nodes
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element1
 * @argument {Element} element2
 * @returns {Element} common offset parent
 */
function findCommonOffsetParent(element1, element2) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) {
    return document.documentElement;
  }

  // Here we make sure to give as "start" the element that comes first in the DOM
  var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
  var start = order ? element1 : element2;
  var end = order ? element2 : element1;

  // Get common ancestor container
  var range = document.createRange();
  range.setStart(start, 0);
  range.setEnd(end, 0);
  var commonAncestorContainer = range.commonAncestorContainer;

  // Both nodes are inside #document

  if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
    if (isOffsetContainer(commonAncestorContainer)) {
      return commonAncestorContainer;
    }

    return getOffsetParent(commonAncestorContainer);
  }

  // one of the nodes is inside shadowDOM, find which one
  var element1root = getRoot(element1);
  if (element1root.host) {
    return findCommonOffsetParent(element1root.host, element2);
  } else {
    return findCommonOffsetParent(element1, getRoot(element2).host);
  }
}

/**
 * Gets the scroll value of the given element in the given side (top and left)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {String} side `top` or `left`
 * @returns {number} amount of scrolled pixels
 */
function getScroll(element) {
  var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';

  var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
  var nodeName = element.nodeName;

  if (nodeName === 'BODY' || nodeName === 'HTML') {
    var html = element.ownerDocument.documentElement;
    var scrollingElement = element.ownerDocument.scrollingElement || html;
    return scrollingElement[upperSide];
  }

  return element[upperSide];
}

/*
 * Sum or subtract the element scroll values (left and top) from a given rect object
 * @method
 * @memberof Popper.Utils
 * @param {Object} rect - Rect object you want to change
 * @param {HTMLElement} element - The element from the function reads the scroll values
 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
 * @return {Object} rect - The modifier rect object
 */
function includeScroll(rect, element) {
  var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var scrollTop = getScroll(element, 'top');
  var scrollLeft = getScroll(element, 'left');
  var modifier = subtract ? -1 : 1;
  rect.top += scrollTop * modifier;
  rect.bottom += scrollTop * modifier;
  rect.left += scrollLeft * modifier;
  rect.right += scrollLeft * modifier;
  return rect;
}

/*
 * Helper to detect borders of a given element
 * @method
 * @memberof Popper.Utils
 * @param {CSSStyleDeclaration} styles
 * Result of `getStyleComputedProperty` on the given element
 * @param {String} axis - `x` or `y`
 * @return {number} borders - The borders size of the given axis
 */

function getBordersSize(styles, axis) {
  var sideA = axis === 'x' ? 'Left' : 'Top';
  var sideB = sideA === 'Left' ? 'Right' : 'Bottom';

  return parseFloat(styles['border' + sideA + 'Width']) + parseFloat(styles['border' + sideB + 'Width']);
}

function getSize(axis, body, html, computedStyle) {
  return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], isIE(10) ? parseInt(html['offset' + axis]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')]) : 0);
}

function getWindowSizes(document) {
  var body = document.body;
  var html = document.documentElement;
  var computedStyle = isIE(10) && getComputedStyle(html);

  return {
    height: getSize('Height', body, html, computedStyle),
    width: getSize('Width', body, html, computedStyle)
  };
}

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/**
 * Given element offsets, generate an output similar to getBoundingClientRect
 * @method
 * @memberof Popper.Utils
 * @argument {Object} offsets
 * @returns {Object} ClientRect like output
 */
function getClientRect(offsets) {
  return _extends({}, offsets, {
    right: offsets.left + offsets.width,
    bottom: offsets.top + offsets.height
  });
}

/**
 * Get bounding client rect of given element
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} element
 * @return {Object} client rect
 */
function getBoundingClientRect(element) {
  var rect = {};

  // IE10 10 FIX: Please, don't ask, the element isn't
  // considered in DOM in some circumstances...
  // This isn't reproducible in IE10 compatibility mode of IE11
  try {
    if (isIE(10)) {
      rect = element.getBoundingClientRect();
      var scrollTop = getScroll(element, 'top');
      var scrollLeft = getScroll(element, 'left');
      rect.top += scrollTop;
      rect.left += scrollLeft;
      rect.bottom += scrollTop;
      rect.right += scrollLeft;
    } else {
      rect = element.getBoundingClientRect();
    }
  } catch (e) {}

  var result = {
    left: rect.left,
    top: rect.top,
    width: rect.right - rect.left,
    height: rect.bottom - rect.top
  };

  // subtract scrollbar size from sizes
  var sizes = element.nodeName === 'HTML' ? getWindowSizes(element.ownerDocument) : {};
  var width = sizes.width || element.clientWidth || result.width;
  var height = sizes.height || element.clientHeight || result.height;

  var horizScrollbar = element.offsetWidth - width;
  var vertScrollbar = element.offsetHeight - height;

  // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
  // we make this check conditional for performance reasons
  if (horizScrollbar || vertScrollbar) {
    var styles = getStyleComputedProperty(element);
    horizScrollbar -= getBordersSize(styles, 'x');
    vertScrollbar -= getBordersSize(styles, 'y');

    result.width -= horizScrollbar;
    result.height -= vertScrollbar;
  }

  return getClientRect(result);
}

function getOffsetRectRelativeToArbitraryNode(children, parent) {
  var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var isIE10 = isIE(10);
  var isHTML = parent.nodeName === 'HTML';
  var childrenRect = getBoundingClientRect(children);
  var parentRect = getBoundingClientRect(parent);
  var scrollParent = getScrollParent(children);

  var styles = getStyleComputedProperty(parent);
  var borderTopWidth = parseFloat(styles.borderTopWidth);
  var borderLeftWidth = parseFloat(styles.borderLeftWidth);

  // In cases where the parent is fixed, we must ignore negative scroll in offset calc
  if (fixedPosition && isHTML) {
    parentRect.top = Math.max(parentRect.top, 0);
    parentRect.left = Math.max(parentRect.left, 0);
  }
  var offsets = getClientRect({
    top: childrenRect.top - parentRect.top - borderTopWidth,
    left: childrenRect.left - parentRect.left - borderLeftWidth,
    width: childrenRect.width,
    height: childrenRect.height
  });
  offsets.marginTop = 0;
  offsets.marginLeft = 0;

  // Subtract margins of documentElement in case it's being used as parent
  // we do this only on HTML because it's the only element that behaves
  // differently when margins are applied to it. The margins are included in
  // the box of the documentElement, in the other cases not.
  if (!isIE10 && isHTML) {
    var marginTop = parseFloat(styles.marginTop);
    var marginLeft = parseFloat(styles.marginLeft);

    offsets.top -= borderTopWidth - marginTop;
    offsets.bottom -= borderTopWidth - marginTop;
    offsets.left -= borderLeftWidth - marginLeft;
    offsets.right -= borderLeftWidth - marginLeft;

    // Attach marginTop and marginLeft because in some circumstances we may need them
    offsets.marginTop = marginTop;
    offsets.marginLeft = marginLeft;
  }

  if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') {
    offsets = includeScroll(offsets, parent);
  }

  return offsets;
}

function getViewportOffsetRectRelativeToArtbitraryNode(element) {
  var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var html = element.ownerDocument.documentElement;
  var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
  var width = Math.max(html.clientWidth, window.innerWidth || 0);
  var height = Math.max(html.clientHeight, window.innerHeight || 0);

  var scrollTop = !excludeScroll ? getScroll(html) : 0;
  var scrollLeft = !excludeScroll ? getScroll(html, 'left') : 0;

  var offset = {
    top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
    left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
    width: width,
    height: height
  };

  return getClientRect(offset);
}

/**
 * Check if the given element is fixed or is inside a fixed parent
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {Element} customContainer
 * @returns {Boolean} answer to "isFixed?"
 */
function isFixed(element) {
  var nodeName = element.nodeName;
  if (nodeName === 'BODY' || nodeName === 'HTML') {
    return false;
  }
  if (getStyleComputedProperty(element, 'position') === 'fixed') {
    return true;
  }
  var parentNode = getParentNode(element);
  if (!parentNode) {
    return false;
  }
  return isFixed(parentNode);
}

/**
 * Finds the first parent of an element that has a transformed property defined
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} first transformed parent or documentElement
 */

function getFixedPositionOffsetParent(element) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element || !element.parentElement || isIE()) {
    return document.documentElement;
  }
  var el = element.parentElement;
  while (el && getStyleComputedProperty(el, 'transform') === 'none') {
    el = el.parentElement;
  }
  return el || document.documentElement;
}

/**
 * Computed the boundaries limits and return them
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} popper
 * @param {HTMLElement} reference
 * @param {number} padding
 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
 * @param {Boolean} fixedPosition - Is in fixed position mode
 * @returns {Object} Coordinates of the boundaries
 */
function getBoundaries(popper, reference, padding, boundariesElement) {
  var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

  // NOTE: 1 DOM access here

  var boundaries = { top: 0, left: 0 };
  var offsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));

  // Handle viewport case
  if (boundariesElement === 'viewport') {
    boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
  } else {
    // Handle other cases based on DOM element used as boundaries
    var boundariesNode = void 0;
    if (boundariesElement === 'scrollParent') {
      boundariesNode = getScrollParent(getParentNode(reference));
      if (boundariesNode.nodeName === 'BODY') {
        boundariesNode = popper.ownerDocument.documentElement;
      }
    } else if (boundariesElement === 'window') {
      boundariesNode = popper.ownerDocument.documentElement;
    } else {
      boundariesNode = boundariesElement;
    }

    var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);

    // In case of HTML, we need a different computation
    if (boundariesNode.nodeName === 'HTML' && !isFixed(offsetParent)) {
      var _getWindowSizes = getWindowSizes(popper.ownerDocument),
          height = _getWindowSizes.height,
          width = _getWindowSizes.width;

      boundaries.top += offsets.top - offsets.marginTop;
      boundaries.bottom = height + offsets.top;
      boundaries.left += offsets.left - offsets.marginLeft;
      boundaries.right = width + offsets.left;
    } else {
      // for all the other DOM elements, this one is good
      boundaries = offsets;
    }
  }

  // Add paddings
  padding = padding || 0;
  var isPaddingNumber = typeof padding === 'number';
  boundaries.left += isPaddingNumber ? padding : padding.left || 0;
  boundaries.top += isPaddingNumber ? padding : padding.top || 0;
  boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
  boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;

  return boundaries;
}

function getArea(_ref) {
  var width = _ref.width,
      height = _ref.height;

  return width * height;
}

/**
 * Utility used to transform the `auto` placement to the placement with more
 * available space.
 * @method
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
  var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;

  if (placement.indexOf('auto') === -1) {
    return placement;
  }

  var boundaries = getBoundaries(popper, reference, padding, boundariesElement);

  var rects = {
    top: {
      width: boundaries.width,
      height: refRect.top - boundaries.top
    },
    right: {
      width: boundaries.right - refRect.right,
      height: boundaries.height
    },
    bottom: {
      width: boundaries.width,
      height: boundaries.bottom - refRect.bottom
    },
    left: {
      width: refRect.left - boundaries.left,
      height: boundaries.height
    }
  };

  var sortedAreas = Object.keys(rects).map(function (key) {
    return _extends({
      key: key
    }, rects[key], {
      area: getArea(rects[key])
    });
  }).sort(function (a, b) {
    return b.area - a.area;
  });

  var filteredAreas = sortedAreas.filter(function (_ref2) {
    var width = _ref2.width,
        height = _ref2.height;
    return width >= popper.clientWidth && height >= popper.clientHeight;
  });

  var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;

  var variation = placement.split('-')[1];

  return computedPlacement + (variation ? '-' + variation : '');
}

/**
 * Get offsets to the reference element
 * @method
 * @memberof Popper.Utils
 * @param {Object} state
 * @param {Element} popper - the popper element
 * @param {Element} reference - the reference element (the popper will be relative to this)
 * @param {Element} fixedPosition - is in fixed position mode
 * @returns {Object} An object containing the offsets which will be applied to the popper
 */
function getReferenceOffsets(state, popper, reference) {
  var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

  var commonOffsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));
  return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
}

/**
 * Get the outer sizes of the given element (offset size + margins)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Object} object containing width and height properties
 */
function getOuterSizes(element) {
  var window = element.ownerDocument.defaultView;
  var styles = window.getComputedStyle(element);
  var x = parseFloat(styles.marginTop || 0) + parseFloat(styles.marginBottom || 0);
  var y = parseFloat(styles.marginLeft || 0) + parseFloat(styles.marginRight || 0);
  var result = {
    width: element.offsetWidth + y,
    height: element.offsetHeight + x
  };
  return result;
}

/**
 * Get the opposite placement of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement
 * @returns {String} flipped placement
 */
function getOppositePlacement(placement) {
  var hash = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' };
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash[matched];
  });
}

/**
 * Get offsets to the popper
 * @method
 * @memberof Popper.Utils
 * @param {Object} position - CSS position the Popper will get applied
 * @param {HTMLElement} popper - the popper element
 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
 * @param {String} placement - one of the valid placement options
 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
 */
function getPopperOffsets(popper, referenceOffsets, placement) {
  placement = placement.split('-')[0];

  // Get popper node sizes
  var popperRect = getOuterSizes(popper);

  // Add position, width and height to our offsets object
  var popperOffsets = {
    width: popperRect.width,
    height: popperRect.height
  };

  // depending by the popper placement we have to compute its offsets slightly differently
  var isHoriz = ['right', 'left'].indexOf(placement) !== -1;
  var mainSide = isHoriz ? 'top' : 'left';
  var secondarySide = isHoriz ? 'left' : 'top';
  var measurement = isHoriz ? 'height' : 'width';
  var secondaryMeasurement = !isHoriz ? 'height' : 'width';

  popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
  if (placement === secondarySide) {
    popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
  } else {
    popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
  }

  return popperOffsets;
}

/**
 * Mimics the `find` method of Array
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function find(arr, check) {
  // use native find if supported
  if (Array.prototype.find) {
    return arr.find(check);
  }

  // use `filter` to obtain the same behavior of `find`
  return arr.filter(check)[0];
}

/**
 * Return the index of the matching object
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function findIndex(arr, prop, value) {
  // use native findIndex if supported
  if (Array.prototype.findIndex) {
    return arr.findIndex(function (cur) {
      return cur[prop] === value;
    });
  }

  // use `find` + `indexOf` if `findIndex` isn't supported
  var match = find(arr, function (obj) {
    return obj[prop] === value;
  });
  return arr.indexOf(match);
}

/**
 * Loop trough the list of modifiers and run them in order,
 * each of them will then edit the data object.
 * @method
 * @memberof Popper.Utils
 * @param {dataObject} data
 * @param {Array} modifiers
 * @param {String} ends - Optional modifier name used as stopper
 * @returns {dataObject}
 */
function runModifiers(modifiers, data, ends) {
  var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, findIndex(modifiers, 'name', ends));

  modifiersToRun.forEach(function (modifier) {
    if (modifier['function']) {
      // eslint-disable-line dot-notation
      console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
    }
    var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
    if (modifier.enabled && isFunction(fn)) {
      // Add properties to offsets to make them a complete clientRect object
      // we do this before each modifier to make sure the previous one doesn't
      // mess with these values
      data.offsets.popper = getClientRect(data.offsets.popper);
      data.offsets.reference = getClientRect(data.offsets.reference);

      data = fn(data, modifier);
    }
  });

  return data;
}

/**
 * Updates the position of the popper, computing the new offsets and applying
 * the new style.<br />
 * Prefer `scheduleUpdate` over `update` because of performance reasons.
 * @method
 * @memberof Popper
 */
function update() {
  // if popper is destroyed, don't perform any further update
  if (this.state.isDestroyed) {
    return;
  }

  var data = {
    instance: this,
    styles: {},
    arrowStyles: {},
    attributes: {},
    flipped: false,
    offsets: {}
  };

  // compute reference element offsets
  data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  data.placement = computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);

  // store the computed placement inside `originalPlacement`
  data.originalPlacement = data.placement;

  data.positionFixed = this.options.positionFixed;

  // compute the popper offsets
  data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);

  data.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute';

  // run the modifiers
  data = runModifiers(this.modifiers, data);

  // the first `update` will call `onCreate` callback
  // the other ones will call `onUpdate` callback
  if (!this.state.isCreated) {
    this.state.isCreated = true;
    this.options.onCreate(data);
  } else {
    this.options.onUpdate(data);
  }
}

/**
 * Helper used to know if the given modifier is enabled.
 * @method
 * @memberof Popper.Utils
 * @returns {Boolean}
 */
function isModifierEnabled(modifiers, modifierName) {
  return modifiers.some(function (_ref) {
    var name = _ref.name,
        enabled = _ref.enabled;
    return enabled && name === modifierName;
  });
}

/**
 * Get the prefixed supported property name
 * @method
 * @memberof Popper.Utils
 * @argument {String} property (camelCase)
 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
 */
function getSupportedPropertyName(property) {
  var prefixes = [false, 'ms', 'Webkit', 'Moz', 'O'];
  var upperProp = property.charAt(0).toUpperCase() + property.slice(1);

  for (var i = 0; i < prefixes.length; i++) {
    var prefix = prefixes[i];
    var toCheck = prefix ? '' + prefix + upperProp : property;
    if (typeof document.body.style[toCheck] !== 'undefined') {
      return toCheck;
    }
  }
  return null;
}

/**
 * Destroys the popper.
 * @method
 * @memberof Popper
 */
function destroy() {
  this.state.isDestroyed = true;

  // touch DOM only if `applyStyle` modifier is enabled
  if (isModifierEnabled(this.modifiers, 'applyStyle')) {
    this.popper.removeAttribute('x-placement');
    this.popper.style.position = '';
    this.popper.style.top = '';
    this.popper.style.left = '';
    this.popper.style.right = '';
    this.popper.style.bottom = '';
    this.popper.style.willChange = '';
    this.popper.style[getSupportedPropertyName('transform')] = '';
  }

  this.disableEventListeners();

  // remove the popper if user explicitly asked for the deletion on destroy
  // do not use `remove` because IE11 doesn't support it
  if (this.options.removeOnDestroy) {
    this.popper.parentNode.removeChild(this.popper);
  }
  return this;
}

/**
 * Get the window associated with the element
 * @argument {Element} element
 * @returns {Window}
 */
function getWindow(element) {
  var ownerDocument = element.ownerDocument;
  return ownerDocument ? ownerDocument.defaultView : window;
}

function attachToScrollParents(scrollParent, event, callback, scrollParents) {
  var isBody = scrollParent.nodeName === 'BODY';
  var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
  target.addEventListener(event, callback, { passive: true });

  if (!isBody) {
    attachToScrollParents(getScrollParent(target.parentNode), event, callback, scrollParents);
  }
  scrollParents.push(target);
}

/**
 * Setup needed event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function setupEventListeners(reference, options, state, updateBound) {
  // Resize event listener on window
  state.updateBound = updateBound;
  getWindow(reference).addEventListener('resize', state.updateBound, { passive: true });

  // Scroll event listener on scroll parents
  var scrollElement = getScrollParent(reference);
  attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
  state.scrollElement = scrollElement;
  state.eventsEnabled = true;

  return state;
}

/**
 * It will add resize/scroll events and start recalculating
 * position of the popper element when they are triggered.
 * @method
 * @memberof Popper
 */
function enableEventListeners() {
  if (!this.state.eventsEnabled) {
    this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
  }
}

/**
 * Remove event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function removeEventListeners(reference, state) {
  // Remove resize event listener on window
  getWindow(reference).removeEventListener('resize', state.updateBound);

  // Remove scroll event listener on scroll parents
  state.scrollParents.forEach(function (target) {
    target.removeEventListener('scroll', state.updateBound);
  });

  // Reset state
  state.updateBound = null;
  state.scrollParents = [];
  state.scrollElement = null;
  state.eventsEnabled = false;
  return state;
}

/**
 * It will remove resize/scroll events and won't recalculate popper position
 * when they are triggered. It also won't trigger `onUpdate` callback anymore,
 * unless you call `update` method manually.
 * @method
 * @memberof Popper
 */
function disableEventListeners() {
  if (this.state.eventsEnabled) {
    cancelAnimationFrame(this.scheduleUpdate);
    this.state = removeEventListeners(this.reference, this.state);
  }
}

/**
 * Tells if a given input is a number
 * @method
 * @memberof Popper.Utils
 * @param {*} input to check
 * @return {Boolean}
 */
function isNumeric(n) {
  return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
}

/**
 * Set the style to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the style to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setStyles(element, styles) {
  Object.keys(styles).forEach(function (prop) {
    var unit = '';
    // add unit if the value is numeric and is one of the following
    if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && isNumeric(styles[prop])) {
      unit = 'px';
    }
    element.style[prop] = styles[prop] + unit;
  });
}

/**
 * Set the attributes to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the attributes to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setAttributes(element, attributes) {
  Object.keys(attributes).forEach(function (prop) {
    var value = attributes[prop];
    if (value !== false) {
      element.setAttribute(prop, attributes[prop]);
    } else {
      element.removeAttribute(prop);
    }
  });
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} data.styles - List of style properties - values to apply to popper element
 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The same data object
 */
function applyStyle(data) {
  // any property present in `data.styles` will be applied to the popper,
  // in this way we can make the 3rd party modifiers add custom styles to it
  // Be aware, modifiers could override the properties defined in the previous
  // lines of this modifier!
  setStyles(data.instance.popper, data.styles);

  // any property present in `data.attributes` will be applied to the popper,
  // they will be set as HTML attributes of the element
  setAttributes(data.instance.popper, data.attributes);

  // if arrowElement is defined and arrowStyles has some properties
  if (data.arrowElement && Object.keys(data.arrowStyles).length) {
    setStyles(data.arrowElement, data.arrowStyles);
  }

  return data;
}

/**
 * Set the x-placement attribute before everything else because it could be used
 * to add margins to the popper margins needs to be calculated to get the
 * correct popper offsets.
 * @method
 * @memberof Popper.modifiers
 * @param {HTMLElement} reference - The reference element used to position the popper
 * @param {HTMLElement} popper - The HTML element used as popper
 * @param {Object} options - Popper.js options
 */
function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
  // compute reference element offsets
  var referenceOffsets = getReferenceOffsets(state, popper, reference, options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  var placement = computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);

  popper.setAttribute('x-placement', placement);

  // Apply `position` to popper before anything else because
  // without the position applied we can't guarantee correct computations
  setStyles(popper, { position: options.positionFixed ? 'fixed' : 'absolute' });

  return options;
}

/**
 * @function
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Boolean} shouldRound - If the offsets should be rounded at all
 * @returns {Object} The popper's position offsets rounded
 *
 * The tale of pixel-perfect positioning. It's still not 100% perfect, but as
 * good as it can be within reason.
 * Discussion here: https://github.com/FezVrasta/popper.js/pull/715
 *
 * Low DPI screens cause a popper to be blurry if not using full pixels (Safari
 * as well on High DPI screens).
 *
 * Firefox prefers no rounding for positioning and does not have blurriness on
 * high DPI screens.
 *
 * Only horizontal placement and left/right values need to be considered.
 */
function getRoundedOffsets(data, shouldRound) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;
  var round = Math.round,
      floor = Math.floor;

  var noRound = function noRound(v) {
    return v;
  };

  var referenceWidth = round(reference.width);
  var popperWidth = round(popper.width);

  var isVertical = ['left', 'right'].indexOf(data.placement) !== -1;
  var isVariation = data.placement.indexOf('-') !== -1;
  var sameWidthParity = referenceWidth % 2 === popperWidth % 2;
  var bothOddWidth = referenceWidth % 2 === 1 && popperWidth % 2 === 1;

  var horizontalToInteger = !shouldRound ? noRound : isVertical || isVariation || sameWidthParity ? round : floor;
  var verticalToInteger = !shouldRound ? noRound : round;

  return {
    left: horizontalToInteger(bothOddWidth && !isVariation && shouldRound ? popper.left - 1 : popper.left),
    top: verticalToInteger(popper.top),
    bottom: verticalToInteger(popper.bottom),
    right: horizontalToInteger(popper.right)
  };
}

var isFirefox = isBrowser && /Firefox/i.test(navigator.userAgent);

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeStyle(data, options) {
  var x = options.x,
      y = options.y;
  var popper = data.offsets.popper;

  // Remove this legacy support in Popper.js v2

  var legacyGpuAccelerationOption = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'applyStyle';
  }).gpuAcceleration;
  if (legacyGpuAccelerationOption !== undefined) {
    console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
  }
  var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;

  var offsetParent = getOffsetParent(data.instance.popper);
  var offsetParentRect = getBoundingClientRect(offsetParent);

  // Styles
  var styles = {
    position: popper.position
  };

  var offsets = getRoundedOffsets(data, window.devicePixelRatio < 2 || !isFirefox);

  var sideA = x === 'bottom' ? 'top' : 'bottom';
  var sideB = y === 'right' ? 'left' : 'right';

  // if gpuAcceleration is set to `true` and transform is supported,
  //  we use `translate3d` to apply the position to the popper we
  // automatically use the supported prefixed version if needed
  var prefixedProperty = getSupportedPropertyName('transform');

  // now, let's make a step back and look at this code closely (wtf?)
  // If the content of the popper grows once it's been positioned, it
  // may happen that the popper gets misplaced because of the new content
  // overflowing its reference element
  // To avoid this problem, we provide two options (x and y), which allow
  // the consumer to define the offset origin.
  // If we position a popper on top of a reference element, we can set
  // `x` to `top` to make the popper grow towards its top instead of
  // its bottom.
  var left = void 0,
      top = void 0;
  if (sideA === 'bottom') {
    // when offsetParent is <html> the positioning is relative to the bottom of the screen (excluding the scrollbar)
    // and not the bottom of the html element
    if (offsetParent.nodeName === 'HTML') {
      top = -offsetParent.clientHeight + offsets.bottom;
    } else {
      top = -offsetParentRect.height + offsets.bottom;
    }
  } else {
    top = offsets.top;
  }
  if (sideB === 'right') {
    if (offsetParent.nodeName === 'HTML') {
      left = -offsetParent.clientWidth + offsets.right;
    } else {
      left = -offsetParentRect.width + offsets.right;
    }
  } else {
    left = offsets.left;
  }
  if (gpuAcceleration && prefixedProperty) {
    styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
    styles[sideA] = 0;
    styles[sideB] = 0;
    styles.willChange = 'transform';
  } else {
    // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
    var invertTop = sideA === 'bottom' ? -1 : 1;
    var invertLeft = sideB === 'right' ? -1 : 1;
    styles[sideA] = top * invertTop;
    styles[sideB] = left * invertLeft;
    styles.willChange = sideA + ', ' + sideB;
  }

  // Attributes
  var attributes = {
    'x-placement': data.placement
  };

  // Update `data` attributes, styles and arrowStyles
  data.attributes = _extends({}, attributes, data.attributes);
  data.styles = _extends({}, styles, data.styles);
  data.arrowStyles = _extends({}, data.offsets.arrow, data.arrowStyles);

  return data;
}

/**
 * Helper used to know if the given modifier depends from another one.<br />
 * It checks if the needed modifier is listed and enabled.
 * @method
 * @memberof Popper.Utils
 * @param {Array} modifiers - list of modifiers
 * @param {String} requestingName - name of requesting modifier
 * @param {String} requestedName - name of requested modifier
 * @returns {Boolean}
 */
function isModifierRequired(modifiers, requestingName, requestedName) {
  var requesting = find(modifiers, function (_ref) {
    var name = _ref.name;
    return name === requestingName;
  });

  var isRequired = !!requesting && modifiers.some(function (modifier) {
    return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
  });

  if (!isRequired) {
    var _requesting = '`' + requestingName + '`';
    var requested = '`' + requestedName + '`';
    console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
  }
  return isRequired;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function arrow(data, options) {
  var _data$offsets$arrow;

  // arrow depends on keepTogether in order to work
  if (!isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) {
    return data;
  }

  var arrowElement = options.element;

  // if arrowElement is a string, suppose it's a CSS selector
  if (typeof arrowElement === 'string') {
    arrowElement = data.instance.popper.querySelector(arrowElement);

    // if arrowElement is not found, don't run the modifier
    if (!arrowElement) {
      return data;
    }
  } else {
    // if the arrowElement isn't a query selector we must check that the
    // provided DOM node is child of its popper node
    if (!data.instance.popper.contains(arrowElement)) {
      console.warn('WARNING: `arrow.element` must be child of its popper element!');
      return data;
    }
  }

  var placement = data.placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isVertical = ['left', 'right'].indexOf(placement) !== -1;

  var len = isVertical ? 'height' : 'width';
  var sideCapitalized = isVertical ? 'Top' : 'Left';
  var side = sideCapitalized.toLowerCase();
  var altSide = isVertical ? 'left' : 'top';
  var opSide = isVertical ? 'bottom' : 'right';
  var arrowElementSize = getOuterSizes(arrowElement)[len];

  //
  // extends keepTogether behavior making sure the popper and its
  // reference have enough pixels in conjunction
  //

  // top/left side
  if (reference[opSide] - arrowElementSize < popper[side]) {
    data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
  }
  // bottom/right side
  if (reference[side] + arrowElementSize > popper[opSide]) {
    data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
  }
  data.offsets.popper = getClientRect(data.offsets.popper);

  // compute center of the popper
  var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;

  // Compute the sideValue using the updated popper offsets
  // take popper margin in account because we don't have this info available
  var css = getStyleComputedProperty(data.instance.popper);
  var popperMarginSide = parseFloat(css['margin' + sideCapitalized]);
  var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width']);
  var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;

  // prevent arrowElement from being placed not contiguously to its popper
  sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);

  data.arrowElement = arrowElement;
  data.offsets.arrow = (_data$offsets$arrow = {}, defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), defineProperty(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);

  return data;
}

/**
 * Get the opposite placement variation of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement variation
 * @returns {String} flipped placement variation
 */
function getOppositeVariation(variation) {
  if (variation === 'end') {
    return 'start';
  } else if (variation === 'start') {
    return 'end';
  }
  return variation;
}

/**
 * List of accepted placements to use as values of the `placement` option.<br />
 * Valid placements are:
 * - `auto`
 * - `top`
 * - `right`
 * - `bottom`
 * - `left`
 *
 * Each placement can have a variation from this list:
 * - `-start`
 * - `-end`
 *
 * Variations are interpreted easily if you think of them as the left to right
 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
 * is right.<br />
 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
 *
 * Some valid examples are:
 * - `top-end` (on top of reference, right aligned)
 * - `right-start` (on right of reference, top aligned)
 * - `bottom` (on bottom, centered)
 * - `auto-end` (on the side with more space available, alignment depends by placement)
 *
 * @static
 * @type {Array}
 * @enum {String}
 * @readonly
 * @method placements
 * @memberof Popper
 */
var placements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];

// Get rid of `auto` `auto-start` and `auto-end`
var validPlacements = placements.slice(3);

/**
 * Given an initial placement, returns all the subsequent placements
 * clockwise (or counter-clockwise).
 *
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement - A valid placement (it accepts variations)
 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
 * @returns {Array} placements including their variations
 */
function clockwise(placement) {
  var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var index = validPlacements.indexOf(placement);
  var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
  return counter ? arr.reverse() : arr;
}

var BEHAVIORS = {
  FLIP: 'flip',
  CLOCKWISE: 'clockwise',
  COUNTERCLOCKWISE: 'counterclockwise'
};

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function flip(data, options) {
  // if `inner` modifier is enabled, we can't use the `flip` modifier
  if (isModifierEnabled(data.instance.modifiers, 'inner')) {
    return data;
  }

  if (data.flipped && data.placement === data.originalPlacement) {
    // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
    return data;
  }

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);

  var placement = data.placement.split('-')[0];
  var placementOpposite = getOppositePlacement(placement);
  var variation = data.placement.split('-')[1] || '';

  var flipOrder = [];

  switch (options.behavior) {
    case BEHAVIORS.FLIP:
      flipOrder = [placement, placementOpposite];
      break;
    case BEHAVIORS.CLOCKWISE:
      flipOrder = clockwise(placement);
      break;
    case BEHAVIORS.COUNTERCLOCKWISE:
      flipOrder = clockwise(placement, true);
      break;
    default:
      flipOrder = options.behavior;
  }

  flipOrder.forEach(function (step, index) {
    if (placement !== step || flipOrder.length === index + 1) {
      return data;
    }

    placement = data.placement.split('-')[0];
    placementOpposite = getOppositePlacement(placement);

    var popperOffsets = data.offsets.popper;
    var refOffsets = data.offsets.reference;

    // using floor because the reference offsets may contain decimals we are not going to consider here
    var floor = Math.floor;
    var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);

    var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
    var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
    var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
    var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);

    var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;

    // flip the variation if required
    var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;

    // flips variation if reference element overflows boundaries
    var flippedVariationByRef = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);

    // flips variation if popper content overflows boundaries
    var flippedVariationByContent = !!options.flipVariationsByContent && (isVertical && variation === 'start' && overflowsRight || isVertical && variation === 'end' && overflowsLeft || !isVertical && variation === 'start' && overflowsBottom || !isVertical && variation === 'end' && overflowsTop);

    var flippedVariation = flippedVariationByRef || flippedVariationByContent;

    if (overlapsRef || overflowsBoundaries || flippedVariation) {
      // this boolean to detect any flip loop
      data.flipped = true;

      if (overlapsRef || overflowsBoundaries) {
        placement = flipOrder[index + 1];
      }

      if (flippedVariation) {
        variation = getOppositeVariation(variation);
      }

      data.placement = placement + (variation ? '-' + variation : '');

      // this object contains `position`, we want to preserve it along with
      // any additional property we may add in the future
      data.offsets.popper = _extends({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));

      data = runModifiers(data.instance.modifiers, data, 'flip');
    }
  });
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function keepTogether(data) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var placement = data.placement.split('-')[0];
  var floor = Math.floor;
  var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
  var side = isVertical ? 'right' : 'bottom';
  var opSide = isVertical ? 'left' : 'top';
  var measurement = isVertical ? 'width' : 'height';

  if (popper[side] < floor(reference[opSide])) {
    data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
  }
  if (popper[opSide] > floor(reference[side])) {
    data.offsets.popper[opSide] = floor(reference[side]);
  }

  return data;
}

/**
 * Converts a string containing value + unit into a px value number
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} str - Value + unit string
 * @argument {String} measurement - `height` or `width`
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @returns {Number|String}
 * Value in pixels, or original string if no values were extracted
 */
function toValue(str, measurement, popperOffsets, referenceOffsets) {
  // separate value from unit
  var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
  var value = +split[1];
  var unit = split[2];

  // If it's not a number it's an operator, I guess
  if (!value) {
    return str;
  }

  if (unit.indexOf('%') === 0) {
    var element = void 0;
    switch (unit) {
      case '%p':
        element = popperOffsets;
        break;
      case '%':
      case '%r':
      default:
        element = referenceOffsets;
    }

    var rect = getClientRect(element);
    return rect[measurement] / 100 * value;
  } else if (unit === 'vh' || unit === 'vw') {
    // if is a vh or vw, we calculate the size based on the viewport
    var size = void 0;
    if (unit === 'vh') {
      size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    } else {
      size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    }
    return size / 100 * value;
  } else {
    // if is an explicit pixel unit, we get rid of the unit and keep the value
    // if is an implicit unit, it's px, and we return just the value
    return value;
  }
}

/**
 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} offset
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @argument {String} basePlacement
 * @returns {Array} a two cells array with x and y offsets in numbers
 */
function parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
  var offsets = [0, 0];

  // Use height if placement is left or right and index is 0 otherwise use width
  // in this way the first offset will use an axis and the second one
  // will use the other one
  var useHeight = ['right', 'left'].indexOf(basePlacement) !== -1;

  // Split the offset string to obtain a list of values and operands
  // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
  var fragments = offset.split(/(\+|\-)/).map(function (frag) {
    return frag.trim();
  });

  // Detect if the offset string contains a pair of values or a single one
  // they could be separated by comma or space
  var divider = fragments.indexOf(find(fragments, function (frag) {
    return frag.search(/,|\s/) !== -1;
  }));

  if (fragments[divider] && fragments[divider].indexOf(',') === -1) {
    console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
  }

  // If divider is found, we divide the list of values and operands to divide
  // them by ofset X and Y.
  var splitRegex = /\s*,\s*|\s+/;
  var ops = divider !== -1 ? [fragments.slice(0, divider).concat([fragments[divider].split(splitRegex)[0]]), [fragments[divider].split(splitRegex)[1]].concat(fragments.slice(divider + 1))] : [fragments];

  // Convert the values with units to absolute pixels to allow our computations
  ops = ops.map(function (op, index) {
    // Most of the units rely on the orientation of the popper
    var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
    var mergeWithPrevious = false;
    return op
    // This aggregates any `+` or `-` sign that aren't considered operators
    // e.g.: 10 + +5 => [10, +, +5]
    .reduce(function (a, b) {
      if (a[a.length - 1] === '' && ['+', '-'].indexOf(b) !== -1) {
        a[a.length - 1] = b;
        mergeWithPrevious = true;
        return a;
      } else if (mergeWithPrevious) {
        a[a.length - 1] += b;
        mergeWithPrevious = false;
        return a;
      } else {
        return a.concat(b);
      }
    }, [])
    // Here we convert the string values into number values (in px)
    .map(function (str) {
      return toValue(str, measurement, popperOffsets, referenceOffsets);
    });
  });

  // Loop trough the offsets arrays and execute the operations
  ops.forEach(function (op, index) {
    op.forEach(function (frag, index2) {
      if (isNumeric(frag)) {
        offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
      }
    });
  });
  return offsets;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @argument {Number|String} options.offset=0
 * The offset value as described in the modifier description
 * @returns {Object} The data object, properly modified
 */
function offset(data, _ref) {
  var offset = _ref.offset;
  var placement = data.placement,
      _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var basePlacement = placement.split('-')[0];

  var offsets = void 0;
  if (isNumeric(+offset)) {
    offsets = [+offset, 0];
  } else {
    offsets = parseOffset(offset, popper, reference, basePlacement);
  }

  if (basePlacement === 'left') {
    popper.top += offsets[0];
    popper.left -= offsets[1];
  } else if (basePlacement === 'right') {
    popper.top += offsets[0];
    popper.left += offsets[1];
  } else if (basePlacement === 'top') {
    popper.left += offsets[0];
    popper.top -= offsets[1];
  } else if (basePlacement === 'bottom') {
    popper.left += offsets[0];
    popper.top += offsets[1];
  }

  data.popper = popper;
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function preventOverflow(data, options) {
  var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper);

  // If offsetParent is the reference element, we really want to
  // go one step up and use the next offsetParent as reference to
  // avoid to make this modifier completely useless and look like broken
  if (data.instance.reference === boundariesElement) {
    boundariesElement = getOffsetParent(boundariesElement);
  }

  // NOTE: DOM access here
  // resets the popper's position so that the document size can be calculated excluding
  // the size of the popper element itself
  var transformProp = getSupportedPropertyName('transform');
  var popperStyles = data.instance.popper.style; // assignment to help minification
  var top = popperStyles.top,
      left = popperStyles.left,
      transform = popperStyles[transformProp];

  popperStyles.top = '';
  popperStyles.left = '';
  popperStyles[transformProp] = '';

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);

  // NOTE: DOM access here
  // restores the original style properties after the offsets have been computed
  popperStyles.top = top;
  popperStyles.left = left;
  popperStyles[transformProp] = transform;

  options.boundaries = boundaries;

  var order = options.priority;
  var popper = data.offsets.popper;

  var check = {
    primary: function primary(placement) {
      var value = popper[placement];
      if (popper[placement] < boundaries[placement] && !options.escapeWithReference) {
        value = Math.max(popper[placement], boundaries[placement]);
      }
      return defineProperty({}, placement, value);
    },
    secondary: function secondary(placement) {
      var mainSide = placement === 'right' ? 'left' : 'top';
      var value = popper[mainSide];
      if (popper[placement] > boundaries[placement] && !options.escapeWithReference) {
        value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
      }
      return defineProperty({}, mainSide, value);
    }
  };

  order.forEach(function (placement) {
    var side = ['left', 'top'].indexOf(placement) !== -1 ? 'primary' : 'secondary';
    popper = _extends({}, popper, check[side](placement));
  });

  data.offsets.popper = popper;

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function shift(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var shiftvariation = placement.split('-')[1];

  // if shift shiftvariation is specified, run the modifier
  if (shiftvariation) {
    var _data$offsets = data.offsets,
        reference = _data$offsets.reference,
        popper = _data$offsets.popper;

    var isVertical = ['bottom', 'top'].indexOf(basePlacement) !== -1;
    var side = isVertical ? 'left' : 'top';
    var measurement = isVertical ? 'width' : 'height';

    var shiftOffsets = {
      start: defineProperty({}, side, reference[side]),
      end: defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
    };

    data.offsets.popper = _extends({}, popper, shiftOffsets[shiftvariation]);
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function hide(data) {
  if (!isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) {
    return data;
  }

  var refRect = data.offsets.reference;
  var bound = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'preventOverflow';
  }).boundaries;

  if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === true) {
      return data;
    }

    data.hide = true;
    data.attributes['x-out-of-boundaries'] = '';
  } else {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === false) {
      return data;
    }

    data.hide = false;
    data.attributes['x-out-of-boundaries'] = false;
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function inner(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isHoriz = ['left', 'right'].indexOf(basePlacement) !== -1;

  var subtractLength = ['top', 'left'].indexOf(basePlacement) === -1;

  popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);

  data.placement = getOppositePlacement(placement);
  data.offsets.popper = getClientRect(popper);

  return data;
}

/**
 * Modifier function, each modifier can have a function of this type assigned
 * to its `fn` property.<br />
 * These functions will be called on each update, this means that you must
 * make sure they are performant enough to avoid performance bottlenecks.
 *
 * @function ModifierFn
 * @argument {dataObject} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {dataObject} The data object, properly modified
 */

/**
 * Modifiers are plugins used to alter the behavior of your poppers.<br />
 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
 * needed by the library.
 *
 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
 * All the other properties are configurations that could be tweaked.
 * @namespace modifiers
 */
var modifiers = {
  /**
   * Modifier used to shift the popper on the start or end of its reference
   * element.<br />
   * It will read the variation of the `placement` property.<br />
   * It can be one either `-end` or `-start`.
   * @memberof modifiers
   * @inner
   */
  shift: {
    /** @prop {number} order=100 - Index used to define the order of execution */
    order: 100,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: shift
  },

  /**
   * The `offset` modifier can shift your popper on both its axis.
   *
   * It accepts the following units:
   * - `px` or unit-less, interpreted as pixels
   * - `%` or `%r`, percentage relative to the length of the reference element
   * - `%p`, percentage relative to the length of the popper element
   * - `vw`, CSS viewport width unit
   * - `vh`, CSS viewport height unit
   *
   * For length is intended the main axis relative to the placement of the popper.<br />
   * This means that if the placement is `top` or `bottom`, the length will be the
   * `width`. In case of `left` or `right`, it will be the `height`.
   *
   * You can provide a single value (as `Number` or `String`), or a pair of values
   * as `String` divided by a comma or one (or more) white spaces.<br />
   * The latter is a deprecated method because it leads to confusion and will be
   * removed in v2.<br />
   * Additionally, it accepts additions and subtractions between different units.
   * Note that multiplications and divisions aren't supported.
   *
   * Valid examples are:
   * ```
   * 10
   * '10%'
   * '10, 10'
   * '10%, 10'
   * '10 + 10%'
   * '10 - 5vh + 3%'
   * '-10px + 5vh, 5px - 6%'
   * ```
   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
   *
   * @memberof modifiers
   * @inner
   */
  offset: {
    /** @prop {number} order=200 - Index used to define the order of execution */
    order: 200,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: offset,
    /** @prop {Number|String} offset=0
     * The offset value as described in the modifier description
     */
    offset: 0
  },

  /**
   * Modifier used to prevent the popper from being positioned outside the boundary.
   *
   * A scenario exists where the reference itself is not within the boundaries.<br />
   * We can say it has "escaped the boundaries" — or just "escaped".<br />
   * In this case we need to decide whether the popper should either:
   *
   * - detach from the reference and remain "trapped" in the boundaries, or
   * - if it should ignore the boundary and "escape with its reference"
   *
   * When `escapeWithReference` is set to`true` and reference is completely
   * outside its boundaries, the popper will overflow (or completely leave)
   * the boundaries in order to remain attached to the edge of the reference.
   *
   * @memberof modifiers
   * @inner
   */
  preventOverflow: {
    /** @prop {number} order=300 - Index used to define the order of execution */
    order: 300,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: preventOverflow,
    /**
     * @prop {Array} [priority=['left','right','top','bottom']]
     * Popper will try to prevent overflow following these priorities by default,
     * then, it could overflow on the left and on top of the `boundariesElement`
     */
    priority: ['left', 'right', 'top', 'bottom'],
    /**
     * @prop {number} padding=5
     * Amount of pixel used to define a minimum distance between the boundaries
     * and the popper. This makes sure the popper always has a little padding
     * between the edges of its container
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='scrollParent'
     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
     * `viewport` or any DOM element.
     */
    boundariesElement: 'scrollParent'
  },

  /**
   * Modifier used to make sure the reference and its popper stay near each other
   * without leaving any gap between the two. Especially useful when the arrow is
   * enabled and you want to ensure that it points to its reference element.
   * It cares only about the first axis. You can still have poppers with margin
   * between the popper and its reference element.
   * @memberof modifiers
   * @inner
   */
  keepTogether: {
    /** @prop {number} order=400 - Index used to define the order of execution */
    order: 400,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: keepTogether
  },

  /**
   * This modifier is used to move the `arrowElement` of the popper to make
   * sure it is positioned between the reference element and its popper element.
   * It will read the outer size of the `arrowElement` node to detect how many
   * pixels of conjunction are needed.
   *
   * It has no effect if no `arrowElement` is provided.
   * @memberof modifiers
   * @inner
   */
  arrow: {
    /** @prop {number} order=500 - Index used to define the order of execution */
    order: 500,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: arrow,
    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
    element: '[x-arrow]'
  },

  /**
   * Modifier used to flip the popper's placement when it starts to overlap its
   * reference element.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   *
   * **NOTE:** this modifier will interrupt the current update cycle and will
   * restart it if it detects the need to flip the placement.
   * @memberof modifiers
   * @inner
   */
  flip: {
    /** @prop {number} order=600 - Index used to define the order of execution */
    order: 600,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: flip,
    /**
     * @prop {String|Array} behavior='flip'
     * The behavior used to change the popper's placement. It can be one of
     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
     * placements (with optional variations)
     */
    behavior: 'flip',
    /**
     * @prop {number} padding=5
     * The popper will flip if it hits the edges of the `boundariesElement`
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='viewport'
     * The element which will define the boundaries of the popper position.
     * The popper will never be placed outside of the defined boundaries
     * (except if `keepTogether` is enabled)
     */
    boundariesElement: 'viewport',
    /**
     * @prop {Boolean} flipVariations=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the reference element overlaps its boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariations: false,
    /**
     * @prop {Boolean} flipVariationsByContent=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the popper element overlaps its reference boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariationsByContent: false
  },

  /**
   * Modifier used to make the popper flow toward the inner of the reference element.
   * By default, when this modifier is disabled, the popper will be placed outside
   * the reference element.
   * @memberof modifiers
   * @inner
   */
  inner: {
    /** @prop {number} order=700 - Index used to define the order of execution */
    order: 700,
    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
    enabled: false,
    /** @prop {ModifierFn} */
    fn: inner
  },

  /**
   * Modifier used to hide the popper when its reference element is outside of the
   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
   * be used to hide with a CSS selector the popper when its reference is
   * out of boundaries.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   * @memberof modifiers
   * @inner
   */
  hide: {
    /** @prop {number} order=800 - Index used to define the order of execution */
    order: 800,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: hide
  },

  /**
   * Computes the style that will be applied to the popper element to gets
   * properly positioned.
   *
   * Note that this modifier will not touch the DOM, it just prepares the styles
   * so that `applyStyle` modifier can apply it. This separation is useful
   * in case you need to replace `applyStyle` with a custom implementation.
   *
   * This modifier has `850` as `order` value to maintain backward compatibility
   * with previous versions of Popper.js. Expect the modifiers ordering method
   * to change in future major versions of the library.
   *
   * @memberof modifiers
   * @inner
   */
  computeStyle: {
    /** @prop {number} order=850 - Index used to define the order of execution */
    order: 850,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: computeStyle,
    /**
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: true,
    /**
     * @prop {string} [x='bottom']
     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
     * Change this if your popper should grow in a direction different from `bottom`
     */
    x: 'bottom',
    /**
     * @prop {string} [x='left']
     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
     * Change this if your popper should grow in a direction different from `right`
     */
    y: 'right'
  },

  /**
   * Applies the computed styles to the popper element.
   *
   * All the DOM manipulations are limited to this modifier. This is useful in case
   * you want to integrate Popper.js inside a framework or view library and you
   * want to delegate all the DOM manipulations to it.
   *
   * Note that if you disable this modifier, you must make sure the popper element
   * has its position set to `absolute` before Popper.js can do its work!
   *
   * Just disable this modifier and define your own to achieve the desired effect.
   *
   * @memberof modifiers
   * @inner
   */
  applyStyle: {
    /** @prop {number} order=900 - Index used to define the order of execution */
    order: 900,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: applyStyle,
    /** @prop {Function} */
    onLoad: applyStyleOnLoad,
    /**
     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: undefined
  }
};

/**
 * The `dataObject` is an object containing all the information used by Popper.js.
 * This object is passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
 * @name dataObject
 * @property {Object} data.instance The Popper.js instance
 * @property {String} data.placement Placement applied to popper
 * @property {String} data.originalPlacement Placement originally defined on init
 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper
 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
 * @property {Object} data.styles Any CSS property defined here will be applied to the popper. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.boundaries Offsets of the popper boundaries
 * @property {Object} data.offsets The measurements of popper, reference and arrow elements
 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
 */

/**
 * Default options provided to Popper.js constructor.<br />
 * These can be overridden using the `options` argument of Popper.js.<br />
 * To override an option, simply pass an object with the same
 * structure of the `options` object, as the 3rd argument. For example:
 * ```
 * new Popper(ref, pop, {
 *   modifiers: {
 *     preventOverflow: { enabled: false }
 *   }
 * })
 * ```
 * @type {Object}
 * @static
 * @memberof Popper
 */
var Defaults = {
  /**
   * Popper's placement.
   * @prop {Popper.placements} placement='bottom'
   */
  placement: 'bottom',

  /**
   * Set this to true if you want popper to position it self in 'fixed' mode
   * @prop {Boolean} positionFixed=false
   */
  positionFixed: false,

  /**
   * Whether events (resize, scroll) are initially enabled.
   * @prop {Boolean} eventsEnabled=true
   */
  eventsEnabled: true,

  /**
   * Set to true if you want to automatically remove the popper when
   * you call the `destroy` method.
   * @prop {Boolean} removeOnDestroy=false
   */
  removeOnDestroy: false,

  /**
   * Callback called when the popper is created.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onCreate}
   */
  onCreate: function onCreate() {},

  /**
   * Callback called when the popper is updated. This callback is not called
   * on the initialization/creation of the popper, but only on subsequent
   * updates.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onUpdate}
   */
  onUpdate: function onUpdate() {},

  /**
   * List of modifiers used to modify the offsets before they are applied to the popper.
   * They provide most of the functionalities of Popper.js.
   * @prop {modifiers}
   */
  modifiers: modifiers
};

/**
 * @callback onCreate
 * @param {dataObject} data
 */

/**
 * @callback onUpdate
 * @param {dataObject} data
 */

// Utils
// Methods
var Popper = function () {
  /**
   * Creates a new Popper.js instance.
   * @class Popper
   * @param {Element|referenceObject} reference - The reference element used to position the popper
   * @param {Element} popper - The HTML / XML element used as the popper
   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
   * @return {Object} instance - The generated Popper.js instance
   */
  function Popper(reference, popper) {
    var _this = this;

    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    classCallCheck(this, Popper);

    this.scheduleUpdate = function () {
      return requestAnimationFrame(_this.update);
    };

    // make update() debounced, so that it only runs at most once-per-tick
    this.update = debounce(this.update.bind(this));

    // with {} we create a new object with the options inside it
    this.options = _extends({}, Popper.Defaults, options);

    // init state
    this.state = {
      isDestroyed: false,
      isCreated: false,
      scrollParents: []
    };

    // get reference and popper elements (allow jQuery wrappers)
    this.reference = reference && reference.jquery ? reference[0] : reference;
    this.popper = popper && popper.jquery ? popper[0] : popper;

    // Deep merge modifiers options
    this.options.modifiers = {};
    Object.keys(_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function (name) {
      _this.options.modifiers[name] = _extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
    });

    // Refactoring modifiers' list (Object => Array)
    this.modifiers = Object.keys(this.options.modifiers).map(function (name) {
      return _extends({
        name: name
      }, _this.options.modifiers[name]);
    })
    // sort the modifiers by order
    .sort(function (a, b) {
      return a.order - b.order;
    });

    // modifiers have the ability to execute arbitrary code when Popper.js get inited
    // such code is executed in the same order of its modifier
    // they could add new properties to their options configuration
    // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
    this.modifiers.forEach(function (modifierOptions) {
      if (modifierOptions.enabled && isFunction(modifierOptions.onLoad)) {
        modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
      }
    });

    // fire the first update to position the popper in the right place
    this.update();

    var eventsEnabled = this.options.eventsEnabled;
    if (eventsEnabled) {
      // setup event listeners, they will take care of update the position in specific situations
      this.enableEventListeners();
    }

    this.state.eventsEnabled = eventsEnabled;
  }

  // We can't use class properties because they don't get listed in the
  // class prototype and break stuff like Sinon stubs


  createClass(Popper, [{
    key: 'update',
    value: function update$$1() {
      return update.call(this);
    }
  }, {
    key: 'destroy',
    value: function destroy$$1() {
      return destroy.call(this);
    }
  }, {
    key: 'enableEventListeners',
    value: function enableEventListeners$$1() {
      return enableEventListeners.call(this);
    }
  }, {
    key: 'disableEventListeners',
    value: function disableEventListeners$$1() {
      return disableEventListeners.call(this);
    }

    /**
     * Schedules an update. It will run on the next UI update available.
     * @method scheduleUpdate
     * @memberof Popper
     */


    /**
     * Collection of utilities useful when writing custom modifiers.
     * Starting from version 1.7, this method is available only if you
     * include `popper-utils.js` before `popper.js`.
     *
     * **DEPRECATION**: This way to access PopperUtils is deprecated
     * and will be removed in v2! Use the PopperUtils module directly instead.
     * Due to the high instability of the methods contained in Utils, we can't
     * guarantee them to follow semver. Use them at your own risk!
     * @static
     * @private
     * @type {Object}
     * @deprecated since version 1.8
     * @member Utils
     * @memberof Popper
     */

  }]);
  return Popper;
}();

/**
 * The `referenceObject` is an object that provides an interface compatible with Popper.js
 * and lets you use it as replacement of a real DOM node.<br />
 * You can use this method to position a popper relatively to a set of coordinates
 * in case you don't have a DOM node to use as reference.
 *
 * ```
 * new Popper(referenceObject, popperNode);
 * ```
 *
 * NB: This feature isn't supported in Internet Explorer 10.
 * @name referenceObject
 * @property {Function} data.getBoundingClientRect
 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
 * @property {number} data.clientWidth
 * An ES6 getter that will return the width of the virtual reference element.
 * @property {number} data.clientHeight
 * An ES6 getter that will return the height of the virtual reference element.
 */


Popper.Utils = (typeof window !== 'undefined' ? window : global).PopperUtils;
Popper.placements = placements;
Popper.Defaults = Defaults;

/* harmony default export */ __webpack_exports__["a"] = (Popper);
//# sourceMappingURL=popper.js.map

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(236)))

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(226);
module.exports = __webpack_require__(1).parseFloat;


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(9);
var $parseFloat = __webpack_require__(227);
// 18.2.4 parseFloat(string)
$export($export.G + $export.F * (parseFloat != $parseFloat), { parseFloat: $parseFloat });


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

var $parseFloat = __webpack_require__(2).parseFloat;
var $trim = __webpack_require__(182).trim;

module.exports = 1 / $parseFloat(__webpack_require__(176) + '-0') !== -Infinity ? function parseFloat(str) {
  var string = $trim(String(str), 3);
  var result = $parseFloat(string);
  return result === 0 && string.charAt(0) == '-' ? -0 : result;
} : $parseFloat;


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

var _Array$isArray = __webpack_require__(128);

function _arrayWithHoles(arr) {
  if (_Array$isArray(arr)) return arr;
}

module.exports = _arrayWithHoles;

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

var _getIterator = __webpack_require__(230);

var _isIterable = __webpack_require__(148);

var _Symbol = __webpack_require__(86);

function _iterableToArrayLimit(arr, i) {
  if (typeof _Symbol === "undefined" || !_isIterable(Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = _getIterator(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

module.exports = _iterableToArrayLimit;

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(231);

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(56);
__webpack_require__(49);
module.exports = __webpack_require__(232);


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(11);
var get = __webpack_require__(73);
module.exports = __webpack_require__(1).getIterator = function (it) {
  var iterFn = get(it);
  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};


/***/ }),
/* 233 */
/***/ (function(module, exports) {

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

module.exports = _nonIterableRest;

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(235);
module.exports = __webpack_require__(1).Number.isFinite;


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.2 Number.isFinite(number)
var $export = __webpack_require__(9);
var _isFinite = __webpack_require__(2).isFinite;

$export($export.S, 'Number', {
  isFinite: function isFinite(it) {
    return typeof it == 'number' && _isFinite(it);
  }
});


/***/ }),
/* 236 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || new Function("return this")();
} catch (e) {
	// This works if the window reference is available
	if (typeof window === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(238);
module.exports = __webpack_require__(1).parseInt;


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(9);
var $parseInt = __webpack_require__(239);
// 18.2.5 parseInt(string, radix)
$export($export.G + $export.F * (parseInt != $parseInt), { parseInt: $parseInt });


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

var $parseInt = __webpack_require__(2).parseInt;
var $trim = __webpack_require__(182).trim;
var ws = __webpack_require__(176);
var hex = /^[-+]?0[xX]/;

module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
  var string = $trim(String(str), 3);
  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
} : $parseInt;


/***/ }),
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "install", function() { return install; });
/* harmony import */ var _src_collapse__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(201);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Collapse", function() { return _src_collapse__WEBPACK_IMPORTED_MODULE_0__["default"]; });

/* harmony import */ var _src_collapse_item__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(217);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CollapseItem", function() { return _src_collapse_item__WEBPACK_IMPORTED_MODULE_1__["default"]; });

/* harmony import */ var _src_actionsheet__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(197);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Actionsheet", function() { return _src_actionsheet__WEBPACK_IMPORTED_MODULE_2__["default"]; });

/* harmony import */ var _src_alert__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(183);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Alert", function() { return _src_alert__WEBPACK_IMPORTED_MODULE_3__["default"]; });

/* harmony import */ var _src_badge__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(198);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Badge", function() { return _src_badge__WEBPACK_IMPORTED_MODULE_4__["default"]; });

/* harmony import */ var _src_button__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(114);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Button", function() { return _src_button__WEBPACK_IMPORTED_MODULE_5__["default"]; });

/* harmony import */ var _src_calendar__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(193);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Calendar", function() { return _src_calendar__WEBPACK_IMPORTED_MODULE_6__["default"]; });

/* harmony import */ var _src_cell__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(146);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Cell", function() { return _src_cell__WEBPACK_IMPORTED_MODULE_7__["default"]; });

/* harmony import */ var _src_checkbox__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(200);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Checkbox", function() { return _src_checkbox__WEBPACK_IMPORTED_MODULE_8__["default"]; });

/* harmony import */ var _src_checkbox_group__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(199);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CheckboxGroup", function() { return _src_checkbox_group__WEBPACK_IMPORTED_MODULE_9__["default"]; });

/* harmony import */ var _src_confirm__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(184);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Confirm", function() { return _src_confirm__WEBPACK_IMPORTED_MODULE_10__["default"]; });

/* harmony import */ var _src_date_picker__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(185);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DatePicker", function() { return _src_date_picker__WEBPACK_IMPORTED_MODULE_11__["default"]; });

/* harmony import */ var _src_date_select__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(186);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DateSelect", function() { return _src_date_select__WEBPACK_IMPORTED_MODULE_12__["default"]; });

/* harmony import */ var _src_date_picker_view__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(157);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DatePickerView", function() { return _src_date_picker_view__WEBPACK_IMPORTED_MODULE_13__["default"]; });

/* harmony import */ var _src_drag__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(95);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Drag", function() { return _src_drag__WEBPACK_IMPORTED_MODULE_14__["default"]; });

/* harmony import */ var _src_icon__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(68);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Icon", function() { return _src_icon__WEBPACK_IMPORTED_MODULE_15__["default"]; });

/* harmony import */ var _src_input__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(187);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Input", function() { return _src_input__WEBPACK_IMPORTED_MODULE_16__["default"]; });

/* harmony import */ var _src_input_number__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(202);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "InputNumber", function() { return _src_input_number__WEBPACK_IMPORTED_MODULE_17__["default"]; });

/* harmony import */ var _src_keyboard__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(158);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Keyboard", function() { return _src_keyboard__WEBPACK_IMPORTED_MODULE_18__["default"]; });

/* harmony import */ var _src_keyboard_picker__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(170);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "KeyboardPicker", function() { return _src_keyboard_picker__WEBPACK_IMPORTED_MODULE_19__["default"]; });

/* harmony import */ var _src_loading__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(180);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Loading", function() { return _src_loading__WEBPACK_IMPORTED_MODULE_20__["default"]; });

/* harmony import */ var _src_mask__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(59);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Mask", function() { return _src_mask__WEBPACK_IMPORTED_MODULE_21__["default"]; });

/* harmony import */ var _src_message__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(171);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Message", function() { return _src_message__WEBPACK_IMPORTED_MODULE_22__["default"]; });

/* harmony import */ var _src_modal__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(145);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Modal", function() { return _src_modal__WEBPACK_IMPORTED_MODULE_23__["default"]; });

/* harmony import */ var _src_notice_bar__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(218);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "NoticeBar", function() { return _src_notice_bar__WEBPACK_IMPORTED_MODULE_24__["default"]; });

/* harmony import */ var _src_nav_bar__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(203);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "NavBar", function() { return _src_nav_bar__WEBPACK_IMPORTED_MODULE_25__["default"]; });

/* harmony import */ var _src_panel__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(204);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Panel", function() { return _src_panel__WEBPACK_IMPORTED_MODULE_26__["default"]; });

/* harmony import */ var _src_panel_header__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(205);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "PanelHeader", function() { return _src_panel_header__WEBPACK_IMPORTED_MODULE_27__["default"]; });

/* harmony import */ var _src_panel_body__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(206);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "PanelBody", function() { return _src_panel_body__WEBPACK_IMPORTED_MODULE_28__["default"]; });

/* harmony import */ var _src_panel_footer__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(207);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "PanelFooter", function() { return _src_panel_footer__WEBPACK_IMPORTED_MODULE_29__["default"]; });

/* harmony import */ var _src_picker__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(188);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Picker", function() { return _src_picker__WEBPACK_IMPORTED_MODULE_30__["default"]; });

/* harmony import */ var _src_picker_view__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(159);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "PickerView", function() { return _src_picker_view__WEBPACK_IMPORTED_MODULE_31__["default"]; });

/* harmony import */ var _src_popup__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(74);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Popup", function() { return _src_popup__WEBPACK_IMPORTED_MODULE_32__["default"]; });

/* harmony import */ var _src_popper__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(195);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Popper", function() { return _src_popper__WEBPACK_IMPORTED_MODULE_33__["default"]; });

/* harmony import */ var _src_progress__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(208);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Progress", function() { return _src_progress__WEBPACK_IMPORTED_MODULE_34__["default"]; });

/* harmony import */ var _src_pull__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(216);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Pull", function() { return _src_pull__WEBPACK_IMPORTED_MODULE_35__["default"]; });

/* harmony import */ var _src_search_bar__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(209);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SearchBar", function() { return _src_search_bar__WEBPACK_IMPORTED_MODULE_36__["default"]; });

/* harmony import */ var _src_select__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(189);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Select", function() { return _src_select__WEBPACK_IMPORTED_MODULE_37__["default"]; });

/* harmony import */ var _src_slider__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__(210);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Slider", function() { return _src_slider__WEBPACK_IMPORTED_MODULE_38__["default"]; });

/* harmony import */ var _src_activity_indicator__WEBPACK_IMPORTED_MODULE_39__ = __webpack_require__(93);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ActivityIndicator", function() { return _src_activity_indicator__WEBPACK_IMPORTED_MODULE_39__["default"]; });

/* harmony import */ var _src_stack_picker__WEBPACK_IMPORTED_MODULE_40__ = __webpack_require__(190);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "StackPicker", function() { return _src_stack_picker__WEBPACK_IMPORTED_MODULE_40__["default"]; });

/* harmony import */ var _src_stack_select__WEBPACK_IMPORTED_MODULE_41__ = __webpack_require__(191);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "StackSelect", function() { return _src_stack_select__WEBPACK_IMPORTED_MODULE_41__["default"]; });

/* harmony import */ var _src_stepper__WEBPACK_IMPORTED_MODULE_42__ = __webpack_require__(211);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Stepper", function() { return _src_stepper__WEBPACK_IMPORTED_MODULE_42__["default"]; });

/* harmony import */ var _src_carousel__WEBPACK_IMPORTED_MODULE_43__ = __webpack_require__(172);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Carousel", function() { return _src_carousel__WEBPACK_IMPORTED_MODULE_43__["default"]; });

/* harmony import */ var _src_swipe_action__WEBPACK_IMPORTED_MODULE_44__ = __webpack_require__(212);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SwipeAction", function() { return _src_swipe_action__WEBPACK_IMPORTED_MODULE_44__["default"]; });

/* harmony import */ var _src_carousel_item__WEBPACK_IMPORTED_MODULE_45__ = __webpack_require__(169);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CarouselItem", function() { return _src_carousel_item__WEBPACK_IMPORTED_MODULE_45__["default"]; });

/* harmony import */ var _src_switch__WEBPACK_IMPORTED_MODULE_46__ = __webpack_require__(213);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Switch", function() { return _src_switch__WEBPACK_IMPORTED_MODULE_46__["default"]; });

/* harmony import */ var _src_radio__WEBPACK_IMPORTED_MODULE_47__ = __webpack_require__(214);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Radio", function() { return _src_radio__WEBPACK_IMPORTED_MODULE_47__["default"]; });

/* harmony import */ var _src_radio_group__WEBPACK_IMPORTED_MODULE_48__ = __webpack_require__(215);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RadioGroup", function() { return _src_radio_group__WEBPACK_IMPORTED_MODULE_48__["default"]; });

/* harmony import */ var _src_tabs__WEBPACK_IMPORTED_MODULE_49__ = __webpack_require__(196);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Tabs", function() { return _src_tabs__WEBPACK_IMPORTED_MODULE_49__["default"]; });

/* harmony import */ var _src_tab_panel__WEBPACK_IMPORTED_MODULE_50__ = __webpack_require__(219);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TabPanel", function() { return _src_tab_panel__WEBPACK_IMPORTED_MODULE_50__["default"]; });

/* harmony import */ var _src_toast__WEBPACK_IMPORTED_MODULE_51__ = __webpack_require__(168);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Toast", function() { return _src_toast__WEBPACK_IMPORTED_MODULE_51__["default"]; });

/* harmony import */ var _src_tooltip__WEBPACK_IMPORTED_MODULE_52__ = __webpack_require__(160);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Tooltip", function() { return _src_tooltip__WEBPACK_IMPORTED_MODULE_52__["default"]; });

/* harmony import */ var _src_file_picker__WEBPACK_IMPORTED_MODULE_53__ = __webpack_require__(194);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "FilePicker", function() { return _src_file_picker__WEBPACK_IMPORTED_MODULE_53__["default"]; });

/* harmony import */ var _src_tab_bar__WEBPACK_IMPORTED_MODULE_54__ = __webpack_require__(220);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TabBar", function() { return _src_tab_bar__WEBPACK_IMPORTED_MODULE_54__["default"]; });

/* harmony import */ var _src_tab_bar_item__WEBPACK_IMPORTED_MODULE_55__ = __webpack_require__(221);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TabBarItem", function() { return _src_tab_bar_item__WEBPACK_IMPORTED_MODULE_55__["default"]; });

/* harmony import */ var _src_locale_provider__WEBPACK_IMPORTED_MODULE_56__ = __webpack_require__(192);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "LocaleProvider", function() { return _src_locale_provider__WEBPACK_IMPORTED_MODULE_56__["default"]; });


























































var version = '2.0.0';
var components = [_src_collapse__WEBPACK_IMPORTED_MODULE_0__["default"], _src_collapse_item__WEBPACK_IMPORTED_MODULE_1__["default"], _src_actionsheet__WEBPACK_IMPORTED_MODULE_2__["default"], _src_alert__WEBPACK_IMPORTED_MODULE_3__["default"], _src_badge__WEBPACK_IMPORTED_MODULE_4__["default"], _src_button__WEBPACK_IMPORTED_MODULE_5__["default"], _src_calendar__WEBPACK_IMPORTED_MODULE_6__["default"], _src_cell__WEBPACK_IMPORTED_MODULE_7__["default"], _src_checkbox__WEBPACK_IMPORTED_MODULE_8__["default"], _src_checkbox_group__WEBPACK_IMPORTED_MODULE_9__["default"], _src_confirm__WEBPACK_IMPORTED_MODULE_10__["default"], _src_date_picker__WEBPACK_IMPORTED_MODULE_11__["default"], _src_date_picker_view__WEBPACK_IMPORTED_MODULE_13__["default"], _src_date_select__WEBPACK_IMPORTED_MODULE_12__["default"], _src_drag__WEBPACK_IMPORTED_MODULE_14__["default"], _src_icon__WEBPACK_IMPORTED_MODULE_15__["default"], _src_input__WEBPACK_IMPORTED_MODULE_16__["default"], _src_input_number__WEBPACK_IMPORTED_MODULE_17__["default"], _src_keyboard__WEBPACK_IMPORTED_MODULE_18__["default"], _src_keyboard_picker__WEBPACK_IMPORTED_MODULE_19__["default"], _src_loading__WEBPACK_IMPORTED_MODULE_20__["default"], _src_mask__WEBPACK_IMPORTED_MODULE_21__["default"], _src_message__WEBPACK_IMPORTED_MODULE_22__["default"], _src_modal__WEBPACK_IMPORTED_MODULE_23__["default"], _src_notice_bar__WEBPACK_IMPORTED_MODULE_24__["default"], _src_nav_bar__WEBPACK_IMPORTED_MODULE_25__["default"], _src_panel__WEBPACK_IMPORTED_MODULE_26__["default"], _src_panel_header__WEBPACK_IMPORTED_MODULE_27__["default"], _src_panel_body__WEBPACK_IMPORTED_MODULE_28__["default"], _src_panel_footer__WEBPACK_IMPORTED_MODULE_29__["default"], _src_picker__WEBPACK_IMPORTED_MODULE_30__["default"], _src_picker_view__WEBPACK_IMPORTED_MODULE_31__["default"], _src_popup__WEBPACK_IMPORTED_MODULE_32__["default"], _src_popper__WEBPACK_IMPORTED_MODULE_33__["default"], _src_progress__WEBPACK_IMPORTED_MODULE_34__["default"], _src_pull__WEBPACK_IMPORTED_MODULE_35__["default"], _src_radio__WEBPACK_IMPORTED_MODULE_47__["default"], _src_radio_group__WEBPACK_IMPORTED_MODULE_48__["default"], _src_search_bar__WEBPACK_IMPORTED_MODULE_36__["default"], _src_select__WEBPACK_IMPORTED_MODULE_37__["default"], _src_slider__WEBPACK_IMPORTED_MODULE_38__["default"], _src_activity_indicator__WEBPACK_IMPORTED_MODULE_39__["default"], _src_stack_picker__WEBPACK_IMPORTED_MODULE_40__["default"], _src_stack_select__WEBPACK_IMPORTED_MODULE_41__["default"], _src_stepper__WEBPACK_IMPORTED_MODULE_42__["default"], _src_carousel__WEBPACK_IMPORTED_MODULE_43__["default"], _src_swipe_action__WEBPACK_IMPORTED_MODULE_44__["default"], _src_carousel_item__WEBPACK_IMPORTED_MODULE_45__["default"], _src_switch__WEBPACK_IMPORTED_MODULE_46__["default"], _src_tabs__WEBPACK_IMPORTED_MODULE_49__["default"], _src_tab_panel__WEBPACK_IMPORTED_MODULE_50__["default"], _src_toast__WEBPACK_IMPORTED_MODULE_51__["default"], _src_tooltip__WEBPACK_IMPORTED_MODULE_52__["default"], _src_file_picker__WEBPACK_IMPORTED_MODULE_53__["default"], _src_tab_bar__WEBPACK_IMPORTED_MODULE_54__["default"], _src_tab_bar_item__WEBPACK_IMPORTED_MODULE_55__["default"], _src_locale_provider__WEBPACK_IMPORTED_MODULE_56__["default"]];

var install = function install(Vue) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  // eslint-disable-line no-unused-vars

  /* istanbul ignore if */
  if (install.installed) return;
  components.map(function (component) {
    return Vue.component(component.name, component);
  });
  Vue.use(_src_loading__WEBPACK_IMPORTED_MODULE_20__["default"].directive);
  Vue.prototype.$zaToast = _src_toast__WEBPACK_IMPORTED_MODULE_51__["default"].root;
  Vue.prototype.$zaTooltip = _src_tooltip__WEBPACK_IMPORTED_MODULE_52__["default"].root;
  Vue.prototype.$zaLoading = _src_loading__WEBPACK_IMPORTED_MODULE_20__["default"].root;
  Vue.prototype.$zaAlert = _src_alert__WEBPACK_IMPORTED_MODULE_3__["default"].root;
  Vue.prototype.$zaConfirm = _src_confirm__WEBPACK_IMPORTED_MODULE_10__["default"].root;
};

if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue);
}


/* harmony default export */ __webpack_exports__["default"] = ({
  install: install,
  version: version
});

/***/ })
/******/ ]);